export default {
  "632": "this is another tag",
  "666": "666",
  "12313": "222",
  "123123": "SFAFA",
  "77777777": "7777",
  "language.name": "English",
  "system.dataScreen": "Data Screen",
  "product.PleaseEnter": "Please enter the Product name",
  "product.PleaseEnterTheProductSerialNumber": "Please enter the Product serial number",
  "product.PleaseEnterSubmodelNumber": "Please enter submodel",
  "product.PleaseenterTheSubmodelSerialNumber": "Please enter the submodel serial number",
  "product.PleaseSelectTheDeviceType": "Please select the device type",
  "product.PleaseSelectDevelopmentType": "Please select development type",
  "product.management": "Product",
  "product.name": "Product Series",
  "product.reset": "Reset",
  "product.search": "Search",
  "product.ApplicationList": "Product List",
  "product.newProduct": "New Product",
  "product.editName": "Edit Name",
  "product.DetailSetting": "Detail setting",
  "product.delete": "Delete",
  "product.deleteConfirm": "Are you sure you want to delete the product {productName}?",
  "product.serialNumber": "Serial number",
  "product.deviceType": "device type",
  "product.RandDtype": "R&D Type",
  "product.subType": "Sub-type",
  "product.updateTime": "update time",
  "product.operation": "Operation",
  "product.shippingMarket": "Shipping Market",
  "product.deviceList": "Device List (Shipping Log)",
  "product.parameterManagement": "Parameter Management",
  "product.updataManagement": "Update Management",
  "product.ParentDevice": "Parent Device",
  "product.AssociatedPowerStationState": "Associated Plant State",
  "product.ImportDeviceList": "Import Device List",
  "product.PlantDetails": "Plant details",
  "product.parameterName": "Parameter Name",
  "product.OwningPowerStation": "Owning Plant",
  "product.ParameterClass": "Parameter Class",
  "product.ParameterSettingType": "Parameter Setting Type",
  "product.ParameterOperationType": "Parameter Operation Type",
  "product.ImportParameter": "Import Parameter",
  "product.OwningUpperLevelParameterCategory": "Owning Upper Level Parameter Category",
  "product.WhetherYoSupportBatchRead": "Whether to Support Batch Read",
  "product.value": "Value",
  "product.scope": "Scope",
  "product.unit": "Unit",
  "product.explain": "Explain",
  "product.remark": "Remark",
  "product.fileName": "File Name",
  "product.fileAddress": "File Address",
  "product.versionNumber": "Version number",
  "product.ProductOfOwnership": "Product of Ownership",
  "product.ProductDetailsSettings": "Balcony 1.0 - Product Details Settings",
  "product.QueryResultList": "Query Result List",
  "product.AddFirmware": "Add Firmware",
  "product.NewParameter": "New Parameter",
  "product.datalog": "Dongle",
  "product.Inverter": "Inverter",
  "product.storage": "Battery",
  "product.battery": "Battery",
  "product.socket": "Socket",
  "product.DownloadTemplate": "DownLoad Template",
  "product.nation": "Country",
  "product.agent": "Agent",
  "product.expirationDate": "Quality guarantee period",
  "product.UpdateTime": "Update time",
  "product.LastWeek": "Last week",
  "product.LastMonth": "Last month",
  "product.LastThreeMonths": "In the past three months",
  "product.parameterType": "Parameter Type",
  "product.ProtocolAddress": "Address in parameter protocol",
  "product.stepSize": "Step",
  "product.PleaseEnterAParameterName": "Please enter the parameter name",
  "product.parameterCoding": "Parameter Encoding",
  "product.PleaseEnterTheParameterCode": "Please enter the parameter code",
  "product.ParameterDataType": "Parameter Data Type",
  "product.PleaseEnterTheAddressInTheParameterProtocol": "Please enter the address in the parameter protocol",
  "product.blockEncoding": "Group coding",
  "product.PleaseEnterABlockCode": "Please enter the group code",
  "product.GroupName": "Group name",
  "product.PleaseEnterAGroupName": "Please enter the group name",
  "product.PleaseEnterTheUnit": "Please enter the minimum value",
  "product.decimalPoint": "Decimal point",
  "product.PleaseEnterTheDecimalPoint": "Please enter the decimal point",
  "product.leastValue": "Minimum value",
  "product.maximumValue": "Maximum value",
  "product.PleaseEnterTheMaximumValue": "Please enter the maximum value",
  "product.PleaseEnterTheStepSize": "Please enter the step size",
  "product.addEquipment": "Add new Device",
  "product.equipment": "Device",
  "product.remove": "Remove",
  "product.sort": "Sort",
  "product.PleaseEnterTheOrder": "Please enter sorting",
  "product.PleaseEnterTheParameterSettingType": "Please enter the parameter setting type",
  "product.PleaseSelectAFolderPath": "Please select folder path",
  "product.ReturnToSuperior": "Return to the superior",
  "product.PleaseEnterTheVersionNumber": "Please enter the version number",
  "product.firmwareSpecification": "Firmware Description",
  "product.PleaseEnterFirmwareDescription": "please enter firmware description",
  "product.FileName": "file name",
  "product.DeviceType": "device type",
  "product.FileAddress": "File address",
  "product.time": "Service Time",
  "sidebar.default": "Navigation page",
  "sidebar.home": "Data Overview",
  "sidebar.endbenutzer": "User",
  "sidebar.plant": "Scene management",
  "sidebar.plant_plant": "Plant",
  "sidebar.device": "Device",
  "sidebar.datalog": "Dongle List",
  "sidebar.inverter": "Inverter List",
  "sidebar.sotrage": "Battery List",
  "sidebar.battery": "Battery List",
  "sidebar.socket": "List of sockets",
  "sidebar.agent": "Agent Management",
  "sidebar.systematicSupply": "Shipment log",
  "sidebar.firmware": "OTA",
  "sidebar.firmware_up": "Firmware UpLoad",
  "sidebar.firmware_log": "Upgrade Record",
  "sidebar.system": "Log",
  "sidebar.system_datalog_log": "Dongle log",
  "sidebar.system_log": "Operation Log",
  "sidebar.system_tongxun": "Communication Log",
  "sidebar.system_app": "App Version",
  "sidebar.personal": "User Information",
  "sidebar.logout": "Exit account",
  "sidebar.organizationalManagement": "Organization",
  "sidebar.auth_manage": "Permission",
  "sidebar.workorder": "Work Order",
  "shipment.shippingManagement": "Shipment",
  "shipment.shippingManagementTemplage": "Shipping Management Import Template",
  "login.email": "E-Mail",
  "login.password": "Password",
  "login.remember": "Remember email and password",
  "login.rememberAccount": "Please enter password",
  "login.enteremail": "Please enter your email address",
  "login.enterpassword": "Please input a password",
  "login.enterAccount": "Please enter email or phone number",
  "login.correctAccount": "Please enter correct email or phone number",
  "login.accountPlaceholder": "Please enter email or phone number",
  "login.accountNumber": "Account number",
  "login.system": "Haier Smart Energy Management System",
  "login.read": "Read and agree",
  "login.userAgreement": "User Agreement",
  "login.privacyPolicy": "Privacy Policy",
  "login.temporarilyDisagree": "Temporarily disagree",
  "login.agreeAndAccept": "Agree and accept",
  "login.retrievePassword": "Retrieve password",
  "login.verCode": "Verification Code",
  "login.newPassword": "New password",
  "login.sendverCode": "Send verification code",
  "login.greenLife": "Innovate clean energy and build a green life",
  "login.welcome": "Welcome to Haier Energy Cloud",
  "login.downloadApp": "Download App",
  "login.sure": "Confirm",
  "home.echarts1.title": "Registered User",
  "home.echarts1.subhead": "Total number of new/users added today",
  "home.echarts2.title": "Log on user",
  "home.echarts2.subhead": "Today's login/total number of users",
  "home.echarts3.title": "Add agent",
  "home.echarts3.subhead": "Today's login/total number of agents",
  "home.echarts4.title": "Add Scene",
  "home.echarts4.subhead": "New scenes/total number of scenes added",
  "home.echarts4.title_plant": "Add Plant",
  "home.echarts4.subhead_plant": "Newly added Plants/total number of Plants",
  "home.echarts5.title": "Add Dongle",
  "home.echarts5.subhead": "New Dongles/ Total number of dongles added",
  "home.echarts6.title": "Add device",
  "home.echarts6.subhead": "Newly added devices/total number of devices",
  "End_user.input_email": "Please enter the user's email address",
  "End_user.btn_search": "Search",
  "End_user.btn_add": "Add to",
  "End_user.btn_delete": "Delete",
  "End_user.btn_binding": "Binding",
  "End_user.add_station": "Add Scene",
  "End_user.lable_StationName": "Scene Name",
  "End_user.lable_StationType": "Scene Type",
  "End_user.lable_PVCapacity": "Solar cell capacity",
  "End_user.lable_InstalltionDate": "Install date",
  "End_user.lable_Country": "Country",
  "End_user.lable_City": "City",
  "End_user.lable_Address": "Address",
  "End_user.lable_TimeZone": "Time zone",
  "End_user.lable_Energyprice": "Energy unit price",
  "End_user.lable_IncomeUnit": "Income unit",
  "End_user.input_StationName": "Please enter the scene name",
  "End_user.input_StationType": "Please select type",
  "End_user.input_PVCapacity": "Please enter the battery capacity",
  "End_user.input_InstalltionDate": "Please select the installation date",
  "End_user.input_Country": "Please select your country",
  "End_user.input_City": "Please select a city",
  "End_user.input_Address": "Please enter the address",
  "End_user.input_TimeZone": "Please choose a time zone",
  "End_user.input_Energyprice": "Please enter the unit price",
  "End_user.input_IncomeUnit": "Select income unit",
  "End_user.max_20": "The maximum number of characters cannot exceed 20",
  "End_user.max_5": "The maximum number of characters cannot exceed 5",
  "End_user.max_8": "The maximum number of characters cannot exceed 8",
  "End_user.format": "Please enter the correct format",
  "End_user.close": "Close",
  "End_user.submit": "Submit",
  "End_user.title_delete": "Delete?",
  "End_user.no": "No",
  "End_user.yes": "Yes",
  "End_user.Bingding_Agent": "Bind agent",
  "End_user.Agent_Code": "Agent:",
  "End_user.please_select": "Please choose",
  "plant.input_email": "Please enter the user's email address",
  "plant.search": "Search",
  "plant.edit": "Edit",
  "plant.delete": "Delete",
  "plant.edit_plant": "Edit Scene",
  "plant.input_station": "Please enter the scene name",
  "plant.lable_StationName": "Scene Name",
  "plant.lable_StationType": "Scene Type",
  "plant.lable_PVCapacity": "Solar cell capacity",
  "plant.lable_InstalltionDate": "Install date",
  "plant.lable_Country": "Country",
  "plant.lable_City": "City",
  "plant.lable_Address": "Address",
  "plant.lable_TimeZone": "Time zone",
  "plant.lable_Energyprice": "Energy unit price",
  "plant.lable_IncomeUnit": "Income unit",
  "plant.input_StationName": "Please enter the scene name",
  "plant.input_StationType": "Please Select Type",
  "plant.input_PVCapacity": "Please enter the battery capacity",
  "plant.input_InstalltionDate": "Please select the installation date",
  "plant.input_Country": "Please select a country",
  "plant.input_City": "Please select a city",
  "plant.input_Address": "Please enter the address",
  "plant.input_TimeZone": "Please choose a time zone",
  "plant.input_Energyprice": "Please enter the unit price",
  "plant.input_IncomeUnit": "Select income unit",
  "plant.max_20": "The maximum number of characters cannot exceed 20",
  "plant.max_5": "The maximum number of characters cannot exceed 5",
  "plant.max_8": "The maximum number of characters cannot exceed 8",
  "plant.format": "Please enter the correct format",
  "plant.close": "Close",
  "plant.submit": "Submit",
  "plant.title_delete": "Delete?",
  "plant.no": "No",
  "plant.yes": "Yes",
  "plant.powerGeneration": "Yield",
  "plant.powerConsumption": "Consumption",
  "plant.spontaneousSelfUse": "Self-consumption Energy",
  "plant.selfSufficient": "Self-sufficient Energy",
  "plant.photovoltaicPowerGeneration": "PV Generation Power",
  "plant.electricPowerConsumption": "Load Power",
  "plant.spontaneousSelfUsePower": "Self-consumption Power",
  "plant.buyPowers": "Grid Imported Power",
  "plant.sellPowers": "Exported Power",
  "plant.selfSufficientPower": "Self-Sufficiency Power",
  "plant.batterySOC": "Battery SOC",
  "plant.storageChargingPower": "Battery Charge Power",
  "plant.storageDischargePower": "Battery Discharge Power",
  "plant.co2emissionReduction": "CO2 Reductions",
  "plant.plantPowerGeneration": "Plant Power Generation",
  "plant.equivalentTreePlanting": "Equivalent Tree Planting",
  "plant.saveStandardCoal": "Standard Coal Saved",
  "plant.today": "Today",
  "plant.month": "This Month",
  "plant.year": "This Year",
  "plant.total": "Total",
  "plant.createType": "Created By",
  "datalog.email": "Please enter your email address",
  "datalog.datalogSn": "Please enter the serial number of the Dongle",
  "datalog.search": "Search",
  "datalog.Version": "Version number",
  "datalog.setting": "Set up",
  "datalog.upgrade": "Upgrade",
  "datalog.delete": "Delete",
  "datalog.title_datalog": "Dongle Settings",
  "datalog.span_info": "Information",
  "datalog.span_datalog": "Dongle SN:",
  "datalog.span_name": "Alias:",
  "datalog.span_time": "Update Time:",
  "datalog.span_firmware": "Signal/firmware version:",
  "datalog.span_order": "Command",
  "datalog.span_settingdns": "Set Domain Name",
  "datalog.span_inputsetting": "Please enter domain name",
  "datalog.span_upgrade": "Upgrade Dongle",
  "datalog.span_reset": "Restart the Dongle",
  "datalog.span_setup": "Advanced setting",
  "datalog.span_param": "Parameter",
  "datalog.span_value": "Value",
  "datalog.btn_setup": "Advanced setting",
  "datalog.btn_setting": "Set up",
  "datalog.btn_settingdns": "Set Domain Name",
  "datalog.btn_upgrade": "Upgrade",
  "datalog.btn_reset": "Restart",
  "datalog.btn_read": "Read",
  "datalog.btn_close": "Cancel",
  "datalog.methods_version": "Detecting version updates?",
  "datalog.no": "No",
  "datalog.yes": "Yes",
  "datalog.methods_delete": "Delete?",
  "datalog.methods_rereset": "Restart?",
  "datalog.methodes_inputDns": "Please enter domain name",
  "datalog.methodes_DNS": "Do you want to set this domain name",
  "sotrage.select": "Please choose",
  "sotrage.email": "Please enter your email address",
  "sotrage.datalogSn": "Please enter the serial number of the dongle",
  "sotrage.deviceSn": "Please enter the device serial number",
  "sotrage.search": "Search",
  "device.select": "Please choose",
  "device.email": "Please enter your email address",
  "device.datalogSn": "Please enter the serial number of the dongle",
  "device.deviceSn": "Please enter the device serial number",
  "device.search": "Search",
  "device.title": "Inverter settings",
  "device.setting": "Set up",
  "device.setting_inverte": "Set Inverter Parameters",
  "device.input_start_address": "Starting register address",
  "device.input_ent_address": "Terminate register address",
  "device.input_setting_value": "Please enter the setting value",
  "device.read_data": "Read Register Data:",
  "device.input_start_read": "Starting register address",
  "device.input_end_read": "Terminate register address",
  "device.btn_address": "Set address",
  "device.btn_value": "Set Parameters",
  "device.btn_read": "Read",
  "device.btn_close": "Return",
  "device.selet_data": "Select date",
  "device.workMode": "Working Mode",
  "device.alarmInfo": "Number Of Alarms",
  "device.countryStandard": "National Standards",
  "device.runningStatus": "Operating Status",
  "device.inverterTemp": "Inverter Temperature(℃)",
  "device.dcdcTemp": "Battery Temperature(℃)",
  "device.mpptTemp": "MPPT Temperature(℃)",
  "device.drmStatus": "DRM Status",
  "device.version": "Version",
  "device.communicationEquipment": "Dongle",
  "device.basicInfo": "Basic Information",
  "device.productName": "Product Name",
  "device.productType": "Product Type",
  "device.productModel": "Product Model",
  "device.softVersion": "Software Version",
  "device.softUpdateTime": "Software Update Time",
  "device.plant": "Plant",
  "device.installer": "Organization",
  "device.installPerson": "Installer",
  "device.deviceRegisterDate": "Device Registration Date",
  "device.ownerEmail": "Owner Email",
  "device.ownerReceiveTime": "Owner Receipt Time",
  "device.ownerFamily": "Owner Family",
  "device.versionInfo": "Version Information",
  "device.searchSn": "Please enter the SN to search",
  "device.user": "User",
  "device.userReceiveDate": "User Reception Date",
  "device.yuan": "PV",
  "device.totalPower": "Total Power",
  "device.todayPowerGeneration": "Today Yield",
  "device.dataGateway": "Data Gateway",
  "device.optimizer": "Optimizer",
  "device.chu": "Battery",
  "device.power": "Power",
  "device.todayChargingCapacity": "Today Charged Energy",
  "device.todayDischargingCapacity": "Today Discharged Energy",
  "device.he": "Load",
  "device.todayElectricityConsumption": "Today Consumption",
  "device.totalElectricityConsumption": "Total Consumption",
  "device.wang": "Grid",
  "device.totalFrequency": "Total Frequency",
  "device.buyPowers": "Electricity Purchase",
  "device.sellPowers": "Exported Energy",
  "device.more": "More",
  "device.readWrite": "Direct Read-Write Tool",
  "device.chargeAndDisChargeSetting": "Charging and Discharging Settings",
  "device.mutipleSave": "Save",
  "device.mutipleRead": "Mutiple Read",
  "device.deviceSnisExist": "Please Confirm if the Device SN Exists",
  "device.saveSuccess": "Parameter command has been sent. Please refresh the page or click the [Read] button to confirm whether the parameters have taken effect.",
  "device.saveFail": "Parameters Dispatch Failed",
  "device.getParamsSuccess": "Parameters Obtained Successfully",
  "device.getParamsFail": "Parameters Obtained Failed",
  "device.operationalDataAnalysis": "Operating Data Analysis",
  "device.pleaseSelect": "Please Select a Data Item on the Left",
  "device.maxFour": "Units Cannot Exceed 4 Types",
  "device.maxFourOrTwenty": "No more than 4 types or 20 options allowed",
  "device.protocolDirectives": "Protocol Command",
  "device.dateRangeError": "Date Range Should Be Within 3 Days",
  "device.noDeviceDetail": "No Device Details Available",
  "device.address": "Register Address",
  "device.faultClearing": "Fault Clearing",
  "device.chargeSetting": "Charge setting",
  "device.importTemplateDownload": "Import Template Download",
  "device.snNumber": "SN Number",
  "device.enterSnCode": "Please enter SN code",
  "device.enterSupplierSN": "Please enter supplier SN",
  "device.deviceModelLabel": "Device Model",
  "device.importTip": "Please import plant code, device name, SN number, and MDM code",
  "device.importTip2": "Please import device name, SN number, and MDM code",
  "device.keepAtLeastOneRow": "Keep at least one row",
  "device.importSuccessWithCount": "Successfully imported {count} device(s)",
  "device.importTemplateEmpty": "Import template is empty",
  "device.fillAllRequiredFields": "Please fill in all required fields",
  "device.enterPlantCode": "Please enter plant code",
  "device.plantCodeLabel": "Plant Code",
  "device.supplierSNLabel": "Supplier SN",
  "device.dischargeSetting": "Discharge setting",
  "battery.select": "Please choose",
  "battery.email": "Please enter your email address",
  "battery.datalogSn": "Please enter the serial number of the Dongle",
  "battery.deviceSn": "Please enter the device serial number",
  "battery.search": "Search",
  "socket.title": "Socket setting up",
  "socket.setting": "Set up",
  "socket.span": "Multiple register addresses have been set, and multiple values must also be set. Set values to be separated by, for example (1, 2, 3)",
  "socket.setting_device": "Set Inverter Parameters:",
  "socket.startaddress": "Starting register address",
  "socket.stopaddress": "Terminate register address",
  "socket.value": "Please enter the setting value",
  "socket.readdata": "Read Register Data:",
  "socket.setting_address": "Set address",
  "socket.setting_value": "Set Parameters",
  "socket.read": "Read",
  "socket.return": "Return",
  "agent.close": "Cancel",
  "agent.submit": "Submit",
  "agent.input_email": "Please enter your email address",
  "agent.search": "Search",
  "agent.import_device": "Import devices",
  "agent.edit": "Edit",
  "agent.add_agent": "Add agent",
  "agent.title": "Add agent",
  "agent.email": "E-Mail",
  "agent.password": "Password",
  "agent.phone": "Phone number",
  "agent.company": "Company",
  "agent.language": "Language",
  "agent.address": "Address",
  "agent.input_password": "Please input a password",
  "agent.input_phone": "Please enter your phone number",
  "agent.input_company": "Please select a company",
  "agent.input_language": "Please enter language",
  "agent.input_address": "Please enter the address",
  "agent.relus_email": "Please enter a valid email address",
  "agent.title_edit": "Edit Agent",
  "agent.title_device": "UpLoad",
  "agent.span": "Example: Exclusive Form",
  "agent.btn_upload": "UpLoad",
  "agent.delete": "Delete",
  "agent.agent_delete": "Delete agent?",
  "ship.starttime": "Start time",
  "ship.endtime": "End time",
  "ship.deviceSn": "Please enter the device serial number",
  "ship.select": "Please select a company",
  "ship.search": "Search",
  "Firmware.file_name": "Please enter the file name",
  "Firmware.search": "Search",
  "Firmware.add": "Add to",
  "Firmware.delete": "Delete",
  "Firmware.title": "Firmware upLoad",
  "Firmware.select_folder": "Select folder:",
  "Firmware.select_folder_type": "Please select folder type",
  "Firmware.folder_name": "File Name:",
  "Firmware.input_folder_name": "Enter File Name",
  "Firmware.craete_folder": "Create a new folder",
  "Firmware.folder_path": "Folder Path:",
  "Firmware.create": "Create folder",
  "Firmware.listed_files": "File List:",
  "Firmware.import_folder": "Import file",
  "Firmware.uplad_folder": "UpLoad files",
  "Firmware.close": "Return",
  "Upgrade.starttime": "Start Time",
  "Upgrade.endtime": "End time",
  "Upgrade.deviceSn": "Please enter the device serial number",
  "Upgrade.type": "Please select type",
  "Upgrade.search": "Search",
  "Upgrade.datalog": "Dongle",
  "Upgrade.Inverter": "Inverter",
  "Upgrade.Control": "Controller",
  "datalogs_logs.starttime": "Start time",
  "datalogs_logs.endtime": "End time",
  "datalogs_logs.deviceSn": "Please enter the device serial number",
  "datalogs_logs.Version": "Please enter the version",
  "datalogs_logs.search": "Search",
  "Logs.starttime": "Start time",
  "Logs.endtime": "End time",
  "Logs.deviceSn": "Please enter the device serial number",
  "Logs.type": "Please select type",
  "Logs.search": "Search",
  "Special.starttime": "Start Time",
  "Special.endtime": "End time",
  "Special.deviceSn": "Please enter the device serial number",
  "Special.datalogSn": "Please enter the serial number of the Dongle",
  "Special.type": "Please Select Type",
  "Special.search": "Search",
  "Special.save": "Save",
  "Special.Examples": "Example: (2305210230,2305210139)",
  "App.System_Config": "System Configuration",
  "App.APP_Version": "App version release",
  "App.Android_Version": "Android version:",
  "App.IOS_Version": "IOS version:",
  "App.APP_Type": "App Type:",
  "App.New_Version": "New version",
  "App.update_content": "Update Description: (divided by \"/n\")",
  "App.Whether_update": "Is it mandatory to update",
  "App.no": "No",
  "App.yes": "Yes",
  "App.submit": "Submit",
  "Tips.app_submit": "Are you sure to modify the information?",
  "Tips.firmware_delete": "Are you sure to delete?",
  "Tips.firmware_deleteCDN": "Delete files from CDN?",
  "Tips.yes": "Yes",
  "Tips.no": "No",
  "global.DataDetails": "Data Details",
  "global.device": "Inverter settings",
  "global.device_data": "Set Inverter Parameters:",
  "global.storage": "Energy storage settings",
  "global.storage_data": "Set Battery Parameters",
  "global.battery": "Battery settings",
  "global.battery_data": "Set battery parameters",
  "global.socket": "Socket setting up",
  "global.socket_data": "Set Socket Parameters",
  "btn.setting_address": "Set address",
  "btn.close": "Return",
  "btn.submit": "Submit",
  "btn.Setting_parameters": "Set Parameters",
  "btn.Reading": "Read",
  "btn.search": "Search",
  "btn.add": "Add to",
  "btn.import": "Import",
  "btn.download": "DownLoad Example",
  "btn.edit": "Edit",
  "btn.login": "Sign in",
  "btn.export": "Export",
  "form.addShip": "Add shipping Device",
  "form.editShip": "Edit Shipping Device",
  "form.import": "Import Device Information",
  "form.shipSN": "Shipment serial number",
  "form.agent": "Agent",
  "form.networkCall": "Whether to execute distribution network callback",
  "form.warrantyPeriod": "Warranty period",
  "form.shiptime": "Delivery Time",
  "form.shiptype": "Type of Shipment",
  "form.classify": "Classification",
  "form.file": "Drag the file here or click upLoad",
  "form.edit_plant": "Edit Scene",
  "form.input_station": "Please enter the scene name",
  "form.lable_StationName": "Scene Name",
  "form.lable_StationType": "Scene Type",
  "form.input_StationName": "Please enter the scene name",
  "form.edit_plant_plant": "Edit Plant",
  "form.input_station_plant": "Please enter the name of the Plant",
  "form.lable_StationName_plant": "Plant",
  "form.lable_StationType_plant": "Type of Plant",
  "form.input_StationName_plant": "Please enter the name of the Plant",
  "placeholder.select": "Please choose",
  "placeholder.choiceCountry": "Please select a country",
  "placeholder.choiceTimezone": "Please choose a time zone",
  "placeholder.enterEmail": "Please enter your email address",
  "placeholder.enterPhone": "Please enter your phone number",
  "placeholder.verificationCode": "Please enter the verification code",
  "placeholder.enterPassword": "Please enter a password of 6-20 digits",
  "placeholder.confirmPassword": "Please confirm password",
  "placeholder.readAndAgree": "I have read and agree",
  "placeholder.search": "Search",
  "placeholder.searchPlantName": "Search for the name of the Plant",
  "placeholder.searchDeviceName": "Search for device name",
  "placeholder.searchDataloggerName": "Search Dongle Name",
  "placeholder.enterPlantName": "Please enter the name of the Plant",
  "placeholder.enterPlantType": "Please enter the type of Plant",
  "placeholder.enterPVCapacity": "Please enter PV capacity",
  "placeholder.choiceInstallationDate": "Please select the installation date",
  "placeholder.enterPlantAddress": "Please enter the address of the Plant",
  "placeholder.enterOldPassword": "Please enter old password",
  "placeholder.enterNewPassword": "Please enter a new password",
  "placeholder.enterConfirmPassword": "Please confirm the new password",
  "placeholder.enter": "Please enter {scope}",
  "placeholder.selectScope": "Please select {scope}",
  "placeholder.country": "Country",
  "placeholder.city": "City",
  "placeholder.scanCodeAddPlant": "Please scan the code to add a Plant!",
  "placeholder.currentNoPlant": "There are Currently no Plants, please click to add!",
  "placeholder.selectRepeatTime": "Please select a repetition time",
  "placeholder.enterDatalogger": "Please enter the serial number of the Dongle",
  "placeholder.enterDeviceSN": "Please enter the device serial number",
  "setting.general.needGreat": "Need to be greater than",
  "setting.general.needSmall": "Need to be less than",
  "setting.general.gapScope": "The interval between input parameters is",
  "setting.general.valScope": "The range of input parameters is",
  "setting.socket.switchStatus": "Socket switch",
  "setting.socket.repetition": "Repetitive time",
  "setting.socket.enableOrNot": "Is it enabled",
  "setting.socket.monday": "Monday",
  "setting.socket.tuesday": "Tuesday",
  "setting.socket.wednesday": "Wednesday",
  "setting.socket.thursday": "Thursday",
  "setting.socket.friday": "Friday",
  "setting.socket.saturday": "Saturday",
  "setting.socket.sunday": "Sunday",
  "setting.type3.dischargeScheduleMode": "Timed discharge mode",
  "setting.type3.timeDischarge": "Timed Discharge",
  "setting.type3.workingDay": "Weekday",
  "setting.type3.weekend": "Weekend",
  "setting.type3.pureLightControlMode": "Pure light control mode",
  "setting.type3.stopDischarge": "SOC low-end stop discharge setting value",
  "setting.type3.chargeTransferDischarge": "SOC full charge to discharge set value",
  "setting.type3.batterySOCSetting": "Battery SOC setting",
  "setting.type3.lowBatteryAlam": "Low end alarm setting value for battery SOC",
  "setting.type3.lowBatteryShutdown": "Low end stop discharge setting value for battery SOC",
  "setting.type3.systemSetting": "System Settings",
  "setting.type3.systemWorkMode": "System Work Mode",
  "setting.type3.restoreFactory": "Restore factory settings",
  "setting.type3.loadMode": "Load mode",
  "setting.type3.timingDischarge": "Timed Discharge Mode",
  "setting.type3.DCOutputNormallyClosed": "DC output normally closed mode",
  "setting.type3.DCOutputNormallyOpen": "DC output normally open mode",
  "setting.type3.ForcedPowerProtection": "Mandatory Power protection mode",
  "setting.type3.mode": "Pattern",
  "setting.type3.startTime": "Start time",
  "setting.type3.stopTime": "End time",
  "setting.type3.onlyAddThree": "Add up to 21 timers",
  "setting.type3.startCompareEnd": "The start time of the timer can only be less than the end time",
  "setting.type3.confirmClose": "Are you sure you want to shut down?",
  "setting.type6.countryCode": "Country code",
  "setting.type6.poweradjppm": "Inverter Power regulation rate",
  "setting.type6.enaINVTR": "Remote Power on/off",
  "setting.type6.enaSysProtIF_selfCheck": "System protection interface self-test",
  "setting.type6.enaRestoretodefault": "Restore default values",
  "setting.type6.UV_resopnseTime": "{num} level underVoltage response time",
  "setting.type6.UF_resopnseTime": "{num} level underfrequency response time",
  "setting.type6.OV_resopnseTime": "{num} Level overVoltage Response Time",
  "setting.type6.OF_resopnseTime": "{num} level overclocking response time",
  "setting.type6.open": "Open",
  "setting.type6.recover": "Recovery",
  "setting.type6.noHave": "Nothing",
  "setting.type6.activePowerSwitch": "Active Power switch",
  "setting.type6.activePowerPermillage": "Active Power percentage per thousand",
  "setting.type7.paramterSetting": "Parameter Settings",
  "setting.type7.batteryVoltage": "Battery Voltage",
  "setting.type7.PVChargingCurrent": "Photovoltaic charging Current",
  "setting.type7.batteryCapacity": "Battery capacity",
  "setting.type7.overVoltage": "OverVoltage Voltage",
  "setting.type7.chargingLimitVoltage": "Charging limit Voltage",
  "setting.type7.increaseChargeReturnVoltage": "Increase the charging return Voltage",
  "setting.type7.overDischargeVoltage": "Overdischarge Voltage",
  "setting.type7.stopchangeCurrent": "Stop charging Current",
  "setting.type7.inverter485Address": "485 Address",
  "setting.type7.passwordValue": "User password",
  "setting.type7.inputPassword": "Password input",
  "setting.type7.recordFaultCodes": "Record fault codes",
  "setting.type7.isOpen": "Power On/Off Control",
  "setting.type7.equalizingChargeCmd": "Immediately charge and balance",
  "setting.type7.reset": "Reset control",
  "setting.type7.factory": "Restore factory settings",
  "setting.type7.clearAlarm": "Clear the Current alarm",
  "setting.type7.clearHistory": "Clear History",
  "setting.type7.generatorSwitchCmd": "Generator switching",
  "setting.type7.nowTimeStr": "Current Time",
  "setting.type7.setVal.reset": "Reset",
  "setting.type7.setVal.recover": "Recovery",
  "setting.type7.setVal.clearAlarm": "Erase warning",
  "setting.type7.setVal.clearHistory": "Clear History",
  "setting.type7.setVal.toggle": "Switch",
  "setting.type8.systemSwitch": "System switch",
  "setting.type10.modeSelect": "Pattern",
  "setting.type10.standbyMode": "Backup mode",
  "setting.type10.PureOffGrid": "Pure off grid startup mode",
  "setting.type10.energyNet": "Grid connected output settings",
  "setting.type10.inverter0": "Inverter to supplement energy to local Load",
  "setting.type10.inverter1": "The Energy From Inverter To Grid",
  "setting.type10.inverter2": "Inverter to local Load with CT",
  "setting.type10.inverter3": "Inverter to local Load or smart socket and smart meter",
  "setting.type10.chargePriority": "Charging priority",
  "setting.type10.PVPriority": "Priority given to photovoltaics",
  "setting.type10.utilityPriority": "Priority given to mains electricity",
  "setting.type10.hybridModel": "Mixed charging",
  "setting.type10.PVOnly": "Only photovoltaic charging",
  "setting.type10.batteryLowAlarm": "Low battery warning point",
  "setting.type10.batteryLowShutdown": "Low battery Power shutdown point",
  "setting.type10.batteryFull": "Battery fully charged shutdown point",
  "setting.type10.ACCharging": "Charging time",
  "setting.type10.startTime": "Starting Time",
  "setting.type10.endTime": "End time",
  "setting.type10.forcedDischarge": "Discharge Time",
  "setting.type10.phaseGridSide": "Grid side",
  "setting.type10.power": "Phase Active Power",
  "setting.type10.current": "Phase Current",
  "setting.type10.gridConnectionStandard": "Grid standard",
  "setting.type10.baudRate": "485 baud rate",
  "setting.type10.disable": "Do not enable",
  "setting.type10.enable": "Enable",
  "setting.type10.ApprovalStandards": "Certification standards",
  "setting.type10.antiRefluxPower": "Anti backflow Power",
  "setting.type10.antiRefluxSet": "Anti backflow enable",
  "setting.type10.batFullSocSet": "Battery saturation judgment value (%)",
  "setting.type10.auxSourceSet": "Auxiliary source switch",
  "setting.type10.timeSharingGridConnectedDischarge": "Time Division Grid Connected Discharge",
  "setting.type10.timeSharingGridConnection": "Time sharing grid connection setting",
  "setting.type10.outputPower": "Output Power",
  "setting.type10.onlyAddThree": "Add up to {num} timers",
  "setting.type10.productModelNumber": "Product Model",
  "setting.type10.PleaseTurnOnThe_PCS_switchFirst": "Please turn on the switch first",
  "setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "There is a conflict in the charging and discharging time",
  "setting.type10.ChargeDischargeTimeSetting": "Charging&Discharging Time Setting",
  "setting.type11.switchPCS": "Power On/Off Control",
  "setting.type11.functionSwitch": "Function switch",
  "setting.type11.maxChargeVol": "Maximum charging Voltage (V)",
  "setting.type11.onGridMinDischargeVol": "Minimum discharge Voltage for grid connection (V)",
  "setting.type11.offGridOutputVol": "Off grid output Voltage (V)",
  "setting.type11.maxChargeCur": "Maximum charging Power",
  "setting.type11.onGridMaxDischargeCur": "Maximum discharge Current for grid connection (A)",
  "setting.type11.offGridMaxDisChargeCur": "Maximum discharge Current off grid (A)",
  "setting.type11.minSocBMS": "Minimum SOC of BMS (%)",
  "setting.type11.minSocDischarge": "Minimum SOC (%) for intelligent discharge",
  "setting.type11.maxSocDischarge": "Intelligent discharge maximum SOC (%)",
  "setting.type11.timeStr": "Device time",
  "setting.type11.timerSetting": "Timer setting {num}",
  "setting.type11.chargeStartTime1": "Starting charging time 1",
  "setting.type11.chargeLongTime1": "Charging duration 1",
  "setting.type11.chargeTimeMaxSOC1": "Maximum SOC (%) during charging period 1",
  "setting.type11.chargeTimeCurrent1": "Charging Period 1 Charging Current (A)",
  "setting.type11.dischargeStartTime1": "Starting discharge time 1",
  "setting.type11.dischargeLongTime1": "Discharge duration 1",
  "setting.type11.dischargeTimeMaxSOC1": "Minimum SOC (%) during discharge period 1",
  "setting.type11.dischargeTimeCurrent1": "Discharge Period 1 Discharge Current (A)",
  "setting.type11.chargeStartTime2": "Starting charging time 2",
  "setting.type11.chargeLongTime2": "Charging duration 2",
  "setting.type11.chargeTimeMaxSOC2": "Maximum SOC during charging period 2 (%)",
  "setting.type11.chargeTimeCurrent2": "Charging Period 2 Charging Current (A)",
  "setting.type11.dischargeStartTime2": "Starting discharge time 2",
  "setting.type11.dischargeLongTime2": "Discharge duration 2",
  "setting.type11.dischargeTimeMaxSOC2": "Minimum SOC (%) during discharge period 2",
  "setting.type11.dischargeTimeCurrent2": "Discharge Period 2 Discharge Current (A)",
  "setting.type11.chargeStartTime3": "Starting charging time 3",
  "setting.type11.chargeLongTime3": "Charging duration 3",
  "setting.type11.chargeTimeMaxSOC3": "Maximum SOC during charging period 3 (%)",
  "setting.type11.chargeTimeCurrent3": "Charging Period 3 Charging Current (A)",
  "setting.type11.dischargeStartTime3": "Starting discharge time 3",
  "setting.type11.dischargeLongTime3": "Discharge duration 3",
  "setting.type11.dischargeTimeMaxSOC3": "Minimum SOC (%) during discharge period 3",
  "setting.type11.dischargeTimeCurrent3": "Discharge period 3 discharge Current (A)",
  "setting.type11.chargeStartTime4": "Starting charging time 4",
  "setting.type11.chargeLongTime4": "Charging duration 4",
  "setting.type11.chargeTimeMaxSOC4": "Maximum SOC during charging period 4 (%)",
  "setting.type11.chargeTimeCurrent4": "Charging Period 4 Charging Current (A)",
  "setting.type11.dischargeStartTime4": "Starting discharge time 4",
  "setting.type11.dischargeLongTime4": "Discharge duration 4",
  "setting.type11.dischargeTimeMaxSOC4": "Minimum SOC (%) during discharge period 4",
  "setting.type11.dischargeTimeCurrent4": "Discharge Period 4 Discharge Current (A)",
  "setting.type11.functionSwitchObj.val1": "Intelligent mode",
  "setting.type11.functionSwitchObj.val2": "Timer mode",
  "setting.type11.functionSwitchObj.val3": "Self-Use Mode",
  "setting.type12.LEDSwitch": "LED switch",
  "setting.type12.LEDSpeed": "LED speed",
  "setting.type12.LEDEffect": "LED effect",
  "setting.type12.LEDBrightness": "LED brightness",
  "setting.type12.dataColor": "Color representation of data",
  "setting.type12.LED1Color": "LED1 color",
  "setting.type12.LED2Color": "LED2 color",
  "setting.type12.LED3Color": "LED3 color",
  "setting.type12.buzzerAlarm": "Buzzer alarm",
  "setting.type12.overLoadToBypass": "OverLoad to bypass",
  "setting.type12.lcdRestartPage": "LCD no operation recovery main interface",
  "setting.type12.overloadReset": "OverLoad restart",
  "setting.type12.overloadTemperature": "Over Temperature restart",
  "setting.type12.backLightOn": "LCD without operation backlight",
  "setting.type12.inputSourceChangeAlarm": "Input source change alarm",
  "setting.type12.faultCodeRecord": "Communication software fault record",
  "setting.type12.solarFeedToGird": "Solar energy idle grid connection",
  "setting.type12.switchOptions": "Switch options",
  "setting.type12.batteryParam": "Battery parameters",
  "setting.type12.outputParam": "Output parameters",
  "setting.type12.ratedOutputVol": "Rated output Voltage",
  "setting.type12.ratedOutputFreq": "Rated output frequency",
  "setting.type12.inputVolRange": "Input Voltage range",
  "setting.type12.outPutSourcePriority": "Output source priority",
  "setting.type12.batType": "Battery Type",
  "setting.type12.batUnderVol": "Battery cut-off Voltage",
  "setting.type12.batBulkVol": "Constant charging Voltage of battery",
  "setting.type12.batFloatVol": "Battery float charging Voltage",
  "setting.type12.maxChargingCur": "Maximum charging Current",
  "setting.type12.maxAcChargingCur": "Maximum AC charging Current",
  "setting.type12.chargeSourcePriority": "Charger source priority",
  "setting.type12.batReChargeVol": "Restore charging Voltage",
  "setting.type12.batFullRestoreDischargeVol": "Restore discharge Voltage",
  "setting.type12.solarSupplyPriority": "Priority given to solar Power supply",
  "setting.type12.resetPvStorage": "Reset PV Statistics Data",
  "setting.type12.countryRegulations": "National regulations",
  "setting.type12.acChargeStartTime": "Start time of communication charger operation",
  "setting.type12.acChargeEndTime": "Stop time of communication charger operation",
  "setting.type12.acSupplyStartTime": "Start time of AC Power supply",
  "setting.type12.acSupplyEndTime": "Stop time of AC Power supply",
  "setting.type12.restoreFactorySet": "Restore factory settings",
  "setting.type12.parallelMode": "Parallel mode",
  "setting.type12.bulkChargeVol": "CV charging Voltage",
  "setting.type12.batEquSet": "Battery equalization function",
  "setting.type12.batEquTime": "Battery average charging time (min)",
  "setting.type12.batEquDay": "Battery average charging interval days (d)",
  "setting.type12.batEquChargeVol": "Battery average charging Voltage (V)",
  "setting.type12.batEquTimeout": "Battery equalization timeout (min)",
  "setting.type12.equInfoSet": "Balanced Information Setting",
  "setting.type12.val.slow": "Slow",
  "setting.type12.val.medium": "In",
  "setting.type12.val.fast": "Fast",
  "setting.type12.val.low": "Low",
  "setting.type12.val.high": "High",
  "setting.type12.val.powerCycle": "Power cycle",
  "setting.type12.val.powerRotation": "Power Rotation",
  "setting.type12.val.additionalPower": "Additional Power",
  "setting.type12.val.powerUnchanged": "Power remains unchanged",
  "setting.type12.val.solarPowerInput": "Solar input Power",
  "setting.type12.val.batteryCapacity": "Percentage of battery capacity",
  "setting.type12.val.percentageLoad": "Load percentage",
  "setting.type12.val.energySource": "Energy source",
  "setting.type12.val.batteryStatus": "Battery charging and discharging status",
  "setting.type12.val.blue": "Blue",
  "setting.type12.val.cyan": "Blue color",
  "setting.type12.val.green": "Green",
  "setting.type12.val.pink": "Pink",
  "setting.type12.val.purple": "Purple;",
  "setting.type12.val.orange": "Orange",
  "setting.type12.val.yellow": "Yellow",
  "setting.type12.val.white": "White",
  "setting.type12.val.inputOvlRange1": "APL mode (90-280V)",
  "setting.type12.val.inputOvlRange2": "UPS mode (170-280V)",
  "setting.type12.val.outputSource1": "Solar Energy ->Public ->Battery",
  "setting.type12.val.outputSource2": "Solar energy ->Battery ->Public use",
  "setting.type12.val.chargeSourcePriority1": "Priority given to photovoltaics",
  "setting.type12.val.chargeSourcePriority2": "Photovoltaic and mains Power",
  "setting.type12.val.chargeSourcePriority3": "Only photovoltaic",
  "setting.type12.val.solarSupplyPriority1": "Battery Load Utility",
  "setting.type12.val.solarSupplyPriority2": "Load - Battery - Utility",
  "setting.type12.val.countryRegulations1": "India",
  "setting.type12.val.countryRegulations2": "Germany",
  "setting.type12.val.countryRegulations3": "South America",
  "setting.type12.val.parallelMode1": "No parallel machine",
  "setting.type12.val.parallelMode2": "Single phase parallel operation",
  "setting.type12.val.outPutSourcePriority1": "Priority given to mains electricity",
  "setting.type12.val.outPutSourcePriority2": "Priority given to solar energy",
  "setting.type12.val.outPutSourcePriority3": "Solar energy ->battery ->mains Power",
  "setting.ops15.invSwitch": "Inverter switch",
  "setting.ops15.workMode": "Working mode",
  "setting.ops15.workMode1": "Feed in Priority Mode",
  "setting.ops15.workMode2": "Off grid mode",
  "setting.ops15.workMode3": "Self Use",
  "setting.ops15.invTime": "Inverter time",
  "setting.ops15.batType": "Battery Type",
  "setting.ops15.batType1": "No battery",
  "setting.ops15.batType2": "Universal lithium battery",
  "setting.ops15.batType3": "Lead acid battery",
  "setting.ops15.batType4": "Lithium battery",
  "setting.ops15.timingTime": "Timed Time",
  "setting.ops15.offGirdSoc": "Over discharge SOC (%)",
  "setting.ops15.optimizeRevenue": "Optimize revenue",
  "setting.type19.totalActivePower": "Active Power",
  "setting.type19.offgridSettings": "Off Grid Setting",
  "setting.type19.gridConnectedControlMode": "Grid Connected Control",
  "setting.type19.offGridControlMode": "Off grid control",
  "setting.type19.offgrid.gridNet": "Grid connection",
  "setting.type19.offgrid.offNet": "Off grid",
  "setting.type22.parameterScope": "Parameter Range",
  "setting.type22.ACStartVoltage": "Starting Voltage/frequency setting",
  "setting.type22.highVoltage": "AC startup high Voltage",
  "setting.type22.lowVoltage": "AC startup low Voltage",
  "setting.type22.pvStartLowVol": "PV startup low Voltage",
  "setting.type22.acUnderVol1": "AC underVoltage first-order (V)",
  "setting.type22.acOverVol1": "AC overVoltage first-order (V)",
  "setting.type22.acUnderVolTime1": "AC Under Voltage First-order Time (s)",
  "setting.type22.acOverVolTime1": "AC overVoltage first-order time (s)",
  "setting.type22.acUnderVol2": "AC underVoltage second-order (V)",
  "setting.type22.acOverVol2": "AC overVoltage second-order (V)",
  "setting.type22.acUnderVolTime2": "AC Under Voltage Second-order Time (s)",
  "setting.type22.acOverVolTime2": "AC overVoltage second-order time (s)",
  "setting.type22.startDelayTime": "Start delay time",
  "setting.type22.restartDelayTime": "Restart delay time",
  "setting.type22.ACStartFrequency": "OverVoltage/underVoltage/frequency setting",
  "setting.type22.highFrequency": "AC startup high-frequency",
  "setting.type22.lowFrequency": "AC startup low frequency",
  "setting.type22.acUnderFrequency1": "AC underfrequency first-order (Hz)",
  "setting.type22.acOverFrequency1": "AC Overfrequency First Order (Hz)",
  "setting.type22.acUnderFrequencyTime1": "AC UnderFrequency First-order Time (s)",
  "setting.type22.acOverFrequencyTime1": "AC Overfrequency First Order Time (s)",
  "setting.type22.acUnderFrequency2": "AC underfrequency second-order (Hz)",
  "setting.type22.acOverFrequency2": "AC Overfrequency Second Order (Hz)",
  "setting.type22.acUnderFrequencyTime2": "AC UnderFrequency Second-order Time (s)",
  "setting.type22.acOverFrequencyTime2": "AC Overfrequency Second Order Time (s)",
  "setting.type22.systemSetting": "Device Information Settings",
  "setting.type22.SNset": "Serial number setting",
  "setting.type22.reactiveControlMode": "Reactive Power control mode",
  "setting.type22.inputMode": "Input mode",
  "setting.type22.startSolpe": "Start slope",
  "setting.type22.restartSolpe": "Restart slope",
  "setting.type22.reactivePercentage": "Reactive Power percentage",
  "setting.type22.activePercentage": "Merit percentage",
  "setting.type22.shutdown": "Remote switch",
  "setting.type22.functionSelect": "Function selection",
  "setting.type22.manufacturer": "Manufacturer",
  "setting.type22.setFunctionSelect.val1": "Prohibit",
  "setting.type22.setFunctionSelect.val2": "Enable anti backflow measures",
  "setting.type22.setManufacturer.val1": "INVT",
  "setting.type22.setManufacturer.val2": "Skyworth",
  "setting.type22.reactiveControlModeChoice.val1": "Power Factor Control",
  "setting.type22.reactiveControlModeChoice.val2": "ReActive Power percentage control",
  "setting.type22.reactiveControlModeChoice.val3": "QV curve control",
  "setting.type22.inputModeChoice.val1": "Input independent mode",
  "setting.type22.inputModeChoice.val2": "Input parallel mode",
  "setting.type22.inputModeChoice.val3": "DC Source Mode",
  "title.login": "Sign in",
  "title.vistorLogin": "Tourist login",
  "title.createAccount": "Create an account",
  "title.retrievePassword": "Retrieve password",
  "title.userAgreement": "User Agreement",
  "title.privacyPolicy": "Privacy Agreement",
  "title.phone": "Telephone",
  "title.addPlant": "Add Plant",
  "title.editPlant": "Edit Plant",
  "title.accountInfo": "Account Information",
  "title.changePassword": "Change Password",
  "title.message": "Notifications",
  "title.systemMessage": "System Message",
  "title.faultMessage": "Fault Message",
  "title.deviceMessage": "Device message",
  "title.aboutUs": "About",
  "title.device": "Device",
  "title.datalogger": "Dongle",
  "title.setting": "Set up",
  "title.socketSetting": "Socket setting up",
  "title.addSchedule": "Add Timer",
  "title.editSchedule": "Edit Timer",
  "title.repetitionTime": "Repetitive time",
  "title.addDatalogger": "Add device",
  "title.connectWifi": "Connection route",
  "title.distributionNetworkStatus": "Distribution network status",
  "title.language": "Language",
  "title.selectCountry": "Select country",
  "title.selectCity": "Select City",
  "bar.home": "Home page",
  "bar.energy": "Analysis",
  "bar.plant": "Plant",
  "bar.user": "User",
  "bar.endpoint": "Terminal",
  "bar.mine": "My",
  "bar.my": "My",
  "button.logOut": "Sign out",
  "button.rememberMe": "Remember account password",
  "button.forgetPassword": "Forgot password",
  "button.register": "Register",
  "button.ok": "Confirm",
  "button.send": "Send out",
  "button.auto": "Automatic",
  "button.cancle": "Cancel",
  "button.yes": "Yes",
  "button.close": "Close",
  "button.refresh": "Refresh",
  "button.next": "Next step",
  "button.redistributionNetwork": "Reorganize the distribution network",
  "button.upload": "UpLoad",
  "button.confirm": "Confirm",
  "button.edit": "Edit",
  "button.delete": "Delete",
  "button.save": "Save",
  "button.allReady": "All read",
  "button.selectAll": "Select All",
  "button.deselectAll": "Cancel all selection",
  "button.unsubscribe": "Cancel account",
  "button.later": "Later",
  "button.upgrade": "To update",
  "button.unfollow": "Cancel Follow",
  "button.add": "Add to",
  "subtitle.NeedMoreHelp": "More Help",
  "subtitle.VisitSupportCenter": "Browse the official website for more help",
  "subtitle.energyFlowDiagram": "Energy flow diagram",
  "subtitle.selectTimezone": "Select Time Zone",
  "subtitle.selectPlantType": "Select Plant type",
  "subtitle.selectInstallationDate": "Select installation date",
  "subtitle.selectCurrency": "Choose Currency",
  "subtitle.selectDateType": "Select Date Type",
  "subtitle.selectDeviceType": "Select Device Type",
  "subtitle.socketBluetooth": "Socket Bluetooth",
  "subtitle.log": "Journal",
  "subtitle.all": "All",
  "subtitle.online": "On-line",
  "subtitle.offline": "Off-line",
  "subtitle.normal": "Normal",
  "subtitle.abnormal": "Fault",
  "subtitle.on": "Open",
  "subtitle.off": "Shut",
  "subtitle.todayEnergy": "Today's electricity consumption",
  "subtitle.totalEnergy": "Total electricity consumption",
  "subtitle.totalRevenue": "Total income",
  "subtitle.plantImage": "Plant pictures",
  "subtitle.plantName": "Name of Plant",
  "subtitle.plantType": "Plant Type",
  "subtitle.PVCapacity": "PV capacity",
  "subtitle.installationDate": "Install date",
  "subtitle.plantAddress": "Plant address",
  "subtitle.revenue": "Income",
  "subtitle.timeZone": "Time zone",
  "subtitle.updatePhone": "Update phone number",
  "subtitle.solar": "Photovoltaic",
  "subtitle.grid": "Power grid",
  "subtitle.battery": "Battery",
  "subtitle.home": "Load",
  "subtitle.load": "Load",
  "subtitle.socket": "Socket",
  "subtitle.today": "Day",
  "subtitle.day": "Day",
  "subtitle.month": "Month",
  "subtitle.year": "Year",
  "subtitle.total": "Total",
  "subtitle.time": "Time",
  "subtitle.Co2": "Carbon dioxide",
  "subtitle.coal": "Coal",
  "subtitle.deforestation": "Trees",
  "subtitle.parameter": "Parameter",
  "subtitle.schedule": "Timer",
  "subtitle.countdown": "Count down",
  "subtitle.socketSwitch": "Socket switch",
  "subtitle.currency": "Currency",
  "subtitle.energyPrice": "Electricity Price",
  "subtitle.storagePlant": "Energy Storage Plant",
  "subtitle.on-GridPlant": "Grid connected Plant",
  "subtitle.photo": "Head portrait",
  "subtitle.email": "E-Mail",
  "subtitle.account": "Account",
  "subtitle.version": "Edition",
  "subtitle.officalWebsite": "Official website",
  "subtitle.SN": "Serial number",
  "subtitle.wifiSignal": "WiFi signal",
  "subtitle.lastSync": "Finally synchronized",
  "subtitle.switch": "Switch",
  "subtitle.happening": "In Progress",
  "subtitle.restored": "Recovered",
  "subtitle.details": "Details",
  "subtitle.warn": "Alarm",
  "subtitle.fault": "Fault",
  "subtitle.status": "State",
  "subtitle.level": "Severity",
  "subtitle.deviceType": "Device type",
  "subtitle.alarmStartTime": "Start Time",
  "subtitle.alarmEndTime": "End Time",
  "subtitle.solution": "Solution",
  "subtitle.noSolution": "Please refer to the user manual for troubleshooting or contact the aftersales service.",
  "subtitle.loginIn": "Logging in",
  "subtitle.checkVersion": "Check For Updates",
  "subtitle.versionUpgrade": "Version Update",
  "subtitle.alarmName": "Alarm Name",
  "subtitle.messageDetail": "Message Details",
  "subtitle.todayConsumption": "Today Consumption",
  "subtitle.totalConsumption": "Total Consumption",
  "subtitle.dataloggerSN": "Dongle SN",
  "subtitle.configurationGuidance": "Configuration guidance",
  "subtitle.guideVideo": "Guidance video",
  "subtitle.manualInstuction": "Guidebook",
  "subtitle.manualInstuction4G": "4G Guidebook",
  "subtitle.manualInstuctionMasterControl": "Master Control Manual",
  "subtitle.masterControlConfiguration": "Main control distribution network",
  "subtitle.defaultConfiguration": "Default distribution network",
  "subtitle.findEmail": "Email retrieval",
  "subtitle.findPhone": "Mobile phone retrieval",
  "subtitle.family": "Family",
  "subtitle.agent": "Agent",
  "subtitle.endUsers": "End user",
  "subtitle.deviceManagement": "Device",
  "subtitle.deviceSN": "Device SN",
  "subtitle.firmwareVersion": "Firmware version",
  "subtitle.alias": "Alias",
  "subtitle.information": "Information",
  "subtitle.domainName": "Domain name",
  "subtitle.restartdatalogger": "Restart the Dongle",
  "subtitle.value": "Value",
  "subtitle.customizable": "Custom",
  "subtitle.ready": "Read",
  "subtitle.deviceDetails": "Device details ",
  "subtitle.startAddress": "Starting register address",
  "subtitle.endAddress": "Terminate register address",
  "subtitle.settingParam": "Set Parameters",
  "subtitle.tariffType": "Electricity Price Type",
  "subtitle.fixed": "Fixed",
  "subtitle.timeshare": "Time-sharing",
  "subtitle.addTime": "Add Time",
  "subtitle.notAllDay": "Not all day",
  "subtitle.dealer": "Distributor",
  "subtitle.dealerNumber": "Dealer ID",
  "subtitle.toggle": "Switch",
  "subtitle.environmentalBenefit": "Environmental benefit",
  "subtitle.basicParam": "Basic parameters",
  "subtitle.realTimeParam": "Real time parameters",
  "subtitle.export": "Export",
  "subtitle.localDebug": "Near end debugging",
  "subtitle.mode": "Mode",
  "subtitle.manuallyAdd": "Manually add",
  "subtitle.AttachTheDevice": "Hanging Device",
  "subtitle.ammeter": "Watt-hour meter",
  "subtitle.FeederPowerOnTheSameDay": "Daily Power supply to the grid",
  "subtitle.BatterySOC": "Battery SOC",
  "subtitle.DailyChargingCapacityOfTheBattery": "Today Charged Energy",
  "subtitle.DailyPowerConsumption": "Daily Consumption",
  "subtitle.CumulativePowerGeneration": "Total Yield",
  "subtitle.total2": "Total",
  "subtitle.run": "Function",
  "subtitle.StopIt": "Stop it",
  "subtitle.Optimizer": "Optimizer",
  "subtitle.DataGateways": "Data Gateway ",
  "subtitle.dataType": "Data type",
  "subtitle.Model": "Model",
  "subtitle.TheAmountOfElectricityGeneratedToday": "Today Yield",
  "subtitle.CurrentPower": "Current Power",
  "subtitle.AllOptimizerWorkingStatus": "All Optimizer Working States",
  "subtitle.WhenClosedAllOptimizersStopWorking": "After shutdown, all optimizers will stop working",
  "subtitle.TheDataGatewayRestarts": "Data gateway reboot",
  "subtitle.Reboot": "Restart",
  "subtitle.Restarting": "Restarting in progress",
  "subtitle.HardwareVersionNumber": "Hardware version number",
  "subtitle.SoftwareVersionNumber": "Software version number",
  "subtitle.OutputPower": "Output Power",
  "subtitle.OutputVoltage": "Output Voltage ",
  "subtitle.OutputCurrent": "Output Current",
  "subtitle.InputPower": "Input Power",
  "subtitle.InputVoltage": "Input Voltage ",
  "subtitle.InputCurrent": "Input Current",
  "subtitle.OperationalStatus": "Operating Status",
  "subtitle.temperature": "Temperature(℃)",
  "subtitle.DeviceAddress": "Device address",
  "subtitle.FeederMode": "Feed network mode",
  "subtitle.StandbyMode": "Backup mode",
  "subtitle.Off-gridMode": "Off grid mode",
  "subtitle.TimedChargingAndDischarging": "Timed Charging and Discharging",
  "subtitle.WorkingModeSettings": "Working mode setting",
  "subtitle.DeviceInformation": "Device Information",
  "subtitle.HMISoftwareVersion": "HMI software version",
  "subtitle.DSPSoftwareVersion": "DSP software version",
  "subtitle.ChargeAndDischargeTimePeriodSetting": "Charging and discharging time period setting",
  "subtitle.ChargingPeriod": "Charging Time Period",
  "subtitle.DischargeTimePeriod": "Discharge time period",
  "subtitle.BatteryMinimumSOC(%)": "Minimum SOC of battery (%)",
  "subtitle.BatteryOvervoltageMethod(V)": "Battery overVoltage method value (V)",
  "subtitle.BatteryUndervoltageThreshold(A)": "Battery underVoltage threshold (A)",
  "subtitle.ChargingCurrentLimit(A)": "Charging Current limit (A)",
  "subtitle.DischargeCurrentLimit(A)": "Discharge Current limit (A)",
  "subtitle.Off-GridDischargeMinimumSOC(%)": "Minimum SOC (%) for off grid discharge",
  "subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "Off grid 2 discharge minimum SOC (%)",
  "subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "Minimum battery Voltage for off grid 2 discharge (V)",
  "subtitle.Auto-replenishment": "Automatic Power replenishment",
  "subtitle.BatteryBMSActivationCommand": "Battery BMS activation command",
  "subtitle.ForcedFullCharge": "Forced full charge",
  "subtitle.ForceCharge2": "Compulsory Charging 2",
  "subtitle.ForceCharge1": "Compulsory Charging 1",
  "subtitle.DischargeEnabled": "Discharge enable",
  "subtitle.ChargingEnabled": "Charging Enable",
  "subtitle.NumberOfOptimizers": "Number of optimizers",
  "subtitle.TheNameOfTheDevice": "Device Name",
  "subtitle.GeneralSettings": "General settings",
  "subtitle.Anti-backflowSwitch": "Anti backflow switch",
  "subtitle.ReflowPowerLimit(W)": "Reflux Power limit (W)",
  "subtitle.OptimizerNumber": "Optimizer number",
  "subtitle.reset": "Reset",
  "subtitle.areYouSure": "Are you sure you want to reset",
  "subtitle.PhysicalView": "Physical View",
  "subtitle.LogicalView": "Logical View",
  "subtitle.LayoutDrawing": "Layout",
  "tip.noData": "No data available at the moment",
  "tip.base.maxDistance": "Furthest",
  "tip.base.minDistance": "Lately",
  "tip.base.maxSize": "Maximum",
  "tip.base.minSize": "Minimum",
  "tip.request.loading": "Loading in progress",
  "tip.request.netWork": "Network connection failed, please check the network",
  "tip.request.connectServerFail": "Unable to connect to the server",
  "tip.request.requestTimeout": "Request Timeout",
  "tip.validate.choiceCountry": "Please select a country first",
  "tip.validate.country": "Country cannot be empty, please select country",
  "tip.validate.timeZone": "Time zone cannot be empty, please select a time zone",
  "tip.validate.email": "Email format error, please enter a correct email address",
  "tip.validate.verification": "Please send the verification code first",
  "tip.validate.verificationError": "Verification code error, please enter a valid verification code",
  "tip.validate.passwordFormTip": "Please enter a password consisting of 6-20 digits of numbers and letters",
  "tip.validate.passwordError": "Password format error, please enter a password consisting of 6-20 digits of numbers and letters",
  "tip.validate.passwordError2": "Please enter a valid password (the password should not include any special characters, symbols, or spaces)",
  "tip.validate.validatePassword": "The two passwords you entered do not match. Please check and re-enter",
  "tip.validate.confirmAgreement": "Please read and agree to the privacy agreement first",
  "tip.validate.plantName": "The name of the plant cannot be empty. Please enter the name of the plant.",
  "tip.validate.plantType": "Plant type cannot be empty, please select Plant type",
  "tip.validate.pvCapacity": "The solar cell capacity cannot be empty, please enter the battery capacity",
  "tip.validate.installationDate": "Installation date cannot be empty, please select installation date",
  "tip.validate.city": "City cannot be empty, please select a city",
  "tip.validate.incomeunit": "Currency cannot be empty, please select currency",
  "tip.validate.energyPrice": "The electricity price cannot be empty, please enter the electricity price",
  "tip.validate.firstChoiceCountry": "Please select a country first",
  "tip.validate.oldPassword": "Old password cannot be empty, please enter old password",
  "tip.validate.newPassword": "The new password cannot be empty, please enter the new password",
  "tip.validate.confirmPassword": "Confirm password cannot be empty, please confirm password",
  "tip.validate.passwordNotMatch": "The two password inputs are inconsistent. Please check and confirm before submitting",
  "tip.validate.SN1": "The serial number cannot be empty",
  "tip.validate.SN2": "The serial number must be 10 digits long",
  "tip.validate.noSocketTimer": "There is Currently no socket timer available. Please click to add it",
  "tip.validate.cameraPermission": "The app requires camera permission for scanning and adding Dongles",
  "tip.validate.searchingState": "Searching for Bluetooth, please do not click again",
  "tip.validate.notInTheScope": "The input parameters are not within the specified range",
  "tip.validate.enterDecimal": "Must input {num} decimal or integer digits",
  "tip.validate.integer": "Must be an integer",
  "tip.validate.phone": "Mobile phone number only supports Chinese Mainland, please use email to retrieve others",
  "tip.validate.can`tEmpty": "{param} cannot be empty",
  "tip.validate.dealerSope": "The dealer number range is 6-8 digits",
  "tip.validate.firstChoicePlant": "Please select the Plant first",
  "tip.log.permissionOpen": "Ensure that location and Bluetooth permissions are enabled",
  "tip.log.openBluetoothSystem": "Open Bluetooth settings",
  "tip.log.openIosBtSystem": "Please restart the Bluetooth switch",
  "tip.log.openLocationSystem": "Open location settings",
  "tip.log.bluetoothAuthorization": "APP Bluetooth authorization not enabled",
  "tip.log.locationAuthorization": "APP location authorization not enabled",
  "tip.log.searchSurroundingDevicesPermission": "Unauthorized search for nearby devices",
  "tip.log.bluetoothNotPermission": "Bluetooth not turned on",
  "tip.log.locationNotPermission": "Positioning not enabled",
  "tip.log.bluetoothPermission": "Bluetooth enabled",
  "tip.log.locationPermission": "Positioning enabled",
  "tip.log.bluetoothException": "Bluetooth abnormal disconnection, please confirm that the device's Bluetooth is turned on and then reconnect",
  "tip.log.listeningFailure": "Monitoring feature value changes failed, please reconnect to Bluetooth",
  "tip.log.communicationException": "Bluetooth communication is abnormal, please reconnect to Bluetooth",
  "tip.log.reconnect": "Bluetooth reconnection",
  "tip.log.connectFail": "Bluetooth connection failed",
  "tip.log.connect": "Connect Bluetooth",
  "tip.log.bluetoothService": "Please enable Bluetooth service",
  "tip.log.locationService": "Please enable location services",
  "tip.log.notsupport": "The Current platform supports calling Bluetooth function",
  "tip.log.locationNotTurnOn": "Location not enabled, unable to search for Bluetooth",
  "tip.log.init": "Bluetooth initialization",
  "tip.log.searching": "Searching for Bluetooth around",
  "tip.log.searchFail": "No devices were found around, please ensure that the Bluetooth of the device is turned on, and then click refresh",
  "tip.log.stopSearch": "Stop searching for surrounding Bluetooth",
  "tip.log.stopSearchFail": "Stop searching for surrounding Bluetooth failed",
  "tip.log.connectSuccess": "Bluetooth connection successful",
  "tip.log.setMTUsSuccess": "Successfully set maximum transmission unit",
  "tip.log.setMTUsFail": "Failed to set maximum transmission unit",
  "tip.log.closeSuccess": "Bluetooth connection disconnected",
  "tip.log.closeFail": "Failed to disconnect Bluetooth connection",
  "tip.log.wifiLoadFail": "WiFi list Loading failed, please manually enter",
  "tip.log.bluetoothAbnormal": "Bluetooth connection abnormal, attempting to reconnect",
  "tip.log.getBluetoothServiceSuccess": "Successfully obtained Bluetooth device service",
  "tip.log.getBluetoothServiceFail": "Failed to obtain Bluetooth device service",
  "tip.log.getFeatureValuesSucess": "Successfully obtained all feature values in the specified service of the Bluetooth device",
  "tip.log.getFeatureValuesFail": "Failed to retrieve all feature values from the specified service of the Bluetooth device",
  "tip.log.subscriptionEigenvalueSuccess": "The notify function for low-Power Bluetooth device feature value changes has been enabled, subscribe to feature values",
  "tip.log.subscriptionEigenvalueFail": "Enable the notify function when the feature value of low-Power Bluetooth devices changes, subscription feature value failed",
  "tip.log.monitoringSuccess": "Successfully monitored the feature value change event of low-Power Bluetooth devices",
  "tip.log.monitoringFail": "Failed to monitor the feature value change event of low-Power Bluetooth devices",
  "tip.log.CRC": "CRC verification failed",
  "tip.log.queryWiFi": "Successfully queried WiFi list",
  "tip.log.queryWiFiState": "Successfully issued WiFi list query command",
  "tip.log.wifiConenct": "Querying routing connection status",
  "tip.log.wifiFail": "Please check the router account and password and try reconnecting",
  "tip.log.connectWiFiSuccess": "Router connection successful",
  "tip.log.connectWiFiFail": "Router connection failed",
  "tip.log.routerAccount": "Router account error",
  "tip.log.routerPassword": "Router password error",
  "tip.log.gettingIP": "Obtaining router IP address",
  "tip.log.getIPFail": "Failed to obtain router IP",
  "tip.log.queryServerState": "Successfully issued the command to query the interaction status between the device and the server",
  "tip.log.server03": "There is 03 data exchange",
  "tip.log.server04": "There is 04 data exchange",
  "tip.log.heartbeat": "Interaction of heartbeat data",
  "tip.log.noInteraction": "No data interaction",
  "tip.log.bluetoothCommunication": "Bluetooth communication has been established",
  "tip.log.connectWiFi": "Connect WiFi",
  "tip.log.getWiFiList": "Querying WiFi list",
  "tip.log.wifiName": "WiFi name cannot be empty, please select or enter 2.4WiFi",
  "tip.log.wifiPasword": "WiFi cannot be empty, please enter password",
  "tip.log.wifiPasswordError": "WiFi password cannot contain special characters (ǎǐò•♢ ∝ ℃℉, etc.)",
  "tip.log.masterControlId": "The main control ID cannot be empty, please enter the ID",
  "tip.addDatalogger.noSearchDevice": "Unable to find device, please ensure that the Bluetooth of the device is turned on",
  "tip.addDatalogger.searchAroundBluetooth": "Surrounding Bluetooth networking is available",
  "tip.addDatalogger.scan": "Scan the QR code or manually enter the dongle SN below the QR code.",
  "tip.addDatalogger.connectBluetoothFail": "Bluetooth connection failed, please scan the QR code or manually enter the dongle SN below the QR code before reconnecting.",
  "tip.connectWifi.tip1": "Configure devices to join the network",
  "tip.connectWifi.tip": "Please choose 2.4G WiFi",
  "tip.connectWifi.devicePower": "Device Power",
  "tip.connectWifi.enterSSID": "Please enter the router account",
  "tip.connectWifi.enterPassword": "Please enter the router password",
  "tip.connectWifi.masterId": "Please enter the main control ID",
  "tip.connectWifi.commandSetFail": "Command setting failed, please reconnect to the Dongle",
  "tip.configurationState.connecting": "Connecting in progress",
  "tip.configurationState.connectFail": "Connection failed",
  "tip.configurationState.connectSuccess": "Connection successful",
  "tip.configurationState.wait": "One moment please",
  "tip.configurationState.addDeviceSuccess": "Device added successfully",
  "tip.home.today": "Daily Yield",
  "tip.home.month": "Monthly Yield",
  "tip.home.year": "Yearly Yield",
  "tip.home.total": "Total Yield",
  "tip.home.homePower": "Total household Load",
  "tip.home.socketPower": "Socket Load",
  "tip.home.off-gridPower": "Off grid Load",
  "tip.home.acPower": "Mains Power",
  "tip.home.on-gridPower": "Grid connected Power",
  "tip.home.others": "Other",
  "tip.home.latestVersion": "It is already the latest version",
  "tip.home.frontEndLoad": "Front end Load",
  "tip.home.backEndLoad": "Off grid Load",
  "tip.energy.choiceDate": "The Current data is only available",
  "tip.energy.explain": "Explain",
  "tip.energy.tip1.load": "The energy consumed by the Load",
  "tip.energy.tip1.solar": "Convert solar energy into electrical energy for battery charging or Load Power supply",
  "tip.energy.tip1.grid": "Accumulated energy sold to the Power grid",
  "tip.energy.tip1.battery": "Accumulated electrical energy used to charge the battery",
  "tip.energy.tip2": "#NAME?",
  "tip.energy.tip3.title": "Social Contribution Calculation Standards",
  "tip.energy.tip3.title2": "1kWh equals:",
  "tip.energy.tip3.Co2": "Reduce carbon dioxide emissions:",
  "tip.energy.tip3.coal": "Save the use of standard coal:",
  "tip.energy.tip3.deforestation": "Protecting trees:",
  "tip.plant.comprehensive": "Comprehensive sorting",
  "tip.plant.totalEnergyMax": "The highest total Power consumption",
  "tip.plant.totalEnergyMin": "Lowest total Power consumption",
  "tip.plant.realTimePower": "Real time Power",
  "tip.plant.pvcapacityMax": "The highest PV capacity",
  "tip.plant.pvcapacityMin": "PV capacity is the lowest",
  "tip.plant.installationDateMax": "The farthest installation date",
  "tip.plant.installationDateMin": "Latest installation date",
  "tip.plant.paramChoice": "Parameter Selection",
  "tip.plant.filter": "Screen",
  "tip.plant.addVisitor": "Add visitor",
  "tip.plant.tip": "Tips",
  "tip.plant.visitorTip": "Can only be shared with registered users",
  "tip.plant.name": "Name",
  "tip.plant.permission": "Jurisdiction",
  "tip.plant.read-write": "Read and write",
  "tip.plant.onlyread": "Read-only",
  "tip.plant.visitor": "Visitor",
  "tip.plant.unfollow": "Are you sure you want to unfollow this Plant?",
  "tip.device.power": "Power",
  "tip.device.type": "Type",
  "tip.device.updateTime": "Update Time",
  "tip.device.powerOnTime": "Power-On Time",
  "tip.device.todayEnergy": "Today Consumption",
  "tip.device.signal": "Signal intensity ",
  "tip.device.deliveryWarning": "Sorry, this device has been delivered to end users and cannot be deleted. You can go to plant management first, withdraw the delivery, and then delete the device.",
  "common.ok": "OK",
  "tip.delDevice": "Are you sure you want to delete this {device}?",
  "tip.currentNoDevice": "There are Currently no devices available",
  "tip.currentNoDatalog": "No Available Dongle",
  "tip.messageInfo.storage": "Battery",
  "tip.messageInfo.inverter": "Inverter",
  "tip.messageInfo.microInverter": "Micro reverse",
  "tip.userLocation": "User's location",
  "tip.ops.setDomainName": "Are you sure you want to set up this domain name?",
  "tip.ops.restartDatalogger": "Are you sure you want to restart the Dongle?",
  "tip.opsLog.addUser": "Add end users",
  "tip.opsLog.bindSuccess": "Binding successful",
  "tip.opsLog.selectDate": "Select date",
  "tip.opsLog.start": "Start",
  "tip.opsLog.end": "End",
  "tip.opsLog.upgrade": "Upgrade",
  "tip.opsLog.operation": "Operation",
  "tip.opsLog.communication": "Communication",
  "tip.opsLog.type": "Type",
  "tip.opsLog.content": "Content",
  "tip.opsLog.control": "Controller",
  "tip.opsLog.command": "Command type",
  "tip.opsLog.reset": "Reset",
  "tip.opsLog.serverTime": "Server Time",
  "tip.opsLog.inverter": "Interval",
  "tip.opsLog.bindAgent": "Bind dealer",
  "tip.opsLog.deleteDeviceSN": "Please confirm if you want to delete it?",
  "tip.opsLog.recordLog": "Devices that require logging",
  "tip.setting.productModelNumberRelevancyOn-gridPower": "The grid connected Active Power cannot exceed the maximum Power of the selected Product model",
  "productEquipment.productModelNumber": "Product Model",
  "productEquipment.warnMessage": "Alarm Information",
  "productEquipment.customInstruction": "Custom Instructions",
  "productEquipment.firmwareUpdate": "Firmware update ",
  "productEquipment.historicalData": "Historical Data",
  "productEquipment.linkageInformation": "Connection Information",
  "systemAuthority.systemSettings": "System Settings",
  "systemAuthority.authorityManagement": "Permission",
  "systemAuthority.accountManagement": "Role",
  "systemAuthority.Disabled": "Disable",
  "systemAuthority.enable": "Enable",
  "org.ChangeSupplier": "Change Installer",
  "common.personalCenter": "Personal Center",
  "common.deviceSet": "Device Set",
  "common.productDetail": "Product Detail",
  "person.changePassword": "Change Password",
  "person.userName": "User Name",
  "person.company": "Company",
  "person.newPassword": "New Password",
  "person.confirmPassword": "Confirm Password",
  "person.userInformation": "User Information",
  "person.basicInformation": "Basic Information",
  "person.address": "Address",
  "person.phone": "Phone",
  "person.confirmChange": "Confirm Change",
  "validator.max": "Maximum of {num} characters allowed",
  "validator.min": "Minimum of {num} characters required",
  "weather.clearSky": "Clear Sky",
  "weather.fewClouds": "Few Clouds",
  "weather.scatteredClouds": "Scattered Clouds",
  "weather.brokenClouds": "Broken Clouds",
  "weather.overcastClouds": "Overcast Clouds",
  "weather.lightRain": "Light Rain",
  "weather.moderateRain": "Moderate Rain",
  "weather.heavyRain": "Heavy Rain",
  "weather.thunderstormWithLightRain": "Thunderstorm with Light Rain",
  "weather.thunderstormWithRain": "Thunderstorm with Rain",
  "weather.thunderstormWithHeavyRain": "Thunderstorm with Heavy Rain",
  "weather.lightSnow": "Light Snow",
  "weather.snow": "Snow",
  "weather.heavySnow": "Heavy Snow",
  "weather.sleet": "Sleet",
  "weather.showerRain": "Shower Rain",
  "weather.lightShowerRain": "Light Shower Rain",
  "weather.heavyShowerRain": "Heavy Shower Rain",
  "weather.mist": "Mist",
  "weather.smoke": "Smoke",
  "weather.haze": "Haze",
  "weather.dust": "Dust",
  "weather.fog": "Fog",
  "weather.sand": "Sand",
  "weather.ash": "Ash",
  "weather.squall": "Squall",
  "weather.tornado": "Tornado",
  "zh-CN": "Chinese",
  "en-US": "English",
  "de-DE": "German",
  "fr-FR": "French",
  "it-IT": "Italian",
  "uk-UA": "Ukrainian",
  "th-TH": "Thai",
  "nl-NL": "Dutch",
  "device.to": "To",
  "device.range": "Range",
  "device.noParamsChange": "No parameters have been changed, no need to send.",
  "device.timeCopy": "There are duplicate time periods, please modify.",
  "language.management": "Multilingual",
  "language.syncIot": "Sync IoT Alarm",
  "language.syncSuccess": "Sync Qingluo IoT Alarm Configuration Successful",
  "sidebar.roleManagement": "Role",
  "user.userEmail": "User Email",
  "user.agentCode": "Agent Code",
  "user.phoneModel": "Phone Model",
  "user.phoneOs": "Phone OS",
  "user.appVersion": "App Version",
  "user.country": "Country",
  "user.createTime": "Create Time",
  "user.loginTime": "Login Time",
  "shipment.MdmCode": "MDM Code",
  "product.createProduct": "Create Product",
  "shipment.MaterialCode": "MDM Material Code",
  "product.deviceSubclass": "Device Subclass",
  "shipment.supplier": "Supplier",
  "product.networkingMode": "Networking Mode",
  "product.productImage": "Product Image",
  "product.bluetoothIcon": "Bluetooth Icon",
  "product.uploadOneBluetoothIcon": "Only one Bluetooth icon can be uploaded",
  "product.UploadUpTo9Photos": "UpLoad Up to 9 Photos",
  "product.PleaseUploadNoBackground": "Please UpLoad Device Images with No Background",
  "product.havePublished": "Published",
  "product.inDevelopment": "In Development",
  "shipment.haierSn": "Haier SN",
  "shipment.category": "Category",
  "shipment.devType": "Development Type",
  "log.operationEmail": "Operation Email",
  "log.deviceSn": "Device SN",
  "log.opType": "Operation Type",
  "log.opTime": "Operation Time",
  "log.operator": "Operator",
  "log.operationDescription": "Operation Description",
  "log.content": "Operation Content",
  "log.params": "Parameters",
  "bTerminal.correlationDeleteTheDevice": "If this device is deleted, the associated devices will also be deleted simultaneously. Are you sure you want to delete?",
  "role.action": "Action",
  "role.add.select.menu": "Please select menu resources",
  "role.addRole": "Add Role",
  "role.addTip": "Support permission configuration for web and B-end APP users, but not for C-end APP users.",
  "role.applySuccess": "Apply Success",
  "role.appPermissions": "App Menu Permissions",
  "role.base": "Basic Information",
  "role.edit": "Edit",
  "role.exist": "The character already exists",
  "role.info": "Information",
  "role.name": "Role Name",
  "role.no": "Role Number",
  "role.not.empty": "Role information cannot be empty",
  "role.per.user": "Each user can only be assigned one role",
  "role.permissions": "Role Permissions",
  "role.status": "Role Status",
  "role.submit": "Submit",
  "role.type": "Role Type",
  "role.typeTip": "Installer Administrator: The default role given to the installer organization leader is that there is only one for the entire platform. Installer role: The role that the installer organization leader can assign to employees can be multiple. Platform role: a role that can be used by anyone except the installer.",
  "role.updateTime": "Update Time",
  "role.webPermissions": "Website Permissions",
  "shipment.PleaseEnterMaterialCode": "Please enter MDM material code",
  "product.PleaseEnterSupplier": "Please enter supplier",
  "common.reset": "Reset",
  "common.confirm": "Confirm",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.add": "Add",
  "common.edit": "Edit",
  "common.update": "Update",
  "common.submit": "Submit",
  "common.tip": "Remind",
  "common.success": "Success",
  "common.fail": "Fail",
  "common.password": "Password",
  "common.handleFail": "Operation Failed",
  "common.required": "Required ",
  "common.environmentChange": "Account Environment Change, Confirm to Refresh Account or Re-login",
  "common.noPermissions": "No content yet, please contact administrator to configure~",
  "plant.plantName": "Plant Name",
  "plant.country": "Country/Region",
  "plant.installer": "Organization",
  "plant.installPerson": "Installer",
  "plant.plantOverview": "Plant Overview",
  "plant.deviceList": "Device List",
  "device.operationMonitoring": "Device Overview",
  "device.parameterControl": "Parameter Control",
  "device.Fault&Alarm": "Faults & Alarms",
  "device.dynamicPriceTip": "AI Mode for this device is enabled  by the home owner, you cant save this parameter.",
  "device.paramRangeErrorDefault": "Range error, please in the range of ",
  "device.paramRangeError": "Parameter range error",
  "plant.dataUpdate": "Data update",
  "plant.pleaseSelectDate": "Please select date",
  "validate.requiredFormat": "Please enter in the example format",
  "plant.addStation": "Add Plant",
  "product.ProtocolCode": "IoT Product ID",
  "product.IoIDandPlatformSource": "IoT product ID and platform source",
  "product.productIdCannotRepeat": "Product ID cannot be duplicated",
  "product.deviceTypeAccess.maxAddRows": "You can add up to 2 entries only",
  "product.accessPlatformCannotRepeat": "Platform source cannot be duplicated",
  "product.productId": "Product ID",
  "product.powerType": "Power Type",
  "product.power": "Rated Power kW",
  "system.taskCenter": "Task Center",
  "task.name": "Task Name",
  "task.type": "Task Type",
  "task.status": "Status",
  "task.createDate": "Creation Date",
  "task.progress": "Progress",
  "task.view": "View",
  "task.stop": "Stop",
  "task.stopConfirm": "Are you sure you want to stop the task?",
  "task.stopSuccess": "Task stopped successfully",
  "task.stopFail": "Failed to stop task",
  "task.confirm": "Confirm",
  "task.cancel": "Cancel",
  "task.mutipleSearch": "Batch Search",
  "task.mutipleSend": "Batch Send",
  "task.taskDetail": "Task Details",
  "task.equipmentList": "Equipment List",
  "task.fileLimit": "Only xls/xlsx files can be uploaded",
  "task.reChoose": "Clear the list and re-select",
  "task.tip": "Drag the file here, or",
  "task.upload": "Click to Upload",
  "task.templateDownload": "Download Template",
  "task.mutipleHandleParams": "Batch Processing Parameters",
  "common.previousStep": "Previous Step",
  "task.requiredProductModel": "Please select a product model",
  "task.requiredEquipmentList": "Please upload the equipment list",
  "task.equipmentListTip": "The table data is empty or upload failed, please check",
  "task.requiredParameter": "Please select a parameter",
  "task.writeValue": "Write Value",
  "task.progressRate": "Completion Rate",
  "task.readTime": "Read Time",
  "task.sendTime": "Send Time",
  "task.mutipleSearchTemplate": "Batch Search Template",
  "task.mutipleSendTemplate": "Batch Send Template",
  "task.uploadSuccess": "Upload Successful",
  "task.sendSuccess": "Task Created Successfully",
  "task.inProgress": "In Progress",
  "task.completed": "Completed",
  "task.failed": "Failed",
  "task.success": "Success",
  "system.configureImport": "Configuration Import",
  "product.DeviceHlepInstructions": "Device Help Instructions",
  "product.addDeviceHlepInstructions": "Add Device Help Instructions",
  "product.deviceInstallationGuideFirst": "Please upload device installation guide images to guide installers step by step through installation and APP operations.",
  "product.deviceInstallationGuideSecond": "It is recommended to include instructions for entering device network configuration mode, SN QR code location, site creation, device addition, Bluetooth operations, quick configuration, etc.",
  "product.mdnTip": "First 9 digits of Haier SN",
  "Firmware.secretType": "Encryption Method",
  "common.copySuccess": "Copy Success",
  "bTerminal.ModifyTheNameOfTheDevice": "Change device name",
  "bTerminal.changeFailed": "Change failed",
  "bTerminal.OnlyWithin100Characters": "Limited to 100 characters or less in Chinese, English, and numbers",
  "bTerminal.OnlyWithin30Characters": "Limited to 30 characters or less in Chinese, English, and numbers",
  "bTerminal.rename": "Rename",
  "sidebar.prefill": "Ratings & Feedback",
  "paramters.basicInformation": "Basic Information",
  "paramters.DCSide": "DC Side",
  "paramters.ACSide": "AC Side",
  "paramters.stringCurrent": "String Current",
  "paramters.moreParamters": "More Information",
  "paramters.debugInformation": "Debug Information",
  "paramters.current": "Current",
  "paramters.voltage": "Voltage",
  "paramters.power": "Power",
  "paramters.init": "Initialization",
  "paramters.wait": "Waiting",
  "paramters.normal": "Normal",
  "paramters.abnormal": "Fault",
  "paramters.burn": "Burn-in",
  "system.reportCenter": "Report Center",
  "system.reportMonth": "Monthly Report",
  "system.reportYear": "Annual Report",
  "system.selfServiceReport": "Self-Service",
  "system.selfServiceReport.hour": "Hour",
  "system.selfServiceReport.selectPlant": "Please select plant",
  "system.selfServiceReport.selectYear": "Select year",
  "system.selfServiceReport.metricSelection": "Metric Selection",
  "system.selfServiceReport.required": "Required",
  "system.selfServiceReport.startTimeCannotBeLater": "Start time cannot be later than end time",
  "system.selfServiceReport.fieldIsRequired": "{field} is required",
  "system.selfServiceReport.hourTimeTooltipLine1": "Hour represents the 1-hour period starting at that full hour",
  "system.selfServiceReport.hourTimeTooltipLine2": "(e.g. 15:00 = 15:00–15:59)",
  "report.exportAll": "Export All",
  "report.installedCapacity": "Installed Capacity",
  "report.capacityErrorTip": "The installed capacity filter range is invalid",
  "report.exportFailed": "Export failed, please try again later",
  "report.firstChoiceTime": "Please select a date first, then export",
  "register.accountVerification": "Account Verification",
  "register.companyRegistration": "Company Registration",
  "register.staffRegistration": "Staff Registration",
  "register.companyInfo": "Provide company information below",
  "register.companyFullName": "Company Full Name",
  "register.installationCountryNotice": "Please carefully select the country where the installer is registered. You cannot install the system outside the registration area.",
  "register.detailAddress": "Detailed Address",
  "register.postalCode": "Postal Code",
  "register.contactName": "Contact Name",
  "register.contactInfo": "Contact Phone or Email",
  "register.applyJoinCompany": "Apply to Join Company",
  "register.companyCodeInfo": "Please fill in the company code and personal information to join a registered enterprise",
  "register.registrationCode": "Company Registration Code",
  "register.codeHint": "Code can be obtained by contacting the enterprise administrator",
  "register.realName": "Name",
  "register.accountVerificationInfo": "Choose one of the following methods to complete account registration",
  "register.emailRegistration": "Email Registration",
  "register.sixDigitCode": "6-digit verification code",
  "register.getVerificationCode": "Get Verification Code",
  "register.resendAfterSeconds": "Resend after {seconds}s",
  "register.resendAfterMinutes": "Resend after {minutes}min",
  "register.resendAfterMinutesSeconds": "Resend after {minutes}min{seconds}s",
  "register.password6to20": "6-20 character password",
  "register.password8to20": "8-20 character password",
  "register.phoneNumber": "Phone Number",
  "register.phoneRegistration": "Phone Registration",
  "register.optionalEmail": "Optional: Email Address",
  "register.previousPage": "Previous Page",
  "register.goToLogin": "Go to login",
  "register.completeRegistration": "Complete registration",
  "register.accountAlreadyRegistered": "This email or phone number is already registered. Please sign in or use another one.",
  "register.emailAlreadyRegistered": "This email is already registered. Please sign in directly or use another account.",
  "register.phoneAlreadyRegistered": "This phone number is already registered. Please sign in directly or use another account.",
  "register.companyAlreadyRegistered": "Company '{companyName}' is already registered",
  "register.companyExistOptions": "You can return to modify the company name, or apply to join this company",
  "register.returnToModify": "Return to Modify",
  "register.companyRegisteredApplyJoin": "Apply to join",
  "register.companyRegisteredApplyJoinFull": "Company already registered? Apply to join",
  "register.validation.selectCountry": "Please select country/region",
  "register.validation.selectCity": "Please select city",
  "register.validation.enterDetailAddress": "Please enter detailed address",
  "register.validation.enterCorrectPostalCode": "Please enter correct postal code format",
  "register.validation.enterContactName": "Please enter contact name",
  "register.validation.enterRegistrationCode": "Please enter company registration code",
  "register.validation.enterYourName": "Please enter your name",
  "register.validation.enterPassword": "Please enter password",
  "register.validation.passwordLength": "Password length must be 6-20 characters",
  "register.validation.passwordLength8to20": "Password length must be 8-20 characters",
  "register.validation.passwordComplexity": "Password must contain at least three different character types (numbers, uppercase letters, lowercase letters, special characters)",
  "register.validation.enterPasswordAgain": "Please enter password again",
  "register.validation.passwordMismatch": "Two passwords do not match",
  "register.validation.correctPhoneFormat": "Please enter correct phone number format",
  "register.validation.correctPhoneOrEmailFormat": "Please enter correct phone number or email format",
  "register.validation.correctEmailFormat": "Please enter correct email format",
  "register.validation.enterVerificationCode": "Please enter verification code",
  "register.validation.sixDigitNumber": "Verification code must be 6 digits",
  "register.validation.enterCompanyName": "Please enter company name",
  "register.validation.companyRegisteredChooseAction": "Company already registered, please choose action",
  "register.message.searchCompanyFailed": "Failed to search company",
  "register.message.checkCompanyStatusFailed": "Failed to check company status",
  "register.message.getCityListFailed": "Failed to get city list",
  "register.message.companyRegisteredChooseAction": "Company already registered, please choose action",
  "register.message.completeCompanyInfo": "Please complete company information",
  "register.message.completeStaffInfo": "Please complete staff information",
  "register.message.enterEmailFirst": "Please enter email address first",
  "register.message.correctEmailFormat": "Please enter correct email format",
  "register.message.verificationCodeSent": "Verification code sent to: {contact}",
  "register.message.sendVerificationCodeFailed": "Failed to send verification code",
  "register.message.enterPhoneFirst": "Please enter phone number first",
  "register.message.correctPhoneFormat": "Please enter correct phone number format",
  "register.message.completeAccountInfoAndFixErrors": "Please complete account information and fix errors",
  "register.message.companyRegistrationSuccess": "Company registration successful!",
  "register.message.companyRegistrationFailed": "Company registration failed",
  "register.message.staffRegistrationSuccess": "Staff registration successful!",
  "register.message.staffRegistrationFailed": "Staff registration failed",
  "register.message.phoneRegistrationNotAvailable": "Registration via phone number is currently unavailable. Please stay tuned.",
  "register.tooltip.title": "How to find the company registration code?",
  "register.tooltip.appPathTitle": "1. In the APP",
  "register.tooltip.appPathDesc": "Go to User -> tap avatar -> Account Information to view the company registration code.",
  "register.tooltip.webPathTitle": "2. In the Web console",
  "register.tooltip.webPathDesc": "Go to Organization Management -> Organization Information to view the company registration code.",
  "registerAccomplish.applicationComplete": "Application Complete",
  "registerAccomplish.congratulations": "Congratulations, you have completed registration.",
  "registerAccomplish.companyRegisterCodeIs": "Your company registration code is",
  "registerAccomplish.certificationRequired": "You need to continue to the certification center for authentication, otherwise you cannot activate devices.",
  "registerAccomplish.greenChannelInfo": "For special emergency situations in departments, in order not to delay on-site installation, you can choose the green channel to get temporary permission to activate devices for 2 months.",
  "registerAccomplish.certificationCenter": "Certification Center",
  "registerAccomplish.greenChannel": "Green Channel",
  "registerAccomplish.returnToLogin": "Return to Login Page",
  "registerAccomplish.useHaierEnergyApp": "You can use Haier Energy APP to add devices.",
  "registerAccomplish.applyingGreenChannel": "You are applying for green channel",
  "registerAccomplish.greenChannelDescription1": "This channel is only for some special emergency situations, to avoid delaying on-site installation, for activating devices.",
  "registerAccomplish.greenChannelDescription2": "The account permissions obtained through this channel are temporary permissions, and the validity period for activating devices is 2 months.",
  "registerAccomplish.greenChannelDescription3": "You need to go to the certification center within 2 months to complete authentication and obtain permanent permission to activate devices.",
  "registerAccomplish.confirmSubmit": "Confirm Submit",
  "registerAccomplish.returnToPrevious": "Return to Previous Page",
  "registerAccomplish.applicationSubmittedSuccessfully": "Your application has been successfully submitted!",
  "registerAccomplish.missingAgentIdParameter": "Missing agentId parameter, cannot apply for green channel",
  "registerAccomplish.greenChannelApplicationSuccess": "Green channel application successful!",
  "registerAccomplish.greenChannelApplicationFailed": "Green channel application failed",
  "registerAccomplish.enterSystem": "Enter System",
  "registerAccomplish.pleaseLoginFirst": "Please complete login first",
  "org.phoneNumber": "Phone Number",
  "org.certificationStatus": "Certification Status",
  "org.permission": "Permission",
  "org.accountSource": "Account Source",
  "org.certificationStatusTip": "Currently only for permissions to add devices in the Haier Energy app",
  "org.unauthenticated": "Unauthenticated",
  "org.authenticated": "Authenticated",
  "org.noNeedToAuthenticate": "No Authentication Required",
  "org.unauthorized": "Unauthorized",
  "org.authorized": "Authorized",
  "org.temporaryAuthorization": "Temporary Authorization",
  "org.remainingDays": "Remaining Days: {scope} days",
  "org.allocated": "Allocated",
  "org.registered": "Registered",
  "org.authorization": "Authorization",
  "org.addressDetail": "Address Details",
  "org.postalCode": "Postal Code",
  "org.accountSwitch": "Account Switch",
  "org.viewAccountInfo": "View Account Information",
  "org.baseInfo": "Basic Information",
  "org.certificationInfo": "Certification Information",
  "org.restDays": "Remaining Days",
  "org.applyTime": "Application Time",
  "org.certificationTime": "Certification Time",
  "org.registerCode": "Registration Code",
  "org.registrationTip": "You can enter the company registration code during registration to apply to join the company.",
  "org.authenticationTip": "This account has been disabled and cannot be authorized.",
  "org.authenticationTip2": "This account has already been authorized or has a temporary authorization that has not expired; re-authorization is not allowed.",
  "org.temporaryAuthorizationTip": "Authorization is temporary by default, lasting 3 months.",
  "org.temporaryAuthorizationSuccess": "Authorization successful",
  "report.allSelect": "Select All",
  "report.compare": "Compare",
  "report.energy": "Active Power",
  "report.ipv": "DC Current",
  "report.vpv": "DC Voltage",
  "report.fac": "AC Frequency",
  "report.vac": "AC Voltage",
  "report.iac": "AC Current",
  "report.temperature": "Internal Temperature",
  "report.str_cur": "String Current",
  "report.inverterCompare": "Inverter Comparison",
  "report.inverterCompareTip": "Already added to the list, please do not add again",
  "report.pleaseChooseInverter": "Please select an inverter",
  "report.pleaseChooseCompare": "Please select comparison items",
  "report.compareItem": "Comparison Items",
  "system.inverterCompare": "Inverter Parameter Comparison",
  "shipment.deviceSource": "Shipment Source",
  "shipment.shippingCustomer": "Shipping Customer",
  "shipment.customerContact": "Customer Contact",
  "shipment.tag": "Tag",
  "shipment.addTag": "Add Tag",
  "shipment.editTag": "Edit Tag",
  "shipment.tagContent": "Tag Content",
  "shipment.tagColor": "Tag Color",
  "placeholder.selectShippingCustomer": "Please select shipping customer",
  "placeholder.enterCustomerContact": "Please enter customer contact",
  "placeholder.selectTag": "Please select tag",
  "placeholder.enterTagContent": "Please enter tag content",
  "placeholder.noResult": "No matching tags",
  "validation.enterTagContent": "Please enter tag content",
  "validation.selectTagColor": "Please select tag color",
  "shipment.operationRecordTitle": "Operation Records",
  "shipment.boundUserWarning": "Sorry, this device is already bound to a user and the shipping customer cannot be updated.",
  "shipment.batchBoundUserWarning": "Sorry, the selected devices include devices that are already bound to users, and the shipping customer cannot be updated in batch.",
  "shipment.uploadEquipmentListRequired": "Please upload the equipment list file",
  "shipment.errorDataTipTitle": "Abnormal Data Reminder",
  "shipment.downloadImportResult": "Download Import Result",
  "shipment.downloading": "Downloading...",
  "shipment.noFailedDataToDownload": "No failed data available to download",
  "shipment.deleteTagConfirm": "Are you sure you want to delete the tag \"{tagName}\"?",
  "common.addSuccess": "Added successfully",
  "common.editSuccess": "Edited successfully",
  "product.basicProperties": "Basic Properties",
  "product.specialProperties": "Special Properties",
  "product.platformRelated": "Platform Related",
  "product.maxPvChannels": "Max supported PV strings",
  "product.componentManufacturer": "Module manufacturer",
  "product.componentType": "Module type",
  "product.ratedPower": "Rated power",
  "product.mppVoltage": "MPP voltage",
  "product.mppCurrent": "MPP current",
  "product.openCircuitVoltage": "Open-circuit voltage",
  "product.shortCircuitCurrent": "Short-circuit current",
  "product.maxPowerTempCoeff": "Temperature coefficient of max power",
  "product.openVoltageTempCoeff": "Temperature coefficient of open-circuit voltage",
  "product.shortCurrentTempCoeff": "Temperature coefficient of short-circuit current",
  "product.componentEfficiency": "Nominal module conversion efficiency",
  "product.firstYearDegradation": "First-year degradation",
  "product.annualDegradation": "Annual degradation",
  "product.fillFactor": "Fill factor",
  "product.ratedPowerOnTheACSide": "Rated power on AC side (kW)",
  "product.ratedPowerOnTheDCSide": "Rated power on DC side (kW)",
  "product.energyStoragePower": "Energy storage power (kW)",
  "product.energyStorageCapacity": "Energy storage capacity (kWh)",
  "product.placeholder.range_0_9999_2dp": "0-9999, up to 2 decimals",
  "product.placeholder.range_0_99_2dp": "0-99, up to 2 decimals",
  "product.placeholder.range_0_999_2dp": "0-999, up to 2 decimals",
  "product.placeholder.range_neg1_1_2dp": "-1 to 1, up to 2 decimals",
  "product.rule.range_0_9999_2dp": "Enter a number between 0-9999, up to 2 decimals",
  "product.rule.range_0_99_2dp": "Enter a number between 0-99, up to 2 decimals",
  "product.rule.range_0_999_2dp": "Enter a number between 0-999, up to 2 decimals",
  "product.rule.range_neg1_1_2dp": "Enter a number between -1 and 1, up to 2 decimals",
  "product.ivScanSupport": "Support IV curve scan",
  "system.intelligentDiagnosis": "Intelligent Diagnosis",
  "system.ivline": "IV Curve",
  "subtitle.ivlineCreate": "Scan Task",
  "diagnosis.diagnosisTime": "Diagnosis Time",
  "diagnosis.faultQuantity": "Fault Quantity",
  "diagnosis.scanCompleteTime": "Scan Complete Time",
  "diagnosis.scanProgress": "Scan Progress",
  "diagnosis.newTask": "New Task",
  "diagnosis.deleteTask": "Delete Task",
  "diagnosis.deleteTaskSuccess": "Task deleted successfully",
  "diagnosis.closeAll": "Clear All",
  "diagnosis.startScan": "Start Scan",
  "diagnosis.pleaseChooseInverter": "Please select inverter",
  "diagnosis.stringSetting": "String Setting",
  "diagnosis.taskSetting": "Task Setting",
  "diagnosis.batchComponentSetting": "Batch Component Setting",
  "diagnosis.componentType": "Component Type",
  "diagnosis.maxPower": "Maximum Power (Pmax)",
  "diagnosis.bestWorkingVoltage": "Optimum Operating Voltage (Vmpp)",
  "diagnosis.bestWorkingCurrent": "Optimum Operating Current (Impp)",
  "diagnosis.openCircuitVoltage": "Open Circuit Voltage (Voc)",
  "diagnosis.shortCircuitCurrent": "Short Circuit Current (Isc)",
  "diagnosis.maxPowerTemperatureCoefficient": "Temperature Coefficient of Maximum Power",
  "diagnosis.openCircuitVoltageTemperatureCoefficient": "Temperature Coefficient of Open Circuit Voltage",
  "diagnosis.shortCircuitCurrentTemperatureCoefficient": "Temperature Coefficient of Short Circuit Current",
  "diagnosis.nominalComponentConversionEfficiency": "Nominal Component Conversion Efficiency",
  "diagnosis.firstYearDecayRate": "First-Year Degradation Rate",
  "diagnosis.yearlyDecayRate": "Annual Degradation Rate",
  "diagnosis.fillFactor": "Fill Factor",
  "diagnosis.componentManufacturer": "Component Manufacturer",
  "diagnosis.componentAmount": "Component Quantity",
  "diagnosis.capacity": "String Capacity",
  "diagnosis.stringAmount": "String Count (pcs)",
  "diagnosis.inverterSerialNumber": "Inverter Serial Number",
  "diagnosis.totalCapacity": "Total String Capacity",
  "diagnosis.pleaseFillInAllItems": "Incomplete fields, please check",
  "diagnosis.moreParamters": "More Parameters",
  "diagnosis.envParam": "Environmental Parameters",
  "diagnosis.startTask": "Start Task",
  "diagnosis.startTaskSuccess": "Task started successfully",
  "diagnosis.start": "Start",
  "diagnosis.noDevice": "No device found",
  "register.contactAdminForCode": "Please contact your company administrator to obtain the company registration code",
  "register.provideCompanyInfoBelow": "Please provide company information below",
  "login.success": "Login successful",
  "flowData.existingInvTip": "Notice:\nExisting INV>0, solar is generating electricity;\nExisting INV<0, INV is consuming electricity.",
  "flowData.alert": "The current Existing INV<0 indicates that the external inverter is consuming power.",
  "dialog.confirm": "I know",
  "paramters.deviceTotalInformation": "Device Total Information",
  "paramters.innerInverter": "Internal Inverter",
  "paramters.outerInverter": "External Inverter",
  "paramters.outerInverterFromPvSide": "From PV Side Meter",
  "paramters.activePower": "Active Power",
  "paramters.apparentPower": "Apparent Power",
  "paramters.reactivePower": "Reactive Power",
  "paramters.powerFactor": "Power Factor",
  "paramters.phaseA": "Phase A",
  "paramters.phaseB": "Phase B",
  "paramters.phaseC": "Phase C",
  "paramters.charge": "Charge",
  "paramters.discharge": "Discharge",
  "paramters.sell": "Sell Electricity",
  "paramters.buy": "Buy Electricity",
  "bw_param_ctrl_group_WorkMode": "Work Mode",
  "bw_param_ctrl_name_GRID_Meter_negate": "GRID_Meter_negate",
  "bw_param_ctrl_name_GridBreake": "Grid Breake",
  "bw_param_ctrl_name_BBSOC_lx1": "SOC for L1 Power Cut-off",
  "bw_param_ctrl_name_BBSOC_lx2": "SOC for L2 Power Cut-off",
  "bw_param_ctrl_name_BBSOC_lx3": "SOC for L3 Power Cut-off",
  "bw_param_ctrl_option_ON": "ON",
  "bw_param_ctrl_name_Systemmode": "System mode",
  "bw_param_ctrl_name_UPSReserveSoc": "UPS Reserve Soc",
  "bw_param_ctrl_option_OFF": "OFF",
  "bw_param_ctrl_option_B5": "Single-Phase 5Kw Model",
  "bw_param_ctrl_name_DispatchActivepower": "Dispatch Active power",
  "bw_param_ctrl_option_withoutBattery": "without Battery",
  "bw_param_ctrl_name_InvSub": "Inv sub",
  "bw_param_ctrl_name_MAXFeedintogridpercent": "MAX Feedinto grid percent",
  "bw_param_ctrl_option_T4": "Three-Phase 4Kw Model",
  "bw_param_ctrl_option_T5": "Three-Phase 5Kw Model",
  "bw_param_ctrl_option_T6": "Three-Phase 6Kw Model",
  "bw_param_ctrl_option_T8": "Three-Phase 8Kw Model",
  "bw_param_ctrl_option_S3": "Single-Phase Energy Storage 3Kw Model",
  "bw_param_ctrl_option_S5": "Single Phase Energy Storage 5Kw Model",
  "bw_param_ctrl_option_S6": "Single-Phase Energy Storage 6Kw Model",
  "bw_param_ctrl_option_S8": "Single Phase Energy Storage 8Kw Model",
  "bw_param_ctrl_option_Grid&PV useCT": "Grid&PV use CT",
  "bw_param_ctrl_note_MAXFeedintogridpercent": "The ratio of max. feed-in power to PV installed capacity (including all PV capacity connected to PV-inverter and energy storage inverter)",
  "bw_param_ctrl_option_Grid&PVUseMeter": "Grid&PVuse Meter",
  "bw_param_ctrl_note_PVCapacityofGridInverter": "Total installed PV capacity connected to energy storage inverter",
  "bw_param_ctrl_option_T10": "Three Phase 10Kw Model",
  "bw_param_ctrl_name_DispatchReactivepower": "Dispatch Reactive power",
  "bw_param_ctrl_name_Grid_Regulation": "Grid_Regulation",
  "bw_param_ctrl_option_Enablecharge&dischargeTimePeriodControl": "Enable charge and discharge Time period control",
  "bw_param_ctrl_name_Timeperiodcontrolflag": "Time period control flag",
  "bw_param_ctrl_note_BatteryReady": "Battery Connection by default is 'with Battery'. If no battery is connected (i.e. the inverter is connected to PV but not to any battery modules), select 'without Battery' or the unit will look for a battery that is not present and will enter Fault mode.",
  "bw_param_ctrl_option_withBattery": "with Battery",
  "bw_param_ctrl_name_PV_Meter_negate": "PV_Meter_negate",
  "bw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Only Enable discharge Time period control",
  "bw_param_ctrl_name_EMSReset": "Ems Reset",
  "bw_param_ctrl_name_FactoryReset": "Factory Reset",
  "bw_param_ctrl_name_DSPReset": "Dsp Reset",
  "bw_param_ctrl_group_RemoteReset": "Remote Reset",
  "bw_param_ctrl_option_FactoryReset": "Reset",
  "bw_param_ctrl_option_DSPReset": "Reset",
  "bw_param_ctrl_option_EMSReset": "Reset",
  "bw_param_ctrl_group_BackupBox": "Backup Box",
  "bw_param_ctrl_name_BBPrio_lx1": "L1 strategy priority",
  "bw_param_ctrl_name_BBPrio_lx2": "L2 strategy priority",
  "bw_param_ctrl_name_BBPrio_lx3": "L3 strategy priority",
  "bw_param_ctrl_note_BBSOC_lx3": "The SOC of priority 3 needs to be higher than the SOC of priority 1 and the SOC of priority 2.",
  "bw_param_ctrl_note_BBSOC_lx1": "The SOC of priority 1 needs to be the min.SOC of L1, L2, and L3.",
  "bw_param_ctrl_note_BBSOC_lx2": "The SOC of priority 2 needs to be higher than SOC with priority 1.",
  "bw_param_ctrl_option_1": "1",
  "bw_param_ctrl_option_3": "3",
  "bw_param_ctrl_option_2": "2",
  "bw_param_ctrl_name_BBLoadEnable": "Backup-Box Enable",
  "bw_param_ctrl_name_MeterCTSelect": "Meter CT Select",
  "bw_param_ctrl_option_GridUse CT&PVUseMeter": "Grid use CT、PV use Meter",
  "bw_param_ctrl_name_ChargeCutSoc": "Charge Cut Soc",
  "bw_param_ctrl_option_HybridMode": "Hybrid Mode",
  "bw_param_ctrl_name_PVCapacityStorage": "PV Capacity Storage",
  "bw_param_ctrl_name_DispatchTime": "Dispatch Time",
  "bw_param_ctrl_name_DispatchStart": "Dispatch Start",
  "bw_param_ctrl_name_UPSreserveenable": "UPS reserve enable",
  "bw_param_ctrl_option_selfuse": "Self Use",
  "bw_param_ctrl_option_DCMode": "DC Mode",
  "bw_param_ctrl_name_PVCapacityofGridInverter": "PV Capacity of Grid Inverter",
  "bw_param_ctrl_name_RTC": "RTC",
  "bw_param_ctrl_option_Normal": "Normal",
  "bw_param_ctrl_group_SystemInfo": "System Info",
  "bw_param_ctrl_note_Systemmode": "DC: 1.Newly installed PV system with hybrid energy storage inverter connecting to PV panels directly. 2.Battery system without PV inverter connecting to the grid directly and only be charged from the grid\n\nAC:Retrofitting PV system which includes PV inverter connecting to PV panels and the grid. Panels cannot directly connect to the hybrid energy storage inverter.\n\nHybrid:The whole system includes PV inverter connecting to the grid and Hybrid energy storage inverter connecting to PV panels directly",
  "bw_param_ctrl_group_GridMeterSettings": "Grid Meter Settings",
  "bw_param_ctrl_option_Forced charging and discharging": "Forced charging and discharging",
  "bw_param_ctrl_note_ChargeCutSoc": "The upper limit of the battery SOC charge.",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiod control": "Only Enable Charge Time period control",
  "bw_param_ctrl_option_Disable": "Disable",
  "bw_param_ctrl_group_BatterySettings": "Battery Settings",
  "bw_param_ctrl_name_BatteryReady": "Battery Ready",
  "bw_param_ctrl_option_GridUse Meter&PVUseCT": "Grid use Meter、PV use CT",
  "bw_param_ctrl_name_DispatchSOC": "Dispatch SOC",
  "bw_param_ctrl_option_Disable TimePeriodControl": "Disable Time period control",
  "bw_param_ctrl_option_Enable": "Enable",
  "bw_param_ctrl_option_TOU": "TOU",
  "bw_param_ctrl_name_ChargeTimeSlot1": "Charge Time Slot 1",
  "bw_param_ctrl_name_ChargeTimeSlot2": "Charge Time Slot 2",
  "bw_param_ctrl_note_Timeperiodcontrolflag": "The charging and discharging settings only take effect when the \"TOU\" mode is selected.",
  "bw_param_ctrl_group_GridSafetyConfig": "Grid Safety Config",
  "bw_param_ctrl_group_SystemConfig": "System Config",
  "bw_param_ctrl_option_ACMode": "AC Mode",
  "bw_param_ctrl_option_Reverse": "Reverse",
  "bw_param_ctrl_option_NotEnabledChargeSetting": "Not Enabled Charge Setting",
  "bw_param_ctrl_group_Charge&DischargeSettings": "Charge and Discharge Settings",
  "bw_param_ctrl_name_DispatchMode": "Dispatch Mode",
  "bw_param_ctrl_note_GridBreake": "Please select according to the actual circuit breaker specifications on the grid side of the inverter. If the specification is incorrectly filled in, it may cause the circuit breaker to trip.",
  "bw_param_ctrl_note_PVCapacityStorage": "Total installed PV capacity connected to PV inverter",
  "bw_param_ctrl_name_DischargeTimeSlot2": "Discharge Time Slot 2",
  "bw_param_ctrl_name_DischargeTimeSlot1": "Discharge Time Slot 1",
  "bw_param_ctrl_group_GridDispatch": "Grid Dispatch",
  "jl_param_ctrl_group_OnOff": "On/Off",
  "jl_param_ctrl_name_OnOff": "On/Off",
  "jl_param_ctrl_option_PowerOFF": "Power OFF",
  "jl_param_ctrl_option_PowerON": "Power ON",
  "product.multipleLanguage": "Thing Model Multilingual Settings",
  "product.multipleLanguageNote": "Thing Model Multilingual Term Library",
  "product.entryCode": "Term Code",
  "product.entryValue": "Term Value",
  "product.endpoint": "Endpoint",
  "product.module": "Module",
  "product.tag": "Tag",
  "product.editLanguage": "Edit Multilingual",
  "product.addLanguage": "Add Multilingual",
  "product.maintainInfo": "Maintenance Information",
  "product.statusChangeSuccess": "Status updated successfully",
  "product.statusChangeFail": "Failed to update status",
  "product.syncIotI18n": "Sync Qingluo IoT Model Entries",
  "product.confirmSyncIotI18n": "Are you sure you want to sync Qingluo IoT model entries?",
  "button.sync": "Sync Multilingual Package",
  "plant.withdrawDelivery": "Withdraw Delivery",
  "plant.deliverUser": "Deliver User",
  "plant.withdrawDeliveryTip": "After withdrawing delivery, the end-user will no longer be able to manage this power station. Please proceed with caution.",
  "plant.undelivered": "Undelivered",
  "plant.deliverManage": "Delivery Management",
  "plant.email_format_error": "Email format error",
  "plant.deliverUserTip": "Note: When users log in to Haier Energy with their email, they can monitor and control your installed devices via the app.",
  "plant.enterUserAccount": "Please enter the user account",
  "plant.deliverUserTipUnified": "Note: When users log in to Haier Energy with their phone number or email, they can monitor and control your installed devices via the app.",
  "plant.placeholderPhoneOrEmail": "Enter phone number or email",
  "plant.phoneOrEmailFormatError": "Please enter a valid phone number or email",
  "plant.deliverSuccess": "Delivery successful",
  "plant.known": "Got it",
  "plant.notRegistered": "Not registered",
  "plant.noPermission": "Sorry, you don't have permission to withdraw delivery. Only platform super admins and installer admins can withdraw delivery.",
  "plant.scanQRCode": "Please have the owner scan the QR code below",
  "plant.qrCodeExpireTip": "This authorization code will expire after successful receipt.",
  "plant.transferMethod": "Transfer Method",
  "plant.transferRecord": "Transfer Records",
  "plant.operationTime": "Operation Time",
  "plant.operator": "Operator",
  "plant.transferType": "Transfer Type",
  "plant.userIdentifier": "User Identifier",
  "plant.transferResult": "Transfer Result",
  "plant.totalRecordCount": "Total {count} records",
  "plant.saveTimezoneTip": "Changing the time zone may cause:\nGaps or overlaps in device data charts (lasting several hours)\nDevice local tasks may become disordered and may briefly go offline",
  "device.Yield": "Yield",
  "device.ExistingINV": "Existing INV",
  "sidebar.dictManage": "Dictionary Management",
  "subtitle.dictData": "Dictionary Data",
  "dict.dictname": "Dictionary Label",
  "dict.dictnameen": "Dictionary Key",
  "dict.dictdataname": "Data Label",
  "dict.dictdatavalue": "Data Value",
  "dict.i18nCode": "Language Code",
  "dict.dictsort": "Sort Order",
  "dict.addDict": "Add Dictionary",
  "dict.addDictData": "Add Dictionary Entry",
  "dict.editDict": "Edit Dictionary",
  "dict.editDictData": "Edit Dictionary Entry",
  "device.otaTabTip": "Note: After the upgrade is complete, the device will go offline briefly. Please restart the device.",
  "product.accessPlatform": "Access Platform",
  "product.valueFilter": "Empty Term Value",
  "setting.type22.restrictCounterCurrent.val1": "Limit total three-phase power",
  "setting.type22.restrictCounterCurrent.val2": "Limit single-phase power",
  "setting.type22.disable": "Disable",
  "setting.type22.enable": "Enable",
  "setting.type22.meterSelect.str": "Stonray Meter",
  "setting.type22.meterSelect.df": "Dongfan Meter",
  "setting.type22.meterSelect.dh": "Donghong Meter",
  "setting.type22.meterSelect.zt": "Chint Meter",
  "setting.type22.meterSelect.yb": "Yeebon",
  "setting.type22.meterSelect.yz": "Ingeteam",
  "setting.type22.meterSelect.nky": "Nengkongyun Smart Meter",
  "bw_RTparam_name_AFCI_Version": "AFCI Version Number",
  "bw_RTparam_name_allowCharged": "Allow to be charged and discharged",
  "bw_RTparam_name_ApparentPOAP_Grid": "Apparent Power of A phase(Grid)",
  "bw_RTparam_name_ApparentPOBP_Grid": "Apparent Power of B phase(Grid)",
  "bw_RTparam_name_ApparentPOCP_Grid": "Apparent Power of C phase(Grid)",
  "bw_RTparam_name_BackupCurrentR": "Backup Current R",
  "bw_RTparam_name_BackupCurrentS": "Backup Current S",
  "bw_RTparam_name_BackupCurrentT": "Backup Current T",
  "bw_RTparam_name_BackupFrequency": "Backup Frequency",
  "bw_RTparam_name_BackupPower": "Backup Power",
  "bw_RTparam_name_BackupVoltageR": "Backup Voltage R",
  "bw_RTparam_name_BackupVoltageS": "Backup Voltage S",
  "bw_RTparam_name_BackupVoltageT": "Backup Voltage T",
  "bw_RTparam_name_batDcdcVersion": "DCDC Version",
  "bw_RTparam_name_BatteryChargeCut-offVoltage": "Battery charge cut-off Voltage",
  "bw_RTparam_name_BatteryChargeFromGrid_Every": "Battery energy charge from Grid",
  "bw_RTparam_name_BatteryChargingCurrentLimit": "Battery Charging Current Limit",
  "bw_RTparam_name_BatteryCurrent": "Battery Current",
  "bw_RTparam_name_BatteryDischargeCurrentLimit": "Battery Discharge Current Limit",
  "bw_RTparam_name_BatteryDischargeCut-offVoltage": "Battery discharge cut-off Voltage",
  "bw_RTparam_name_BatteryMaxChargePower": "Battery Max Charge Power",
  "bw_RTparam_name_BatteryMaxDischargePower": "Battery Max Discharge Power",
  "bw_RTparam_name_BatteryMode": "Battery Mode",
  "bw_RTparam_name_BatteryModel": "Battery Model",
  "bw_RTparam_name_BatteryNum": "Battery Num",
  "bw_RTparam_name_BatteryPower": "Battery Power",
  "bw_RTparam_name_BatteryRelayStatus": "Battery Relay Status",
  "bw_RTparam_name_BatteryRunningTime": "Battery Running Time",
  "bw_RTparam_name_BatterySN": "Battery SN",
  "bw_RTparam_name_BatterySN1": "Battery1 SN",
  "bw_RTparam_name_BatterySN2": "Battery2 SN",
  "bw_RTparam_name_BatterySN3": "Battery3 SN",
  "bw_RTparam_name_BatterySN4": "Battery4 SN",
  "bw_RTparam_name_BatterySN5": "Battery5 SN",
  "bw_RTparam_name_BatterySN6": "Battery6 SN",
  "bw_RTparam_name_BatterySOC": "Battery SOC",
  "bw_RTparam_name_BatterySOH": "Battery SOH",
  "bw_RTparam_name_BatteryStatus": "Battery Status",
  "bw_RTparam_name_BatteryVersion": "Battery Version",
  "bw_RTparam_name_BatteryVoltage": "Battery Voltage",
  "bw_RTparam_name_BatWarnningPack": "Bat Warnning Pack",
  "bw_RTparam_name_BB_Version": "Backup Box Version Number",
  "bw_RTparam_name_buy": "Buy electricity",
  "bw_RTparam_name_charge": "The charge/discharge function is not enabled",
  "bw_RTparam_name_ChargeCutSoc": "Charge Cut Soc",
  "bw_RTparam_name_charging": "Allow charge and not allowed discharge",
  "bw_RTparam_name_CurrentOfAPhase_PV": "Current of A Phase(PV)",
  "bw_RTparam_name_CurrentOfBPhase_PV": "Current of B Phase(PV)",
  "bw_RTparam_name_CurrentOfCPhase_PV": "Current of C phase(PV)",
  "bw_RTparam_name_DailyDeviceEnergy": "Total Daily PV Generation",
  "bw_RTparam_name_DailyEnergyfromGrid": "Daily  Imported",
  "bw_RTparam_name_DailyEnergytoGrid": "Daily Exported",
  "bw_RTparam_name_DataloggerSN": "Datalogger SN",
  "bw_RTparam_name_DataloggerVersion": "Dongle Version",
  "bw_RTparam_name_DataUploadCycle": "Data UpLoad Cycle",
  "bw_RTparam_name_deviceRunningState": "Work Operate Status",
  "bw_RTparam_name_DongleRssi": "RSSI",
  "bw_RTparam_name_dontBuy": "Don't buy, don't sell",
  "bw_RTparam_name_electricity": "Electricity meters are used for power grids, and CT is used for photovoltaics",
  "bw_RTparam_name_forbidden": "Not allowed charge and allow discharge",
  "bw_RTparam_name_ForceChargingSOC": "Force Charging SOC",
  "bw_RTparam_name_forced": "Forced charging and discharging",
  "bw_RTparam_name_forcedCharge": "Forced charge and discharge",
  "bw_RTparam_name_forcedCharging": "Forced charging and prohibiting",
  "bw_RTparam_name_Frequent_PV": "Frequent(PV)",
  "bw_RTparam_name_Fullchargecapacityofbattery": "Full charge capacity of battery",
  "bw_RTparam_name_grid": "Grid and photovoltaic meters",
  "bw_RTparam_name_gridCT": "The grid uses CT, and the photovoltaic uses meters",
  "bw_RTparam_name_GridCurrentL1": "Grid CurrentL1",
  "bw_RTparam_name_GridCurrentL2": "Grid Current L2",
  "bw_RTparam_name_GridCurrentL3": "Grid Current L3",
  "bw_RTparam_name_GridFrequency": "Grid Frequency",
  "bw_RTparam_name_GridFrequencyINV": "Grid Frequency（Form INV）",
  "bw_RTparam_name_GridLoadPower": "Grid Load Power",
  "bw_RTparam_name_GridPowerL1": "Grid Active Power L1",
  "bw_RTparam_name_GridPowerL2": "Grid Active Power L2",
  "bw_RTparam_name_GridPowerL3": "Grid Active Power L3",
  "bw_RTparam_name_GridStatus": "Grid Status",
  "bw_RTparam_name_GridTotalActivePower": "Grid Total Active Power",
  "bw_RTparam_name_GridVoltageL1": "Grid VoltageL1",
  "bw_RTparam_name_GridVoltageL2": "Grid Voltage L2",
  "bw_RTparam_name_GridVoltageL3": "Grid Voltage L3",
  "bw_RTparam_name_InvActivePower": "Inv Active Power",
  "bw_RTparam_name_InvApparentPower": "Inv Apparent Power",
  "bw_RTparam_name_InvCurrentR": "Inv Current R",
  "bw_RTparam_name_InvCurrentS": "Inv Current S",
  "bw_RTparam_name_InvCurrentT": "Inv Current T",
  "bw_RTparam_name_InverterInternalOperatingAmbientTemperature": "Inverter Internal Operating Ambient Temperature",
  "bw_RTparam_name_InverterMasterSoftwareVersion": "Inverter master software version",
  "bw_RTparam_name_InvModuleTemperature": "Inv Module Temperature",
  "bw_RTparam_name_InvPowerFactor": "Inv Power Factor",
  "bw_RTparam_name_InvReactivePower": "Inv Reactive Power",
  "bw_RTparam_name_LANIP": "LAN IP",
  "bw_RTparam_name_Locationofthehighesttemperaturebatterycellinthesystem": "Location of the highest Temperature battery cell in the system",
  "bw_RTparam_name_Locationofthelowesttemperaturebatterycellinthesystem": "Location of the lowest Temperature battery cell in the system",
  "bw_RTparam_name_Mac": "Mac",
  "bw_RTparam_name_Maximumcellvoltage": "Max.cell Voltage",
  "bw_RTparam_name_Maximumtemperatureofbattery": "Max.high-Temperature",
  "bw_RTparam_name_Meter.CTSetting": "Meter/CT Setting",
  "bw_RTparam_name_MeterInstallationLocation": "Meter Installation Location",
  "bw_RTparam_name_MeterTypeandInstallationLocation": "Meter Type and Installation Location",
  "bw_RTparam_name_Minimumcellvoltage": "Min.cell Voltage",
  "bw_RTparam_name_Minimumtemperatureofbattery": "Max.low-Temperature",
  "bw_RTparam_name_noCharging": "No charging and no discharging",
  "bw_RTparam_name_offline": "Offline",
  "bw_RTparam_name_online": "online",
  "bw_RTparam_name_OverDischargeSOC": "Over Discharge SOC",
  "bw_RTparam_name_PackIDofMaxCellTemperature": "Pack ID of max cell Temperature",
  "bw_RTparam_name_PackIDofMaxCellVoltage": "Pack ID of max cell Voltage",
  "bw_RTparam_name_PackIDofMinCellTemperature": "Pack ID of min cell Temperature",
  "bw_RTparam_name_PackIDofMinCellVoltage": "Pack ID of min cell Voltage",
  "bw_RTparam_name_PFOA_Grid": "Power factor of A phase(Grid)",
  "bw_RTparam_name_PFOB_Grid": "Power factor of B phase(Grid)",
  "bw_RTparam_name_PFOC_Grid": "Power Factor of C phase(Grid)",
  "bw_RTparam_name_photovoltaics": "CT is used for power grids and photovoltaics",
  "bw_RTparam_name_Positionofthehighestvoltagecellinthesystem": "Position of the highest Voltage cell in the system",
  "bw_RTparam_name_Positionofthelowestvoltagebatterycellinthesystem": "Position of the lowest Voltage battery cell in the system",
  "bw_RTparam_name_Power-onTime": "Power-on Time",
  "bw_RTparam_name_PowerBoardTemperature": "Power Board Temperature",
  "bw_RTparam_name_PSSILevel": "PSSI Level",
  "bw_RTparam_name_PV1Current": "PV1 Current",
  "bw_RTparam_name_PV1Power": "PV1 Power",
  "bw_RTparam_name_PV1Voltage": "PV1 Voltage",
  "bw_RTparam_name_PV2Current": "PV2 Current",
  "bw_RTparam_name_PV2Power": "PV2 Power",
  "bw_RTparam_name_PV2Voltage": "PV2 Voltage",
  "bw_RTparam_name_PV3Current": "PV3 Current",
  "bw_RTparam_name_PV3Power": "PV3 Power",
  "bw_RTparam_name_PV3Voltage": "PV3 Voltage",
  "bw_RTparam_name_PvBoostTemperature": "Pv Boost Temperature",
  "bw_RTparam_name_PVConnectState": "Work Operate Status",
  "bw_RTparam_name_PVMeterNegate": "PV Meter Access Direction",
  "bw_RTparam_name_PV_ActivePowerOfAPhase": "Active Power of A Phase(PV)",
  "bw_RTparam_name_PV_ActivePowerOfBPhase": "Active Power of B Phase(PV)",
  "bw_RTparam_name_PV_ActivePowerOfCPhase": "Active Power of C Phase(PV)",
  "bw_RTparam_name_PV_ApparentPowerOfAPhase": "Apparent Power of A Phase(PV)",
  "bw_RTparam_name_PV_ApparentPowerOfBPhase": "Apparent Power of B Phase(PV)",
  "bw_RTparam_name_PV_ApparentPowerOfCPhase": "Apparent Power of C Phase(PV)",
  "bw_RTparam_name_PV_PowerFactorOfAPhase": "Power Factor of A Phase(PV)",
  "bw_RTparam_name_PV_PowerFactorOfBPhase": "Power Factor of B Phase(PV)",
  "bw_RTparam_name_PV_PowerFactorOfCPhase": "Power Factor of C Phase(PV)",
  "bw_RTparam_name_PV_ReactivePowerOfAPhase": "Reactive Power of A Phase(PV)",
  "bw_RTparam_name_PV_ReactivePowerOfBPhase": "Reactive Power of B Phase(PV)",
  "bw_RTparam_name_PV_ReactivePowerOfCPhase": "Reactive Power of C Phase(PV)",
  "bw_RTparam_name_ReactivePOAP_Grid": "ReActive Power of A phase(Grid)",
  "bw_RTparam_name_ReactivePOBP_Grid": "ReActive Power of B phase(Grid)",
  "bw_RTparam_name_ReactivePOCP_Grid": "ReActive Power of C phase(Grid)",
  "bw_RTparam_name_RSSI": "RSSI",
  "bw_RTparam_name_sell": "Sell electricity",
  "bw_RTparam_name_SSID": "SSID",
  "bw_RTparam_name_State": "State",
  "bw_RTparam_name_Systemmaximumtemperaturecellserialnumber": "System maximum Temperature cell serial number",
  "bw_RTparam_name_Systemmaximumvoltagecellserialnumber": "System maximum Voltage cell serial number",
  "bw_RTparam_name_Systemminimumtemperaturecellserialnumber": "System minimum Temperature cell serial number",
  "bw_RTparam_name_Systemminimumvoltagecellserialnumber": "System minimum Voltage cell serial number",
  "bw_RTparam_name_TheSystemTotalPVEnergy": "The System Total PV Energy（Include PV Meter Energy）",
  "bw_RTparam_name_TodayConsumption": "Today Consumption",
  "bw_RTparam_name_TodayGridLoadConsumption": "Today Grid Load Consumption",
  "bw_RTparam_name_TodayYield": "Inside INV Daily PV Generation",
  "bw_RTparam_name_TotalActivePower_PV": "Total Active Power(PV)",
  "bw_RTparam_name_TotalApparent Power_Grid": "Total Apparent Power(Grid)",
  "bw_RTparam_name_TotalApparentPower_PV": "Total Apparent Power(PV)",
  "bw_RTparam_name_TotalConsumption": "Battery Total Charge Energy",
  "bw_RTparam_name_TotalConsumptionEnergy": "Total Consumption Energy",
  "bw_RTparam_name_TotalConsumptionPower": "Total Consumption Power",
  "bw_RTparam_name_TotalDevicePower": "Total PV Power",
  "bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "Total energy consume from Grid(PV)",
  "bw_RTparam_name_TotalEnergyFeedToGrid_PV": "Total energy feed to grid(PV)",
  "bw_RTparam_name_TotalEnergyfromBattery": "Total Discharged Energy",
  "bw_RTparam_name_TotalEnergyfromGrid": "Total Imported",
  "bw_RTparam_name_TotalEnergyInvInput": "Total Energy Inv Input",
  "bw_RTparam_name_TotalEnergyInvOutput": "Total energy INV output",
  "bw_RTparam_name_TotalEnergytoGrid": "Total Exported",
  "bw_RTparam_name_TotalGridLoadConsumption": "Total Grid Load Consumption",
  "bw_RTparam_name_TotalOperationTime": "Total Operation Time",
  "bw_RTparam_name_TotalPower": "Total Power",
  "bw_RTparam_name_TotalPowerFactor_Grid": "Total Power Factor(Grid)",
  "bw_RTparam_name_TotalPowerFactor_PV": "Total Power Factor(PV)",
  "bw_RTparam_name_TotalPowerFactor_PV1": "Total Power Factor(PV)1",
  "bw_RTparam_name_TotalPVEnergy_includePVMeter": "Total PV Generation（Inside+outside INV）",
  "bw_RTparam_name_TotalReactivePower_Grid": "Total Reactive Power(Grid)",
  "bw_RTparam_name_TotalReactivePower_PV": "Total reActive Power(PV)",
  "bw_RTparam_name_TotalRuntime": "Total Runtime",
  "bw_RTparam_name_TotalYield": "Total Yield",
  "bw_RTparam_name_UPSReserveSoc": "EPS Reserve SOC",
  "bw_RTparam_name_vatBmsVersion": "BMS Version",
  "bw_RTparam_name_VoltageOfAPhase_PV": "Voltage of A phase(PV)",
  "bw_RTparam_name_VoltageOfBPhase_PV": "Voltage of B Phase(PV)",
  "bw_RTparam_name_VoltageOfCPhase_PV": "Voltage of C Phase(PV)",
  "bw_RTparam_name_WiFiType": "WiFi Type",
  "org.keyFilter": "Enter keyword to filter",
  "language.zoneTip": "This time is in the time zone of +8",
  "shipment.confirmDownload": "Download List",
  "shipment.updateCustomer": "Update Shipping Customer",
  "shipment.invalidEquipmentList": "Do you want to download the list of devices that failed validation? (Valid for 10 minutes) Number of invalid devices:",
  "shipment.fileExpired": "File Expired",
  "workorder.searchCreateTime": "Created Time",
  "workorder.statusAll": "All",
  "workorder.statusPending": "Pending",
  "workorder.statusCompleted": "Completed",
  "workorder.statusClosed": "Closed",
  "workorder.no": "Work Order No.",
  "workorder.tableDescription": "Description",
  "workorder.plant": "Plant",
  "workorder.device": "Device",
  "workorder.tableStatus": "Status",
  "workorder.owner": "Person in charge",
  "workorder.handler": "Handler",
  "workorder.handledTime": "Handled Time",
  "workorder.creator": "Creator",
  "workorder.createTime": "Created Time",
  "workorder.timeTooltip": "Time in the plant's timezone",
  "workorder.tableAction": "Operation",
  "workorder.actionDetails": "Details",
  "workorder.actionHandle": "Handle",
  "workorder.actionCancel": "Cancel",
  "workorder.createTitle": "Create Work Order",
  "workorder.description": "Fault Description",
  "workorder.images": "Fault Images",
  "workorder.handleTitle": "Handle Work Order",
  "workorder.group": "Handling Information",
  "workorder.feedback": "Handling Feedback",
  "workorder.handleimages": "Handling Images",
  "workorder.detailsTitle": "Work Order Details",
  "workorder.detailsGroup": "Work Order Information",
  "workorder.uploadSuccess": "Upload Successful",
  "workorder.uploadNums": "Maximum 3 images allowed",
  "workorder.uploadFormatTip": "Invalid file format. Please upload files in JPG, JPEG or PNG format",
  "workorder.uploadFormat": "Please upload files no larger than 5MB in PNG/JPG/JPEG format",
  "workorder.uploadImage": "Upload",
  "workorder.cancelTip": "Cancelling this work order will close it automatically. Continue?",
  "workorder.basicInformation": "Basic Information",
  "priceConfig.currentEffectivePrice": "Current effective tariff",
  "priceConfig.currencyUnitLabel": "Currency unit:",
  "priceConfig.addPrice": "Add tariff",
  "priceConfig.effectiveTimeLabel": "Effective time",
  "priceConfig.powerPrice": "Energy tariff",
  "priceConfig.additionalFees": "Additional fees",
  "priceConfig.lastUpdateTime": "Last updated",
  "priceConfig.lastUpdateTimeLabel": "Last updated",
  "priceConfig.emptyCurrent": "No effective tariff. Click the button to configure.",
  "priceConfig.emptyUpcoming": "No upcoming tariff",
  "priceConfig.upcomingTitle": "Upcoming tariff",
  "priceConfig.copyPriceTitle": "Copy tariff",
  "priceConfig.deletePriceTitle": "Delete tariff",
  "priceConfig.deleteConfirmText": "Please confirm deletion of the following tariff",
  "priceConfig.otherPrice": "Other fees",
  "priceConfig.deleteWarning": "If this tariff is currently effective, it will affect revenue calculation and AI strategy execution.",
  "priceConfig.priceTypeLabel": "Tariff type",
  "priceConfig.timeOfUse": "Time-of-use",
  "priceConfig.dynamic": "Dynamic",
  "priceConfig.timeOfUsePrice": "Time-of-use tariff",
  "priceConfig.dynamicPrice": "Dynamic tariff",
  "priceConfig.effectiveDatePlaceholder": "Please select an effective date",
  "priceConfig.copyEffectiveDatePlaceholder": "Please select an effective date",
  "priceConfig.nextStep": "Next",
  "priceConfig.buyPriceTitle": "Purchase tariff",
  "priceConfig.feedInPriceTitle": "Feed-in tariff",
  "priceConfig.addTimePeriod": "Add time period",
  "priceConfig.electricitySurchargeTitle": "Energy surcharge",
  "priceConfig.electricitySurchargeTooltip": "Additional fee charged per kWh purchased.",
  "priceConfig.fixedFeeTitle": "Fixed fee",
  "priceConfig.fixedFeeTooltip": "A fixed base charge per billing period that does not vary with consumption or demand.",
  "priceConfig.hasFeeYes": "Yes",
  "priceConfig.countryLabel": "Country",
  "priceConfig.secondaryRegionLabel": "Secondary region",
  "priceConfig.secondaryRegionPlaceholder": "Please select a secondary region",
  "priceConfig.currencyUnitPlaceholder": "Please select a currency unit",
  "priceConfig.powerMarketLabel": "Power market",
  "priceConfig.powerMarketPlaceholder": "Please select a power market",
  "priceConfig.electricitySurchargePlaceholder": "Max 7 integer digits, 8 decimal places, ≥ 0",
  "priceConfig.fixedFeePlaceholder": "Max 7 integer digits, 8 decimal places, ≥ 0",
  "priceConfig.priceInputPlaceholder": "Enter electricity price (max 7 integer digits, 8 decimal places, ≥ 0)",
  "priceConfig.timePlaceholder": "Select time",
  "priceConfig.selectEffectiveTimeTip": "Please select an effective time",
  "priceConfig.selectPriceTypeTip": "Please select a tariff type",
  "priceConfig.selectCountryTip": "Please select a country",
  "priceConfig.selectSecondaryRegionTip": "Please select a secondary region",
  "priceConfig.selectCurrencyUnitTip": "Please select a currency unit",
  "priceConfig.selectPowerMarketTip": "Please select a power market",
  "priceConfig.electricitySurchargeInputTip": "Please enter energy surcharge (max 7 integer digits, 8 decimal places, ≥ 0)",
  "priceConfig.electricitySurchargeRangeTip": "Energy surcharge must be at most 7 integer digits, 8 decimal places, and ≥ 0",
  "priceConfig.fixedFeeInputTip": "Please enter fixed fee (max 7 integer digits, 8 decimal places, ≥ 0)",
  "priceConfig.fixedFeeRangeTip": "Fixed fee must be at most 7 integer digits, 8 decimal places, and ≥ 0",
  "priceConfig.buyTimeFullDayTip": "Purchase tariff time periods must cover 24 hours",
  "priceConfig.feedInTimeFullDayTip": "Feed-in tariff time periods must cover 24 hours",
  "priceConfig.buyTimeNoOverlapTip": "Purchase tariff time periods cannot overlap",
  "priceConfig.feedInTimeNoOverlapTip": "Feed-in tariff time periods cannot overlap",
  "priceConfig.loadFail": "Failed to load tariff data",
  "priceConfig.copySelectPriceTip": "No tariff selected, cannot copy",
  "priceConfig.copyMissingPlantTip": "Missing plant information, cannot copy tariff",
  "priceConfig.copySuccess": "Copied successfully",
  "priceConfig.copyFail": "Copy failed",
  "priceConfig.networkTimeout": "Network timeout. Please try again after the network recovers.",
  "priceConfig.copyUnsupportedTip": "Copy is not supported for this tariff type",
  "priceConfig.deleteSelectPriceTip": "No tariff selected",
  "priceConfig.deleteIdMissingTip": "Failed to get tariff ID, deletion failed",
  "priceConfig.deleteSuccess": "Deleted successfully",
  "priceConfig.deleteFail": "Deletion failed",
  "priceConfig.missingPlantInfoTip": "Missing plant information",
  "priceConfig.confirmGiveUpCreateTip": "Are you sure you want to discard this tariff creation?",
  "priceConfig.pageTitleAdd": "Add tariff",
  "priceConfig.pageTitleEdit": "Edit tariff",
  "priceConfig.pageTitleView": "View tariff",
  "priceConfig.createSuccess": "Created successfully",
  "priceConfig.editSuccess": "Edited successfully",
  "priceConfig.saveFail": "Save failed",
  "priceConfig.dateRangePermanent": "{start} to permanent",
  "priceConfig.dateRange": "{start} to {end}",
  "priceConfig.routeTitle": "Electricity price",
  "priceConfig.priceLabel": "Price",
  "priceConfig.surchargeLabel": "Surcharge",
  "priceConfig.fixedFeeLabel": "Fixed fee",
  "button.copy": "Copy",
  "common.view": "View",
  "common.networkUnstable": "Network connection has been lost, please check your network settings",
  "common.networkFull": "The Internet is as full as the sun again",
  "common.networkSlow": "The current network is slow, please wait patiently or check the network settings",
  "common.requestTimeout": "Request timed out, please check the network or try again later",
  "screen.platform": "Energy Management Platform",
  "plantScreen.title": "Plant Management",
  "plantScreen.DailyElectricityGenerated": "Daily Electricity Generated",
  "plantScreen.DailyElectricityUsed": "Daily Electricity Used",
  "plantScreen.DailyElectricityPurchased": "Daily Electricity Purchased",
  "plantScreen.DailyElectricitySold": "Daily Electricity Sold",
  "plantScreen.ChargingStatus": "Charging Status",
  "plantScreen.BatteryLevel": "Battery Level",
  "plantScreen.PhotovoltaicStatus": "Photovoltaic Status",
  "plantScreen.GridStatus": "Grid Status",
  "plantScreen.Charging": "Charging",
  "plantScreen.Discharging": "Discharging",
  "plantScreen.Generating": "Generating",
  "plantScreen.Idle": "Idle",
  "plantScreen.pvIDLE": "Not Generating",
  "plantScreen.BuyingElectricity": "Buying Electricity",
  "plantScreen.SellingElectricity": "Selling Electricity",
  "plantScreen.netdead": "Off-grid",
  "plantScreen.day": "Day",
  "plantScreen.month": "Month",
  "plantScreen.year": "Year",
  "plantScreen.life": "Lifetime",
  "plantScreen.BatterySOC": "Battery SOC",
  "plantScreen.PowerAnalysis": "Power Analysis",
  "plantScreen.EquivalentRevenue": "Equivalent Revenue",
  "plantScreen.EnergyAnalysis": "Energy Analysis",
  "plantScreen.SocialContribution": "Social Contribution",
  "plantScreen.Photovoltaic": "Photovoltaic",
  "plantScreen.Grid": "Grid",
  "plantScreen.Battery": "Battery",
  "plantScreen.Load": "Load",
  "plantScreen.Daily": "Daily",
  "plantScreen.Monthly": "Monthly",
  "plantScreen.Yearly": "Yearly",
  "plantScreen.Cumulative": "Cumulative",
  "plantScreen.Unit": "Unit",
  "plantScreen.ElectricityGeneration": "Electricity Generation",
  "plantScreen.ElectricityConsumption": "Electricity Consumption",
  "plantScreen.ChartSet.explain": "Note: Power > 0 = Discharging; Power < 0 = Charging.",
  "plantScreen.ChartSet.Self-consumption": "Self-consumption",
  "plantScreen.ChartSet.GridElectricity": "Grid Feed-in",
  "plantScreen.ChartSet.Self-Sufficiency": "Self-sufficiency",
  "plantScreen.ChartSet.PurchasedElectricity": "Purchased Electricity",
  "plantScreen.ChartSet.PVPower": "PV Power",
  "plantScreen.ChartSet.ConsumptionPower": "Consumption Power",
  "plantScreen.ChartSet.BatterySOC": "Battery SOC",
  "plantScreen.ChartSet.BatteryChargingPower": "Battery Charging Power",
  "plantScreen.ChartSet.BatteryDischargingPower": "Battery Discharging Power",
  "plantScreen.ProtectedForest": "Protected Forest",
  "plantScreen.CO2Emission": "CO2 Emission",
  "plantScreen.Media": "Media",
  "plantScreen.coal": "Coal",
  "plant.EquivalentBenefit.GridView": "Equivalent Benefit = Self-consumption * Buy Rate + Grid Feed-in * Sell Rate",
  "plant.MonitoringScreen": "Monitoring Screen",
  "plantScreen.ChartSet.explainPower": "Note: Grid Power > 0 = Selling Electricity; Grid Power < 0 = Buying Electricity.",
  "device.operatingDataInfoTip": "Note: If this field is empty, please contact the IoT platform administrator for configuration.",
  "alarmInfo.time": "Alarm Time",
  "alarmInfo.duration": "Alarm duration",
  "alarmInfo.level": "Alert Level",
  "alarmInfo.triggerCondition": "trigger condition",
  "alarmInfo.reason": "Alarm reason",
  "alarmInfo.exceptionDesc": "Exception Description",
  "alarmInfo.suggestion": "Handling Suggestion",
  "alarmInfo.handleTime": "processing time",
  "alarmInfo.handleType": "Processing Type",
  "device.realTimeMonitoring": "Real-time Monitoring",
  "device.propertyName": "property name",
  "device.issueCommand": "issue",
  "device.history": "history",
  "device.properName": "name",
  "device.daterange": "customize",
  "device.near24h": "Near 24:00",
  "device.date": "today",
  "device.near3d": "last 3 days",
  "device.chartModule": "Chart Module",
  "device.lineChart": "curve graph",
  "device.barChart": "bar chart",
  "device.dateRangeDayError": "The date range should be within {scope} days",
  "device.SOCHistoryData": "historical data",
  "device.paramSave": "Parameter distribution",
  "common.deleteTip": "Are you sure you want to delete this {scope}?",
  "plant.plantCategory": "Power station type",
  "plant.plantCode": "Power station code",
  "plant.energyStorageCapacity": "energy storage capacity",
  "plant.energyStoragePower": "energy storage power",
  "plant.gridConnectionMode": "Internet access method",
  "plant.img": "Power station pictures",
  "upgrade.upgradeSN": "Upgrade SN",
  "upgrade.devicesSN": "Device SN",
  "upgrade.datalogSN": "Data log SN",
  "upgrade.upgradeType": "Upgrade Type",
  "upgrade.fileAddress": "file path",
  "upgrade.plantTime": "Power station time",
  "upgrade.timeUTC8": "Time (UTC+8)",
  "upgrade.timeServer": "Time (server)",
  "upgrade.content": "content",
  "upgrade.account": "account",
  "firmware.secretType": "Secret Type",
  "plant.electrovalence": "Tariff Configuration",
  "plant.energy_management": "Energy Management",
  "plant.energy_todayStrategy": "Today's Strategy",
  "plant.energy_PeakShavingAndValleyFilling": "Peak Shaving & Valley Filling",
  "plant.energy_ValidTime": "Valid Time",
  "plant.energy_Charging": "Charging",
  "plant.energy_Discharging": "Discharging",
  "plant.energy_SelectStartTime": "Select Start Time",
  "plant.energy_StrategyName": "Strategy Name",
  "plant.energy_StrategyType": "Strategy Type",
  "plant.energy_Status": "Status",
  "plant.energy_No": "No.",
  "plant.energy_StartDate": "Start Date",
  "plant.energy_EndDate": "End Date",
  "plant.energy_AddStrategy": "Add Strategy",
  "plant.energy_EffectiveTime": "Effective Time",
  "plant.energy_SelectStrategy": "Select Strategy",
  "plant.energy_SelectCorrespondingStrategy": "Select Corresponding Strategy",
  "plant.energy_ConfirmAndDeploy": "Confirm & Deploy",
  "plant.energy_PleaseConfirmSaveAndDeployTheStrategy": "Please confirm, save, and deploy the strategy.",
  "plant.energy_Cancel": "Cancel",
  "plant.energy_PleaseConfirmStrategyDeletion": "Please confirm strategy deletion.",
  "plant.energy_IfNoOtherStrategyExistsExecuteManualStrategy": "If no other strategy exists, execute manual strategy.",
  "plant.energy_PriorityChargingTime": "Priority Charging Time",
  "plant.energy_PriorityDischargingTime": "Priority Discharging Time",
  "plant.energy_PVConsumptionPeriod": "PV Consumption Period",
  "plant.energy_StartTime": "Start Time",
  "plant.energy_EndTime": "End Time",
  "plant.energy_ChargingPower": "Charging Power",
  "plant.energy_DischargingPower": "Discharging Power",
  "plant.energy_SOCUpperLimit": "SOC Upper Limit",
  "plant.energy_SOCLowerLimit": "SOC Lower Limit",
  "plant.energy_Action": "Action",
  "plant.energy_AddTimePeriod": "Add Time Period",
  "plant.energy_ChargingStatus": "Charging Status",
  "plant.energy_DischargingPower_kW": "Discharging Power (kW)",
  "plant.energy_copyStrategy": "Copy Strategy",
  "plant.energy_examine": "View",
  "plant.energy_delete": "Delete",
  "plant.energy_edit": "Edit",
  "plant.energy_basicInfo": "Basic Information",
  "common.ConfirmDeploy": "Confirm & Deploy",
  "plant.energy_PriorityChargingDischargingTime": "Priority Charging & Discharging Time",
  "plant.energy_PeakShavingAtLeastOne": "Keep at least one entry.",
  "common.formInvalid": "Required field(s) missing.",
  "plant.energy_overlapTime": "Do not overlap time periods.",
  "plant.energy_cover24hour": "Time periods must cover 24 hours.",
  "plant.energy_PleaseConfirmStrategyModification": "Please confirm the strategy modification.",
  "plant.energy_Strategy": "Strategy",
  "plant.energy_cutOff_SOC": "Stop SOC",
  "plant.energy_CopyStrategy": "Copy Strategy",
  "plant.energy_EditStrategy": "Edit Strategy",
  "plant.energy_ExamineStrategy": "View Strategy",
  "plant.energy_photovoltaic_storage_peak_valley_explain1": "1) Priority Charging Period: Charges the battery using surplus PV power and (off-peak) grid electricity to ensure the SOC reaches the set value; the battery does not discharge.",
  "plant.energy_photovoltaic_storage_peak_valley_explain2": "2) Priority Discharging Period: Surplus PV charges the battery. When PV is insufficient, the battery discharges first, down to the set SOC limit; grid supply is secondary.",
  "plant.energy_photovoltaic_storage_peak_valley_explain3": "3) PV Consumption Period: PV power is prioritized for load use, then for battery charging (up to SOC upper limit), and finally, surplus is curtailed or fed into the grid. When PV is insufficient, the battery discharges first (down to SOC lower limit), followed by grid supply.",
  "plant.energy_photovoltaic_storage_peak_valley_explain4": "4) Other Periods: PV power is prioritized for load use, then for battery charging (up to SOC upper limit), and finally, surplus is curtailed or fed into the grid. The battery does not discharge.",
  "plant.energy_peak_shaving_valley_filling_explain": "A strategy that schedules battery charging/discharging to shave peak load and fill valley demand, achieving balanced resource utilization.",
  "plant.energy_photovoltaic_consumption_self_consumption_explain": "PV power is prioritized for load use, then for battery consumption, and finally, PV output is curtailed to ensure no backfeed. When PV is insufficient, the battery discharges first, followed by grid supply.",
  "plant.energy_photovoltaic_consumptionsurplus_power_grid_feed_in_explain": "PV power is prioritized for load use, then for battery consumption, and finally, surplus is fed into the grid. When PV is insufficient, the battery discharges first, followed by grid supply.",
  "plant.energy_smart_strategy_station_profit_priority_explain": "Integrates multi-dimensional objectives such as time-of-use tariffs, PV consumption, peak-valley arbitrage, PV and load forecasting, and demand management. Under the premise of ensuring stable microgrid operation, an AI robot intelligently computes and solves the optimal scheduling for energy storage and adjustable loads, thereby maximizing the overall site revenue.",
  "plant.energy_manual_mode_explain": "Currently, there is no dispatch strategy for PV and energy storage. Please go to the device page for manual operation.",
  "plant.energy_SOCUpperLowerLimits": "SOC Upper & Lower Limits",
  "plant.energy_ChargeDischargePower": "Charge & Discharge Power",
  "plant.energy_ChargeDischargeStatus": "Charge & Discharge Status",
  "plant.stationTopology": "Station Topology",
  "plant.topologyConfig": "Topology Configuration",
  "plant.projectName": "Project Name",
  "plant.topologyUrl": "Topology URL",
  "plant.topologyMap": "Topology Map",
  "plant.topologyPlaceholder": "Please enter the topology URL",
  "plant.addScopeSuccess": "{scope} added successfully",
  "plant.updateScopeSuccess": "{scope} edited successfully",
  "plant.topologyUrlFormatError": "Topology URL format error",
  "cookie.necessary": "Strictly Necessary Cookies",
  "cookie.performance": "Performance Cookies",
  "cookie.functional": "Functional Cookies",
  "cookie.targeting": "Targeting Cookies",
  "cookie.necessaryExplain": "These cookies are strictly necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in, or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site may not work then. These cookies do not store any personally identifiable information.",
  "cookie.performanceExplain": "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.",
  "cookie.functionalExplain": "These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies, then some or all of these services may not function properly.",
  "cookie.targetingExplain": "These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.",
  "cookie.necessaryAccount": "ID Verification",
  "cookie.necessaryAccountExplain": "Used to maintain user login status, it is a core function of website authentication and session management. Without this cookie, user accounts may not display correctly on visited pages.",
  "cookie.sessionManagement": "Session Management",
  "cookie.sessionManagementExplain": "Used to uniquely identify user sessions, maintaining key functions such as user login status, shopping cart contents, and form data.",
  "cookie.userInfo": "User Information",
  "cookie.userInfoExplain": "Used to track business metrics such as page views (PV) and unique visitors (UV), analyze system traffic and user engagement, to optimize feature prioritization and alignment with core needs.",
  "cookie.deviceInfo": "Device Information",
  "cookie.deviceInfoExplain": "Based on different operating systems, device models, and browser types, it resolves layout and compatibility issues across terminals, optimizing adaptation functions for different devices.",
  "cookie.pageInfo": "Page Information",
  "cookie.pageInfoExplain": "Records page access paths, API requests, and resource loading times to identify performance bottlenecks, request failures, and code errors, assisting the development team in quickly resolving issues.",
  "cookie.networkInfo": "Network Information",
  "cookie.networkInfoExplain": "Analyzes geographic location and Internet Service Provider (ISP) networks to identify malicious access and abnormal traffic, optimizing content delivery efficiency for cloud service providers.",
  "cookie.userPreference": "Interface Preferences",
  "cookie.userPreferenceExplain": "Used only to record user interface preferences to enhance user experience, it is not a core function required for website operation.",
  "cookie.longTerm": "Long-term",
  "cookie.duration180": "180 days",
  "cookie.durationSession": "Session",
  "cookie.bannerExplain": "To optimize your browsing experience, we use cookies primarily to record login status, remember your preferences, and adapt to your browsing habits. Clicking 'Accept All' signifies your agreement to our Cookie Policy.",
  "cookie.acceptNecessary": "Necessary Only",
  "cookie.openPreferences": "Preference Settings",
  "cookie.acceptAll": "Accept All",
  "cookie.cookieSet": "Cookie Settings",
  "cookie.cookieSetExplain": "For more information, see",
  "cookie.cookiePolicy": "Cookie Policy",
  "cookie.cookieCategory": "Cookie Category",
  "cookie.cookieName": "Cookie Name",
  "cookie.cookieDescription": "Purpose",
  "cookie.cookieDuration": "Validity Period",
  "cookie.cookieSwitch": "Toggle",
  "cookie.savePreferences": "Save Preferences",
  "cookie.preferencesTitle": "Cookie Preferences",
  "cookie.cookiePolicyText": "Cookie Policy",
  "plant.settlementMeter": "Settlement Meter",
  "plant.settlementSuccess": "{scope} adjustment successful",
  "plant.energyBalanceTip": "Self-Consumption\nAmount of PV energy the consumed by loads and charged into ESS. \nGrid Exported Energy\nAmount of energy fed to the power grid from the PV plant in a given statistical period.\nSelf-Sufficiency\nAmount of energy consumed from PV, including the surplus PV energy stored in the ESS.\nGrid Imported Energy\nAmount of energy statistical period. consumed from the grid in a given",
  "common.currentVersion": "Current Version",
  "common.versionUpdateNotice": "Version Update Notice",
  "common.later": "Later",
  "common.immediateUpdate": "Immediate Update",
  "priceConfig.confirmGiveUpEditTip": "Are you sure you want to discard this tariff edit",
  "device.defaultParams": "Default Parameters",
  "device.nonIOTDeviceTip": "Non-IOT device, please check",
  "device.advancedFeatures": "Advanced Features",
  "device.toSettings": "To Settings",
  "device.dryNodeSettings": "Dry Node Settings",
  "device.dryNodeSettingsTip": "The dry node of the inverter can be set to multiple functions.",
  "device.workModeSettingsTip": "Configure the working mode and parameters of the device.",
  "system.physicalModels": "Thing Model Management",
  "subtitle.physicalModelsDetail": "Thing Model Details",
  "physicalModels.minItemsTip": "At least {scope} item(s) must be retained",
  "physicalModels.maxItemsTip": "A maximum of {scope} item(s) is allowed",
  "physicalModels.Empty": "{scope} cannot be empty",
  "physicalModels.conflictTip": "Conflict period: {scope}",
  "physicalModels.name": "Configuration Name",
  "physicalModels.jsonCorrect": "JSON format is correct",
  "physicalModels.jsonCorrectTip": "JSON format is correct (validation service not connected)",
  "physicalModels.jsonInCorrect": "JSON format is incorrect",
  "physicalModels.jsonComplete": "JSON Completion",
  "physicalModels.jsonCompleteTip": "If the JSON has been saved, re-completion may cause production issues. Please proceed with caution.",
  "physicalModels.actualDataData": "Actual Delivered Data",
  "physicalModels.deleteFailed": "Deletion failed",
  "physicalModels.loadPreviewFailed": "Failed to load preview configuration",
  "physicalModels.configEditor": "Configuration Editor",
  "physicalModels.selectTemplate": "Select Preset Template",
  "physicalModels.jsonConfig": "JSON Configuration",
  "physicalModels.realTimePreview": "Real-time Preview",
  "physicalModels.checkJsonFormat": "Please check if the JSON format is correct",
  "physicalModels.readDataStructure": "Read Data Structure",
  "physicalModels.userBehaviorData": "User Behavior Raw Data",
  "physicalModels.ready": "Ready",
  "physicalModels.previewConfigLoaded": "Preview Configuration Loaded",
  "physicalModels.pasteFromClipboard": "Pasted from Clipboard",
  "physicalModels.pasteFromClipboardTip": "Please append the device SN after the browser path, for example:",
  "physicalModels.error": "Error",
  "physicalModels.missingIoTIdTip": "Missing IoTId or virtualId, please check",
  "physicalModels.slotId": "Ad Identifier",
  "physicalModels.moduleDisplay": "Module Display Config",
  "physicalModels.moduleLable": "Module Label",
  "physicalModels.display": "Display Status",
  "physicalModels.createIndex": "Create Index",
  "plant.deviceCount": "Number of Installed Devices",
  "common.rangeErrorTip": "{scope} range error, please confirm",
  "sidebar.policyConfig": "Policy Configuration",
  "common.addScope": "Add {scope}",
  "editor.header.title": "Title",
  "editor.header.text": "Text",
  "editor.fontSize.title": "Font Size",
  "editor.fontSize.default": "Default Size",
  "editor.fontFamily.title": "Font Family",
  "editor.fontFamily.default": "Default Font",
  "editor.bold": "Bold",
  "editor.italic": "Italic",
  "editor.underline": "Underline",
  "editor.through": "Strikethrough",
  "editor.code": "Inline Code",
  "editor.sub": "Subscript",
  "editor.sup": "Superscript",
  "editor.clearStyle": "Clear Format",
  "editor.color.color": "Text Color",
  "editor.color.bgColor": "Background Color",
  "editor.color.default": "Default Color",
  "editor.color.clear": "Clear Color",
  "editor.bulletedList": "Bulleted List",
  "editor.numberedList": "Numbered List",
  "editor.todo": "Todo List",
  "editor.todo.title": "Todo",
  "editor.emotion.title": "Emoji",
  "editor.justifyLeft": "Align Left",
  "editor.justifyRight": "Align Right",
  "editor.justifyCenter": "Align Center",
  "editor.justifyJustify": "Justify",
  "editor.indent": "Increase Indent",
  "editor.delIndent": "Decrease Indent",
  "editor.indent.increase": "Increase Indent",
  "editor.indent.decrease": "Decrease Indent",
  "editor.lineHeight.title": "Line Height",
  "editor.lineHeight.default": "Default Height",
  "editor.blockquote": "Quote",
  "editor.link.insert": "Insert Link",
  "editor.link.text": "Link Text",
  "editor.link.url": "Link URL",
  "editor.link.unLink": "Unlink",
  "editor.link.edit": "Edit Link",
  "editor.link.view": "View Link",
  "editor.image.netImage": "Network Image",
  "editor.image.delete": "Delete Image",
  "editor.image.edit": "Edit Image",
  "editor.image.viewLink": "View Link",
  "editor.image.src": "Image URL",
  "editor.image.desc": "Image Description",
  "editor.image.link": "Image Link",
  "editor.video.insert": "Insert Video",
  "editor.video.delete": "Delete Video",
  "editor.video.uploadVideo": "Upload Video",
  "editor.video.insertVideo": "Insert Video",
  "editor.video.videoSrc": "Video URL",
  "editor.video.videoSrcPlaceHolder": "Please enter video URL",
  "editor.video.videoPoster": "Video Poster",
  "editor.video.videoPosterPlaceHolder": "Please enter video poster URL",
  "editor.video.ok": "OK",
  "editor.video.editSize": "Edit Size",
  "editor.video.width": "Width",
  "editor.video.height": "Height",
  "editor.table.header": "Table",
  "editor.table.insertTable": "Insert Table",
  "editor.table.deleteTable": "Delete Table",
  "editor.table.insertRow": "Insert Row",
  "editor.table.deleteRow": "Delete Row",
  "editor.table.insertCol": "Insert Column",
  "editor.table.deleteCol": "Delete Column",
  "editor.table.widthAuto": "Auto Width",
  "editor.table.widthFixed": "Fixed Width",
  "editor.codeBlock.title": "Code Block",
  "editor.divider": "Divider",
  "editor.emotion": "Emoji",
  "editor.insertFormula": "Insert Formula",
  "editor.fullScreen": "Full Screen",
  "editor.undo": "Undo",
  "editor.redo": "Redo",
  "editor.delete": "Delete",
  "editor.enter": "Enter",
  "editor.ok": "OK",
  "editor.cancel": "Cancel",
  "editor.uploadImgMaxSize": "Max image size",
  "editor.uploadImgMaxSizeErr": "Image size exceeds limit",
  "editor.uploadImgMaxLength": "Max upload",
  "editor.uploadImgMaxLengthErr": "Image count exceeds limit",
  "editor.uploadVideoMaxSize": "Max video size",
  "editor.uploadVideoMaxSizeErr": "Video size exceeds limit",
  "editor.placeholder": "Please enter content...",
  "UserHome.plantFlow.load": "Load",
  "UserHome.plantFlow.grid": "Grid",
  "UserHome.plantFlow.battery": "Battery",
  "UserHome.plantFlow.pv": "PV",
  "ota.don.upgrade": "Dongle Upgrade",
  "device.ota.tip.newversion": "The current version is the latest and does not require any updates.",
  "device.button.cancle": "Back",
  "common.title": "Column Display Settings",
  "common.fixedLeft": "Fixed on the left",
  "common.fixedRight": "Fixed on the right",
  "common.notFixed": "Not Fixed",
  "common.unfix": "Unfix",
  "common.resetSuccess": "Column settings reset successfully",
  "plantScreen.singleSiteScree.PVPower": "PV Power",
  "plantScreen.singleSiteScree.LoadPower": "Load Power",
  "plantScreen.singleSiteScree.SelfConsumptionRate": "Self-consumption Rate",
  "plantScreen.ChartSet.GenerationPower": "Generation Power",
  "plantScreen.ChartSet.DayAheadForecast": "Day-ahead Forecast",
  "plantScreen.ChartSet.RealTimeForecast": "Real-time Forecast",
  "plantScreen.ChartSet.DayAheadScheduling": "Day-ahead Scheduling",
  "plantScreen.ChartSet.RealTimeScheduling": "Real-time Scheduling",
  "plantScreen.PlantInfo": "Plant Information",
  "plantScreen.PhotovoltaicCapacity": "PV Installed Capacity",
  "plantScreen.StorageCapacity": "Battery Capacity",
  "plantScreen.EnergyDispatch": "Energy Scheduling",
  "plantScreen.SelfGenerationRate": "Self-generation Rate",
  "plantScreen.DailyStorageCharging": "Daily Charged Energy",
  "plantScreen.DailyStorageDischarging": "Daily Discharged Energy",
  "plantScreen.DailyElectricitySold2": "Daily Electricity Sold",
  "plantScreen.ChartSet.Storage": "Energy Storage",
  "plantScreen.ChartSet.Solar": "PV",
  "plantScreen.ChartSet.Load": "Load",
  "plantScreen.singleSiteScree.GridImportPower": "Grid Import Power",
  "plantScreen.singleSiteScree.GridExportPower": "Grid Export Power",
  "plantScreen.singleSiteScree.ChargingPower": "Charging Power",
  "plantScreen.singleSiteScree.DischargingPower": "Discharging Power",
  "plantScreen.ChartSet.ChargeDischargePower": "Charge/Discharge Power",
  "device.systemTime": "System Time",
  "device.traceId": "Trace ID",
  "device.collectorSn": "Collector SN",
  "device.functionCode": "Function Code",
  "device.encryptedStr": "Encrypted Message",
  "device.decryptedStr": "Decrypted Message",
  "device.dateRangeErrorScope": "The date range should be within {scope} days",
  "common.noMore": "No more",
  "solid.snake.test": "E+",
  "plant.e-station": "Zero Carbon E-Station",
  "ADD": "Add",
  "DELETE": "Delete",
  "EDIT": "Edit",
  "netherland.area": "Netherland",
  "cc": "w",
  "country.austria": "Austria",
  "county.france": "france",
  "test.code.update": "test.code.update",
  "epex.country.unit.netherland": "Netherlands",
  "epex.income.unit": "EUR",
  "plant.running.status.alarm": "Alarm",
  "nl.second.code": "NL",
  "50901.ctrl_xitongjichupeizhi.grid_param.tag": "param",
  "50901.ctrl_xitongjichupeizhi.inventor_param.tag": "param",
  "50901.ctrl_dianchiguanli.battery_param.tag": "param",
  "unit.norway": "Norway",
  "country.norway": "norwayAreas",
  "nether.areas": "NL",
  "nether.areas2": "NL2",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.time_param.tag": "param",
  "60420.real_time.device_param.tag": "param",
  "60420.real_time.device_status.tag": "status",
  "60420.real_time.pv_param.tag": "param",
  "60420.real_time.hardware_param.tag": "param",
  "60420.real_time.scan_param.tag": "param",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.frequency_param.tag": "param",
  "60420.real_time.basic_info.tag": "info",
  "60420.real_time.alarm_param.tag": "param",
  "60420.real_time.system_param.tag": "param",
  "60420.real_time.debug_param.tag": "param",
  "60420.real_time.time_param.tag": "param",
  "60420.ctrl_param_guoqianya_pinshezhi.time_param.tag": "param",
  "60420.real_time.temperature_param.tag": "param",
  "60420.real_time.energy_param.tag": "param",
  "60420.ctrl_param_shebeixinxishezhi.control_param.tag": "param",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.voltage_param.tag": "param",
  "60420.ctrl_param_guoqianya_pinshezhi.frequency_param.tag": "param",
  "60420.ctrl_param_shebeixinxishezhi.slope_param.tag": "param",
  "60420.real_time.control_param.tag": "param",
  "60420.ctrl_param_shebeixinxishezhi.power_param.tag": "param",
  "60420.ctrl_param_guoqianya_pinshezhi.voltage_param.tag": "param",
  "60420.real_time.power_param.tag": "param",
  "60420.real_time.electrical_param.tag": "param",
  "tag_test": "English",
  "tag_test_1": "anglais1",
  "UPDATE": "update",
  "end.web": "web",
  "50901.real_time.analysis_inverter_temperature.tag": "inverter_temperature",
  "50901.real_time.analysis_energy_flow_cumulative.tag": "energy_flow_cumulative",
  "50901.real_time.analysis_meter_pv_electrical.tag": "meter_pv_electrical",
  "50901.real_time.analysis_meter_pv_power.tag": "meter_pv_power",
  "50901.real_time.analysis_grid_electrical.tag": "grid_electrical",
  "50901.real_time.analysis_pv_electrical.tag": "pv_electrical",
  "50901.real_time.analysis_battery_electrical.tag": "battery_electrical",
  "50901.real_time.analysis_generator_power.tag": "generator_power",
  "50901.real_time.analysis_load_power.tag": "load_power",
  "50901.real_time.analysis_meter_ac_power_quality.tag": "meter_ac_power_quality",
  "50901.real_time.analysis_grid_power_quality.tag": "grid_power_quality",
  "50901.real_time.analysis_grid_temperature.tag": "grid_temperature",
  "50901.real_time.analysis_pv_power.tag": "pv_power",
  "50901.real_time.analysis_battery_cell_status.tag": "battery_cell_status",
  "50901.real_time.analysis_battery_power.tag": "battery power",
  "50901.real_time.analysis_pv_temperature.tag": "pv_temperature",
  "50901.real_time.analysis_energy_daily.tag": "energy_daily",
  "50901.real_time.analysis_grid_power.tag": "grid_power",
  "50901.real_time.analysis_inverter_ac_output.tag": "inverter_ac_output",
  "50901.real_time.analysis_energy_flow_daily.tag": "energy_flow_daily",
  "50901.real_time.analysis_internal_voltage.tag": "internal_voltage",
  "50901.real_time.analysis_energy_cumulative.tag": "energy_cumulative",
  "50901.real_time.analysis_eps_power.tag": "eps_power",
  "50901.real_time.analysis_ambient_temperature.tag": "ambient_temperature",
  "50901.real_time.analysis_fan_speed.tag": "fan_speed",
  "50901.real_time.analysis_comm_status.tag": "comm_status",
  "50901.real_time.analysis_battery_status.tag": "battery_status",
  "50901.real_time.analysis_generator_electrical.tag": "generator_electrical",
  "50901.real_time.analysis_eps_electrical.tag": "eps_electrical",
  "50901.real_time.analysis_meter_ac_electrical.tag": "meter_ac_electrical",
  "50901.real_time.analysis_power_flow.tag": "power_flow",
  "50901.real_time.analysis_meter_ac_power.tag": "meter_ac_power",
  "grid.connection.mode.selfUseNoGrid": "self_use_no_grid",
  "grid.connection.mode.surplusPowerGrid": "SURPLUS_POWER_GRID",
  "grid.connection.mode.fullPowerGrid": "FULL_POWER_GRID",
  "grid.connection.mode.offGridOnly": "OFF_GRID_ONLY",
  "grid.connection.mode.other": "OTHER",
  "plant.category.house.hold": "Household",
  "plant.category.industry.commerce": "Industry and Commerce",
  "test.label_G_P_C_L2": "Gen L2 Power",
  "connect.type.other": "other",
  "device.offline": "Device offline",
  "solid.snake.msf.test": "solid",
  "bigboss.shaed.test": "shaed test",
  "ywt.60419.AllowCounterCurrentPower": "Allow reverse power flow",
  "ywt.60419.internalharderror0": "No abnormalities",
  "ywt.60419.loadDropMode": "Derating mode",
  "ywt.60419.loadDropMode11": "Single machine anti-backflow derating",
  "ywt.60419.meterCommQuality": "Electric meter communication quality",
  "ywt.60419.meterRPower": "R-phase power of the electric meter",
  "ywt.60419.meterSelect": "Electric meter selection",
  "ywt.60419.meterSPower": "S-phase power of the electric meter",
  "ywt.60419.meterTPower": "T-phase power of the electric meter",
  "ywt.60419.multiReverseFlowEnable": "Enable anti-reverse flow for multiple devices",
  "ywt.60419.restrictCounterCurrent": "Reverse power flow limitation method",
  "ywt.60419.singleReverseFlowEnable": "Enable anti-reverse flow for single device",
  "bw_param_ctrl_group_ParallelSetting": "Parallel Settings",
  "bw_param_ctrl_group_SpecialSetting": "Special Settings",
  "bw_param_ctrl_name_PhaseOrderResume": "Phase Order Resume",
  "bw_param_ctrl_note_ParallelModeSetting": "To set if the inverter is a master unit or slave unit in parallel operation.",
  "bw_param_ctrl_option_host": "Master in Parallel Mode",
  "bw_param_ctrl_option_PhaseOrderResume": "Reset",
  "bw_param_ctrl_option_single": "Not Parallel Mode (Single Mode)",
  "bw_param_ctrl_option_Slave": "Slave in Parallel Mode",
  "ice.robot.strategy.type.pea.sha.val.fil": "Peak Shaving and Valley Filling",
  "ice.robot.strategy.type.pho.con": "Photovoltaic consumption",
  "ice.robot.strategy.type.self.use": "Self Use",
  "ice.robot.strategy.type.sur.ele.on.grid": "Surplus Electricity On-Grid",
  "ice.robot.strategy.type.grid.priority": "Grid Priority",
  "ice.robot.strategy.type.int.str": "Intelligent Strategy",
  "ice.robot.strategy.type.manual.strategy": "Manual Strategy",
  "charge.discharge.state.charge": "charge",
  "charge.discharge.state.discharge": "discharge",
  "ice.rob.stra.det.typ.pea.sha.val.fil": "Peak Shaving and Valley Filling",
  "ice.rob.stra.det.typ.pea.cha.pri": "Charging Priority",
  "ice.rob.stra.det.typ.pea.discha.pri": "Discharging Priority",
  "ice.rob.stra.det.typ.pho.con": "Photovoltaic consumption",
  "ice.rob.stra.det.typ.discha.pri": "Discharging Priority",
  "ice.rob.stra.det.typ.cha.pri": "Charging Priority",
  "ice.rob.stra.execute.state.executing": "Executing",
  "ice.rob.stra.execute.state.executed": "Executed",
  "0X3809-F-0607": "PV Terminal Overtemperature Protection Fault",
  "0X3809-F-1103": "Relay Self-Test Anomaly",
  "0X3809-F-3112": "Grid Voltage Phase-Locking Fault",
  "0X3809-F-3113": "Grid Phase Sequence Anomaly",
  "0X3809-S-0101": "1. Check if the PV module connections are normal, and whether there is any damage, surface dust, or shading on the modules.\n2. Check if the PV modules are properly connected and if their voltage specifications are above the inverter's operating voltage range.\n3. Check if there is any short circuit in the PV modules.",
  "0X3809-S-0102": "1. Check if the PV module connections are normal, and whether there is any damage, surface dust, or shading on the modules.\n2. Check if the PV modules are properly connected and if their voltage specifications are above the inverter's operating voltage range.\n3. Check if there is any short circuit in the PV modules.",
  "0X3809-S-0103": "1. Check if the PV module connections are normal, and whether there is any damage, surface dust, or shading on the modules.\n2. Check if the PV modules are properly connected and if their voltage specifications are above the inverter's operating voltage range.\n3. Check if there is any short circuit in the PV modules.",
  "0X3809-S-0301": "1. Often occurs in the early morning; please check the cleanliness of the PV panel surface.\n2. Check whether the PV panels are properly connected and whether the panel voltage specifications exceed the inverter's operating voltage range.\n3. Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0302": "1. Often occurs in the early morning; please check the cleanliness of the PV panel surface.\n2. Check whether the PV panels are properly connected and whether the panel voltage specifications exceed the inverter's operating voltage range.\n3. Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0303": "1. Often occurs in the early morning; please check the cleanliness of the PV panel surface.\n2. Check whether the PV panels are properly connected and whether the panel voltage specifications exceed the inverter's operating voltage range.\n3. Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0304": "1. Often occurs in the early morning; please check the cleanliness of the PV panel surface.\n2. Check whether the PV panels are properly connected and whether the panel voltage specifications exceed the inverter's operating voltage range.\n3. Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0501": "Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0502": "Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0503": "Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0504": "Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0505": "Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0506": "Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0507": "Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0508": "Please restart the inverter. If the fault persists, please contact your dealer.",
  "0X3809-S-0601": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the heatsink air duct is obstructed\n3. Restart the inverter after cooling down. If it cannot recover, please contact the dealer",
  "0X3809-S-0602": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the heatsink air duct is obstructed\n3. Restart the inverter after cooling down. If it cannot recover, please contact the dealer",
  "0X3809-S-0603": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the heatsink air duct is obstructed\n3. Restart the inverter after cooling down. If it cannot recover, please contact the dealer",
  "0X3809-S-0604": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the heatsink air duct is obstructed\n3. Restart the inverter after cooling down. If it cannot recover, please contact the dealer",
  "0X3809-S-0605": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the heatsink air duct is obstructed\n3. Restart the inverter after cooling down. If it cannot recover, please contact the dealer",
  "0X3809-S-0606": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the heatsink air duct is obstructed\n3. Restart the inverter after cooling down. If it cannot recover, please contact the dealer",
  "0X3809-S-0607": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the heatsink air duct is obstructed\n3. Restart the inverter after cooling down. If it cannot recover, please contact the dealer",
  "0X3809-S-0701": "1. Check whether the module has a ground fault.\n2. Check for loose connections in the DC circuit.\n3. If no issues are found in the DC circuit, power off for 5 minutes and then restore power. If the problem persists, contact your dealer.",
  "0X3809-S-0801": "1. Drive circuit fault.\n2. Power off and restart the inverter. If it cannot recover, contact your dealer.",
  "0X3809-S-0901": "1. Control board fault\n2. Power off and restart the inverter. If it cannot recover, please contact the dealer",
  "0X3809-S-0902": "1. Control board fault\n2. Power off and restart the inverter. If it cannot recover, please contact the dealer",
  "0X3809-S-0903": "1. Control board fault\n2. Power off and restart the inverter. If it cannot recover, please contact the dealer",
  "0X3809-S-0904": "1. Control board fault\n2. Power off and restart the inverter. If it cannot recover, please contact the dealer",
  "0X3809-S-0905": "1. Control board fault\n2. Power off and restart the inverter. If it cannot recover, please contact the dealer",
  "0X3809-S-0906": "1. Control board fault\n2. Power off and restart the inverter. If it cannot recover, please contact the dealer",
  "0X3809-S-0907": "1. Control board fault\n2. Power off and restart the inverter. If it cannot recover, please contact the dealer",
  "0X3809-S-1001": "1. If it occurs occasionally, it may be caused by occasional external line abnormalities. Restarting the inverter will restore normal operation.\n2. If it occurs frequently or cannot be recovered for a long time, please check whether the photovoltaic string grounding is reliable.",
  "0X3809-S-1002": "1. If it occurs occasionally, it may be caused by occasional external line abnormalities. Restarting the inverter will restore normal operation.\n2. If it occurs frequently or cannot be recovered for a long time, please check whether the photovoltaic string grounding is reliable.",
  "0X3809-S-1003": "1. If it occurs occasionally, it may be caused by occasional external line abnormalities. Restarting the inverter will restore normal operation.\n2. If it occurs frequently or cannot be recovered for a long time, please check whether the photovoltaic string grounding is reliable.",
  "0X3809-S-1004": "1. If it occurs occasionally, it may be caused by occasional external line abnormalities. Restarting the inverter will restore normal operation.\n2. If it occurs frequently or cannot be recovered for a long time, please check whether the photovoltaic string grounding is reliable.",
  "0X3809-S-1101": "1. Check whether the AC side ground wire is live.\n2. Internal relay fault.\n3. Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1102": "1. Check whether the AC side ground wire is live.\n2. Internal relay fault.\n3. Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1103": "1. Check whether the AC side ground wire is live.\n2. Internal relay fault.\n3. Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1201": "1. Internal fan damaged\n2. Fan detection circuit fault\n3. Power off and restart the inverter. If it cannot recover, please contact the dealer",
  "0X3809-S-1901": "Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1902": "Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1903": "Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1904": "Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1905": "Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1906": "Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-1907": "Power off and restart the inverter. If it cannot recover, please contact the dealer.",
  "0X3809-S-3101": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3102": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3103": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3104": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3105": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3106": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3107": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3108": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3109": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3110": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3111": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3112": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3113": "1. Check whether any circuit breaker in the distribution box has tripped.\n2. Measure whether the actual voltage exceeds the inverter's range.\n3. If the voltage is out of range, you can adjust the inverter's overvoltage and undervoltage protection values.",
  "0X3809-S-3301": "1. Check for loose connections in the power grid.\n2. Adjust the frequency range appropriately.",
  "0X3809-S-3302": "1. Check for loose connections in the power grid.\n2. Adjust the frequency range appropriately.",
  "0X3809-S-3303": "1. Check for loose connections in the power grid.\n2. Adjust the frequency range appropriately.",
  "0X3809-S-3304": "1. Check for loose connections in the power grid.\n2. Adjust the frequency range appropriately.",
  "0X3809-S-3305": "1. Check for loose connections in the power grid.\n2. Adjust the frequency range appropriately.",
  "0X3809-S-3306": "1. Check for loose connections in the power grid.\n2. Adjust the frequency range appropriately.",
  "0X3809-S-3701": "Check whether the inverter has been manually shut down.",
  "0X3809-S-3801": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3802": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3803": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3804": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3805": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3806": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3807": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3808": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3809": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3810": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3811": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3812": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3813": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3814": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3815": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3816": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3817": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3818": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3819": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3820": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3901": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3902": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3903": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3904": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3905": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3906": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3907": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3908": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3909": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3910": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3911": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3912": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3913": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3914": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3915": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3916": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3917": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3918": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3919": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-3920": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-4101": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-4201": "Check if the N-PE voltage is abnormal",
  "0X3809-S-4301": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3809-S-4401": "Please power off the inverter and disconnect the input/output switches. Restart the inverter after 5 minutes. If the fault is not cleared, please contact the dealer.",
  "0X3807-F-02": "PV2 Short Circuit Alarm",
  "0X3807-F-03": "PV Low Voltage Alarm",
  "0X3807-S-0101": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0102": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0103": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0104": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0105": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0106": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0107": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0108": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0109": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0110": "1. Check whether the fan is blocked by foreign objects\n2. Check whether the fan is rotating normally\n3. Restart the inverter; if it cannot recover, please replace the fan",
  "0X3807-S-0401": "Check whether the meter wiring is incorrect.",
  "0X3807-S-0402": "Check whether the meter wiring is incorrect.",
  "0X3807-S-0404": "Check whether the meter wiring is incorrect.",
  "0X3807-S-0408": "Check whether the meter wiring is incorrect.",
  "0X3807-S-0416": "Check whether the meter wiring is incorrect.",
  "0X3807-S-0500": "1. If it occurs occasionally, it may be due to a temporary grid abnormality. The inverter will resume normal operation after the grid returns to normal.\n2. If this fault is reported frequently, please check whether the grid is abnormal.",
  "0X3807-S-0601": "After shutdown, check whether the module voltage is normal. If restarting does not resolve the issue, it indicates an internal fault in the inverter.",
  "0X3807-S-02": "After shutdown, check whether the module voltage is normal. If restarting does not resolve the issue, it indicates an internal fault in the inverter.",
  "0X3807-S-03": "After shutdown, check whether the module voltage is normal. If restarting does not resolve the issue, it indicates an internal fault in the inverter.",
  "In Alarm": "In Alarm",
  "collector.upgrade.progress:": "Collector upgrade progress",
  "获取固件失败": "Failed to obtain firmware",
  "File CRC check failed": "File CRC check failed",
  "烧录超时": "烧录超时",
  "burning failed": "Burning failed",
  "Inverter": "Inverter",
  "Controller": "Controller",
  "Collector": "collector",
  "BMS": "BMS（.bin）",
  "Inverter (hex)": "Inverter (hex)",
  "AFCI": "AFCI",
  "BMS（.S19）": "BMS（.S19）",
  "Grid-tie & Off-grid Control Box": "Grid-tie & Off-grid Control Box",
  "逆变器ARM（禾迈）": "sleep mode",
  "数据棒（禾迈）": "sleep mode",
  "Gateway (Weimai)": "Gateway (Weimai)",
  "Display Screen (Weimai)": "Display Screen (Weimai)",
  "HMID (Weimai)": "HMID (Weimai)",
  "DCDC (Weimai)": "DCDC (Weimai)",
  "Battery BMS (Weimai)": "Battery BMS (Weimai)",
  "Inverter Auxiliary DSP (Weimai)": "Inverter Auxiliary DSP (Weimai)",
  "Inverter Main DSP (Weimai)": "Inverter Main DSP (Weimai)",
  "Charging Pile (Weimai)": "upgrade.type.Charging",
  "device.category.energyStorageCabinet": "Energy Storage Cabinet",
  "device.category.commercialRobot": "Commercial Robot",
  "device.category.pvinverter": "Photovoltaic Inverter",
  "settlementMeterType.type.checkpoint": "1111",
  "settlementMeterType.type.GATEWAY_METER": "1111",
  "settlementMeterType. PV_METER": "222",
  "settlementMeterType. ENERGY_STORAGE_METER": "33",
  "collector.upgrade.progress": "Collector upgrade progress",
  "device.upgrade.progress": "Device Upgrade Progress",
  "failed.to.obtain.firmware": "Failed to obtain firmware",
  "file.CRC.check.failed": "File CRC check failed",
  "burning.timed.out": "Burning timed out",
  "burning.failed": "Burning failed",
  "shujvabng": "Data Stick (Bumai)",
  "paramSet.select.dataError.tip": "The option is not the optimal option, please reset it.",
  "ywt.60419.pbusVol": "PBUS Voltage",
  "50901.ctrl_dianchiguanli": "Battery Manage",
  "bw_param_qqq": "Parallel Mode Setting",
  "paramSet.dateTime.title.month": "M",
  "ywt.60419.invRTemp": "INV ModuleR (℃)Temperature(℃)",
  "ywt.60419.rGridPower": "R-phase Grid-connected Power",
  "ywt.60419.sGridVol": "S grid phase Voltage",
  "paramSet.dateTime.title.year": "Y",
  "50500_0x7572-C-15": "Heat sink high temperature failure",
  "50500_0x7572-C-14": "ARC fault",
  "50500_0x7572-C-13": "EPS Volt Low Fault",
  "50500_0x7572-C-12": "Button_Manual_OFF",
  "50500_0x7572-C-11": "OVER LOAD ",
  "50500_0x7572-C-10": "Batt Shutdown Fault",
  "60420.real_time.analysis_AC_Side.tag": "Communication side",
  "ywt.60419.btDspDebugInfo8": "BT DSP Debug Information 8",
  "ywt.60419.btDspDebugInfo7": "BT DSP Debug Information 7",
  "ywt.60419.btDspDebugInfo6": "BT DSP Debug Information 6",
  "ywt.60419.sPhaseDci": "S DCI",
  "50500_0x756F-S-6": "DC/DC softstart fault\n 1. Check the battery fuse;\n 2. Restart and check whether it is in normal;\n 3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-7": "INV Relay Fault 1.Confirm that the wiring between each device is correct\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-4": "EEPROM Read Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-5": "EEPROM Write Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror1": "External FLASH Abnormality",
  "ywt.60419.internalharderror3": "EEPROM Writing Abnormality",
  "50500_0x756F-S-8": "Auxiliary power supply failure\n1. Wait for minutes then check;\n2. Remove wifi plug or other communicator;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror2": "EEPROM Reading Abnormality",
  "50500_0x756F-S-9": "Auxiliary power supply failure\n 1. Wait for minutes then check;\n 2. Remove wifi plug or other communicator;\n 3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.armDebugInfo7": "ARM Debug Information 7",
  "ywt.60419.internalharderror4": "GFCI Self-Test Failure",
  "ywt.60419.armDebugInfo5": "ARM Debug Information 5",
  "ywt.60419.armDebugInfo6": "ARM Debug Information 6",
  "50500_0x756F-S-2": "GFCI Device Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.armDebugInfo3": "ARM Debug Information 3",
  "ywt.60419.armDebugInfo4": "ARM Debug Information 4",
  "ywt.60419.armDebugInfo1": "ARM Debug Information 1",
  "ywt.60419.armDebugInfo2": "ARM Debug Information 2",
  "50500_0x756F-C-5": "EEPROM Write Fault",
  "50500_0x756F-C-4": "EEPROM Read Fault",
  "50500_0x756F-C-7": "INV Relay Fault",
  "50500_0x756F-C-6": "DC/DC_Softsart_Fault",
  "50500_0x756F-C-9": "AuxPowerBoard_Failure",
  "ywt.60419.deratedPower": "Derated Power",
  "50500_0x7570-F-14": "Soft_Start_Failed",
  "50500_0x7570-F-12": "Parallel_CANBus_Fault",
  "50500_0x756F-C-2": "GFCI Device Fault",
  "50500_0x7570-F-11": "Parallel Set Faut ",
  "50500_0x7570-F-10": "Bus Volt unbanlence",
  "50500_0x756F-C-13": "Working mode change",
  "50500_0x756F-C-14": "INV OCP ",
  "50500_0x756F-C-12": "Batt Mode Changed",
  "ywt.60419.todayPvEnergy": "Toady Power generation",
  "ywt.60419.btDspDebugInfo1": "BT DSP Debug Information 1",
  "ywt.60419.invSTemp": "INV ModuleS Temperature(℃)",
  "ywt.60419.btDspDebugInfo5": "BT DSP Debug Information 5",
  "ywt.60419.btDspDebugInfo4": "BT DSP Debug Information 4",
  "ywt.60419.btDspDebugInfo3": "BT DSP Debug Information 3",
  "ywt.60419.btDspDebugInfo2": "BT DSP Debug Information 2",
  "ywt.60419.dcInsulationImpedance": "DC insulation impedance",
  "60420.real_time.analysis_groupString.tag": "String current",
  "test.label_G_P_C_L1": "Gen L1 Power",
  "ywt.60419.internalHardwareError": "Internal hardware malfunction",
  "ywt.60419.versionStr": "Version",
  "test.label_G_P_C_L5": "Gen L2 Voltage",
  "common.50500.xnl_RTparam_name_G_P_V_L2": "Gen L2 Voltage",
  "test.label_G_P_C_L4": "Gen L1 Voltage",
  "common.50500.xnl_RTparam_name_G_P_V_L3": "Gen L3 Voltage",
  "test.label_G_P_C_L3": "Gen L3 Power",
  "common.50500.xnl_RTparam_name_G_P_V_L1": "Gen L1 Voltage",
  "test.label_G_P_C_L6": "Gen L3 Voltage",
  "ywt.60419.envTemp": "Ambient Temperature(℃)",
  "bw_param_ctrl_name_ParallelSetting": "Parallel Status",
  "ywt.60419.rGridVol": "R grid phase Voltage",
  "ywt.60419.scanStatus": "I/V scan status",
  "ywt.60419.groupStrCurrent1": "String 1 Current",
  "ywt.60419.invTTemp": "INV ModuleT Temperature(℃)",
  "ywt.60419.groupStrCurrent2": "Group string 2 Current",
  "ywt.60419.groupStrCurrent5": "String 5 Current",
  "ywt.60419.groupStrCurrent6": "Group string 6 Current",
  "ywt.60419.groupStrCurrent3": "String 3 Current",
  "ywt.60419.groupStrCurrent4": "Group string 4 Current",
  "ywt.60419.groupStrCurrent9": "String 9 Current",
  "ywt.60419.groupStrCurrent7": "String 7 Current",
  "ywt.60419.groupStrCurrent8": "Group string 8 Current",
  "ywt.60419.pvInputVol2": "PV2 Input Voltage",
  "ywt.60419.pvInputVol1": "PV1 Input Voltage",
  "ywt.60419.pvPower2": "PV Power 2",
  "ywt.60419.pvPower1": "PV Power 1",
  "ywt.60419.pvPower8": "PV Power 8",
  "ywt.60419.pvPower7": "PV Power 7",
  "ywt.60419.pvPower9": "PV Power 9",
  "50500_0x7571-S-10": "1.Confirm that the wiring between each device is correct\n2. Check the AC voltage is in the range of standard voltage in specification;\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower4": "PV Power 4",
  "50500_0x7571-S-15": "Grid frequency out of range\n 1. Check the frequency is in the range of specification or not;\n 2. Check whether AC cables are firmly and correctly connected;\n 3. Seek help from us, if can not go back to normal state.",
  "ywt.60419.pvPower3": "PV Power 3",
  "ywt.60419.pvPower6": "PV Power 6",
  "50500_0x7571-S-13": "Backup battery fault. \n 1. Check the battery capacity;\n 2. Check the connection between batteries and inverters;\n 3. If inverter can’t go back to normal after load reduction, seek help from us",
  "ywt.60419.pvPower5": "PV Power 5",
  "50500_0x7571-S-14": "Grid frequency out of range\n 1. Check the frequency is in the range of specification or not;\n 2. Check whether AC cables are firmly and correctly connected;\n 3. Seek help from us, if can not go back to normal state.",
  "50500_0x7570-C-14": "Soft_Start_Failed",
  "50500_0x7570-C-12": "Parallel_CANBus_Fault",
  "50500_0x7570-C-10": "Bus Volt unbanlence",
  "50500_0x7570-C-11": "Parallel Set Faut ",
  "ywt.60419.pvInputVol9": "PV9 Input Voltage",
  "ywt.60419.pvInputVol8": "PV8 Input Voltage",
  "ywt.60419.pvInputVol7": "PV7 Input Voltage",
  "ywt.60419.pvInputVol6": "PV6 Input Voltage",
  "ywt.60419.pvInputVol5": "PV5 Input Voltage",
  "ywt.60419.pvInputVol4": "PV4 Input Voltage",
  "ywt.60419.pvInputVol3": "PV3 Input Voltage",
  "60420.real_time.analysis_AC_Basic.tag": "Basic information",
  "ywt.60419.pvChargeTime": "Power generation time",
  "ywt.60419.invDspDebugInfo1": "INV DSP Debug Information 1",
  "ywt.60419.invDspDebugInfo2": "INV DSP Debug Information 2",
  "ywt.60419.invDspDebugInfo3": "INV DSP Debug Information 3",
  "ywt.60419.invDspDebugInfo4": "INV DSP Debug Information 4",
  "ywt.60419.invDspDebugInfo5": "INV DSP Debug Information 5",
  "ywt.60419.invDspDebugInfo6": "INV DSP Debug Information 6",
  "ywt.60419.invDspDebugInfo7": "INV DSP Debug Information 7",
  "ywt.60419.invDspDebugInfo8": "INV DSP Debug Information 8",
  "ywt.60419.workStatus0": "Initialization",
  "ywt.60419.workStatus1": "Please wait",
  "ywt.60419.workStatus2": "On-grid ",
  "ywt.60419.workStatus3": "Fault",
  "ywt.60419.workStatus4": "Programming",
  "ywt.60419.workStatus5": "Off-grad",
  "ywt.60419.rPhaseDci": "R DCI",
  "50500_0x756F-F-13": "Working mode change",
  "50500_0x756F-F-12": "Batt Mode Changed",
  "50500_0x756F-F-14": "INV OCP ",
  "common.50500.xnl_RTparam_name_G_P_C_L2": "Gen L2 Power",
  "common.50500.xnl_RTparam_name_G_P_C_L1": "Gen L1 Power",
  "common.50500.xnl_RTparam_name_G_P_C_L3": "Gen L3 Power",
  "paramSet.dateTime.title.hour": "H",
  "ywt.60419.tOnGridCurrent": "Phase T on-grid Current",
  "ywt.60419.tGridPower": "T-phase Grid-connected Power",
  "ywt.60419.trGridVol": "TR grid line Voltage",
  "paramSet.dateTime.title.minute": "Min",
  "ywt.60419.loadPower": "Load power",
  "50500_0x7572-S-15": "Heat sink temperature is too high\n 1. Check whether the work environment temperature is too high;\n 2. Turn off the inverter for 10mins and restart;\n 3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-14": "1. ARC fault detection is only for US market;\n 2. Check PV module cable connection and clear the fault;\n 3. Seek help from us, if can not go back to normal state.",
  "ywt.60419.tPhaseDci": "T DCI",
  "50500_0x7572-S-13": "1.Confirm that the load is appropriate\n2.Ensure sufficient PV energy and Reduce the load appropriately\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-12": "1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower11": "PV11 Power",
  "50500_0x7572-S-11": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower10": "PV10 Power",
  "50500_0x7572-S-10": "Batt Shutdown Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-F-8": "AC_Active_Batt_Fault",
  "50500_0x7570-F-9": "The DC busbar is unbalanced",
  "ywt.60419.reactivePower": "ReActive Power",
  "50500_0x7570-F-0": "Active_Battery_Hold",
  "50500_0x7570-F-1": "AC over current fault of hardware",
  "50500_0x7570-F-3": "DC over current fault ofthe hardware",
  "50500_0x7570-F-5": "Tz_EmergSStop_Fault",
  "50500_0x7570-F-6": "AC leakage current is transient over current",
  "50500_0x7570-F-7": "DC insulation impedance failure",
  "ywt.60419.rsGirdVol": "RS grid line Voltage",
  "ywt.60419.rOnGridCurrent": "Phase R on-grid Current",
  "ywt.60419.pvInputVol11": "PV11 Input Voltage",
  "ywt.60419.pvInputVol10": "PV10 Input Voltage",
  "ywt.60419.pvInputVol12": "PV12 Input Voltage",
  "50500_0x7571-F-13": "Bcakup_Battery_Fault",
  "50500_0x7571-F-14": "AC over frequency",
  "50500_0x7571-F-15": "AC lower frequency",
  "50500_0x7570-S-3": "DC side over current fault\n 1. Check PV module connect and battery connect;\n 2. Turn off the DC switch and AC switch and then wait one minute,then turn on the DC/AC switch again;\n 3. Seek help from us, if can not go back to normal state.",
  "50500_0x7570-S-5": "Seek help from us,This failure hardly happens.",
  "50500_0x7570-S-6": "Leakage current fault\n 1. Check the cable of PV module and inverter;\n 2. Restart inverter;\n 3. Seek help from us, if can not go back to normal state.",
  "50500_0x7570-S-7": "PV isolation resistance is too low\n 1. Check the connection of PV panels and inverter is firmly and correctly;\n 2. Check whether the PE cable of inverter is connected to ground;\n 3. Seek help from us, if can not go back to normal state.",
  "50500_0x7570-S-8": "AC_Active_Batt_Fault\n1.Check the battery fuse;\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-9": "1. Please wait for a while and check whether it is normal;\n 2. If still same, and turn off the DC switch and AC switch and wait for one minute and then turn on the DC/AC switch;\n 3. Seek help from us, if can not go back to normal state.",
  "ywt.60419.totalPvEnergy": "Total Yield",
  "50500_0x7570-S-0": "1.Check  insulation in the battery pack.\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-1": "AC side over current fault\n 1. Please check whether the backup load power and common load power are within the range;\n 2. Restart and check whether it is in normal;\n 3. Seek help from us, if can not go back to normal state.",
  "50500_0x7570-C-3": "DC over current fault ofthe hardware",
  "50500_0x7571-F-10": "Grid Volt Fault",
  "50500_0x7570-C-5": "Tz_EmergSStop_Fault",
  "50500_0x7570-C-6": "AC leakage current is transient over current",
  "50500_0x7570-C-7": "DC insulation impedance failure",
  "50500_0x7570-C-8": "AC_Active_Batt_Fault",
  "50500_0x7570-C-9": "The DC busbar is unbalanced",
  "50500_0x7571-C-8": "Parallel_system_Stop",
  "50500_0x7571-C-9": "AC line low voltage",
  "50500_0x7571-C-6": "DCLLC_Over_Current",
  "50500_0x7571-C-7": "Batt_Over_Current",
  "50500_0x756F-S-12": "Batt Mode Changed\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-4": "DCLLC_Soft_Over_Cur",
  "50500_0x7571-C-5": "Battery OV ",
  "50500_0x7570-C-0": "Active_Battery_Hold",
  "50500_0x756F-S-14": "INV OCP \n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-C-1": "AC over current fault of hardware",
  "50500_0x7571-C-2": "No AC grid",
  "50500_0x756F-S-13": "Inverter work mode changed\n 1. wait for a minute and check;\n 2. Seek help from us, if can't go back to normal state.",
  "60420.real_time.fault_param.tag": "tag",
  "paramSet.dateTime.title.second": "Sec",
  "50500_0x7571-S-8": "In parallel system,due to other inverter faults.\n 1. Wait for minutes then check all inverters in this parallel system;\n 2. If inverter can’t go back to normal state, record fault codes of all inverters, then seek help from us.",
  "50500_0x7571-S-7": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-6": "1.Confirm that the wiring between each device is correct\n2.Confirm that the PV voltage is not too low\n3.Confirm that the load is appropriate\n4.Confirm that the device parameter settings are correct\n5.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-5": "1.Confirm if the battery specifications match our device\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-4": "DCLLC_Soft_Over_Cur\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-2": "No Utility\n 1. Please confirm grid is lost or not;\n 2. Check the grid connection is good or not;\n 3. Check the switch between inverter and grid is on or not;\n 4. Seek help from us, if can not go back to normal state.",
  "ywt.60419.groupStrCurrent23": "String 23 Current",
  "ywt.60419.groupStrCurrent22": "Group string 22 Current",
  "ywt.60419.groupStrCurrent21": "String 21 Current",
  "ywt.60419.groupStrCurrent20": "Group string 20 Current",
  "ywt.60419.pvInputCurrent9": "PV9 Input Current",
  "ywt.60419.stGirdVol": "ST grid line Voltage",
  "ywt.60419.sGridPower": "S-phase Grid-connected Power",
  "50500_0x7571-F-5": "Battery OV ",
  "50500_0x7571-F-6": "DCLLC_Over_Current",
  "50500_0x7571-F-4": "DCLLC_Soft_Over_Cur",
  "ywt.60419.groupStrCurrent19": "String 19 Current",
  "ywt.60419.groupStrCurrent18": "Group string 18 Current",
  "50500_0x7571-F-2": "No AC grid",
  "ywt.60419.groupStrCurrent17": "String 17 Current",
  "ywt.60419.groupStrCurrent16": "Group string 16 Current",
  "ywt.60419.groupStrCurrent15": "String 15 Current",
  "ywt.60419.groupStrCurrent14": "Group string 14 Current",
  "ywt.60419.groupStrCurrent13": "String 13 Current",
  "ywt.60419.groupStrCurrent12": "Group string 12 Current",
  "ywt.60419.groupStrCurrent11": "String 11 Current",
  "50500_0x7571-F-9": "AC line low voltage",
  "ywt.60419.groupStrCurrent10": "Group string 10 Current",
  "50500_0x7571-F-7": "Batt_Over_Current",
  "50500_0x7571-F-8": "Parallel_system_Stop",
  "ywt.60419.pvInputCurrent7": "PV7 Input Current",
  "ywt.60419.leakCurrent": "Leakage Current",
  "ywt.60419.pvInputCurrent8": "PV8 Input Current",
  "ywt.60419.pvInputCurrent5": "PV5 Input Current",
  "ywt.60419.pvInputCurrent6": "PV6 Input Current",
  "ywt.60419.pvInputCurrent3": "PV3 Input Current",
  "ywt.60419.pvInputCurrent4": "PV4 Input Current",
  "ywt.60419.pvInputCurrent1": "PV1 Input Current",
  "ywt.60419.pvInputCurrent2": "PV2 Input Current",
  "ywt.60419.scanPercentage": "I/V scan percentage",
  "ywt.60419.powerFactor": "Power factor",
  "ywt.60419.loadDropMode10": "ATE Adjustment Derating",
  "50500_0x7572-C-0": "INV Volt Consistent Fauit",
  "ywt.60419.loadDropMode12": "Multi-machine Anti-backflow Derating",
  "ywt.60419.loadDropMode13": "Over-frequency Derating",
  "ywt.60419.onGridCountdown": "Countdown to grid connection",
  "50500_0x7572-S-6": "PV Volt High Fault \n1. Check whether PV voltage is normal;\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-5": "DC Volt Low Fault\n1.Check whether PV voltage is normal;\n2.Check whether battery voltage is normal;\n3.Confirm that the wiring between each device is correct\n4. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-8": "Batt Over Load Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-7": "Battery voltage low\n 1. Check whether battery voltage is too low;\n 2. If the battery voltage is too low, using PV or grid to charge the battery;\n 3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-2": "GFCI Consistent Frault",
  "50500_0x7572-S-1": "Grid Volt Consistent Fault\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-3": "Inter Comm Fault\n1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can not go back to normal state.",
  "60420.real_time.analysis_DC_Side.tag": "Dc side",
  "50500_0x7572-S-9": "1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-C-5": "DC Volt Low Fault",
  "50500_0x7572-C-6": "PV Volt High Fault ",
  "ywt.60419.radiatorTemp": "Radiator Temperature(℃)",
  "50500_0x7572-C-7": "DC busbar voltage is too low",
  "50500_0x7572-C-8": "Batt Over Load Fault",
  "50500_0x7572-C-1": "Grid Volt Consistent Fault",
  "50500_0x7572-C-2": "GFCI Consistent Frault",
  "ywt.60419.rsGridFrequency": "RS Power grid frequency",
  "50500_0x7572-C-3": "Inter Comm Fault",
  "50500_0x7572-S-0": "INV Volt Consistent Fauit\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-C-9": "BMS communication faultBMS",
  "ywt.60419.loadDropMode3": "Inverter Derating",
  "ywt.60419.loadDropMode2": "BST High Temperature Derating",
  "ywt.60419.loadDropMode1": "High Voltage Derating",
  "ywt.60419.loadDropMode0": "No Derating",
  "50500_0x756F-F-9": "AuxPowerBoard_Failure",
  "ywt.60419.loadDropMode9": "AC High Voltage Derating",
  "ywt.60419.loadDropMode8": "Load Slope Derating",
  "ywt.60419.loadDropMode7": "Reactive Power Derating",
  "ywt.60419.loadDropMode6": "Reset MPPT Derating",
  "ywt.60419.loadDropMode5": "PF Derating",
  "ywt.60419.loadDropMode4": "Ambient Temperature Derating",
  "50500_0x756F-F-2": "GFCI Device Fault",
  "50500_0x7570-S-12": "This ault only for inverters working in parallel mode\n 1. Check the parallel setting according to the instructions;\n 2. Check the connection of the CANBus;\n 3. Seek help from us",
  "50500_0x7571-C-10": "Batt Shutdown Fault",
  "50500_0x756F-F-4": "EEPROM Read Fault",
  "50500_0x7570-S-14": "Soft_Start_Failed\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3.Confirm that the battery level is not too low\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-F-10": "Batt Shutdown Fault",
  "50500_0x756F-F-6": "DC/DC_Softsart_Fault",
  "50500_0x756F-F-5": "EEPROM Write Fault",
  "50500_0x7571-C-15": "AC lower frequency",
  "ywt.60419.activePower": "Active Power",
  "50500_0x7570-S-11": "Parallel Set Faut \n1.Confirm that the device parameter settings are correct\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-F-12": "Button_Manual_OFF",
  "50500_0x7571-C-14": "AC over frequency",
  "50500_0x7570-S-10": "Bus Volt unbanlence\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-7": "INV Relay Fault",
  "50500_0x7572-F-11": "OVER LOAD ",
  "50500_0x7571-C-13": "Bcakup_Battery_Fault",
  "paramSet.dateTime.title.day": "D",
  "50500_0x7572-F-2": "GFCI Consistent Frault",
  "50500_0x7572-F-3": "Inter Comm Fault",
  "50500_0x7572-F-5": "DC Volt Low Fault",
  "50500_0x7572-F-0": "INV Volt Consistent Fauit",
  "50500_0x7572-F-1": "Grid Volt Consistent Fault",
  "50500_0x7572-F-14": "ARC fault",
  "50500_0x7572-F-13": "EPS Volt Low Fault",
  "50500_0x7572-F-15": "Heat sink high temperature failure",
  "50500_0x7572-F-6": "PV Volt High Fault ",
  "50500_0x7572-F-7": "DC busbar voltage is too low",
  "50500_0x7572-F-8": "Batt Over Load Fault",
  "50500_0x7572-F-9": "BMS communication faultBMS",
  "ywt.60419.meterPower": "Total power of the electric meter",
  "paramSet.input.dataError.tip": "The value is not within a reasonable range, please reset it.",
  "ywt.60419.workStatus": "Inverter Working State",
  "ywt.60419.tGridVol": "T grid phase Voltage",
  "ywt.60419.sOnGridCurrent": "Phase S On-grid Current",
  "ywt.60419.nbusVol": "NBUS Voltage",
  "ywt.60419.pvInputCurrent10": "PV10 Input Current",
  "ywt.60419.pvInputCurrent11": "PV11 Input Current",
  "ywt.60419.pvInputCurrent12": "PV12 Input Current",
  "current.collector.upgrade.progress": "The current upgrade progress of the collector is",
  "CSP Plant": "CSP Plant",
  "plant.others": "Others",
  "plant.csp": "CSP Plant",
  "ice.robot.strategy.type.peak.storage.valley": "Peak Storage Valley",
  "platformType.android": "Android",
  "platformType.ios": "IOS",
  "settlementMeterType.GATEWAY_METER": "Gateway electricity meter",
  "settlementMeterType.PV_METER": "Photovoltaic electricity meter",
  "settlementMeterType.ENERGY_STORAGE_METER": "Energy storage electricity meter",
  "settlementMeterType.CHARGING_PILE_METER": "Charging pile electricity meter",
  "NC2022": "New Caledonia_NC2022",
  "EN50549_IE": "EU_EN50549_IE",
  "PR_240VAC": "PR_240VAC",
  "VDE0126_GR": "France_VDE0126_GR",
  "PPDS": "Czechia_PPDS",
  "NCRFG": "Poland_NCRFG",
  "NF50549_1": "France_NF50549_1",
  "RESERVE_SFAY_E": "China_NBT32004",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable": "Grid CT Reverse Enable",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable": "PV CT Reverse Enable",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio": "Grid CT Meter Turns Ratio Setting",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio": "PV CT Meter Turns Ratio Setting",
  "50901.ctrl_Config-Grid Profile.country": "Country / Grid Standard Country",
  "50901.ctrl_Device.meterConfiguration": "Meter Configuration",
  "50901.ctrl_WorkMode.workMode": "EMS Operation Mode",
  "50901.ctrl_ESS_Advanced_Config-System": "Advanced Configuration - System",
  "50901.ctrl_Config-Grid Profile": "Configuration - Grid Parameters",
  "50901.ctrl_Device": "Control_Device",
  "50901.ctrl_WorkMode": "Working Mode",
  "connect.type.wifi": "Wireless Network",
  "connect.type.lan": "LAN",
  "ice.rob.stra.execute.state.pen.exe": "Pending Execute",
  "50901.ctrl_WorkModeSetting": "Work Mode Setting",
  "50901.ctrl_WorkMode-Backup": "Operation Mode - Backup",
  "50901.ctrl_WorkMode-economic": "Operation Mode - Economic",
  "50901.ctrl_WorkMode-forceCharge": "Operation Mode - Force Charge ",
  "50901.ctrl_WorkMode-forceDischarge": "peration Mode - Force Discharge ",
  "50901.ctrl_WorkMode-peakMeter": "Operation Mode - Peak Meter",
  "50901.ctrl_WorkMode-Selfuse": "Operation Mode - Self-Use",
  "50901.ctrl_WorkMode-TOU": "Operation Mode - TOU",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc.desc": "OU Mode Reserved SOC",
  "50901.ctrl_Device.meterConfiguration.desc": "Description of Meter Configuration",
  "50901.ctrl_Config-Grid Profile.country.desc": "Description of Country / Grid Connection Standard Country",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.0": "Disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.1": "Enable",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.0": "Disable",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.1": "Enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.0": "Disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.1": "Enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.0": "Disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.1": "Enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.0": "Disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.1": "Enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.0": "Disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.1": "Enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.0": "Disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.1": "Enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.1": "Enable",
  "50901.ctrl_Device.meterConfiguration.0": "No Meter Type",
  "50901.ctrl_Device.meterConfiguration.1": "Configure Grid-Side Meter",
  "50901.ctrl_Device.meterConfiguration.2": " Configure PV Meter",
  "50901.ctrl_Device.meterConfiguration.3": "Configure Grid-Side + PV Meter",
  "Do_not_connect": "Do not connect",
  "connect.type.Do.not.connect": "Do not connect",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.0": "Disable",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.1": "Enable",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.0": "Disable",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.1": "Enable",
  "50901.ctrl_Config.Device.meterConfiguration.0": "No Meter Type",
  "50901.ctrl_Config.Device.meterConfiguration.desc": "Meter Configuration Description",
  "50901.ctrl_Config.Device.meterConfiguration.1": "Grid Meter Configured",
  "50901.ctrl_Config.Device.meterConfiguration.2": "Pv Meter Configured",
  "50901.ctrl_Config.Device.meterConfiguration.3": "Grid + Pv Meter Configured",
  "50901.ctrl_WorkMode.workMode.0": "Self-Consumption Mode",
  "50901.ctrl_WorkMode.workMode.1": "Economic Mode",
  "50901.ctrl_WorkMode.workMode.2": "Backup Mode",
  "50901.ctrl_WorkMode.workMode.3": "Off-grid Mode",
  "50901.ctrl_WorkMode.workMode.4": "Force Charge Mode",
  "50901.ctrl_WorkMode.workMode.5": "Force Discharge Mode",
  "50901.ctrl_WorkMode.workMode.6": "Peak Shaving Mode",
  "50901.ctrl_WorkMode.workMode.7": "Scheduled Charge/Discharge Mode",
  "common.device.check.tab.communication": "communication",
  "common.device.check.tab.inveter": "inveter",
  "50901.Selfuse": "Self-Consumption",
  "50901.TOU": "Time-Of-Use Tariff",
  "50901.ctrl_Config.Grid Profile.country.desc": "Country/Grid Connection Standard Description",
  "50901.ctrl_WorkMode.Switch.workMode.0": "Self-Consumption",
  "50901.ctrl_WorkMode.Switch.workMode.1": "Economic Mode",
  "50901.ctrl_WorkMode.Switch.workMode.2": "Backup Mode",
  "50901.ctrl_WorkMode.Switch.workMode.3": "Off-Grid Mode",
  "50901.ctrl_WorkMode.Switch.workMode.4": "Force Charge Mode",
  "50901.ctrl_WorkMode.Switch.workMode.5": "Force Discharge Mode",
  "50901.ctrl_WorkMode.Switch.workMode.6": "Peak Shaving Mode",
  "50901.ctrl_WorkMode.Switch.workMode.7": "TOU Mode",
  "50901.ctrl_Config.Device.meterConfiguration": "Meter Configuration",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable": "Grid Ct Reverse Enable",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio": "Grid Ct Meter Turns Ratio Setting",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable": "Pv Ct Reverse Enable",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio": "Pv Ct Meter Turns Ratio Setting",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH": "Usage Time Period 1 Charge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH": "Usage Time Period 2 Charge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH": "Usage Time Period 3 Charge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH": "Usage Time Period 4 Charge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH": "Usage Time Period 1 Discharge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH": "Usage Time Period 2 Discharge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH": "Usage Time Period 3 Discharge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH": "Usage Time Period 4 Discharge Start - Hour",
  "50901.ctrl_Config.Grid Profile.country.0": "EU Standard EN 50549",
  "50901.ctrl_Config.Grid Profile.country.1": "En_En50549(Default)",
  "50901.ctrl_Config.Grid Profile.country.10": "Australia AU AS 4777 AZ",
  "50901.ctrl_Config.Grid Profile.country.11": "Philippines PH_GRID",
  "50901.ctrl_Config.Grid Profile.country.12": "Brazil BR_Inmetro_220V",
  "50901.ctrl_Config.Grid Profile.country.13": "Pakistan PAK_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.14": "Pakistan PAK_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.15": "Italy IT_CEIO-21",
  "50901.ctrl_Config.Grid Profile.country.17": "Colombia CNO_1862_240V",
  "50901.ctrl_Config.Grid Profile.country.19": "United Kingdom UK_G98/G99",
  "50901.ctrl_Config.Grid Profile.country.2": "Australia AU_AS4777_A",
  "50901.ctrl_Config.Grid Profile.country.20": "United Kingdom UK_G98NI/G99NI",
  "50901.ctrl_Config.Grid Profile.country.21": "Ecuador EC_IEEE1547",
  "50901.ctrl_Config.Grid Profile.country.22": "Slovenia SI_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.23": "France FR_VFR 2019",
  "50901.ctrl_Config.Grid Profile.country.24": "Spain ES_RD1699",
  "50901.ctrl_Config.Grid Profile.country.25": "Spain ES_RD647",
  "50901.ctrl_Config.Grid Profile.country.26": "Lithuania LT_EN50549",
  "50901.ctrl_Config.Grid Profile.country.27": "Ieee1547_208(Usa)",
  "50901.ctrl_Config.Grid Profile.country.28": "Thailand THA-EMA",
  "50901.ctrl_Config.Grid Profile.country.3": "Austria AT_TOR",
  "50901.ctrl_Config.Grid Profile.country.30": "Ieee1547_220(Usa)",
  "50901.ctrl_Config.Grid Profile.country.31": "United Kingdom UK_G98",
  "50901.ctrl_Config.Grid Profile.country.32": "United Kingdom UK_G99",
  "50901.ctrl_Config.Grid Profile.country.33": "United Kingdom UK_G98NI/G99NI",
  "50901.ctrl_Config.Grid Profile.country.34": "United Kingdom UK_G99NI",
  "50901.ctrl_Config.Grid Profile.country.35": "Vietnam VN_CCDE",
  "50901.ctrl_Config.Grid Profile.country.36": "Panama PA_GRID_240V",
  "50901.ctrl_Config.Grid Profile.country.37": "Brazil BR_Inmetro_220V_US",
  "50901.ctrl_Config.Grid Profile.country.38": "Puerto Rico LUMAPR-2024_208V",
  "50901.ctrl_Config.Grid Profile.country.39": "Puerto Rico LUMAPR-2024_240V",
  "50901.ctrl_Config.Grid Profile.country.4": "Poland PL_EN50549",
  "50901.ctrl_Config.Grid Profile.country.40": "India IND_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.41": "Romania RO_Ordinul208_2018",
  "50901.ctrl_Config.Grid Profile.country.42": "China CN_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.43": "Iraq IRAQ_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.44": "Us_Miso_208V(Usa)",
  "50901.ctrl_Config.Grid Profile.country.45": "Us_Miso_240V(Usa)",
  "50901.ctrl_Config.Grid Profile.country.46": "Saudi Arabia SA_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.47": "Sri Lanka LK_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.48": "Czech Republic CZ_PPDS2020 ",
  "50901.ctrl_Config.Grid Profile.country.49": "Belgium BE_C10_26",
  "50901.ctrl_Config.Grid Profile.country.5": "Estonia EE_EVS_EN50549",
  "50901.ctrl_Config.Grid Profile.country.50": "Netherlands NL_NEN_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.51": "Ukraine UA_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.52": "Canada CA_IEEE1547_240V",
  "50901.ctrl_Config.Grid Profile.country.53": "Canada CA_IEEE1547_208V",
  "50901.ctrl_Config.Grid Profile.country.54": "Malaysia MY_GRID_CODE",
  "50901.ctrl_Config.Grid Profile.country.55": "Indonesia ID_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.56": "South Africa ZA_NRS097_2024",
  "50901.ctrl_Config.Grid Profile.country.57": "Sweden SE_SS-EN 50549",
  "50901.ctrl_Config.Grid Profile.country.58": "Greece GR_VDE0126",
  "50901.ctrl_Config.Grid Profile.country.59": "Luxembourg LU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.6": "Hungary HU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.60": "Ireland IE_EN50438",
  "50901.ctrl_Config.Grid Profile.country.61": "Zambia ZAM_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.62": "Generator GEN_GRID_50Hz",
  "50901.ctrl_Config.Grid Profile.country.63": "Generator GEN_GRID_60Hz",
  "50901.ctrl_Config.Grid Profile.country.64": "Saudi Arabia SA_GRID_2025_265V",
  "50901.ctrl_Config.Grid Profile.country.65": "Serbia SRB_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.66": "Switzerland CH_NAEEA_NE7",
  "50901.ctrl_Config.Grid Profile.country.67": "Lebanon LB_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.68": "Chile CL_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.69": "Syria SYR_GRID_2026",
  "50901.ctrl_Config.Grid Profile.country.7": "Australia AU_AS4777_B",
  "50901.ctrl_Config.Grid Profile.country.8": "Australia AU_AS4777_C",
  "50901.ctrl_Config.Grid Profile.country.9": "Us_Ieee1547(Usa)",
  "50901.ctrl_Config.Grid Profile.country.18": "USHECO_Rule14(Hawaii)",
  "50901.ctrl_Config.Grid Profile.country.29": "LX_US_50HZ(USA TEST)",
  "platformType.web": "Web",
  "ceshi": "ceshi",
  "tt": "ce",
  "tt1": "test",
  "tt2": "test",
  "tt3": "cease",
  "test23": "ree",
  "50901.Backup": "Backup",
  "50901.Battery": "Battery",
  "50901.ClockSetting": "Clock Setting",
  "50901.Connection": "Communication Connection",
  "50901.ctrl_Config": "Communication Connection Control",
  "50901.ctrl_Config.Device.checkTime.desc": "Device Time Description",
  "50901.ctrl_Dry_Contact": "Dry Contact Setting",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent.desc": "EV Charger Rated Current",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent.desc": "Main Breaker Rated Current",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.desc": "Timed Mode - Battery SOC Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc.desc": "Timed Mode - Battery Start SOC",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc.desc": "Timed Mode - Battery Stop SOC",
  "50901.ctrl_ESS_Advanced_Config": "Advanced Configuration",
  "50901.ctrl_Safety": "Safety Regulations",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc.desc": "TOU Mode Reserved SOC",
  "50901.DCI": "Dc Isolation",
  "50901.Device": "Device",
  "50901.economic": "Economic Mode",
  "50901.EPS": "Emergency Power Supply",
  "50901.forceCharge": "Force Charge",
  "50901.forceDischarge": "Force Discharge",
  "50901.FRT": "Frequency Ride-Through",
  "50901.FW": "Frequency Drift",
  "50901.Gateway": "Gateway",
  "50901.Generator": "Generator",
  "50901.Grid Profile": "Grid Parameters",
  "50901.otaHttpUrl.otaHttpUrl.desc": "Upgrade Command Description",
  "50901.peakMeter": "Peak Metering",
  "50901.PV": "Chint Single-Phase",
  "50901.RCD": "Leakage Current Protection",
  "50901.real_time.copy_dspVersionMainUVersion.desc": "Dsp Version (Main U Version) Description",
  "50901.real_time.dTSReset.desc": "Data Stick Reset Description",
  "50901.real_time.数据分析_AC光伏功率.tag": "Ac Pv Power",
  "50901.real_time.数据分析_AC光伏无功功率.tag": "Ac Pv Reactive Power",
  "50901.real_time.数据分析_AC光伏有功功率.tag": "Ac Pv Active Power",
  "50901.real_time.数据分析_AC光伏电压.tag": "Ac Pv Voltage",
  "50901.real_time.数据分析_AC光伏电流.tag": "Ac Pv Current",
  "50901.real_time.数据分析_EPS功率.tag": "Eps Power",
  "50901.real_time.数据分析_EPS电压.tag": "Eps Voltage",
  "50901.real_time.数据分析_EPS电流.tag": "Eps Current",
  "50901.real_time.数据分析_单体SOC.tag": "Cell SOC",
  "50901.real_time.数据分析_发电机功率.tag": "Generator Power",
  "50901.real_time.数据分析_发电机电压.tag": "Generator Voltage",
  "50901.real_time.数据分析_发电机电流.tag": "Generator Current",
  "50901.real_time.数据分析_混逆光伏功率.tag": "Hybrid Inverter Pv Power",
  "50901.real_time.数据分析_混逆光伏电压.tag": "Hybrid Inverter Pv Voltage",
  "50901.real_time.数据分析_混逆光伏电流.tag": "Hybrid Inverter Pv Current",
  "50901.real_time.数据分析_电池包.tag": "Battery Pack",
  "50901.real_time.数据分析_电网功率.tag": "Grid Power",
  "50901.real_time.数据分析_电网电压.tag": "Grid Voltage",
  "50901.real_time.数据分析_电网电流.tag": "Grid Current",
  "50901.RPC": "No",
  "50901.RR": "Rate Of Change",
  "50901.RT": "Meaning Of Enumeration Value 0",
  "50901.Settings": "Working Mode",
  "50901.Settings-Load_Control": "Load Control",
  "50901.Settings-Manual_Control": "Meaning Of Enumeration Value 0",
  "50901.Switch": "Mode Switching",
  "50901.System": "Meaning Of Enumeration Value 0",
  "50901.VRT": "Meaning Of Enumeration Value 0",
  "50901.VW": "Voltage Drift",
  "50901.ctrl_Config.Device.networkingType.desc": "Grid Connection Type Description",
  "50901.fault.arcFault.desc": "Arc Fault Description",
  "50901.fault.arcSelfTestFault.desc": "Arc Fault Self-Check Failure Description",
  "50901.fault.armCommunicationFault.desc": "ARM Communication Fault Description",
  "50901.fault.auxiliaryPowerAbnormality.desc": "Auxiliary Power Supply Abnormal Description",
  "50901.Fault.batteryCapacityAbnormality.desc": "Battery Capacity Abnormal Description",
  "50901.Fault.batteryFault.desc": "Battery Fault Description",
  "50901.Fault.batteryForceChargeRequest.desc": "Battery Force Charge Request Description",
  "50901.Fault.bmsCanCommunicationAbnormality.desc": "BMS CAN Communication Abnormal Description",
  "50901.fault.busbarAbnormality.desc": "DC Bus Abnormal Description",
  "50901.fault.cmpssBiasCalculationError.desc": "CMPSS Offset Calculation Error Description",
  "50901.fault.comparatorFault.desc": "Comparator Fault Description",
  "50901.fault.driveAbnormality.desc": "Drive Abnormal Description",
  "50901.Fault.dspPwrCommunicationAbnormality.desc": "DSP Power Communication Abnormal Description",
  "50901.Fault.dspSafCommunicationAbnormality.desc": "DSP Secure Communication Abnormal Description",
  "50901.Fault.dtsCommunicationAbnormality.desc": "DTS Communication Abnormal Description",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.desc": "DTU1 RS485 Communication Abnormal Description",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.desc": "DTU2 RS485 Communication Abnormal Description",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.desc": "DTU3 RS485 Communication Abnormal Description",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.desc": "DTU4 RS485 Communication Abnormal Description",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.desc": "DTU5 RS485 Communication Abnormal Description",
  "50901.fault.e2rpomFault.desc": "EEPROM Fault Description",
  "50901.fault.emergencyStopSwitchStatus.desc": "Emergency Stop Description",
  "50901.fault.epsOverload.desc": "EPS Overload Description",
  "50901.fault.epsRelayProtection.desc": "EPS Relay Protection Description",
  "50901.fault.epsVoltageAbnormality.desc": "EPS Voltage Abnormal Description",
  "50901.Fault.evCharger1CommunicationAbnormality.desc": "EV Charger 1 Communication Abnormal Description",
  "50901.Fault.evCharger1Fault.desc": "EV Charger 1 Fault Description",
  "50901.Fault.evCharger2CommunicationAbnormality.desc": "EV Charger 2 Communication Abnormal Description",
  "50901.Fault.evCharger2Fault.desc": "EV Charger 2 Fault Description",
  "50901.fault.fanFault.desc": "Fan Fault Description",
  "50901.Fault.fanSpeedAbnormality.desc": "Fan Speed Abnormal Description",
  "50901.fault.fiveVoltPowerSupplyFault.desc": "5V Power Supply Fault Description",
  "50901.fault.flashCommunicationFault.desc": "Flash Memory Communication Fault Description",
  "50901.fault.frequencyVariationRateOutOfRange.desc": "Frequency Change Rate Over-limit Description",
  "50901.fault.genAbnormality.desc": "Generator Abnormal Description",
  "50901.fault.genOverload.desc": "Generator Overload Description",
  "50901.fault.genPortOvercurrent.desc": "Generator Port Overcurrent Description",
  "50901.fault.genRelayAFault.desc": "Generator A Relay Fault Description",
  "50901.fault.genRelayBFault.desc": "Generator B Relay Fault Description",
  "50901.fault.gridCurrentDcOffsetOutOfRange.desc": "Grid Current DC Offset Over-limit Description",
  "50901.fault.gridMeter.desc": "Grid Meter Communication Failure Description",
  "50901.Fault.gridMeterCommunicationAbnormality.desc": "Grid Meter Communication Abnormal Description",
  "50901.Fault.gridMeterTypeError.desc": "Grid Meter Type Error Description",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.desc": "Off-Grid Voltage DC Offset Over-limit Description",
  "50901.fault.gridOverfrequency.desc": "Grid Overfrequency Description",
  "50901.fault.gridOvervoltage.desc": "Grid Overvoltage Description",
  "50901.fault.gridPortOvercurrent.desc": "Grid Port Overcurrent Description",
  "50901.fault.gridPowerOutage.desc": "Grid Power Loss Description",
  "50901.fault.gridRelayProtection.desc": "Grid Relay Protection Description",
  "50901.fault.gridUnderfrequency.desc": "Grid Underfrequency Description",
  "50901.fault.gridUndervoltage.desc": "Grid Undervoltage Description",
  "50901.fault.gridVoltageAbnormality.desc": "Grid Voltage Abnormal Description",
  "50901.Fault.hmidCommunicationAbnormality.desc": "HMI Communication Abnormal Description",
  "50901.Fault.hmidMachineFault.desc": "HMI Device Fault Description",
  "50901.fault.insulationFault.desc": "Insulation Fault Description",
  "50901.fault.interruptOverflow.desc": "Interrupt Overflow Description",
  "50901.fault.inverterCanCommunicationFailed.desc": "Inverter CAN Communication Failure Description",
  "50901.fault.inverterCommunicationFailed.desc": "Inverter Communication Failure Description",
  "50901.fault.kmRelayFault.desc": "KM Relay Fault Description",
  "50901.fault.lineToEarthFault.desc": "Ground Fault (Line-to-Ground) Description",
  "50901.fault.loadRelayAFault.desc": "Load A Relay Fault Description",
  "50901.fault.loadRelayBFault.desc": "Load B Relay Fault Description",
  "50901.fault.lowAmbientTemperature.desc": "Ambient Temperature Too Low Description",
  "50901.Fault.lowDtuVersion.desc": "DTU Version Too Low Description",
  "50901.fault.machineTypeMismatch.desc": "Model Mismatch Description",
  "50901.Fault.masterSlaveCommunicationAbnormality.desc": "Master-Slave Communication Abnormal Description",
  "50901.fault.meterWiringAbnormality.desc": "Meter Wiring Abnormal Description",
  "50901.fault.microelectronicFault.desc": "Microelectronics Fault Description",
  "50901.fault.neutralWireNotConnected.desc": "Neutral Line Not Connected Description",
  "50901.fault.neutralWireToEarthFault.desc": "Neutral Line-to-Ground Fault Description",
  "50901.fault.overTemperature.desc": "Overtemperature Description",
  "50901.fault.overtemperatureAlarm.desc": "Overheat Alarm Description",
  "50901.fault.pllLockFailed.desc": "PLL Lock Failure Description",
  "50901.fault.preSynchronizationFailed.desc": "Pre-Synchronization Failure Description",
  "50901.fault.pvFault.desc": "PV Fault Description",
  "50901.Fault.pvMeterCommunicationAbnormality.desc": "PV Meter Communication Abnormal Description",
  "50901.Fault.pvMeterTypeError.desc": "PV Meter Type Error Description",
  "50901.fault.pvPortOvercurrent.desc": "PV Port Overcurrent Description",
  "50901.fault.pvRelayAbFault.desc": "PV AB Relay Fault Description",
  "50901.fault.pvVoltageExceedingBusVoltage.desc": "PV Voltage Exceeding Bus Voltage Description",
  "50901.fault.rcdFault.desc": "RCD Fault Description",
  "50901.fault.rcdSelfTestFault.desc": "RCD Self-Check Failure Description",
  "50901.fault.reconnectionFailed.desc": "Reconnection Failure Description",
  "50901.fault.samplingBiasAbnormality.desc": "Sampling Offset Abnormal Description",
  "50901.fault.shutDown.desc": "System Shutdown Description",
  "50901.Fault.slaveWrongBatteryConnection.desc": "Slave Battery Connection Error Description",
  "50901.fault.smartloadPortOvercurrent.desc": "Smart Load Port Overcurrent Description",
  "50901.fault.spiCommunicationFault.desc": "SPI Communication Fault Description",
  "50901.Fault.sustainedNegativeLoad.desc": "Sustained Negative Load Description",
  "50901.fault.temperatureAbnormality.desc": "Temperature Abnormal Description",
  "50901.fault.tenMinuteOvervoltage.desc": "10-Minute Overvoltage Description",
  "50901.fault.threePointThreeVoltPowerSupplyFault.desc": "3.3V Power Supply Fault Description",
  "50901.fault.twelveVoltPowerSupplyFault.desc": "12V Power Supply Fault Description",
  "50901.fault.versionMismatch.desc": "Version Mismatch Description",
  "50901.fault.wiringAbnormality.desc": "Wiring Abnormal Description",
  "50901.real_time.12vAuxiliaryVoltageSampling.desc": "12V Auxiliary Voltage Sampling Description",
  "50901.real_time.12vOutputVoltageSampling.desc": "12V Output Voltage Sampling Description",
  "50901.real_time.3_3vAuxiliaryVoltageSampling.desc": "3.3V Auxiliary Voltage Sampling Description",
  "50901.real_time.5vAuxiliaryVoltageSampling.desc": "5V Auxiliary Voltage Sampling Description",
  "50901.real_time.afciVersion.desc": "AFCI Version Description",
  "50901.real_time.ambientTemperatureSampling.desc": "Ambient Temperature Sampling Description",
  "50901.real_time.appSoftwareVersion.desc": "APP Software Version Description",
  "50901.real_time.batteryChargePower.desc": "Battery Cumulative Charge Capacity Description",
  "50901.real_time.batteryConnectionStatus.desc": "Battery Connection Status Description",
  "50901.real_time.batteryCurrent.desc": "Battery Current Description",
  "50901.real_time.batteryDailyChargeEnergy.desc": "Battery Daily Charge Capacity Description",
  "50901.real_time.batteryDailyDischargeEnergy.desc": "Battery Daily Discharge Capacity Description",
  "50901.real_time.batteryDischargePower.desc": "Battery Cumulative Discharge Capacity Description",
  "50901.real_time.batteryModuleNum.desc": "Battery Cell Count (Cells in Series per Module) Description",
  "50901.real_time.batteryPower.desc": "Battery Power (Charge/Discharge) Description",
  "50901.real_time.batteryPowerWholeSystem.desc": "Battery Total Power (Whole System) Description",
  "50901.real_time.batterySoc.desc": "Battery SOC Description",
  "50901.real_time.batteryToLoadPower.desc": "Battery-to-Load Power Description",
  "50901.real_time.batterytotCap.desc": "Battery Total Installed Capacity Description",
  "50901.real_time.batteryType_04.desc": "Battery Type Description",
  "50901.real_time.batteryVoltage.desc": "Battery Voltage Description",
  "50901.real_time.batteryWorkingStatus.desc": "Battery Status Description",
  "50901.real_time.bootSoftwareVersion.desc": "Bootloader Software Version Description",
  "50901.real_time.communicationStickHardwareVersion.desc": "Communication Dongle Hardware Version Description",
  "50901.real_time.communicationStickSn.desc": "Communication Dongle SN Description",
  "50901.real_time.communicationStickSoftwareVersion.desc": "Communication Dongle Software Version Description",
  "50901.real_time.dailyBatteryToLoadEnergy.desc": "Today Battery-to-Load Energy Description",
  "50901.real_time.dailyExportEnergyToGrid.desc": "Today Selling Energy Description",
  "50901.real_time.dailyGridToLoadEnergy.desc": "Today Grid-to-Load Energy Description",
  "50901.real_time.dailyImportEnergyFromGrid.desc": "Today Buying Energy Description",
  "50901.real_time.dailyPvToBatteryEnegry.desc": "Today PV-to-Battery Energy Description",
  "50901.real_time.dailyPvToGridEnegry.desc": "Today PV-to-Grid Energy Description",
  "50901.real_time.dailyPvToLoadEnegry.desc": "Today PV-to-Load Energy Description",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.desc": "DRM Status (For Australia/Germany/Austria) Description",
  "50901.real_time.dspVersionAuxiliaryUVersion.desc": "DSP Version (Auxiliary U Version) Description",
  "50901.real_time.externalFanSpeed1.desc": "Outer Fan Speed 1 Description",
  "50901.real_time.externalFanSpeed2.desc": "Outer Fan Speed 2 Description",
  "50901.real_time.externalFanSpeed3.desc": "Outer Fan Speed 3 Description",
  "50901.real_time.externalFanSpeed4.desc": "Outer Fan Speed 4 Description",
  "50901.real_time.firmwareBuildTimeDateHour.desc": "Firmware Build Time (Day/Hour) Description",
  "50901.real_time.firmwareBuildTimeYearMonth.desc": "Firmware Build Time (Year & Month) Description",
  "50901.real_time.firmwareCrc.desc": "Firmware CRC Description",
  "50901.real_time.firmwareEndAddressHigh.desc": "Firmware End Address (High) Description",
  "50901.real_time.firmwareEndAddressLow.desc": "Firmware End Address (Low) Description",
  "50901.real_time.firmwareInformationCrc.desc": "Firmware Info CRC Description",
  "50901.real_time.firmwareStartAddressHigh.desc": "Firmware Start Address (High) Description",
  "50901.real_time.firmwareStartAddressLow.desc": "Firmware Start Address (Low) Description",
  "50901.real_time.generatorCurrentA.desc": "Generator Phase A Current Description",
  "50901.real_time.generatorCurrentB.desc": "Generator Phase B Current Description",
  "50901.real_time.generatorCurrentC.desc": "Generator Phase C Current Description",
  "50901.real_time.generatorDailyYield.desc": "Generator Daily Generation Description",
  "50901.real_time.generatorPower.desc": "Generator Power Description",
  "50901.real_time.generatorPowerA.desc": "Generator Phase A Power Description",
  "50901.real_time.generatorPowerB.desc": "Generator Phase B Power Description",
  "50901.real_time.generatorPowerC.desc": "Generator Phase C Power Description",
  "50901.real_time.generatorTotalYield.desc": "Generator Cumulative Generation Description",
  "50901.real_time.gridBuyPower.desc": "Cumulative Buying Energy Description",
  "50901.real_time.gridCurrentA.desc": "Grid Side Phase A Current Description",
  "50901.real_time.gridCurrentB.desc": "Grid Side Phase B Current Description",
  "50901.real_time.gridCurrentC.desc": "Grid Side Phase C Current Description",
  "50901.real_time.gridMeasurementOfRadiatorTemperature.desc": "Grid Side Heatsink Temperature Description",
  "50901.real_time.gridMeterSerialNumber.desc": "Grid Side Meter Serial Number Description",
  "50901.real_time.gridPower.desc": "Grid Side Power Description",
  "50901.real_time.gridPowerA.desc": "Grid Side Phase A Power Description",
  "50901.real_time.gridPowerB.desc": "Grid Side Phase B Power Description",
  "50901.real_time.gridPowerC.desc": "Grid Side Phase C Power Description",
  "50901.real_time.gridPowerFactor.desc": "Grid Side Power Factor Description",
  "50901.real_time.gridPowerFactorA.desc": "Grid Side Phase A Power Factor Description",
  "50901.real_time.gridPowerFactorB.desc": "Grid Side Phase B Power Factor Description",
  "50901.real_time.gridPowerFactorC.desc": "Grid Side Phase C Power Factor Description",
  "50901.real_time.gridPowerWholeSystem.desc": "Grid Total Power (Whole System) Description",
  "50901.real_time.gridReactivePower.desc": "Grid Side Reactive Power Description",
  "50901.real_time.gridReactivePowerA.desc": "Grid Side Phase A Reactive Power Description",
  "50901.real_time.gridReactivePowerB.desc": "Grid Side Phase B Reactive Power Description",
  "50901.real_time.gridReactivePowerC.desc": "Grid Side Phase C Reactive Power Description",
  "50901.real_time.gridSellPower.desc": "Cumulative Selling Energy Description",
  "50901.real_time.gridTotalFrequency.desc": "Grid Side Frequency Description",
  "50901.real_time.gridVoltageA.desc": "Grid Side Phase A Voltage Description",
  "50901.real_time.gridVoltageB.desc": "Grid Side Phase B Voltage Description",
  "50901.real_time.gridVoltageC.desc": "Grid Side Phase C Voltage Description",
  "50901.real_time.hoymilesSerialNumber.desc": "Hoymiles Serial Number Description",
  "50901.real_time.internalFanSpeed1.desc": "Inner Fan Speed 1 Description",
  "50901.real_time.internalFanSpeed2.desc": "Inner Fan Speed 2 Description",
  "50901.real_time.internalFanSpeed3.desc": "Inner Fan Speed 3 Description",
  "50901.real_time.inverterHardwareVersion.desc": "Inverter Hardware Version Description",
  "50901.real_time.inverterModelNumber.desc": "Inverter Model Number Description",
  "50901.real_time.inverterSideRadiatorTemperature.desc": "Inverter Side Heatsink Temperature Description",
  "50901.real_time.inverterTemp.desc": "Inverter Internal Operating Temperature Description",
  "50901.real_time.loadEnergy.desc": "Load Daily Energy Consumption Description",
  "50901.real_time.loadPowerWholeSystem.desc": "Load Total Power (Whole System) Description",
  "50901.real_time.macAddr.desc": "MAC Address Description",
  "50901.real_time.materType.desc": "Meter Type Description",
  "50901.real_time.maxCellSoc.desc": "Max Cell SOC Description",
  "50901.real_time.maxCellSocCellId.desc": "Max Cell SOC Corresponding Index Description",
  "50901.real_time.maxCellTemperature.desc": "Max Cell Temperature Description",
  "50901.real_time.maxCellTemperatureCellId.desc": "Max Cell Temperature Corresponding Index Description",
  "50901.real_time.maxCellVoltage.desc": "Max Cell Voltage Description",
  "50901.real_time.maxCellVoltageCellId.desc": "Max Cell Voltage Corresponding Index Description",
  "50901.real_time.MaxChargeCurrent.desc": "Max Charge Current Description",
  "50901.real_time.MaxDisChargeCurrent.desc": "Max Discharge Current Description",
  "50901.real_time.meterFlag.desc": "Meter Flag Description",
  "50901.real_time.minCellSoc.desc": "Min Cell SOC Description",
  "50901.real_time.minCellSocCellId.desc": "Min Cell SOC Corresponding Index Description",
  "50901.real_time.minCellTemperature.desc": "Min Cell Temperature Description",
  "50901.real_time.minCellTemperatureCellId.desc": "Min Cell Temperature Corresponding Index Description",
  "50901.real_time.minCellVoltage.desc": "Min Cell Voltage Description",
  "50901.real_time.minCellVoltageCellId.desc": "Min Cell Voltage Corresponding Index Description",
  "50901.real_time.mpptTemp.desc": "PV Side Heatsink Temperature Description",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack.desc": "Battery Pack Cycle Count Description",
  "50901.real_time.oemModelName.desc": "OEM Model Name Description",
  "50901.real_time.oemSerialNumber.desc": "OEM Serial Number Description",
  "50901.real_time.packCurrent.desc": "Battery Pack Current Description",
  "50901.real_time.packNum.desc": "Parallel Quantity (Number of Battery Packs) Description",
  "50901.real_time.packPower.desc": "Battery Pack Power Description",
  "50901.real_time.packSoc.desc": "Battery Pack SOC Description",
  "50901.real_time.packSoh.desc": "Battery Pack SOH Description",
  "50901.real_time.packVoltage.desc": "Battery Pack Voltage Description",
  "50901.real_time.powerGeneration.desc": "PV Cumulative Generation Description",
  "50901.real_time.pv1RealTimePower.desc": "PV1 Real-time Power Description",
  "50901.real_time.pv2RealTimePower.desc": "PV2 Real-time Power Description",
  "50901.real_time.pv3RealTimePower.desc": "PV3 Real-time Power Description",
  "50901.real_time.pv4RealTimePower.desc": "PV4 Real-time Power Description",
  "50901.real_time.pvDailyYield.desc": "PV Daily Generation Description",
  "50901.real_time.pvMeterConnectionStatus.desc": "PV Meter Connection Status Description",
  "50901.real_time.pvMeterCurrentA.desc": "PV Meter Phase A Current Description",
  "50901.real_time.pvMeterCurrentB.desc": "PV Meter Phase B Current Description",
  "50901.real_time.pvMeterCurrentC.desc": "PV Meter Phase C Current Description",
  "50901.real_time.pvMeterDailyYield.desc": "External Inverter Daily Generation Description",
  "50901.real_time.pvMeterFrequency.desc": "PV Meter Frequency Description",
  "50901.real_time.pvMeterPhaseAActivePower.desc": "PV Meter Phase A Active Power Description",
  "50901.real_time.pvMeterPhaseAPowerFactor.desc": "PV Meter Phase A Power Factor Description",
  "50901.real_time.pvMeterPhaseAReactivePower.desc": "PV Meter Phase A Reactive Power Description",
  "50901.real_time.pvMeterPhaseBActivePower.desc": "PV Meter Phase B Active Power Description",
  "50901.real_time.pvMeterPhaseBPowerFactor.desc": "PV Meter Phase B Power Factor Description",
  "50901.real_time.pvMeterPhaseBReactivePower.desc": "PV Meter Phase B Reactive Power Description",
  "50901.real_time.pvMeterPhaseCActivePower.desc": "PV Meter Phase C Active Power Description",
  "50901.real_time.pvMeterPhaseCPowerFactor.desc": "PV Meter Phase C Power Factor Description",
  "50901.real_time.pvMeterPhaseCReactivePower.desc": "PV Meter Phase C Reactive Power Description",
  "50901.real_time.pvMeterPower.desc": "PV Meter Power Description",
  "50901.real_time.pvMeterPowerA.desc": "PV Meter Phase A Power Description",
  "50901.real_time.pvMeterPowerB.desc": "PV Meter Phase B Power Description",
  "50901.real_time.pvMeterPowerC.desc": "PV Meter Phase C Power Description",
  "50901.real_time.pvMeterSerialNumber.desc": "PV Meter Serial Number Description",
  "50901.real_time.pvMeterTotalYield.desc": "External Inverter Cumulative Generation Description",
  "50901.real_time.pvMeterVoltageA.desc": "PV Meter Phase A Voltage Description",
  "50901.real_time.pvMeterVoltageB.desc": "PV Meter Phase B Voltage Description",
  "50901.real_time.pvMeterVoltageC.desc": "PV Meter Phase C Voltage Description",
  "50901.real_time.pvPower.desc": "PV Power Description",
  "50901.real_time.pvPowerWholeSystem.desc": "PV Total Power (Whole System) Description",
  "50901.real_time.pvToBatteryPower.desc": "PV-to-Battery Power Description",
  "50901.real_time.pvToGridPower.desc": "PV-to-Grid Power Description",
  "50901.real_time.pvToLoadPower.desc": "PV-to-Load Power Description",
  "50901.real_time.relayStatus.desc": "Relay Status Description",
  "50901.real_time.relaySupplyVoltageSampling.desc": "Relay Power Supply Voltage Sampling Description",
  "50901.real_time.rssi.desc": "Signal Strength Description",
  "50901.real_time.soh.desc": "SOH Description",
  "50901.real_time.ssid.desc": "SSID Description",
  "50901.real_time.totalBatteryToLoadEnergy.desc": "Cumulative Battery-to-Load Energy Description",
  "50901.real_time.totalGridToLoadEnergy.desc": "Cumulative Grid-to-Load Energy Description",
  "50901.real_time.totalLoadEnergy.desc": "Load Cumulative Energy Consumption Description",
  "50901.real_time.totalPvToBatteryEnegry.desc": "Cumulative PV-to-Battery Energy Description",
  "50901.real_time.totalPvToGridEnegry.desc": "Cumulative PV-to-Grid Energy Description",
  "50901.real_time.totalPvToLoadEnegry.desc": "Cumulative PV-to-Load Energy Description",
  "50901.warning.batteryHighVoltageAlarm.desc": "Battery Overvoltage Alarm Description",
  "50901.warning.batteryLowVoltageAlarm.desc": "Battery Undervoltage Description",
  "50901.warning.batteryPackChargeHighVoltageAlarm.desc": "Battery Pack Charge Overvoltage Alarm Description",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.desc": "Battery Pack Discharge Undervoltage Alarm Description",
  "50901.warning.canCommunicationTimeout.desc": "CAN Communication Timeout Description",
  "50901.warning.chargeHighTemperatureAlarm.desc": "Charge High Temperature Alarm Description",
  "50901.warning.chargeLowTemperatureAlarm.desc": "Charge Low Temperature Alarm Description",
  "50901.warning.dischargeHighTemperatureAlarm.desc": "Discharge High Temperature Alarm Description",
  "50901.warning.dischargeLowTemperatureAlarm.desc": "Discharge Low Temperature Alarm Description",
  "50901.warning.hardwareProtection.desc": "Hardware Protection Description",
  "50901.warning.inputOvervoltageAlarm.desc": "Input Overvoltage Alarm Description",
  "50901.warning.lowBatteryEnergy.desc": "Battery Low Capacity Description",
  "50901..absoluteTime.desc": "Absolute Time Description",
  "50901..batteryHealing.desc": "Battery Recovery Description",
  "50901..connectionRouterStatus.desc": "Router Connection Status Description",
  "50901..connectionServerStatus.desc": "Cloud Service Connection Status Description",
  "50901..dfs.desc": "Capability Set Description",
  "50901..dspVersionMainUVersion.desc": "DSP Version (Main U Version) Description",
  "50901..timeZone.desc": "Time Zone Description",
  "50901.ctrl_Config.ClockSetting.ClockSetting.desc": "Clock Setting Description",
  "50901.ctrl_Config.ClockSetting.clockSetting_day.desc": "Clock Setting - Day Description",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour.desc": "Clock Setting - Hour Description",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute.desc": "Clock Setting - Minute Description",
  "50901.ctrl_Config.ClockSetting.clockSetting_month.desc": "Clock Setting - Month Description",
  "50901.ctrl_Config.ClockSetting.clockSetting_second.desc": "Clock Setting - Second Description",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday.desc": "Clock Setting - Weekday Description",
  "50901.ctrl_Config.ClockSetting.clockSetting_year.desc": "Clock Setting - Year Description",
  "50901.ctrl_Config.Device.masterSlave.desc": "Master/Slave Description",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold.desc": "Ambient Temperature Threshold Description",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold.desc": "PCB Ambient Temperature Threshold Description",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress.desc": "Gateway Communication Address Description",
  "50901.ctrl_WorkMode.Backup.backupSoc.desc": "Reserved SOC Description",
  "50901.ctrl_WorkMode.economic.economicModeSoc.desc": "Economic Mode SOC Description",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber.desc": "Economic Mode Date Index Description",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1.desc": "Section 1 Peak Start Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2.desc": "Section 1 Peak Start Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1.desc": "Section 1 Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2.desc": "Section 1 Peak Start Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1.desc": "Section 1 Peak Stop Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2.desc": "Section 1 Peak Stop Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1.desc": "Section 1 Peak Stop Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2.desc": "Section 1 Peak Stop Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section1StartDay.desc": "Section 1 Start Day Description",
  "50901.ctrl_WorkMode.economic.section1StartMonth.desc": "Section 1 Start Month Description",
  "50901.ctrl_WorkMode.economic.section1StopDay.desc": "Section 1 Stop Day Description",
  "50901.ctrl_WorkMode.economic.section1StopMonth.desc": "Section 1 Stop Month Description",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1.desc": "Section 1 Off-Peak Start Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2.desc": "Section 1 Off-Peak Start Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1.desc": "Section 1 Off-Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2.desc": "Section 1 Off-Peak Start Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1.desc": "Section 1 Off-Peak Stop Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2.desc": "Section 1 Off-Peak Stop Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1.desc": "Section 1 Off-Peak Stop Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2.desc": "Section 1 Off-Peak Stop Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.desc": "Section 1 Week Range 1 Description",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.desc": "Section 1 Week Range 2 Description",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1.desc": "Section 2 Peak Start Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2.desc": "Section 2 Peak Start Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1.desc": "Section 2 Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2.desc": "Section 2 Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1.desc": "Section 2 Peak Stop Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2.desc": "Section 2 Peak Stop Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1.desc": "Section 2 Peak Stop Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2.desc": "Section 2 Peak Stop Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section2StartDay.desc": "Section 2 Start Day Description",
  "50901.ctrl_WorkMode.economic.section2StartMonth.desc": "Section 2 Start Month Description",
  "50901.ctrl_WorkMode.economic.section2StopDay.desc": "Section 2 Stop Day Description",
  "50901.ctrl_WorkMode.economic.section2StopMonth.desc": "Section 2 Stop Month Description",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1.desc": "Section 2 Off-Peak Start Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2.desc": "Section 2 Off-Peak Start Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1.desc": "Section 2 Off-Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2.desc": "Section 2 Off-Peak Start Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1.desc": "Section 2 Off-Peak Stop Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2.desc": "Section 2 Off-Peak Stop Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1.desc": "Section 2 Off-Peak Stop Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2.desc": "Section 2 Off-Peak Stop Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.desc": "Section 2 Week Range 1 Description",
  "50901.ctrl_WorkMode.economic.section2WeekRange2.desc": "Section 2 Week Range 2 Description",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1.desc": "Section 3 Peak Start Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2.desc": "Section 3 Peak Start Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1.desc": "Section 3 Peak Start Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2.desc": "Section 3 Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1.desc": "Section 3 Peak Stop Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2.desc": "Section 3 Peak Stop Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1.desc": "Section 3 Peak Stop Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2.desc": "Section 3 Peak Stop Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section3StartDay.desc": "Section 3 Start Day Description",
  "50901.ctrl_WorkMode.economic.section3StartMonth.desc": "Section 3 Start Month Description",
  "50901.ctrl_WorkMode.economic.section3StopDay.desc": "Section 3 Stop Day Description",
  "50901.ctrl_WorkMode.economic.section3StopMonth.desc": "Section 3 Stop Month Description",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1.desc": "Section 3 Off-Peak Start Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2.desc": "Section 3 Off-Peak Start Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1.desc": "Section 3 Off-Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2.desc": "Section 3 Off-Peak Start Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1.desc": "Section 3 Off-Peak Stop Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2.desc": "Section 3 Off-Peak Stop Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1.desc": "Section 3 Off-Peak Stop Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2.desc": "Section 3 Off-Peak Stop Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.desc": "Section 3 Week Range 1 Description",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.desc": "Section 3 Week Range 2 Description",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1.desc": "Section 4 Peak Start Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2.desc": "Section 4 Peak Start Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1.desc": "Section 4 Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2.desc": "Section 4 Peak Start Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1.desc": "Section 4 Peak Stop Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2.desc": "Section 4 Peak Stop Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1.desc": "Section 4 Peak Stop Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2.desc": "Section 4 Peak Stop Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section4StartDay.desc": "Section 4 Start Day Description",
  "50901.ctrl_WorkMode.economic.section4StartMonth.desc": "Section 4 Start Month Description",
  "50901.ctrl_WorkMode.economic.section4StopDay.desc": "Section 4 Stop Day Description",
  "50901.ctrl_WorkMode.economic.section4StopMonth.desc": "Section 4 Stop Month Description",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1.desc": "Section 4 Off-Peak Start Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2.desc": "Section 4 Off-Peak Start Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1.desc": "Section 4 Off-Peak Start Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2.desc": "Section 4 Off-Peak Start Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1.desc": "Section 4 Off-Peak Stop Time 1 - Hour Description",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2.desc": "Section 4 Off-Peak Stop Time 2 - Hour Description",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1.desc": "Section 4 Off-Peak Stop Time 1 - Minute Description",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2.desc": "Section 4 Off-Peak Stop Time 2 - Minute Description",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.desc": "Section 4 Week Range 1 Description",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.desc": "Section 4 Week Range 2 Description",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc.desc": "Force Charge SOC Description",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower.desc": "Max Charge Power Description",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc.desc": "Force Discharge SOC Description",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower.desc": "Max Discharge Power Description",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower.desc": "Peak Meter Power Description",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc.desc": "Peak Meter SOC Description",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc.desc": "Self-Use SOC Description",
  "50901.ctrl_WorkMode.Switch.workMode.desc": "EMS Working Mode Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange.desc": "TOU Mode Time Range Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH.desc": "Usage Time Time1 Charge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin.desc": "Usage Time Time1 Charge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower.desc": "Charge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH.desc": "Usage Time Time1 Charge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin.desc": "Usage Time Time1 Charge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc.desc": "Charge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH.desc": "Usage Time Time1 Discharge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin.desc": "Usage Time Time1 Discharge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH.desc": "Usage Time Time1 Discharge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin.desc": "Usage Time Time1 Discharge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc.desc": "Discharge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH.desc": "Usage Time Time2 Charge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin.desc": "Usage Time Time2 Charge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower.desc": "Charge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH.desc": "Usage Time Time2 Charge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin.desc": "Usage Time Time2 Charge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc.desc": "Charge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH.desc": "Usage Time Time2 Discharge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin.desc": "Usage Time Time2 Discharge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH.desc": "Usage Time Time2 Discharge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin.desc": "Usage Time Time2 Discharge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc.desc": "Discharge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH.desc": "Usage Time Time3 Charge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin.desc": "Usage Time Time3 Charge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower.desc": "Charge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH.desc": "Usage Time Time3 Charge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin.desc": "Usage Time Time3 Charge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc.desc": "Charge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH.desc": "Usage Time Time3 Discharge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin.desc": "Usage Time Time3 Discharge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH.desc": "Usage Time Time3 Discharge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin.desc": "Usage Time Time3 Discharge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc.desc": "Discharge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH.desc": "Usage Time Time4 Charge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin.desc": "Usage Time Time4 Charge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower.desc": "Charge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH.desc": "Usage Time Time4 Charge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin.desc": "Usage Time Time4 Charge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc.desc": "Charge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH.desc": "Usage Time Time4 Discharge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin.desc": "Usage Time Time4 Discharge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH.desc": "Usage Time Time4 Discharge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin.desc": "Usage Time Time4 Discharge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc.desc": "Discharge Cut-off Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH.desc": "Usage Time Time5 Charge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin.desc": "Usage Time Time5 Charge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower.desc": "Charge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH.desc": "Usage Time Time5 Charge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin.desc": "Usage Time Time5 Charge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc.desc": "Charge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH.desc": "Usage Time Time5 Discharge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin.desc": "Usage Time Time5 Discharge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH.desc": "Usage Time Time5 Discharge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin.desc": "Usage Time Time5 Discharge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc.desc": "Discharge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH.desc": "Usage Time Time6 Charge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin.desc": "Usage Time Time6 Charge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower.desc": "Charge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH.desc": "Usage Time Time6 Charge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin.desc": "Usage Time Time6 Charge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc.desc": "Charge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH.desc": "Usage Time Time6 Discharge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin.desc": "Usage Time Time6 Discharge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH.desc": "Usage Time Time6 Discharge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin.desc": "Usage Time Time6 Discharge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc.desc": "Discharge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH.desc": "Usage Time Time7 Charge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin.desc": "Usage Time Time7 Charge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH.desc": "Usage Time Time7 Charge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin.desc": "Usage Time Time7 Charge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc.desc": "Discharge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH.desc": "Usage Time Time7 Discharge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin.desc": "Usage Time Time7 Discharge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH.desc": "Usage Time Time7 Discharge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin.desc": "Usage Time Time7 Discharge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc.desc": "Discharge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH.desc": "Usage Time Time8 Charge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin.desc": "Usage Time Time8 Charge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower.desc": "Charge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH.desc": "Usage Time Time8 Charge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin.desc": "Usage Time Time8 Charge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc.desc": "Charge Cut-off Capacity Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH.desc": "Usage Time Time8 Discharge End - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin.desc": "Usage Time Time8 Discharge End - Minute Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower.desc": "Discharge Power Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH.desc": "Usage Time Time8 Discharge Start - H Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin.desc": "Usage Time Time8 Discharge Start - Min Description",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc.desc": "Discharge Cut-off Capacity Description",
  "50901.real_time.bmsSoftwareVersion.desc": "BMS Version - Software Description",
  "50901.real_time.commAddress10Slave9.desc": "Communication Address 10 (Slave 9) Description",
  "50901.real_time.commAddress1Master.desc": "Communication Address 1 (Master) Description",
  "50901.real_time.commAddress2Slave1.desc": "Communication Address 2 (Slave 1) Description",
  "50901.real_time.commAddress3Slave2.desc": "Communication Address 3 (Slave 2) Description",
  "50901.real_time.commAddress3Slave3.desc": "Communication Address 4 (Slave 3) Description",
  "50901.real_time.commAddress4Slave4.desc": "Communication Address 5 (Slave 4) Description",
  "50901.real_time.commAddress6Slave6.desc": "Communication Address 6 (Slave 5) Description",
  "50901.real_time.commAddress7Slave6.desc": "Communication Address 7 (Slave 6) Description",
  "50901.real_time.commAddress8Slave7.desc": "Communication Address 8 (Slave 7) Description",
  "50901.real_time.commAddress9Slave8.desc": "Communication Address 9 (Slave 8) Description",
  "50901.real_time.epsCurrentA.desc": "EPS Side Phase A Current Description",
  "50901.real_time.epsCurrentB.desc": "EPS Side Phase B Current Description",
  "50901.real_time.epsCurrentC.desc": "EPS Side Phase C Current Description",
  "50901.real_time.epsPower.desc": "EPS Side Power Description",
  "50901.real_time.epsPowerA.desc": "EPS Side Phase A Power Description",
  "50901.real_time.epsPowerB.desc": "EPS Side Phase B Power Description",
  "50901.real_time.epsPowerC.desc": "EPS Side Phase C Power Description",
  "50901.real_time.epsVoltageA.desc": "EPS Side Phase A Voltage Description",
  "50901.real_time.epsVoltageB.desc": "EPS Side Phase B Voltage Description",
  "50901.real_time.epsVoltageC.desc": "EPS Side Phase C Voltage Description",
  "50901.real_time.essAccessPoint.desc": "ESS Access Point Description",
  "50901.real_time.generatorConnectionStatus.desc": "Generator Connection Status Description",
  "50901.real_time.generatorVoltageA.desc": "Generator Phase A Voltage Description",
  "50901.real_time.generatorVoltageB.desc": "Generator Phase B Voltage Description",
  "50901.real_time.generatorVoltageC.desc": "Generator Phase C Voltage Description",
  "50901.real_time.invAcFrequency.desc": "Inverter AC Output Frequency Description",
  "50901.real_time.inverCombinedActivePower.desc": "Inverter AC Output Power Description",
  "50901.real_time.invRatedPower.desc": "Rated Power Description",
  "50901.real_time.invRunningtime.desc": "INV Operating Time (Hoymiles: Normal Operation Time) Description",
  "50901.real_time.machineSnMaster.desc": "Master Unit SN Description",
  "50901.real_time.machineSnSlave1.desc": "Slave 1 SN Description",
  "50901.real_time.machineSnSlave2.desc": "Slave 2 SN Description",
  "50901.real_time.machineSnSlave3.desc": "Slave 3 SN Description",
  "50901.real_time.machineSnSlave4.desc": "Slave 4 SN Description",
  "50901.real_time.machineSnSlave5.desc": "Slave 5 SN Description",
  "50901.real_time.machineSnSlave6.desc": "Slave 6 SN Description",
  "50901.real_time.machineSnSlave7.desc": "Slave 7 SN Description",
  "50901.real_time.machineSnSlave8.desc": "Slave 8 SN Description",
  "50901.real_time.machineSnSlave9.desc": "Slave 9 SN Description",
  "50901.real_time.numberOfUnits.desc": "Unit Quantity Description",
  "50901.real_time.phaseAOfInverterActivePower.desc": "Inverter AC Side Phase A Power Description",
  "50901.real_time.phaseAOfInverterSideCurrent.desc": "Inverter AC Side Phase A Current Description",
  "50901.real_time.phaseAOfInverterSideVoltage.desc": "Inverter AC Side Phase A Voltage Description",
  "50901.real_time.phaseBOfInverterActivePower.desc": "Inverter AC Side Phase B Power Description",
  "50901.real_time.phaseBOfInverterSideCurrent.desc": "Inverter AC Side Phase B Current Description",
  "50901.real_time.phaseBOfInverterSideVoltage.desc": "Inverter AC Side Phase B Voltage Description",
  "50901.real_time.phaseCOfInverterActivePower.desc": "Inverter AC Side Phase C Power Description",
  "50901.real_time.phaseCOfInverterSideCurrent.desc": "Inverter AC Side Phase C Current Description",
  "50901.real_time.phaseCOfInverterSideVoltage.desc": "Inverter AC Side Phase C Voltage Description",
  "50901.real_time.pv1Current.desc": "PV1 Current Description",
  "50901.real_time.pv1Power.desc": "PV1 Power Description",
  "50901.real_time.pv1Voltage.desc": "PV1 Voltage Description",
  "50901.real_time.pv2Current.desc": "PV2 Current Description",
  "50901.real_time.pv2Power.desc": "PV2 Power Description",
  "50901.real_time.pv2Voltage.desc": "PV2 Voltage Description",
  "50901.real_time.pv3Current.desc": "PV3 Current Description",
  "50901.real_time.pv3Power.desc": "PV3 Power Description",
  "50901.real_time.pv3Voltage.desc": "PV3 Voltage Description",
  "50901.real_time.pv4Current.desc": "PV4 Current Description",
  "50901.real_time.pv4Power.desc": "PV4 Power Description",
  "50901.real_time.pv4Voltage.desc": "PV4 Voltage Description",
  "50901.real_time.pvConnectionStatus.desc": "PV Connection Status Description",
  "50901.real_time.serviceEntranceBreakerCurrent.desc": "Service Entrance Breaker Current Description",
  "50901.real_time.workStatus.desc": "Operation Status Description",
  "50901..antiIslandingEnable.desc": "Anti-Islanding Enable Description",
  "50901..apcEn.desc": "APC Enable Description",
  "50901..apcPwrLmt.desc": "APC Power Limit Description",
  "50901..apcRamp.desc": "APC Ramp Rate Description",
  "50901..drmEnable.desc": "DRM Enable Description",
  "50901..fixPfTr.desc": "FixPF_Tr Time Description",
  "50901..functionCode.desc": "Function Code Description",
  "50901..fwDelayTime.desc": "FW Delay Time Description",
  "50901..fwOverFdroop.desc": "FW Overfrequency Droop Coefficient Description",
  "50901..fwUnderFdroop.desc": "FW Underfrequency Droop Coefficient Description",
  "50901..gcfExportHardTime.desc": "GCF Export Hard Limit Time Description",
  "50901..gcfGenerationHardLimitRatio.desc": "GCF Generation Hard Limit Ratio Description",
  "50901..gcfGenerationHardTime.desc": "GCF Generation Hard Limit Time Description",
  "50901..gcfGenerationSoftLimitRatio.desc": "GCF Generation Soft Limit Ratio Description",
  "50901..gcfImportHardTime.desc": "GCF Import Hard Limit Time Description",
  "50901..gcfImportLimitRatio.desc": "GCF Import Limit Ratio Description",
  "50901..gcfReconnectionTime.desc": "GCF Reconnection Time Description",
  "50901..gridLevel2LimitTimeScale.desc": "Grid Secondary Limit Time Scale Description",
  "50901..permitEnable.desc": "Permit Enable Description",
  "50901..phaseOrderInverseDisable.desc": "Phase Sequence Reverse Disable Description",
  "50901..pqFuncCode.desc": "PQ Function Code Description",
  "50901..pqP1.desc": "PQ_P1 Description",
  "50901..pqP2.desc": "PQ_P2 Description",
  "50901..pqP3.desc": "PQ_P3 Description",
  "50901..pqP4.desc": "PQ_P4 Description",
  "50901..pqP5.desc": "PQ_P5 Description",
  "50901..pqP6.desc": "PQ_P6 Description",
  "50901..pqQ1.desc": "PQ_Q1 Description",
  "50901..pqQ2.desc": "PQ_Q2 Description",
  "50901..pqQ3.desc": "PQ_Q3 Description",
  "50901..pqQ4.desc": "PQ_Q4 Description",
  "50901..pqQ5.desc": "PQ_Q5 Description",
  "50901..pqQ6.desc": "PQ_Q6 Description",
  "50901..pqTr.desc": "PQ_Tr Time Description",
  "50901..relayU16NlineRlyTestDis.desc": "Relay N Test Disable Description",
  "50901..rpaP1.desc": "RPA_P1 Description",
  "50901..rpaP2.desc": "RPA_P2 Description",
  "50901..rpaQ1.desc": "RPA_Q1 Description",
  "50901..rpaQ2.desc": "RPA_Q2 Description",
  "50901..vvTr.desc": "VV_Tr Time Description",
  "50901..wattRegulationPriority.desc": "Watt Priority Description",
  "50901..wpfTr.desc": "WPF_Tr Time Description",
  "50901.ctrl_Config.Battery.absorptionVoltage.desc": "Absorption Voltage Description",
  "50901.ctrl_Config.Battery.batteryCapacity.desc": "BMS Capacity Description",
  "50901.ctrl_Config.Battery.endChargeVoltage.desc": "Charge Termination Voltage Description",
  "50901.ctrl_Config.Battery.endOfChargeCurrent.desc": "Charge End Current Description",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout.desc": "Equalization Charge Timeout Description",
  "50901.ctrl_Config.Battery.equalizationEnable.desc": "Equalization Enable Description",
  "50901.ctrl_Config.Battery.equalizationIntervalDays.desc": "Equalization Interval Days Description",
  "50901.ctrl_Config.Battery.equalizationTime.desc": "Equalization Time Description",
  "50901.ctrl_Config.Battery.equalizationVoltage.desc": "Equalization Voltage Description",
  "50901.ctrl_Config.Battery.floatVoltage.desc": "Float Voltage Description",
  "50901.ctrl_Config.Battery.initialResistance.desc": "Initial Resistance Description",
  "50901.ctrl_Config.Battery.maximumChargeLimit.desc": "Max Charge Limit Description",
  "50901.ctrl_Config.Battery.maximumDischargeLimit.desc": "Max Discharge Limit Description",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor.desc": "Temperature Correction Coefficient Description",
  "50901.ctrl_Config.Connection.dtu_comm_enable.desc": "DTU Communication Enable Description",
  "50901.ctrl_Config.Device.arcFaultClear.desc": "Arc Fault Clear Description",
  "50901.ctrl_Config.Device.batActivate.desc": "Battery Activation Description",
  "50901.ctrl_Config.Device.batteryBalancing.desc": "Battery Balancing Description",
  "50901.ctrl_Config.Device.clearFault.desc": "Fault Clear Description",
  "50901.ctrl_Config.Device.parallelNetworking.desc": "Parallel Network Description",
  "50901.ctrl_Config.Device.restartSystem.desc": "System Restart Description",
  "50901.ctrl_Config.Device.restoreDefault.desc": "Restore Defaults Description",
  "50901.ctrl_Config.Device.selfTest.desc": "Self-Test Description",
  "50901.ctrl_Config.Device.systemPowerOnOff.desc": "System Power On/Off Description",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH.desc": "Generator Control - Charge End Time - H Description",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin.desc": "Generator Control - Charge End Time - Minute Description",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH.desc": "Generator Control - Charge Start Time - H Description",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin.desc": "Generator Control - Charge Start Time - Minute Description",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity.desc": "Generator Shutdown Battery Capacity Description",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.desc": "Generator Mode Description",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity.desc": "Generator Start Battery Capacity Description",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.desc": "Generator Exercise Mode Frequency Description",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.desc": "Generator Exercise Mode Description",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime.desc": "Generator Exercise Mode Runtime Description",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH.desc": "Generator Exercise Mode Start Time - Hour Description",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin.desc": "Generator Exercise Mode Start Time - Minute Description",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.desc": "Generator Exercise Mode Start Time Description",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH.desc": "Standby Time 1 End - H Description",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin.desc": "Standby Time 1 End - Minute Description",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH.desc": "Standby Time 1 Start - H Description",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin.desc": "Standby Time 1 Start - Minute Description",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH.desc": "Standby Time 2 End - H Description",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin.desc": "Standby Time 2 End - Minute Description",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH.desc": "Standby Time 2 Start - H Description",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin.desc": "Standby Time 2 Start - Minute Description",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable.desc": "Standby Time Enable Description",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.desc": "Load Control Mode Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.desc": "Load Control Monday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.desc": "Load Control Tuesday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.desc": "Load Control Wednesday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.desc": "Load Control Thursday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.desc": "Load Control Friday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.desc": "Load Control Saturday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.desc": "Load Control Sunday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.desc": "Manual Mode Switch Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower.desc": "Load Mode Load Power Threshold Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime.desc": "Load Control Minimum On Time Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc.desc": "Off-Grid Protection SOC Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1.desc": "Time Range 1 Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.desc": "Monday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.desc": "Tuesday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.desc": "Wednesday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.desc": "Thursday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.desc": "Friday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.desc": "Saturday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.desc": "Sunday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour.desc": "Timer 1 End - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2.desc": "Timer 1 End_2 - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3.desc": "Time Slot 1 End - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute.desc": "Timer 1 End - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2.desc": "Timer 1 End_2 - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3.desc": "Time Slot 1 End - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min.desc": "Timer 1 Start - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2.desc": "Timer 1 Start_2 - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3.desc": "Time Slot 1 Start - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour.desc": "Timer 2 End - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2.desc": "Timer 2 End_2 - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3.desc": "Time Slot 2 End - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes.desc": "Timer 2 End - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2.desc": "Timer 2 End_2 - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3.desc": "Time Slot 2 End - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes.desc": "Timer 2 Start - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2.desc": "Timer 2 Start_2 - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3.desc": "Time Slot 2 Start - Minute Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour.desc": "Timer 1 Start - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2.desc": "Timer 1 Start_2 - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3.desc": "Time Slot 1 Start - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour.desc": "Timer 2 Start - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2.desc": "Timer 2 Start_2 - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3.desc": "Time Slot 2 Start - Hour Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.desc": "Monday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.desc": "Tuesday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.desc": "Wednesday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.desc": "Thursday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.desc": "Friday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.desc": "Saturday Description",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.desc": "Sunday Description",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.desc": "Dry Contact Working Mode Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak.desc": "Peak Battery Max Discharge Power Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak.desc": "Peak Grid Feed-In Power Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower.desc": "Battery Max Charge Power Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower.desc": "Battery Max Discharge Power Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime.desc": "Lead-Acid Battery Maintenance Time Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc.desc": "Max Soc Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc.desc": "Min Soc Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower.desc": "Power Compensation Description",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower.desc": "Rsvd Reserve Power Description",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.desc": "Bypass Disable Description",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.desc": "Eps Mode Description",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.desc": "Pv Mode Enable Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq.desc": "Generator Frequency Upper Limit Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt.desc": "Generator Voltage Upper Limit Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq.desc": "Generator Frequency Lower Limit Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt.desc": "Generator Voltage Lower Limit Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power.desc": "Generator-to-Battery Charge Power in Multi-Unit Parallel Description",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.desc": "Global Scan Enable Description",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley.desc": "Limit Grid Power Description",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.desc": "Mid / Gateway Enable Description",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.desc": "Three-Phase Imbalance Enable Description",
  "50901.ctrl_Safety.DCI.dciEnable.desc": "DCI Enable Description",
  "50901.ctrl_Safety.DCI.lowerLimit.desc": "DCI Lower Limit Current Description",
  "50901.ctrl_Safety.DCI.lowerTime.desc": "DCI Lower Limit Time Description",
  "50901.ctrl_Safety.DCI.upperLimit.desc": "DCI Upper Limit Current Description",
  "50901.ctrl_Safety.DCI.upperTime.desc": "DCI Upper Limit Time Description",
  "50901.ctrl_Safety.FRT.frtFuncCode.desc": "FRT Function Code Description",
  "50901.ctrl_Safety.FRT.frtHighLimit1.desc": "Frequency Upper Limit 1 Description",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time.desc": "Frequency Upper Limit 1 Duration Description",
  "50901.ctrl_Safety.FRT.frtHighLimit2.desc": "Frequency Upper Limit 2 Description",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time.desc": "Frequency Upper Limit 2 Duration Description",
  "50901.ctrl_Safety.FRT.frtHighLimit3.desc": "Frequency Upper Limit 3 Description",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time.desc": "Frequency Upper Limit 3 Duration Description",
  "50901.ctrl_Safety.FRT.frtLowLimit1.desc": "Frequency Lower Limit 1 Description",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time.desc": "Frequency Lower Limit 1 Duration Description",
  "50901.ctrl_Safety.FRT.frtLowLimit2.desc": "Frequency Lower Limit 2 Description",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time.desc": "Frequency Lower Limit 2 Duration Description",
  "50901.ctrl_Safety.FRT.frtLowLimit3.desc": "Frequency Lower Limit 3 Description",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time.desc": "Frequency Lower Limit 3 Duration Description",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.desc": "FW Battery Mode Difference Enable Description",
  "50901.ctrl_Safety.FW.fwEnable.desc": "FW Enable Description",
  "50901.ctrl_Safety.FW.fwFuncCode.desc": "FW Function Code Description",
  "50901.ctrl_Safety.FW.fwOverEndFreq.desc": "FW Overfrequency End Frequency Description",
  "50901.ctrl_Safety.FW.fwOverStartFreq.desc": "FW Overfrequency Start Frequency Description",
  "50901.ctrl_Safety.FW.fwOverTransFreq.desc": "FW Overfrequency Transition Frequency Description",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency.desc": "FW Recovery Frequency Lower Limit Description",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime.desc": "FW Recovery Stabilization Time Description",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency.desc": "FW Recovery Frequency Upper Limit Description",
  "50901.ctrl_Safety.FW.fwTr.desc": "FW_Tr Time Description",
  "50901.ctrl_Safety.FW.fwUnderEndFreq.desc": "FW Underfrequency End Frequency Description",
  "50901.ctrl_Safety.FW.fwUnderStartFreq.desc": "FW Underfrequency Start Frequency Description",
  "50901.ctrl_Safety.FW.fwUnderStopFreq.desc": "FW Underfrequency Stop Frequency Description",
  "50901.ctrl_Safety.RCD.continueLimitTime.desc": "RCD Continuous Limit Time Description",
  "50901.ctrl_Safety.RCD.continueLimitValue.desc": "RCD Continuous Limit Current Description",
  "50901.ctrl_Safety.RCD.rcdEnable.desc": "RCD Enable Description",
  "50901.ctrl_Safety.RCD.step1LimitTime.desc": "RCD Step 1 Limit Time Description",
  "50901.ctrl_Safety.RCD.step1LimitValue.desc": "RCD Step 1 Limit Current Description",
  "50901.ctrl_Safety.RCD.step2LimitTime.desc": "RCD Step 2 Limit Time Description",
  "50901.ctrl_Safety.RCD.step2LimitValue.desc": "RCD Step 2 Limit Current Description",
  "50901.ctrl_Safety.RCD.step3LimitTime.desc": "RCD Step 3 Limit Time Description",
  "50901.ctrl_Safety.RCD.step3LimitValue.desc": "RCD Step 3 Limit Current Description",
  "50901.ctrl_Safety.RPC.gcfEn.desc": "GCF Enable Description",
  "50901.ctrl_Safety.RPC.gcfFuncCode.desc": "GCF Function Code Description",
  "50901.ctrl_Safety.RPC.rpcMode.desc": "RP Mode Description",
  "50901.ctrl_Safety.RPC.rpcPf.desc": "RPC Power Factor PF Description",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio.desc": "RPC Reactive Power Ratio Description",
  "50901.ctrl_Safety.RPC.rpcTr.desc": "RPC_Tr Time Description",
  "50901.ctrl_Safety.RPC.vvFuncCode.desc": "VV Function Code Description",
  "50901.ctrl_Safety.RPC.vvLockIn.desc": "VV Lock-in Value Description",
  "50901.ctrl_Safety.RPC.vvLockOut.desc": "VV Lock-out Value Description",
  "50901.ctrl_Safety.RPC.vvQ1.desc": "VV_Q1 Description",
  "50901.ctrl_Safety.RPC.vvQ2.desc": "VV_Q2 Description",
  "50901.ctrl_Safety.RPC.vvQ3.desc": "VV_Q3 Description",
  "50901.ctrl_Safety.RPC.vvQ4.desc": "VV_Q4 Description",
  "50901.ctrl_Safety.RPC.vvV1.desc": "VV_V1 Description",
  "50901.ctrl_Safety.RPC.vvV2.desc": "VV_V2 Description",
  "50901.ctrl_Safety.RPC.vvV3.desc": "VV_V3 Description",
  "50901.ctrl_Safety.RPC.vvV4.desc": "VV_V4 Description",
  "50901.ctrl_Safety.RPC.vvVref.desc": "VV Reference Value (Vref) Description",
  "50901.ctrl_Safety.RPC.vvVrefTr.desc": "VV Reference Value Tr Time Description",
  "50901.ctrl_Safety.RPC.wpfFuncCode.desc": "WPF Function Code Description",
  "50901.ctrl_Safety.RPC.wpfLockIn.desc": "WPF Lock-in Value Description",
  "50901.ctrl_Safety.RPC.wpfLockOut.desc": "WPF Lock-out Value Description",
  "50901.ctrl_Safety.RPC.wpfMinPFOver.desc": "WPF Overpower Min PF Description",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder.desc": "WPF Underpower Min PF Description",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio.desc": "WPF Power End Ratio Description",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio.desc": "WPF Power Start Ratio Description",
  "50901.ctrl_Safety.RR.rrFuncCode.desc": "RR Function Code Description",
  "50901.ctrl_Safety.RR.rrRurNm.desc": "RR_RUR_NM Description",
  "50901.ctrl_Safety.RR.rrRurSs.desc": "RR_RUR_SS Description",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue.desc": "RT Frequency Recovery Upper Limit Description",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue.desc": "RT Frequency Recovery Lower Limit Description",
  "50901.ctrl_Safety.RT.rtFuncCode.desc": "RT Function Code Description",
  "50901.ctrl_Safety.RT.rtNMTime.desc": "RT_NM Time Description",
  "50901.ctrl_Safety.RT.rtSRTTime.desc": "RT_SRT Time Description",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue.desc": "RT Voltage Recovery Upper Limit Description",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue.desc": "RT Voltage Recovery Lower Limit Description",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage.desc": "10-Minute Average Voltage Description",
  "50901.ctrl_Safety.VRT.vrtEn.desc": "VRT Enable Description",
  "50901.ctrl_Safety.VRT.vrtFuncCode.desc": "VRT Function Code Description",
  "50901.ctrl_Safety.VRT.vrtHighLimit.desc": "VRT High Voltage Threshold Description",
  "50901.ctrl_Safety.VRT.vrtLowLimit.desc": "VRT Low Voltage Threshold Description",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime.desc": "VRT Recovery Stabilization Time Description",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime.desc": "Instantaneous Overvoltage Duration Description",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage.desc": "Instantaneous Overvoltage Threshold Description",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1.desc": "Voltage Upper Limit 1 Description",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time.desc": "Voltage Upper Limit 1 Duration Description",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2.desc": "Voltage Upper Limit 2 Description",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time.desc": "Voltage Upper Limit 2 Duration Description",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3.desc": "Voltage Upper Limit 3 Description",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time.desc": "Voltage Upper Limit 3 Duration Description",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1.desc": "Voltage Lower Limit 1 Description",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time.desc": "Voltage Lower Limit 1 Duration Description",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2.desc": "Voltage Lower Limit 2 Description",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time.desc": "Voltage Lower Limit 2 Duration Description",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3.desc": "Voltage Lower Limit 3 Description",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time.desc": "Voltage Lower Limit 3 Duration Description",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.desc": "VW Battery Mode Difference Enable Description",
  "50901.ctrl_Safety.VW.vwEnable.desc": "VW Enable Description",
  "50901.ctrl_Safety.VW.vwFuncCode.desc": "VW Function Code Description",
  "50901.ctrl_Safety.VW.vwOverEndVolt.desc": "VW Overvoltage End Voltage Description",
  "50901.ctrl_Safety.VW.vwOverKPVolt.desc": "VW Overvoltage KP Voltage / Coefficient Voltage Description",
  "50901.ctrl_Safety.VW.vwOverStartVolt.desc": "VW Overvoltage Start Voltage Description",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage.desc": "VW Recovery Voltage Lower Limit Description",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime.desc": "VW Recovery Stabilization Time Description",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage.desc": "VW Recovery Voltage Upper Limit Description",
  "50901.ctrl_Safety.VW.vwTr.desc": "VW_Tr Time Description",
  "50901.ctrl_Safety.VW.vwUnderEndVolt.desc": "VW Undervoltage End Voltage Description",
  "50901.ctrl_Safety.VW.vwUnderKPVolt.desc": "VW Undervoltage KP Voltage / Coefficient Voltage Description",
  "50901.ctrl_Safety.VW.vwUnderStartVolt.desc": "VW Undervoltage Start Voltage Description",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio.desc": "GCF Export Hard Limit Ratio Description",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio.desc": "GCF Export Soft Limit Ratio Description",
  "50901.real_time.BatteryModel.desc": "Battery Model Description",
  "50901.real_time.cfgMultPcsBmsFlag.desc": "BMS Flag Description",
  "50901.real_time.inverterSn.desc": "Inverter SN Description",
  "50901..brightness.desc": "Display Brightness Description",
  "50901.ctrl_Config.Device.networkingType.1": "Wifi",
  "50901.ctrl_Config.Device.networkingType.2": "Ethernet",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.1": "Enable",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.desc": "Generator Port Mode Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.desc": "Generator Location Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay.desc": "Generator Shutdown Delay Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time.desc": "Generator Synchronization Time Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.desc": "Generator Type Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time.desc": "Max Runtime Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time.desc": "Min Runtime Description",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold.desc": "Operation Protection Interval Description",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.desc": "Grid Ct Reverse Enable Description",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio.desc": "Grid Ct Meter Turns Ratio Setting Description",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.desc": "Meter Model Description",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.desc": "Pv Ct Reverse Enable Description",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio.desc": "Pv Ct Meter Turns Ratio Setting Description",
  "50901.fault.arcFault.00": "Disable",
  "50901.fault.arcFault.01": "Enable",
  "50901.fault.arcSelfTestFault.00": "Disable",
  "50901.fault.arcSelfTestFault.01": "Enable",
  "50901.fault.armCommunicationFault.00": "Disable",
  "50901.fault.armCommunicationFault.01": "Enable",
  "50901.fault.auxiliaryPowerAbnormality.00": "Disable",
  "50901.fault.auxiliaryPowerAbnormality.01": "Enable",
  "50901.Fault.batteryCapacityAbnormality.00": "Disable",
  "50901.Fault.batteryCapacityAbnormality.01": "Enable",
  "50901.Fault.batteryFault.00": "Disable",
  "50901.Fault.batteryFault.01": "Enable",
  "50901.Fault.batteryForceChargeRequest.00": "Disable",
  "50901.Fault.batteryForceChargeRequest.01": "Enable",
  "50901.Fault.bmsCanCommunicationAbnormality.00": "Disable",
  "50901.Fault.bmsCanCommunicationAbnormality.01": "Enable",
  "50901.fault.busbarAbnormality.00": "Disable",
  "50901.fault.busbarAbnormality.01": "Enable",
  "50901.fault.cmpssBiasCalculationError.00": "Disable",
  "50901.fault.cmpssBiasCalculationError.01": "Enable",
  "50901.fault.comparatorFault.00": "Disable",
  "50901.fault.comparatorFault.01": "Enable",
  "50901.fault.driveAbnormality.00": "Disable",
  "50901.fault.driveAbnormality.01": "Enable",
  "50901.Fault.dspPwrCommunicationAbnormality.00": "Disable",
  "50901.Fault.dspPwrCommunicationAbnormality.01": "Enable",
  "50901.Fault.dspSafCommunicationAbnormality.00": "Disable",
  "50901.Fault.dspSafCommunicationAbnormality.01": "Enable",
  "50901.Fault.dtsCommunicationAbnormality.00": "Disable",
  "50901.Fault.dtsCommunicationAbnormality.01": "Enable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.00": "Disable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.01": "Enable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.00": "Disable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.01": "Enable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.00": "Disable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.01": "Enable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.00": "Disable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.01": "Enable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.00": "Disable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.01": "Enable",
  "50901.fault.e2rpomFault.00": "Disable",
  "50901.fault.e2rpomFault.01": "Enable",
  "50901.fault.emergencyStopSwitchStatus.00": "Disable",
  "50901.fault.emergencyStopSwitchStatus.01": "Enable",
  "50901.fault.epsOverload.00": "Disable",
  "50901.fault.epsOverload.01": "Enable",
  "50901.fault.epsRelayProtection.00": "Disable",
  "50901.fault.epsRelayProtection.01": "Enable",
  "50901.fault.epsVoltageAbnormality.00": "Disable",
  "50901.fault.epsVoltageAbnormality.01": "Enable",
  "50901.Fault.evCharger1CommunicationAbnormality.00": "Disable",
  "50901.Fault.evCharger1CommunicationAbnormality.01": "Enable",
  "50901.Fault.evCharger1Fault.00": "Disable",
  "50901.Fault.evCharger1Fault.01": "Enable",
  "50901.Fault.evCharger2CommunicationAbnormality.00": "Disable",
  "50901.Fault.evCharger2CommunicationAbnormality.01": "Enable",
  "50901.Fault.evCharger2Fault.00": "Disable",
  "50901.Fault.evCharger2Fault.01": "Enable",
  "50901.fault.fanFault.00": "Disable",
  "50901.fault.fanFault.01": "Enable",
  "50901.Fault.fanSpeedAbnormality.00": "Disable",
  "50901.Fault.fanSpeedAbnormality.01": "Enable",
  "50901.fault.fiveVoltPowerSupplyFault.00": "Disable",
  "50901.fault.fiveVoltPowerSupplyFault.01": "Enable",
  "50901.fault.flashCommunicationFault.00": "Disable",
  "50901.fault.flashCommunicationFault.01": "Enable",
  "50901.fault.frequencyVariationRateOutOfRange.00": "Disable",
  "50901.fault.frequencyVariationRateOutOfRange.01": "Enable",
  "50901.fault.genAbnormality.00": "Disable",
  "50901.fault.genAbnormality.01": "Enable",
  "50901.fault.genOverload.00": "Disable",
  "50901.fault.genOverload.01": "Enable",
  "50901.fault.genPortOvercurrent.00": "Disable",
  "50901.fault.genPortOvercurrent.01": "Enable",
  "50901.fault.genRelayAFault.00": "Disable",
  "50901.fault.genRelayAFault.01": "Enable",
  "50901.fault.genRelayBFault.00": "Disable",
  "50901.fault.genRelayBFault.01": "Enable",
  "50901.fault.gridCurrentDcOffsetOutOfRange.00": "Disable",
  "50901.fault.gridCurrentDcOffsetOutOfRange.01": "Enable",
  "50901.fault.gridMeter.00": "Disable",
  "50901.fault.gridMeter.01": "Enable",
  "50901.Fault.gridMeterCommunicationAbnormality.00": "Disable",
  "50901.Fault.gridMeterCommunicationAbnormality.01": "Enable",
  "50901.Fault.gridMeterTypeError.00": "Disable",
  "50901.Fault.gridMeterTypeError.01": "Enable",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.00": "Disable",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.01": "Enable",
  "50901.fault.gridOverfrequency.00": "Disable",
  "50901.fault.gridOverfrequency.01": "Enable",
  "50901.fault.gridOvervoltage.00": "Disable",
  "50901.fault.gridOvervoltage.01": "Enable",
  "50901.fault.gridPortOvercurrent.00": "Disable",
  "50901.fault.gridPortOvercurrent.01": "Enable",
  "50901.fault.gridPowerOutage.00": "Disable",
  "50901.fault.gridPowerOutage.01": "Enable",
  "50901.fault.gridRelayProtection.00": "Disable",
  "50901.fault.gridRelayProtection.01": "Enable",
  "50901.fault.gridUnderfrequency.00": "Disable",
  "50901.fault.gridUnderfrequency.01": "Enable",
  "50901.fault.gridUndervoltage.00": "Disable",
  "50901.fault.gridUndervoltage.01": "Enable",
  "50901.fault.gridVoltageAbnormality.00": "Disable",
  "50901.fault.gridVoltageAbnormality.01": "Enable",
  "50901.Fault.hmidCommunicationAbnormality.00": "Disable",
  "50901.Fault.hmidCommunicationAbnormality.01": "Enable",
  "50901.Fault.hmidMachineFault.00": "Disable",
  "50901.Fault.hmidMachineFault.01": "Enable",
  "50901.fault.insulationFault.00": "Disable",
  "50901.fault.insulationFault.01": "Enable",
  "50901.fault.interruptOverflow.00": "Disable",
  "50901.fault.interruptOverflow.01": "Enable",
  "50901.fault.inverterCanCommunicationFailed.00": "Disable",
  "50901.fault.inverterCanCommunicationFailed.01": "Enable",
  "50901.fault.inverterCommunicationFailed.00": "Disable",
  "50901.fault.inverterCommunicationFailed.01": "Enable",
  "50901.fault.kmRelayFault.00": "Disable",
  "50901.fault.kmRelayFault.01": "Enable",
  "50901.fault.lineToEarthFault.00": "Disable",
  "50901.fault.lineToEarthFault.01": "Enable",
  "50901.fault.loadRelayAFault.00": "Disable",
  "50901.fault.loadRelayAFault.01": "Enable",
  "50901.fault.loadRelayBFault.00": "Disable",
  "50901.fault.loadRelayBFault.01": "Enable",
  "50901.fault.lowAmbientTemperature.00": "Disable",
  "50901.fault.lowAmbientTemperature.01": "Enable",
  "50901.Fault.lowDtuVersion.00": "Disable",
  "50901.Fault.lowDtuVersion.01": "Enable",
  "50901.fault.machineTypeMismatch.00": "Disable",
  "50901.fault.machineTypeMismatch.01": "Enable",
  "50901.Fault.masterSlaveCommunicationAbnormality.00": "Disable",
  "50901.Fault.masterSlaveCommunicationAbnormality.01": "Enable",
  "50901.fault.meterWiringAbnormality.00": "Disable",
  "50901.fault.meterWiringAbnormality.01": "Enable",
  "50901.fault.microelectronicFault.00": "Disable",
  "50901.fault.microelectronicFault.01": "Enable",
  "50901.fault.neutralWireNotConnected.00": "Disable",
  "50901.fault.neutralWireNotConnected.01": "Enable",
  "50901.fault.neutralWireToEarthFault.00": "Disable",
  "50901.fault.neutralWireToEarthFault.01": "Enable",
  "50901.fault.overTemperature.00": "Disable",
  "50901.fault.overTemperature.01": "Enable",
  "50901.fault.overtemperatureAlarm.00": "Disable",
  "50901.fault.overtemperatureAlarm.01": "Enable",
  "50901.fault.pllLockFailed.00": "Disable",
  "50901.fault.pllLockFailed.01": "Enable",
  "50901.fault.preSynchronizationFailed.00": "Disable",
  "50901.fault.preSynchronizationFailed.01": "Enable",
  "50901.fault.pvFault.00": "Disable",
  "50901.fault.pvFault.01": "Enable",
  "50901.Fault.pvMeterCommunicationAbnormality.00": "Disable",
  "50901.Fault.pvMeterCommunicationAbnormality.01": "Enable",
  "50901.Fault.pvMeterTypeError.00": "Disable",
  "50901.Fault.pvMeterTypeError.01": "Enable",
  "50901.fault.pvPortOvercurrent.00": "Disable",
  "50901.fault.pvPortOvercurrent.01": "Enable",
  "50901.fault.pvRelayAbFault.00": "Disable",
  "50901.fault.pvRelayAbFault.01": "Enable",
  "50901.fault.pvVoltageExceedingBusVoltage.00": "Disable",
  "50901.fault.pvVoltageExceedingBusVoltage.01": "Enable",
  "50901.fault.rcdFault.00": "Disable",
  "50901.fault.rcdFault.01": "Enable",
  "50901.fault.rcdSelfTestFault.00": "Disable",
  "50901.fault.rcdSelfTestFault.01": "Enable",
  "50901.fault.reconnectionFailed.00": "Disable",
  "50901.fault.reconnectionFailed.01": "Enable",
  "50901.fault.samplingBiasAbnormality.00": "Disable",
  "50901.fault.samplingBiasAbnormality.01": "Enable",
  "50901.fault.shutDown.00": "Disable",
  "50901.fault.shutDown.01": "Enable",
  "50901.Fault.slaveWrongBatteryConnection.00": "Disable",
  "50901.Fault.slaveWrongBatteryConnection.01": "Enable",
  "50901.fault.smartloadPortOvercurrent.00": "Disable",
  "50901.fault.smartloadPortOvercurrent.01": "Enable",
  "50901.fault.spiCommunicationFault.00": "Disable",
  "50901.fault.spiCommunicationFault.01": "Enable",
  "50901.Fault.sustainedNegativeLoad.00": "Disable",
  "50901.Fault.sustainedNegativeLoad.01": "Enable",
  "50901.fault.temperatureAbnormality.00": "Disable",
  "50901.fault.temperatureAbnormality.01": "Enable",
  "50901.fault.tenMinuteOvervoltage.00": "Disable",
  "50901.fault.tenMinuteOvervoltage.01": "Enable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.00": "Disable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.01": "Enable",
  "50901.fault.twelveVoltPowerSupplyFault.00": "Disable",
  "50901.fault.twelveVoltPowerSupplyFault.01": "Enable",
  "50901.fault.versionMismatch.00": "Disable",
  "50901.fault.versionMismatch.01": "Enable",
  "50901.fault.wiringAbnormality.00": "Disable",
  "50901.fault.wiringAbnormality.01": "Enable",
  "50901.real_time.relayStatus.02": "Generator A Feed",
  "50901.real_time.relayStatus.03": "Generator A Feed",
  "50901.real_time.relayStatus.04": "Generator B Feed",
  "50901.real_time.relayStatus.05": "Generator B Feed",
  "50901.real_time.relayStatus.06": "Generator Ab Feed",
  "50901.real_time.relayStatus.07": "Generator Ab Feed",
  "50901.real_time.relayStatus.08": "Critical Load A Feed",
  "50901.real_time.relayStatus.09": "Critical Load A Feed",
  "50901.real_time.relayStatus.10": "Critical Load B Feed",
  "50901.real_time.relayStatus.14": "Reserved",
  "50901.real_time.relayStatus.15": "Reserved",
  "50901.warning.batteryHighVoltageAlarm.00": "Disable",
  "50901.warning.batteryHighVoltageAlarm.01": "Enable",
  "50901.warning.batteryLowVoltageAlarm.00": "Disable",
  "50901.warning.batteryLowVoltageAlarm.01": "Enable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.00": "Disable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.01": "Enable",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.00": "Disable",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.01": "Enable",
  "50901.warning.canCommunicationTimeout.00": "Disable",
  "50901.warning.canCommunicationTimeout.01": "Enable",
  "50901.warning.chargeHighTemperatureAlarm.00": "Disable",
  "50901.warning.chargeHighTemperatureAlarm.01": "Enable",
  "50901.warning.chargeLowTemperatureAlarm.00": "Disable",
  "50901.warning.chargeLowTemperatureAlarm.01": "Enable",
  "50901.warning.dischargeHighTemperatureAlarm.00": "Disable",
  "50901.warning.dischargeHighTemperatureAlarm.01": "Enable",
  "50901.warning.dischargeLowTemperatureAlarm.00": "Disable",
  "50901.warning.dischargeLowTemperatureAlarm.01": "Enable",
  "50901.warning.hardwareProtection.00": "Disable",
  "50901.warning.hardwareProtection.01": "Enable",
  "50901.warning.inputOvervoltageAlarm.00": "Disable",
  "50901.warning.inputOvervoltageAlarm.01": "Enable",
  "50901.warning.lowBatteryEnergy.00": "Disable",
  "50901.warning.lowBatteryEnergy.01": "Enable",
  "50901..connectionRouterStatus.0": "Not Connected",
  "50901..connectionRouterStatus.1": "Connected",
  "50901..connectionRouterStatus.3": "Not Connected",
  "50901..connectionServerStatus.0": "Not Connected",
  "50901..connectionServerStatus.1": "Connected",
  "50901..connectionServerStatus.2": "Connected",
  "50901..connectionServerStatus.3": "Not Connected",
  "50901.ctrl_Config.Battery.equalizationEnable.0": "No",
  "50901.ctrl_Config.Battery.equalizationEnable.1": "Yes",
  "50901.ctrl_Config.Connection.dtu_comm_enable.0": "Disable",
  "50901.ctrl_Config.Connection.dtu_comm_enable.1": "Enable",
  "50901.ctrl_Config.Device.arcFaultClear.0": "No",
  "50901.ctrl_Config.Device.arcFaultClear.1": "Yes",
  "50901.ctrl_Config.Device.batActivate.0": "No",
  "50901.ctrl_Config.Device.batActivate.1": "Yes",
  "50901.ctrl_Config.Device.batteryBalancing.0": "No",
  "50901.ctrl_Config.Device.batteryBalancing.1": "Yes",
  "50901.ctrl_Config.Device.clearFault.0": "No",
  "50901.ctrl_Config.Device.clearFault.1": "Yes",
  "50901.ctrl_Config.Device.masterSlave.0": "Single Unit",
  "50901.ctrl_Config.Device.masterSlave.1": "Master",
  "50901.ctrl_Config.Device.masterSlave.2": "Slave",
  "50901.ctrl_Config.Device.parallelNetworking.0": "Invalid",
  "50901.ctrl_Config.Device.parallelNetworking.1": "Networking",
  "50901.ctrl_Config.Device.parallelNetworking.2": "Disband Network",
  "50901.ctrl_Config.Device.restartSystem.0": "No",
  "50901.ctrl_Config.Device.restartSystem.1": "Yes",
  "50901.ctrl_Config.Device.restoreDefault.0": "No",
  "50901.ctrl_Config.Device.restoreDefault.1": "Yes",
  "50901.ctrl_Config.Device.selfTest.0": "No",
  "50901.ctrl_Config.Device.selfTest.1": "Yes",
  "50901.ctrl_Config.Device.systemPowerOnOff.0": "Stop System",
  "50901.ctrl_Config.Device.systemPowerOnOff.1": "Start System",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.0": "Off",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.1": "Manual",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.2": "Auto",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.0": "None",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.1": "Weekly",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.2": "Biweekly",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.3": "Triweekly",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.4": "Every 4 Weeks",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.0": "No",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.1": "Yes",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.0": "Disable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.1": "Manual",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.2": "Time Mode",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.3": "Smart Load",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.4": "Off-Grid Smart Load",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.5": "Ev Charger",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.0": "No",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.1": "Yes",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.1": "Enable",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.0": "None",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.1": "Ground Fault",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.2": "Load Control",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.3": "Generator",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.0": "No",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.1": "Yes",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.0": "Disabled",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.1": "Eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.2": "Ups",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.0": "No",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.1": "Yes",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.0": "Monday",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.1": "Tuesday",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.2": "Wednesday",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.3": "Thursday",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.4": "Friday",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.5": "Saturday",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.6": "Sunday",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.00": "Enum Value 0 Description",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.01": "Enum Value 1 Description",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.00": "Enum Value 0 Description",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.01": "Enum Value 2 Description",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.00": "Enum Value 0 Description",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.01": "Enum Value 2 Description",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.00": "Enum Value 0 Description",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.01": "Enum Value 1 Description",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.00": "Enum Value 0 Description",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.01": "Enum Value 2 Description",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.00": "Enum Value 0 Description",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.01": "Enum Value 1 Description",
  "50901.real_time.batteryConnectionStatus.00": "No",
  "50901.real_time.batteryConnectionStatus.01": "Yes",
  "50901.real_time.BatteryModel.10": "Xin Yi Lv",
  "50901.real_time.BatteryModel.11": "Vestwoods Lv",
  "50901.real_time.BatteryModel.12": "Jk Hv",
  "50901.real_time.BatteryModel.13": "Byd Lv",
  "50901.real_time.BatteryModel.14": "Uz Hv",
  "50901.real_time.BatteryModel.15": "Zetara Lv",
  "50901.real_time.BatteryModel.16": "Feb Hv",
  "50901.real_time.BatteryModel.17": "Pytes Lv",
  "50901.real_time.BatteryModel.18": "Dmegc Lv",
  "50901.real_time.BatteryModel.19": "Weineng Lv",
  "50901.real_time.BatteryModel.2": "Pylon Hv",
  "50901.real_time.BatteryModel.20": "Weineng Hv",
  "50901.real_time.BatteryModel.21": "Gsl Lv",
  "50901.real_time.BatteryModel.22": "Hoy Lv",
  "50901.real_time.BatteryModel.23": "Hoy Hv",
  "50901.real_time.BatteryModel.24": "Feb Lv",
  "50901.real_time.BatteryModel.25": "Uhhome Lv",
  "50901.real_time.BatteryModel.26": "Uhhome Hv",
  "50901.real_time.BatteryModel.27": "Byd Hv",
  "50901.real_time.BatteryModel.28": "Vestwoods Hv",
  "50901.real_time.BatteryModel.29": "Phylion Hv",
  "50901.real_time.BatteryModel.3": "Dyness Lv",
  "50901.real_time.BatteryModel.30": "Hoymiles Lv",
  "50901.real_time.BatteryModel.31": "Pholion Lv",
  "50901.real_time.BatteryModel.32": "Wattsonic Lv",
  "50901.real_time.BatteryModel.33": "Enershare Hv",
  "50901.real_time.BatteryModel.34": "Beghelli Lv",
  "50901.real_time.BatteryModel.35": "Lvtopsun Lv",
  "50901.real_time.BatteryModel.36": "Pytes Hv",
  "50901.real_time.BatteryModel.37": "Lvtopsun Hv",
  "50901.real_time.BatteryModel.38": "Raja Hv",
  "50901.real_time.BatteryModel.39": "Felicity Lv",
  "50901.real_time.BatteryModel.4": "Dyness Hv",
  "50901.real_time.BatteryModel.5": "Sunwoda Lv",
  "50901.real_time.BatteryModel.6": "Uz Lv",
  "50901.real_time.BatteryModel.7": "Soluna Hv",
  "50901.real_time.BatteryModel.8": "Soluna Lv",
  "50901.real_time.BatteryModel.9": "Steltec Lv",
  "50901.real_time.batteryType_04.00": "No Battery",
  "50901.real_time.batteryType_04.01": "Lithium Battery",
  "50901.real_time.batteryType_04.02": "Lead-Acid Battery",
  "50901.real_time.batteryWorkingStatus.00": "Standby",
  "50901.real_time.batteryWorkingStatus.01": "Charging",
  "50901.real_time.batteryWorkingStatus.02": "Discharging",
  "50901.real_time.cfgMultPcsBmsFlag.00": "No",
  "50901.real_time.cfgMultPcsBmsFlag.01": "Yes",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.00": "Power Limit Released, Default Mode",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.01": "Inverter Power 0, Off-Grid",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.02": "Charge Power Pc=0, Not Off-Grid",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.03": "Charge Power Pc<50%Pn Rated Power",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.04": "Charge Power Pc<75%Pn Rated Power && Reactive Power Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.05": "Charge Power Pc, No Limit",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.06": "Discharge Power P=0, Not Off-Grid",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.07": "Discharge Power P<50%Pn Rated Power",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.08": "Discharge Power P<75%Pn Rated Power && Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.09": "Discharge Power P, No Limit",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.10": "Charge Power Pc<50%Pn Rated Power --> Charge Power Reduced To 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.11": "Charge Power Pc<50%Pn Rated Power && Q=Qmax",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.12": "Discharge Power P<50%Pn Rated Power --> Discharge Power Reduced To 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.13": "Charge Power Pc<50%Pn Rated Power && Q=-Qmax",
  "50901.real_time.materType.0": "No Grid Meter",
  "50901.real_time.materType.1": "CHINT Single Phase",
  "50901.real_time.materType.2": "CHINT Single Phase",
  "50901.real_time.materType.3": "CHINT Split Phase",
  "50901.real_time.materType.5": "Metering Module",
  "50901.real_time.materType.6": "Acrel Single Circuit",
  "50901.real_time.materType.7": "Acrel Dual Circuit",
  "50901.real_time.meterFlag.0": "Offline",
  "50901.real_time.meterFlag.1": "Online",
  "50901.real_time.meterFlag.3": "Gateway Communication Normal",
  "50901.real_time.meterFlag.4": "Gateway Communication Disconnected",
  "50901.real_time.relayStatus.00": "Km1 Feed",
  "50901.real_time.relayStatus.01": "Km1 Feed",
  "50901.real_time.relayStatus.11": "Critical Load B Feed",
  "50901.real_time.relayStatus.12": "Reserved",
  "50901.real_time.relayStatus.13": "Reserved",
  "50901.real_time.workStatus.00": "Power Initialization",
  "50901.real_time.workStatus.01": "Standby Mode",
  "50901.real_time.workStatus.02": "Grid-Tie Test",
  "50901.real_time.workStatus.03": "Grid-Tie Mode",
  "50901.real_time.workStatus.04": "Fault Mode",
  "50901.real_time.workStatus.05": "Off-Grid Mode",
  "50901.real_time.workStatus.06": "Bypass Mode",
  "50901..antiIslandingEnable.0": "Disable",
  "50901..antiIslandingEnable.1": "Enable",
  "50901..apcEn.0": "Disable",
  "50901..apcEn.1": "Enable",
  "50901..drmEnable.0": "Disable",
  "50901..drmEnable.1": "Enable",
  "50901..permitEnable.0": "Disable",
  "50901..permitEnable.1": "Enable",
  "50901..phaseOrderInverseDisable.00": "Disable",
  "50901..phaseOrderInverseDisable.01": "Enable",
  "50901..relayU16NlineRlyTestDis.00": "Disable",
  "50901..relayU16NlineRlyTestDis.01": "Enable",
  "50901.ctrl_Config.Device.checkTime": "Device Time",
  "50901.ctrl_Config.Device.networkingType": "Grid Connection Type",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent": "Ev Charger Rated Current",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent": "Main Breaker Rated Current",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable": "Timed Mode - Battery Soc Enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc": "Timed Mode - Battery Start Soc",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc": "Timed Mode - Battery Stop Soc",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.0": "Prohibit",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.1": "External Pv",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.2": "External Generator",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.3": "Force Start",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.4": "Local Control",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.0": "None",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.1": "Generator Side",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.2": "Grid Side",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.0": "Manual",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.1": "Di/Do",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.0": "Disable",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.1": "Enable",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.0": "No Meter Used",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.1": "Single Phase Meter",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.2": "Two Phase Meter",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.3": "Three Phase Meter",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.4": "Smart Meter (Hmid)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.5": "Current Transformer (Ct)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.6": "Acrel Single Phase Meter",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.7": "Acrel Two Phase Meter",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.0": "Disable",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.1": "Enable",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.0": "Disable",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.1": "Enable",
  "50901.ctrl_Safety.DCI.dciEnable.0": "Disable",
  "50901.ctrl_Safety.DCI.dciEnable.1": "Enable",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.0": "Disable",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.1": "Enable",
  "50901.ctrl_Safety.FW.fwEnable.0": "Disable",
  "50901.ctrl_Safety.FW.fwEnable.1": "Enable",
  "50901.ctrl_Safety.RCD.rcdEnable.0": "Disable",
  "50901.ctrl_Safety.RCD.rcdEnable.1": "Enable",
  "50901.ctrl_Safety.RPC.gcfEn.0": "Disable",
  "50901.ctrl_Safety.RPC.gcfEn.1": "Enable",
  "50901.ctrl_Safety.RPC.rpcMode.00": "Disable",
  "50901.ctrl_Safety.RPC.rpcMode.01": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety.RPC.rpcMode.02": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety.RPC.rpcMode.03": "PF(P) Curve, PF(P) Mode",
  "50901.ctrl_Safety.RPC.rpcMode.04": "W",
  "50901.ctrl_Safety.RPC.rpcMode.05": "PQ",
  "50901.ctrl_Safety.VRT.vrtEn.0": "Disable",
  "50901.ctrl_Safety.VRT.vrtEn.1": "Enable",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.0": "Disable",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.1": "Enable",
  "50901.ctrl_Safety.VW.vwEnable.0": "Disable",
  "50901.ctrl_Safety.VW.vwEnable.1": "Enable",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc": "Tou Mode Reserved Soc",
  "50901.fault.arcFault": "Arc Fault",
  "50901.fault.arcSelfTestFault": "Arc Fault Self-Check Failure",
  "50901.fault.armCommunicationFault": "ARM Communication Fault",
  "50901.fault.auxiliaryPowerAbnormality": "Auxiliary Power Supply Abnormal",
  "50901.Fault.batteryCapacityAbnormality": "Battery Capacity Abnormal",
  "50901.Fault.batteryFault": "Battery Fault",
  "50901.Fault.batteryForceChargeRequest": "Battery Force Charge Request",
  "50901.Fault.bmsCanCommunicationAbnormality": "Bms Can Communication Abnormal",
  "50901.fault.busbarAbnormality": "DC Bus Abnormal",
  "50901.fault.cmpssBiasCalculationError": "CMPSS Offset Calculation Error",
  "50901.fault.comparatorFault": "Comparator Fault",
  "50901.fault.driveAbnormality": "Drive Abnormal",
  "50901.Fault.dspPwrCommunicationAbnormality": "Dsp Power Communication Abnormal",
  "50901.Fault.dspSafCommunicationAbnormality": "Dsp Secure Communication Abnormal",
  "50901.Fault.dtsCommunicationAbnormality": "Dts Communication Abnormal",
  "50901.Fault.dtu1Rs485CommunicationAbnormality": "Dtu1 Rs485 Communication Abnormal",
  "50901.Fault.dtu2Rs485CommunicationAbnormality": "Dtu2 Rs485 Communication Abnormal",
  "50901.Fault.dtu3Rs485CommunicationAbnormality": "Dtu3 Rs485 Communication Abnormal",
  "50901.Fault.dtu4Rs485CommunicationAbnormality": "Dtu4 Rs485 Communication Abnormal",
  "50901.Fault.dtu5Rs485CommunicationAbnormality": "Dtu5 Rs485 Communication Abnormal",
  "50901.fault.e2rpomFault": "EEPROM Fault",
  "50901.fault.emergencyStopSwitchStatus": "Emergency Stop",
  "50901.fault.epsOverload": "EPS Overload",
  "50901.fault.epsRelayProtection": "EPS Relay Protection",
  "50901.fault.epsVoltageAbnormality": "EPS Voltage Abnormal",
  "50901.Fault.evCharger1CommunicationAbnormality": "Ev Charger 1 Communication Abnormal",
  "50901.Fault.evCharger1Fault": "Ev Charger 1 Fault",
  "50901.Fault.evCharger2CommunicationAbnormality": "Ev Charger 2 Communication Abnormal",
  "50901.Fault.evCharger2Fault": "Ev Charger 2 Fault",
  "50901.fault.fanFault": "Fan Fault",
  "50901.Fault.fanSpeedAbnormality": "Fan Speed Abnormal",
  "50901.fault.fiveVoltPowerSupplyFault": "5V Power Supply Fault",
  "50901.fault.flashCommunicationFault": "Flash Memory Communication Fault",
  "50901.fault.frequencyVariationRateOutOfRange": "Frequency Change Rate Over-limit",
  "50901.fault.genAbnormality": "Generator Abnormal",
  "50901.fault.genOverload": "Generator Overload",
  "50901.fault.genPortOvercurrent": "Generator Port Overcurrent",
  "50901.fault.genRelayAFault": "Generator A Relay Fault",
  "50901.fault.genRelayBFault": "Generator B Relay Fault",
  "50901.fault.gridCurrentDcOffsetOutOfRange": "Grid Current DC Offset Over-limit",
  "50901.fault.gridMeter": "Grid Meter Communication Failure",
  "50901.Fault.gridMeterCommunicationAbnormality": "Grid Meter Communication Abnormal",
  "50901.Fault.gridMeterTypeError": "Grid Meter Type Error",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange": "Off-Grid Voltage DC Offset Over-limit",
  "50901.fault.gridOverfrequency": "Grid Overfrequency",
  "50901.fault.gridOvervoltage": "Grid Overvoltage",
  "50901.fault.gridPortOvercurrent": "Grid Port Overcurrent",
  "50901.fault.gridPowerOutage": "Grid Power Loss",
  "50901.fault.gridRelayProtection": "Grid Relay Protection",
  "50901.fault.gridUnderfrequency": "Grid Underfrequency",
  "50901.fault.gridUndervoltage": "Grid Undervoltage",
  "50901.fault.gridVoltageAbnormality": "Grid Voltage Abnormal",
  "50901.Fault.hmidCommunicationAbnormality": "Hmi Communication Abnormal",
  "50901.Fault.hmidMachineFault": "Hmi Device Fault",
  "50901.fault.insulationFault": "Insulation Fault",
  "50901.fault.interruptOverflow": "Interrupt Overflow",
  "50901.fault.inverterCanCommunicationFailed": "Inverter Can Communication Failure",
  "50901.fault.inverterCommunicationFailed": "Inverter Communication Failure",
  "50901.fault.kmRelayFault": "Km Relay Fault",
  "50901.fault.lineToEarthFault": "Ground Fault (Line-to-Ground)",
  "50901.fault.loadRelayAFault": "Load A Relay Fault",
  "50901.fault.loadRelayBFault": "Load B Relay Fault",
  "50901.fault.lowAmbientTemperature": "Ambient Temperature Too Low",
  "50901.Fault.lowDtuVersion": "Dtu Version Too Low",
  "50901.fault.machineTypeMismatch": "Model Mismatch",
  "50901.Fault.masterSlaveCommunicationAbnormality": "Master-Slave Communication Abnormal",
  "50901.fault.meterWiringAbnormality": "Meter Wiring Abnormal",
  "50901.fault.microelectronicFault": "Microelectronics Fault",
  "50901.fault.neutralWireNotConnected": "Neutral Line Not Connected",
  "50901.fault.neutralWireToEarthFault": "Neutral Line-to-Ground Fault",
  "50901.fault.overTemperature": "Overtemperature",
  "50901.fault.overtemperatureAlarm": "Overheat Alarm",
  "50901.fault.pllLockFailed": "PLL Lock Failure",
  "50901.fault.preSynchronizationFailed": "Pre-Synchronization Failure",
  "50901.fault.pvFault": "PV Fault",
  "50901.Fault.pvMeterCommunicationAbnormality": "Pv Meter Communication Abnormal",
  "50901.Fault.pvMeterTypeError": "Pv Meter Type Error",
  "50901.fault.pvPortOvercurrent": "Pv Port Overcurrent",
  "50901.fault.pvRelayAbFault": "Pv Ab Relay Fault",
  "50901.fault.pvVoltageExceedingBusVoltage": "PV Voltage Exceeding Bus Voltage",
  "50901.fault.rcdFault": "RCD Fault",
  "50901.fault.rcdSelfTestFault": "RCD Self-Check Failure",
  "50901.fault.reconnectionFailed": "Reconnection Failure",
  "50901.fault.samplingBiasAbnormality": "Sampling Offset Abnormal",
  "50901.fault.shutDown": "System Shutdown",
  "50901.Fault.slaveWrongBatteryConnection": "Slave Battery Connection Error",
  "50901.fault.smartloadPortOvercurrent": "Smart Load Port Overcurrent",
  "50901.fault.spiCommunicationFault": "SPI Communication Fault",
  "50901.Fault.sustainedNegativeLoad": "Sustained Negative Load",
  "50901.fault.temperatureAbnormality": "Temperature Abnormal",
  "50901.fault.tenMinuteOvervoltage": "10-Minute Overvoltage",
  "50901.fault.threePointThreeVoltPowerSupplyFault": "3.3V Power Supply Fault",
  "50901.fault.twelveVoltPowerSupplyFault": "12V Power Supply Fault",
  "50901.fault.versionMismatch": "Version Mismatch",
  "50901.fault.wiringAbnormality": "Wiring Abnormal",
  "50901.otaHttpUrl.otaHttpUrl": "Upgrade Command",
  "50901.real_time.12vAuxiliaryVoltageSampling": "12V Auxiliary Voltage Sampling",
  "50901.real_time.12vOutputVoltageSampling": "12V Output Voltage Sampling",
  "50901.real_time.3_3vAuxiliaryVoltageSampling": "3.3V Auxiliary Voltage Sampling",
  "50901.real_time.5vAuxiliaryVoltageSampling": "5V Auxiliary Voltage Sampling",
  "50901.real_time.ambientTemperatureSampling": "Ambient Temperature Sampling",
  "50901.real_time.appSoftwareVersion": "App Software Version",
  "50901.real_time.batteryDailyChargeEnergy": "Battery Daily Charge Capacity",
  "50901.real_time.batteryDailyDischargeEnergy": "Battery Daily Discharge Capacity",
  "50901.real_time.batteryModuleNum": "Battery Cell Count (Cells in Series per Module)",
  "50901.real_time.batteryPowerWholeSystem": "Battery Total Power (Whole System)",
  "50901.real_time.batteryToLoadPower": "Battery-to-Load Power",
  "50901.real_time.bootSoftwareVersion": "Bootloader Software Version",
  "50901.real_time.communicationStickHardwareVersion": "Communication Dongle Hardware Version",
  "50901.real_time.communicationStickSn": "Communication Dongle Sn",
  "50901.real_time.communicationStickSoftwareVersion": "Communication Dongle Software Version",
  "50901.real_time.copy_dspVersionMainUVersion": "Dsp Version (Main U Version)",
  "50901.real_time.dailyBatteryToLoadEnergy": "Today Battery-to-Load Energy",
  "50901.real_time.dailyExportEnergyToGrid": "Today Selling Energy",
  "50901.real_time.dailyGridToLoadEnergy": "Today Grid-to-Load Energy",
  "50901.real_time.dailyImportEnergyFromGrid": "Today Buying Energy",
  "50901.real_time.dailyPvToBatteryEnegry": "Today PV-to-Battery Energy",
  "50901.real_time.dailyPvToGridEnegry": "Today PV-to-Grid Energy",
  "50901.real_time.dailyPvToLoadEnegry": "Today PV-to-Load Energy",
  "50901.real_time.dTSReset": "Data Stick Reset",
  "50901.real_time.firmwareBuildTimeDateHour": "Firmware Build Time (Day/Hour)",
  "50901.real_time.firmwareBuildTimeYearMonth": "Firmware Build Time (Year & Month)",
  "50901.real_time.firmwareCrc": "Firmware Crc",
  "50901.real_time.firmwareEndAddressHigh": "Firmware End Address (High)",
  "50901.real_time.firmwareEndAddressLow": "Firmware End Address (Low)",
  "50901.real_time.firmwareInformationCrc": "Firmware Info Crc",
  "50901.real_time.firmwareStartAddressHigh": "Firmware Start Address (High)",
  "50901.real_time.firmwareStartAddressLow": "Firmware Start Address (Low)",
  "50901.real_time.generatorDailyYield": "Generator Daily Generation",
  "50901.real_time.generatorPower": "Generator Power",
  "50901.real_time.generatorPowerA": "Generator Phase A Power",
  "50901.real_time.generatorPowerB": "Generator Phase B Power",
  "50901.real_time.generatorPowerC": "Generator Phase C Power",
  "50901.real_time.gridMeasurementOfRadiatorTemperature": "Grid Side Heatsink Temperature",
  "50901.real_time.gridMeterSerialNumber": "Grid Side Meter Serial Number",
  "50901.real_time.gridPowerWholeSystem": "Grid Total Power (Whole System)",
  "50901.real_time.hoymilesSerialNumber": "Hoymiles Serial Number",
  "50901.real_time.inverterHardwareVersion": "Inverter Hardware Version",
  "50901.real_time.inverterModelNumber": "Inverter Model Number",
  "50901.real_time.loadEnergy": "Load Daily Energy Consumption",
  "50901.real_time.loadPowerWholeSystem": "Load Total Power (Whole System)",
  "50901.real_time.macAddr": "Mac Address",
  "50901.real_time.materType": "Meter Type",
  "50901.real_time.maxCellSoc": "Max Cell SOC",
  "50901.real_time.maxCellSocCellId": "Max Cell SOC Corresponding Index",
  "50901.real_time.maxCellTemperature": "Max Cell Temperature",
  "50901.real_time.maxCellTemperatureCellId": "Max Cell Temperature Corresponding Index",
  "50901.real_time.maxCellVoltage": "Max Cell Voltage",
  "50901.real_time.maxCellVoltageCellId": "Max Cell Voltage Corresponding Index",
  "50901.real_time.minCellSoc": "Min Cell SOC",
  "50901.real_time.minCellSocCellId": "Min Cell SOC Corresponding Index",
  "50901.real_time.minCellTemperature": "Min Cell Temperature",
  "50901.real_time.minCellTemperatureCellId": "Min Cell Temperature Corresponding Index",
  "50901.real_time.minCellVoltage": "Min Cell Voltage",
  "50901.real_time.minCellVoltageCellId": "Min Cell Voltage Corresponding Index",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack": "Battery Pack Cycle Count",
  "50901.real_time.oemModelName": "Oem Model Name",
  "50901.real_time.oemSerialNumber": "Oem Serial Number",
  "50901.real_time.packCurrent": "Battery Pack Current",
  "50901.real_time.packPower": "Battery Pack Power",
  "50901.real_time.packSoc": "Battery Pack SOC",
  "50901.real_time.packSoh": "Battery Pack SOH",
  "50901.real_time.packVoltage": "Battery Pack Voltage",
  "50901.real_time.pv1RealTimePower": "PV1 Real-time Power",
  "50901.real_time.pv2RealTimePower": "PV2 Real-time Power",
  "50901.real_time.pv3RealTimePower": "PV3 Real-time Power",
  "50901.real_time.pv4RealTimePower": "PV4 Real-time Power",
  "50901.real_time.pvMeterSerialNumber": "Pv Meter Serial Number",
  "50901.real_time.pvPower": "Pv Power",
  "50901.real_time.pvPowerWholeSystem": "PV Total Power (Whole System)",
  "50901.real_time.pvToBatteryPower": "PV-to-Battery Power",
  "50901.real_time.pvToGridPower": "PV-to-Grid Power",
  "50901.real_time.pvToLoadPower": "PV-to-Load Power",
  "50901.real_time.relayStatus": "Relay Status",
  "50901.real_time.relaySupplyVoltageSampling": "Relay Power Supply Voltage Sampling",
  "50901.real_time.rssi": "Signal Strength",
  "50901.real_time.ssid": "Ssid",
  "50901.warning.batteryHighVoltageAlarm": "Battery Overvoltage Alarm",
  "50901.warning.batteryLowVoltageAlarm": "Battery Undervoltage",
  "50901.warning.batteryPackChargeHighVoltageAlarm": "Battery Pack Charge Overvoltage Alarm",
  "50901.warning.batteryPackDischargeLowVoltageAlarm": "Battery Pack Discharge Undervoltage Alarm",
  "50901.warning.canCommunicationTimeout": "CAN Communication Timeout",
  "50901.warning.chargeHighTemperatureAlarm": "Charge High Temperature Alarm",
  "50901.warning.chargeLowTemperatureAlarm": "Charge Low Temperature Alarm",
  "50901.warning.dischargeHighTemperatureAlarm": "Discharge High Temperature Alarm",
  "50901.warning.dischargeLowTemperatureAlarm": "Discharge Low Temperature Alarm",
  "50901.warning.hardwareProtection": "Hardware Protection",
  "50901.warning.inputOvervoltageAlarm": "Input Overvoltage Alarm",
  "50901.warning.lowBatteryEnergy": "Battery Low Capacity",
  "50901.ctrl_Config.ClockSetting.ClockSetting": "Clock Setting",
  "50901.ctrl_Config.ClockSetting.clockSetting_day": "Clock Setting - Day",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour": "Clock Setting - Hour",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute": "Clock Setting - Minute",
  "50901.ctrl_Config.ClockSetting.clockSetting_month": "Clock Setting - Month",
  "50901.ctrl_Config.ClockSetting.clockSetting_second": "Clock Setting - Second",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday": "Clock Setting - Weekday",
  "50901.ctrl_Config.ClockSetting.clockSetting_year": "Clock Setting - Year",
  "50901.ctrl_Config.Device.masterSlave": "Master/Slave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold": "Ambient Temperature Threshold",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold": "Pcb Ambient Temperature Threshold",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress": "Gateway Communication Address",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH": "Usage Time Period 1 Charge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin": "Usage Time Period 1 Charge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower": "Charge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin": "Usage Time Period 1 Charge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc": "Charge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH": "Usage Time Period 1 Discharge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin": "Usage Time Period 1 Discharge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin": "Usage Time Period 1 Discharge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc": "Discharge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH": "Usage Time Period 2 Charge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin": "Usage Time Period 2 Charge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower": "Charge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin": "Usage Time Period 2 Charge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc": "Charge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH": "Usage Time Period 2 Discharge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin": "Usage Time Period 2 Discharge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin": "Usage Time Period 2 Discharge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc": "Discharge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH": "Usage Time Period 3 Charge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin": "Usage Time Period 3 Charge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower": "Charge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin": "Usage Time Period 3 Charge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc": "Charge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH": "Usage Time Period 3 Discharge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin": "Usage Time Period 3 Discharge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin": "Usage Time Period 3 Discharge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc": "Discharge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH": "Usage Time Period 4 Charge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin": "Usage Time Period 4 Charge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower": "Charge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin": "Usage Time Period 4 Charge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc": "Charge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH": "Usage Time Period 4 Discharge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin": "Usage Time Period 4 Discharge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin": "Usage Time Period 4 Discharge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc": "Discharge Cut-Off Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH": "Usage Time Period 5 Charge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin": "Usage Time Period 5 Charge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower": "Charge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH": "Usage Time Period 5 Charge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin": "Usage Time Period 5 Charge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc": "Charge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH": "Usage Time Period 5 Discharge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin": "Usage Time Period 5 Discharge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH": "Usage Time Period 5 Discharge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin": "Usage Time Period 5 Discharge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc": "Discharge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH": "Usage Time Period 6 Charge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin": "Usage Time Period 6 Charge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower": "Charge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH": "Usage Time Period 6 Charge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin": "Usage Time Period 6 Charge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc": "Charge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH": "Usage Time Period 6 Discharge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin": "Usage Time Period 6 Discharge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH": "Usage Time Period 6 Discharge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin": "Usage Time Period 6 Discharge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc": "Discharge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH": "Usage Time Period 7 Charge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin": "Usage Time Period 7 Charge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH": "Usage Time Period 7 Charge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin": "Usage Time Period 7 Charge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc": "Discharge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH": "Usage Time Period 7 Discharge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin": "Usage Time Period 7 Discharge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH": "Usage Time Period 7 Discharge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin": "Usage Time Period 7 Discharge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc": "Discharge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH": "Usage Time Period 8 Charge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin": "Usage Time Period 8 Charge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower": "Charge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH": "Usage Time Period 8 Charge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin": "Usage Time Period 8 Charge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc": "Charge Cut-Off Capacity",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH": "Usage Time Period 8 Discharge End - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin": "Usage Time Period 8 Discharge End - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower": "Discharge Power",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH": "Usage Time Period 8 Discharge Start - Hour",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin": "Usage Time Period 8 Discharge Start - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc": "Discharge Cut-Off Capacity",
  "50901.real_time.afciVersion": "Afci Version",
  "50901.real_time.batteryChargePower": "Battery Cumulative Charge Capacity",
  "50901.real_time.batteryConnectionStatus": "Battery Connection Status",
  "50901.real_time.batteryCurrent": "Battery Current",
  "50901.real_time.batteryDischargePower": "Battery Cumulative Discharge Capacity",
  "50901.real_time.batteryPower": "Battery Power (Charge/Discharge)",
  "50901.real_time.batterySoc": "Battery Soc",
  "50901.real_time.batterytotCap": "Battery Total Installed Capacity",
  "50901.real_time.batteryType_04": "Battery Type",
  "50901.real_time.batteryVoltage": "Battery Voltage",
  "50901.real_time.batteryWorkingStatus": "Battery Status",
  "50901.real_time.bmsSoftwareVersion": "BMS Version - Software",
  "50901.real_time.commAddress10Slave9": "Communication Address 10 (Slave 9)",
  "50901.real_time.commAddress1Master": "Communication Address 1 (Master)",
  "50901.real_time.commAddress2Slave1": "Communication Address 2 (Slave 1)",
  "50901.real_time.commAddress3Slave2": "Communication Address 3 (Slave 2)",
  "50901.real_time.commAddress3Slave3": "Communication Address 4 (Slave 3)",
  "50901.real_time.commAddress4Slave4": "Communication Address 5 (Slave 4)",
  "50901.real_time.commAddress6Slave6": "Communication Address 6 (Slave 5)",
  "50901.real_time.commAddress7Slave6": "Communication Address 7 (Slave 6)",
  "50901.real_time.commAddress8Slave7": "Communication Address 8 (Slave 7)",
  "50901.real_time.commAddress9Slave8": "Communication Address 9 (Slave 8)",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria": "Drm Status (For Australia/Germany/Austria)",
  "50901.real_time.dspVersionAuxiliaryUVersion": "Dsp Version (Aux U Version)",
  "50901.real_time.epsCurrentA": "Eps Side Phase A Current",
  "50901.real_time.epsCurrentB": "Eps Side Phase B Current",
  "50901.real_time.epsCurrentC": "Eps Side Phase C Current",
  "50901.real_time.epsPower": "Eps Side Power",
  "50901.real_time.epsPowerA": "Eps Side Phase A Power",
  "50901.real_time.epsPowerB": "Eps Side Phase B Power",
  "50901.real_time.epsPowerC": "Eps Side Phase C Power",
  "50901.real_time.epsVoltageA": "Eps Side Phase A Voltage",
  "50901.real_time.epsVoltageB": "Eps Side Phase B Voltage",
  "50901.real_time.epsVoltageC": "Eps Side Phase C Voltage",
  "50901.real_time.essAccessPoint": "Ess Access Point",
  "50901.real_time.externalFanSpeed1": "Outer Fan Speed 1",
  "50901.real_time.externalFanSpeed2": "Outer Fan Speed 2",
  "50901.real_time.externalFanSpeed3": "Outer Fan Speed 3",
  "50901.real_time.externalFanSpeed4": "Outer Fan Speed 4",
  "50901.real_time.generatorConnectionStatus": "Generator Connection Status",
  "50901.real_time.generatorCurrentA": "Generator Phase A Current",
  "50901.real_time.generatorCurrentB": "Generator Phase B Current",
  "50901.real_time.generatorCurrentC": "Generator Phase C Current",
  "50901.real_time.generatorTotalYield": "Generator Cumulative Generation",
  "50901.real_time.generatorVoltageA": "Generator Phase A Voltage",
  "50901.real_time.generatorVoltageB": "Generator Phase B Voltage",
  "50901.real_time.generatorVoltageC": "Generator Phase C Voltage",
  "50901.real_time.gridBuyPower": "Cumulative Buying Energy",
  "50901.real_time.gridCurrentA": "Grid Side Phase A Current",
  "50901.real_time.gridCurrentB": "Grid Side Phase B Current",
  "50901.real_time.gridCurrentC": "Grid Side Phase C Current",
  "50901.real_time.gridPower": "Grid Side Power",
  "50901.real_time.gridPowerA": "Grid Side Phase A Power",
  "50901.real_time.gridPowerB": "Grid Side Phase B Power",
  "50901.real_time.gridPowerC": "Grid Side Phase C Power",
  "50901.real_time.gridPowerFactor": "Grid Side Power Factor",
  "50901.real_time.gridPowerFactorA": "Grid Side Phase A Power Factor",
  "50901.real_time.gridPowerFactorB": "Grid Side Phase B Power Factor",
  "50901.real_time.gridPowerFactorC": "Grid Side Phase C Power Factor",
  "50901.real_time.gridReactivePower": "Grid Side Reactive Power",
  "50901.real_time.gridReactivePowerA": "Grid Side Phase A Reactive Power",
  "50901.real_time.gridReactivePowerB": "Grid Side Phase B Reactive Power",
  "50901.real_time.gridReactivePowerC": "Grid Side Phase C Reactive Power",
  "50901.real_time.gridSellPower": "Cumulative Selling Energy",
  "50901.real_time.gridTotalFrequency": "Grid Side Frequency",
  "50901.real_time.gridVoltageA": "Grid Side Phase A Voltage",
  "50901.real_time.gridVoltageB": "Grid Side Phase B Voltage",
  "50901.real_time.gridVoltageC": "Grid Side Phase C Voltage",
  "50901.real_time.internalFanSpeed1": "Inner Fan Speed 1",
  "50901.real_time.internalFanSpeed2": "Inner Fan Speed 2",
  "50901.real_time.internalFanSpeed3": "Inner Fan Speed 3",
  "50901.real_time.invAcFrequency": "Inverter AC Output Frequency",
  "50901.real_time.inverCombinedActivePower": "Inverter AC Output Power",
  "50901.real_time.inverterSideRadiatorTemperature": "Inverter Side Heatsink Temperature",
  "50901.real_time.inverterTemp": "Inverter Internal Operating Temperature",
  "50901.real_time.invRatedPower": "Rated Power",
  "50901.real_time.invRunningtime": "Inv Operating Time (Hoymiles: Normal Operation Time)",
  "50901.real_time.machineSnMaster": "Master Unit Sn",
  "50901.real_time.machineSnSlave1": "Slave 1 Sn",
  "50901.real_time.machineSnSlave2": "Slave 2 Sn",
  "50901.real_time.machineSnSlave3": "Slave 3 Sn",
  "50901.real_time.machineSnSlave4": "Slave 4 Sn",
  "50901.real_time.machineSnSlave5": "Slave 5 Sn",
  "50901.real_time.machineSnSlave6": "Slave 6 Sn",
  "50901.real_time.machineSnSlave7": "Slave 7 Sn",
  "50901.real_time.machineSnSlave8": "Slave 8 Sn",
  "50901.real_time.machineSnSlave9": "Slave 9 Sn",
  "50901.real_time.MaxChargeCurrent": "Max Charge Current",
  "50901.real_time.MaxDisChargeCurrent": "Max Discharge Current",
  "50901.real_time.meterFlag": "Meter Flag",
  "50901.real_time.mpptTemp": "Pv Side Heatsink Temperature",
  "50901.real_time.numberOfUnits": "Unit Quantity",
  "50901.real_time.packNum": "Parallel Quantity (Number Of Battery Packs)",
  "50901.real_time.phaseAOfInverterActivePower": "Inverter AC Side Phase A Power",
  "50901.real_time.phaseAOfInverterSideCurrent": "Inverter AC Side Phase A Current",
  "50901.real_time.phaseAOfInverterSideVoltage": "Inverter AC Side Phase A Voltage",
  "50901.real_time.phaseBOfInverterActivePower": "Inverter AC Side Phase B Power",
  "50901.real_time.phaseBOfInverterSideCurrent": "Inverter AC Side Phase B Current",
  "50901.real_time.phaseBOfInverterSideVoltage": "Inverter AC Side Phase B Voltage",
  "50901.real_time.phaseCOfInverterActivePower": "Inverter AC Side Phase C Power",
  "50901.real_time.phaseCOfInverterSideCurrent": "Inverter AC Side Phase C Current",
  "50901.real_time.phaseCOfInverterSideVoltage": "Inverter AC Side Phase C Voltage",
  "50901.real_time.powerGeneration": "PV Cumulative Generation",
  "50901.real_time.pv1Current": "Pv1 Current",
  "50901.real_time.pv1Power": "Pv1 Power",
  "50901.real_time.pv1Voltage": "Pv1 Voltage",
  "50901.real_time.pv2Current": "Pv2 Current",
  "50901.real_time.pv2Power": "Pv2 Power",
  "50901.real_time.pv2Voltage": "Pv2 Voltage",
  "50901.real_time.pv3Current": "Pv3 Current",
  "50901.real_time.pv3Power": "Pv3 Power",
  "50901.real_time.pv3Voltage": "Pv3 Voltage",
  "50901.real_time.pv4Current": "Pv4 Current",
  "50901.real_time.pv4Power": "Pv4 Power",
  "50901.real_time.pv4Voltage": "Pv4 Voltage",
  "50901.real_time.pvConnectionStatus": "Pv Connection Status",
  "50901.real_time.pvDailyYield": "Pv Daily Generation",
  "50901.real_time.pvMeterConnectionStatus": "Pv Meter Connection Status",
  "50901.real_time.pvMeterCurrentA": "Pv Meter Phase A Current",
  "50901.real_time.pvMeterCurrentB": "Pv Meter Phase B Current",
  "50901.real_time.pvMeterCurrentC": "Pv Meter Phase C Current",
  "50901.real_time.pvMeterDailyYield": "External Inverter Daily Generation",
  "50901.real_time.pvMeterFrequency": "Pv Meter Frequency",
  "50901.real_time.pvMeterPhaseAActivePower": "Pv Meter Phase A Active Power",
  "50901.real_time.pvMeterPhaseAPowerFactor": "Pv Meter Phase A Power Factor",
  "50901.real_time.pvMeterPhaseAReactivePower": "Pv Meter Phase A Reactive Power",
  "50901.real_time.pvMeterPhaseBActivePower": "Pv Meter Phase B Active Power",
  "50901.real_time.pvMeterPhaseBPowerFactor": "Pv Meter Phase B Power Factor",
  "50901.real_time.pvMeterPhaseBReactivePower": "Pv Meter Phase B Reactive Power",
  "50901.real_time.pvMeterPhaseCActivePower": "Pv Meter Phase C Active Power",
  "50901.real_time.pvMeterPhaseCPowerFactor": "Pv Meter Phase C Power Factor",
  "50901.real_time.pvMeterPhaseCReactivePower": "Pv Meter Phase C Reactive Power",
  "50901.real_time.pvMeterPower": "Pv Meter Power",
  "50901.real_time.pvMeterPowerA": "Pv Meter Phase A Power",
  "50901.real_time.pvMeterPowerB": "Pv Meter Phase B Power",
  "50901.real_time.pvMeterPowerC": "Pv Meter Phase C Power",
  "50901.real_time.pvMeterTotalYield": "External Inverter Cumulative Generation",
  "50901.real_time.pvMeterVoltageA": "Pv Meter Phase A Voltage",
  "50901.real_time.pvMeterVoltageB": "Pv Meter Phase B Voltage",
  "50901.real_time.pvMeterVoltageC": "Pv Meter Phase C Voltage",
  "50901.real_time.serviceEntranceBreakerCurrent": "Service Entrance Breaker Current",
  "50901.real_time.soh": "Soh",
  "50901.real_time.totalBatteryToLoadEnergy": "Cumulative Battery-to-Load Energy",
  "50901.real_time.totalGridToLoadEnergy": "Cumulative Grid-to-Load Energy",
  "50901.real_time.totalLoadEnergy": "Load Cumulative Energy Consumption",
  "50901.real_time.totalPvToBatteryEnegry": "Cumulative PV-to-Battery Energy",
  "50901.real_time.totalPvToGridEnegry": "Cumulative PV-to-Grid Energy",
  "50901.real_time.totalPvToLoadEnegry": "Cumulative PV-to-Load Energy",
  "50901.real_time.workStatus": "Operation Status",
  "50901.ctrl_Config.Battery.absorptionVoltage": "Absorption Voltage",
  "50901.ctrl_Config.Battery.batteryCapacity": "BMS Capacity",
  "50901.ctrl_Config.Battery.endChargeVoltage": "Charge Termination Voltage",
  "50901.ctrl_Config.Battery.endOfChargeCurrent": "Charge End Current",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout": "Equalization Charge Timeout",
  "50901.ctrl_Config.Battery.equalizationEnable": "Equalization Enable",
  "50901.ctrl_Config.Battery.equalizationIntervalDays": "Equalization Interval Days",
  "50901.ctrl_Config.Battery.equalizationTime": "Equalization Time",
  "50901.ctrl_Config.Battery.equalizationVoltage": "Equalization Voltage",
  "50901.ctrl_Config.Battery.floatVoltage": "Float Voltage",
  "50901.ctrl_Config.Battery.initialResistance": "Initial Resistance",
  "50901.ctrl_Config.Battery.maximumChargeLimit": "Max Charge Limit",
  "50901.ctrl_Config.Battery.maximumDischargeLimit": "Max Discharge Limit",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor": "Temperature Correction Coefficient",
  "50901.ctrl_Config.Connection.dtu_comm_enable": "Dtu Communication Enable",
  "50901.ctrl_Config.Device.arcFaultClear": "Arc Fault Clear",
  "50901.ctrl_Config.Device.batActivate": "Battery Activation",
  "50901.ctrl_Config.Device.batteryBalancing": "Battery Balancing",
  "50901.ctrl_Config.Device.clearFault": "Fault Clear",
  "50901.ctrl_Config.Device.parallelNetworking": "Parallel Network",
  "50901.ctrl_Config.Device.restartSystem": "System Restart",
  "50901.ctrl_Config.Device.restoreDefault": "Restore Defaults",
  "50901.ctrl_Config.Device.selfTest": "Self-Test",
  "50901.ctrl_Config.Device.systemPowerOnOff": "System Power On/Off",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH": "Generator Control - Charge End Time - Hour",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin": "Generator Control - Charge End Time - Minute",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH": "Generator Control - Charge Start Time - Hour",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin": "Generator Control - Charge Start Time - Minute",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity": "Generator Shutdown Battery Capacity",
  "50901.ctrl_Dry_Contact.Generator.generatorMode": "Generator Mode",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity": "Generator Start Battery Capacity",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq": "Generator Exercise Mode Frequency",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn": "Generator Exercise Mode",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime": "Generator Exercise Mode Runtime",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH": "Generator Exercise Mode Start Time - Hour",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin": "Generator Exercise Mode Start Time - Minute",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek": "Generator Exercise Mode Start Time",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH": "Standby Time 1 End - Hour",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin": "Standby Time 1 End - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH": "Standby Time 1 Start - Hour",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin": "Standby Time 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH": "Standby Time 2 End - Hour",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin": "Standby Time 2 End - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH": "Standby Time 2 Start - Hour",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin": "Standby Time 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable": "Standby Time Enable",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode": "Load Control Mode",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1": "Load Control Monday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2": "Load Control Tuesday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3": "Load Control Wednesday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4": "Load Control Thursday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5": "Load Control Friday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6": "Load Control Saturday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7": "Load Control Sunday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch": "Manual Mode Switch",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower": "Load Mode Load Power Threshold",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime": "Load Control Minimum On Time",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc": "Off-Grid Protection Soc",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1": "Time Range 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20": "Monday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21": "Tuesday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22": "Wednesday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23": "Thursday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24": "Friday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25": "Saturday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26": "Sunday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour": "Timer 1 End - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2": "Timer 1 End_2 - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3": "Time Slot 1 End - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute": "Timer 1 End - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2": "Timer 1 End_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3": "Time Slot 1 End - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min": "Timer 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2": "Timer 1 Start_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3": "Time Slot 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour": "Timer 2 End - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2": "Timer 2 End_2 - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3": "Time Slot 2 End - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes": "Timer 2 End - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2": "Timer 2 End_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3": "Time Slot 2 End - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes": "Timer 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2": "Timer 2 Start_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3": "Time Slot 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour": "Timer 1 Start - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2": "Timer 1 Start_2 - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3": "Time Slot 1 Start - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour": "Timer 2 Start - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2": "Timer 2 Start_2 - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3": "Time Slot 2 Start - Hour",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1": "Monday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2": "Tuesday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3": "Wednesday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4": "Thursday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5": "Friday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6": "Saturday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7": "Sunday",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode": "Dry Contact Working Mode",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak": "Peak Battery Max Discharge Power",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak": "Peak Grid Feed-In Power",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower": "Battery Max Charge Power",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower": "Battery Max Discharge Power",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime": "Lead-Acid Battery Maintenance Time",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc": "Max Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc": "Min Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower": "Power Compensation",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower": "Rsvd Reserve Power",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable": "Bypass Disable",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode": "Eps Mode",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn": "Pv Mode Enable",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq": "Generator Frequency Upper Limit",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt": "Generator Voltage Upper Limit",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq": "Generator Frequency Lower Limit",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt": "Generator Voltage Lower Limit",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power": "Generator-To-Battery Charge Power In Multi-Unit Parallel",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable": "Global Scan Enable",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley": "Limit Grid Power",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable": "Three-Phase Imbalance Enable",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio": "GCF Export Hard Limit Ratio",
  "50901.ctrl_WorkMode.Backup.backupSoc": "Reserved Soc",
  "50901.ctrl_WorkMode.economic.economicModeSoc": "Economic Mode Soc",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber": "Economic Mode Date Index",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1": "Section 1 Peak Start Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2": "Section 1 Peak Start Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1": "Section 1 Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2": "Section 1 Peak Start Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1": "Section 1 Peak Stop Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2": "Section 1 Peak Stop Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1": "Section 1 Peak Stop Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2": "Section 1 Peak Stop Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1StartDay": "Section 1 Start Day",
  "50901.ctrl_WorkMode.economic.section1StartMonth": "Section 1 Start Month",
  "50901.ctrl_WorkMode.economic.section1StopDay": "Section 1 Stop Day",
  "50901.ctrl_WorkMode.economic.section1StopMonth": "Section 1 Stop Month",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1": "Section 1 Off-Peak Start Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2": "Section 1 Off-Peak Start Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1": "Section 1 Off-Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2": "Section 1 Off-Peak Start Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1": "Section 1 Off-Peak Stop Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2": "Section 1 Off-Peak Stop Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1": "Section 1 Off-Peak Stop Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2": "Section 1 Off-Peak Stop Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1WeekRange1": "Section 1 Week Range 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange2": "Section 1 Week Range 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1": "Section 2 Peak Start Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2": "Section 2 Peak Start Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1": "Section 2 Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2": "Section 2 Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1": "Section 2 Peak Stop Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2": "Section 2 Peak Stop Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1": "Section 2 Peak Stop Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2": "Section 2 Peak Stop Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2StartDay": "Section 2 Start Day",
  "50901.ctrl_WorkMode.economic.section2StartMonth": "Section 2 Start Month",
  "50901.ctrl_WorkMode.economic.section2StopDay": "Section 2 Stop Day",
  "50901.ctrl_WorkMode.economic.section2StopMonth": "Section 2 Stop Month",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1": "Section 2 Off-Peak Start Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2": "Section 2 Off-Peak Start Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1": "Section 2 Off-Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2": "Section 2 Off-Peak Start Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1": "Section 2 Off-Peak Stop Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2": "Section 2 Off-Peak Stop Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1": "Section 2 Off-Peak Stop Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2": "Section 2 Off-Peak Stop Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2WeekRange1": "Section 2 Week Range 1",
  "50901.ctrl_WorkMode.economic.section2WeekRange2": "Section 2 Week Range 2",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1": "Section 3 Peak Start Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2": "Section 3 Peak Start Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1": "Section 3 Peak Start Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2": "Section 3 Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1": "Section 3 Peak Stop Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2": "Section 3 Peak Stop Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1": "Section 3 Peak Stop Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2": "Section 3 Peak Stop Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3StartDay": "Section 3 Start Day",
  "50901.ctrl_WorkMode.economic.section3StartMonth": "Section 3 Start Month",
  "50901.ctrl_WorkMode.economic.section3StopDay": "Section 3 Stop Day",
  "50901.ctrl_WorkMode.economic.section3StopMonth": "Section 3 Stop Month",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1": "Section 3 Off-Peak Start Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2": "Section 3 Off-Peak Start Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1": "Section 3 Off-Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2": "Section 3 Off-Peak Start Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1": "Section 3 Off-Peak Stop Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2": "Section 3 Off-Peak Stop Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1": "Section 3 Off-Peak Stop Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2": "Section 3 Off-Peak Stop Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3WeekRange1": "Section 3 Week Range 1",
  "50901.ctrl_WorkMode.economic.section3WeekRange2": "Section 3 Week Range 2",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1": "Section 4 Peak Start Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2": "Section 4 Peak Start Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1": "Section 4 Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2": "Section 4 Peak Start Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1": "Section 4 Peak Stop Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2": "Section 4 Peak Stop Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1": "Section 4 Peak Stop Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2": "Section 4 Peak Stop Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4StartDay": "Section 4 Start Day",
  "50901.ctrl_WorkMode.economic.section4StartMonth": "Section 4 Start Month",
  "50901.ctrl_WorkMode.economic.section4StopDay": "Section 4 Stop Day",
  "50901.ctrl_WorkMode.economic.section4StopMonth": "Section 4 Stop Month",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1": "Section 4 Off-Peak Start Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2": "Section 4 Off-Peak Start Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1": "Section 4 Off-Peak Start Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2": "Section 4 Off-Peak Start Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1": "Section 4 Off-Peak Stop Time 1 - Hour",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2": "Section 4 Off-Peak Stop Time 2 - Hour",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1": "Section 4 Off-Peak Stop Time 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2": "Section 4 Off-Peak Stop Time 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4WeekRange1": "Section 4 Week Range 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange2": "Section 4 Week Range 2",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc": "Force Charge Soc",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower": "Max Charge Power",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc": "Force Discharge Soc",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower": "Max Discharge Power",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower": "Peak Meter Power",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc": "Peak Meter Soc",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc": "Self-Use Soc",
  "50901.ctrl_WorkMode.Switch.workMode": "Ems Working Mode",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange": "Tou Mode Time Range",
  "50901.real_time.BatteryModel": "Battery Model",
  "50901.real_time.cfgMultPcsBmsFlag": "BMS Flag",
  "50901.real_time.inverterSn": "Inverter Sn",
  "50901.ctrl_Config.Grid Profile.country": "Country/Grid Connection Standard",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode": "Generator Port Mode",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position": "Generator Location",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay": "Generator Shutdown Delay",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time": "Generator Synchronization Time",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type": "Generator Type",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time": "Max Runtime",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time": "Min Runtime",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold": "Operation Protection Interval",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model": "Meter Model",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable": "Mid / Gateway Enable",
  "50901.ctrl_Safety.DCI.dciEnable": "Dci Enable",
  "50901.ctrl_Safety.DCI.lowerLimit": "Dci Lower Limit Current",
  "50901.ctrl_Safety.DCI.lowerTime": "Dci Lower Limit Time",
  "50901.ctrl_Safety.DCI.upperLimit": "Dci Upper Limit Current",
  "50901.ctrl_Safety.DCI.upperTime": "Dci Upper Limit Time",
  "50901.ctrl_Safety.FRT.frtFuncCode": "Frt Function Code",
  "50901.ctrl_Safety.FRT.frtHighLimit1": "Frequency Upper Limit 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time": "Frequency Upper Limit 1 Duration",
  "50901.ctrl_Safety.FRT.frtHighLimit2": "Frequency Upper Limit 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time": "Frequency Upper Limit 2 Duration",
  "50901.ctrl_Safety.FRT.frtHighLimit3": "Frequency Upper Limit 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time": "Frequency Upper Limit 3 Duration",
  "50901.ctrl_Safety.FRT.frtLowLimit1": "Frequency Lower Limit 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time": "Frequency Lower Limit 1 Duration",
  "50901.ctrl_Safety.FRT.frtLowLimit2": "Frequency Lower Limit 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time": "Frequency Lower Limit 2 Duration",
  "50901.ctrl_Safety.FRT.frtLowLimit3": "Frequency Lower Limit 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time": "Frequency Lower Limit 3 Duration",
  "50901.ctrl_Safety.FW.fwDiffInBatMode": "Fw Battery Mode Difference Enable",
  "50901.ctrl_Safety.FW.fwEnable": "Fw Enable",
  "50901.ctrl_Safety.FW.fwFuncCode": "Fw Function Code",
  "50901.ctrl_Safety.FW.fwOverEndFreq": "Fw Overfrequency End Frequency",
  "50901.ctrl_Safety.FW.fwOverStartFreq": "Fw Overfrequency Start Frequency",
  "50901.ctrl_Safety.FW.fwOverTransFreq": "Fw Overfrequency Transition Frequency",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency": "Fw Recovery Frequency Lower Limit",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime": "Fw Recovery Stabilization Time",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency": "Fw Recovery Frequency Upper Limit",
  "50901.ctrl_Safety.FW.fwTr": "Fw_Tr Time",
  "50901.ctrl_Safety.FW.fwUnderEndFreq": "Fw Underfrequency End Frequency",
  "50901.ctrl_Safety.FW.fwUnderStartFreq": "Fw Underfrequency Start Frequency",
  "50901.ctrl_Safety.FW.fwUnderStopFreq": "Fw Underfrequency Stop Frequency",
  "50901.ctrl_Safety.RCD.continueLimitTime": "Rcd Continuous Limit Time",
  "50901.ctrl_Safety.RCD.continueLimitValue": "Rcd Continuous Limit Current",
  "50901.ctrl_Safety.RCD.rcdEnable": "Rcd Enable",
  "50901.ctrl_Safety.RCD.step1LimitTime": "Rcd Step 1 Limit Time",
  "50901.ctrl_Safety.RCD.step1LimitValue": "Rcd Step 1 Limit Current",
  "50901.ctrl_Safety.RCD.step2LimitTime": "Rcd Step 2 Limit Time",
  "50901.ctrl_Safety.RCD.step2LimitValue": "Rcd Step 2 Limit Current",
  "50901.ctrl_Safety.RCD.step3LimitTime": "Rcd Step 3 Limit Time",
  "50901.ctrl_Safety.RCD.step3LimitValue": "Rcd Step 3 Limit Current",
  "50901.ctrl_Safety.RPC.gcfEn": "Gcf Enable",
  "50901.ctrl_Safety.RPC.gcfFuncCode": "Gcf Function Code",
  "50901.ctrl_Safety.RPC.rpcMode": "Rpc Mode",
  "50901.ctrl_Safety.RPC.rpcPf": "Rpc Power Factor Pf",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio": "Rpc Reactive Power Ratio",
  "50901.ctrl_Safety.RPC.rpcTr": "Rpc_Tr Time",
  "50901.ctrl_Safety.RPC.vvFuncCode": "Volt-Var Function Code",
  "50901.ctrl_Safety.RPC.vvLockIn": "Vv Lock-In Value",
  "50901.ctrl_Safety.RPC.vvLockOut": "Vv Lock-Out Value",
  "50901.ctrl_Safety.RPC.vvQ1": "Reactive Set Point_Q1",
  "50901.ctrl_Safety.RPC.vvQ2": "Reactive Set Point_Q2",
  "50901.ctrl_Safety.RPC.vvQ3": "Reactive Set Point_Q3",
  "50901.ctrl_Safety.RPC.vvQ4": "Reactive Set Point_Q4",
  "50901.ctrl_Safety.RPC.vvV1": "Voltage Set Point_V1",
  "50901.ctrl_Safety.RPC.vvV2": "Voltage Set Point_V2",
  "50901.ctrl_Safety.RPC.vvV3": "Voltage Set Point_V3",
  "50901.ctrl_Safety.RPC.vvV4": "Voltage Set Point_V4",
  "50901.ctrl_Safety.RPC.vvVref": "Volt-Var Reference Value (Vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr": "Volt-Var Reference Value Tr Time",
  "50901.ctrl_Safety.RPC.wpfFuncCode": "Wpf Function Code",
  "50901.ctrl_Safety.RPC.wpfLockIn": "Wpf Lock-In Value",
  "50901.ctrl_Safety.RPC.wpfLockOut": "Wpf Lock-Out Value",
  "50901.ctrl_Safety.RPC.wpfMinPFOver": "Wpf Overpower Min Pf",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder": "Wpf Underpower Min Pf",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio": "Wpf Power End Ratio",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio": "Wpf Power Start Ratio",
  "50901.ctrl_Safety.RR.rrFuncCode": "Rr Function Code",
  "50901.ctrl_Safety.RR.rrRurNm": "Rr_Rur_Nm",
  "50901.ctrl_Safety.RR.rrRurSs": "Rr_Rur_Ss",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue": "Rt Frequency Recovery Upper Limit",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue": "Rt Frequency Recovery Lower Limit",
  "50901.ctrl_Safety.RT.rtFuncCode": "Rt Function Code",
  "50901.ctrl_Safety.RT.rtNMTime": "Rt_Nm Time",
  "50901.ctrl_Safety.RT.rtSRTTime": "Rt_Srt Time",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue": "Rt Voltage Recovery Upper Limit",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue": "Rt Voltage Recovery Lower Limit",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage": "10-Minute Average Voltage",
  "50901.ctrl_Safety.VRT.vrtEn": "Vrt Enable",
  "50901.ctrl_Safety.VRT.vrtFuncCode": "Vrt Function Code",
  "50901.ctrl_Safety.VRT.vrtHighLimit": "Vrt High Voltage Threshold",
  "50901.ctrl_Safety.VRT.vrtLowLimit": "Vrt Low Voltage Threshold",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime": "Vrt Recovery Stabilization Time",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime": "Instantaneous Overvoltage Duration",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage": "Instantaneous Overvoltage Threshold",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1": "Voltage Upper Limit 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time": "Voltage Upper Limit 1 Duration",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2": "Voltage Upper Limit 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time": "Voltage Upper Limit 2 Duration",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3": "Voltage Upper Limit 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time": "Voltage Upper Limit 3 Duration",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1": "Voltage Lower Limit 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time": "Voltage Lower Limit 1 Duration",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2": "Voltage Lower Limit 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time": "Voltage Lower Limit 2 Duration",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3": "Voltage Lower Limit 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time": "Voltage Lower Limit 3 Duration",
  "50901.ctrl_Safety.VW.vwDiffInBatMode": "Vw Battery Mode Difference Enable",
  "50901.ctrl_Safety.VW.vwEnable": "Vw Enable",
  "50901.ctrl_Safety.VW.vwFuncCode": "Vw Function Code",
  "50901.ctrl_Safety.VW.vwOverEndVolt": "Vw Overvoltage End Voltage",
  "50901.ctrl_Safety.VW.vwOverKPVolt": "Vw Overvoltage Kp Voltage / Coefficient Voltage",
  "50901.ctrl_Safety.VW.vwOverStartVolt": "Vw Overvoltage Start Voltage",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage": "Vw Recovery Voltage Lower Limit",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime": "Vw Recovery Stabilization Time",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage": "Vw Recovery Voltage Upper Limit",
  "50901.ctrl_Safety.VW.vwTr": "Vw_Tr Time",
  "50901.ctrl_Safety.VW.vwUnderEndVolt": "Vw Undervoltage End Voltage",
  "50901.ctrl_Safety.VW.vwUnderKPVolt": "Vw Undervoltage Kp Voltage / Coefficient Voltage",
  "50901.ctrl_Safety.VW.vwUnderStartVolt": "Vw Undervoltage Start Voltage",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio": "GCF Export Soft Limit Ratio",
  "alarm.trigger.condition": "triggered by device",
  "alarm.iot": "IoT Alarm",
  "module.alarmInfo": "alarmInfo",
  "user.privacy.user": "User Agreement",
  "user.privacy.pivacy": "privacy policy",
  "user.privacy.cookie": "Cookie Policy",
  "module.selfReport": "SelfReport",
  "ice.robot.strategy.type.int.str.sta.rev.pri": "Station Revenue Priority",
  "edit.failed": "Failed to edit",
  "50901.real_time.BatteryModel.1": "Haier HV",
  "tag_test_3": "tag_test_345455",
  "plant.create.type.1": "End User",
  "plant.create.type.0": "Installer",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode": "dry",
  "China": "Mainland China",
  "Australia": "Australia",
  "SoutheastAsia": "Southeast Asia",
  "Europe": "Europe",
  "Jimo_Factory": "JimoFactoryMES",
  "Transit_Warehouse": "Transit Warehouse",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Chag": "Time sharing node period 1 charging",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Out": "Time-Of-Use Node Period 1 Discharge",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.desc": "Soc Enabling Mode For Heat Pump Batteries 0: Disable 1: Enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc.desc": "Read, write, and report",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt.desc": "Read, write, and report",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower.desc": "Maximum Network Feeding Power Of The Heat Pump",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay.desc": "Read, write, and report",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable.desc": "Read, write, and report",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce.desc": "When The Single Operation Time Reaches This Value, The Heat Pump Control Mode Is Disabled",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower.desc": "Read, write, and report",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc.desc": "When The Battery Soc Reaches This Value, The Heat Pump Control Mode Is Enabled",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower.desc": "Read, write, and report",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts.desc": "Up To 4 Operation Periods Can Be Set",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.0": "No",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.1": "Yes",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.0": "Disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.1": "Enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.0": "Disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.1": "Enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.1": "Enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.0": "Disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.1": "Enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.0": "No",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.1": "Yes",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.0": "Disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.1": "enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.0": "disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.1": "Enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.0": "disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.1": "enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.0": "Disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.1": "enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.0": "disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.1": "Enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.0": "disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.1": "enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.0": "Disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.1": "enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.0": "disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.1": "Enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.0": "disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.1": "enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.0": "Disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.1": "enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.0": "disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.1": "Enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.0": "disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.1": "Enable",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.0": "Disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.0": "disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.1": "Enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.0": "disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.1": "Enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.0": "disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.1": "Enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.1": "Enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.0": "disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.1": "Enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.0": "disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.1": "enable",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.0": "Disable",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.1": "enable",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.0": "Disable",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.1": "Enable",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.0": "disable",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.1": "enable",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.0": "Disable",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.1": "enable",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.0": "Disable",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.1": "Enable",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.0": "disable",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.1": "enable",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.0": "Disable",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.1": "enable",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.0": "Disable",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.1": "enable",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.0": "The meaning of enumeration value 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.1": "Meaning Of Enumeration Value 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.0": "disable",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.1": "enable",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.0": "Disable",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.1": "enable",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.0": "Disable",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.1": "Enable",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.0": "Disable",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.1": "enable",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.0": "disable",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.1": "Enable",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.0": "Disable",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.1": "enable",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.0": "Disable",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.1": "enable",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.0": "The meaning of enumeration value 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.1": "Meaning Of Enumeration Value 1",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.6": "Heat pump control",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.0": "Disable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.1": "enable",
  "50901.ctrl_Safety.RPC.rpcMode.1": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety.RPC.rpcMode.2": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety.RPC.rpcMode.3": "Pf(P) Curve, Pf(P) Mode",
  "50901.ctrl_Safety.RPC.rpcMode.4": "W",
  "50901.ctrl_Safety.RPC.rpcMode.5": "PQ",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.0": "Disable",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.1": "enable",
  "50901.ctrl_Config.ClockSetting.clockSet": "Clock setting time period",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeCharge": "Dry node generator charging",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait1": "Dry node generator standby 1",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait2": "Dry Contact Generator Standby 2",
  "50901.ctrl_Dry_Contact.Generator.dryContactPracticeTime": "Generator Practice Mode Start Time",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump1": "Heat pump time period 1",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump2": "Heat Pump Time Period 2",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump3": "Heat pump time period 3",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump4": "Heat pump time period 4",
  "50901.ctrl_Safety.RPC.rpcMode.0": "Disable",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down1": "Mode Node Period 1 Valley 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down2": "Mode Node Period 1 Low Valley 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak1": "Mode Node Period 1 Peak 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak2": "Mode Node Period 1 Peak 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down1": "Mode Node Period 2 Low Valley 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down2": "Mode Node Period 2 Low Valley 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak1": "Mode Node Period 2 Peak 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak2": "Mode Node Period 2 Peak 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down1": "Mode Node Period 3 Valley 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down2": "Mode Node Period 3 Low Valley 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak1": "Mode Node Period 3 Peak 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak2": "Mode Node Period 3 Peak 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down1": "Mode Node Period 4 Low Valley 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down2": "Mode Node Period 4 Valley 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak1": "Mode Node Period 4 Peak 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak2": "Mode Node Period 4 Peak 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer1": "Mode Node Period 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer2": "Mode Node Period 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer3": "Mode Node Period 3",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer4": "Mode Node Period 4",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Chag": "Time division node period 2 charging",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Out": "Time division node period 2 discharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Chag": "Time-Of-Use Node Period 3 Charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Out": "Time division node period 3 discharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Chag": "Time sharing node period 4 charging",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Out": "Time-Of-Use Node Period 4 Discharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Chag": "Time sharing node period 5 charging",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Out": "Time-Of-Use Node Period 5 Discharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Chag": "Time sharing node period 6 charging",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Out": "Time division node period 6 discharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Chag": "Time-Of-Use Node Period 7 Charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Out": "Time division node period 7 discharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Chag": "Time division node period 8 charging",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Out": "Time-Of-Use Node Period 8 Discharge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer1": "Dry Contact Timer 1 Period 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer2": "Dry Node Timing 1 Time Period 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer1": "Dry Node Timing 2 Time Period 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer2": "Dry Contact Timer 2 Period 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer1": "Dry Node Period 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer2": "Dry Node Period 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode": "BattSoc detection mode for heat pump",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc": "Heat pump shutdown Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt": "Heat Pump Delay Detection Time Limit",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower": "Maximum feedback power of heat pump",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay": "The maximum daily operating time of the heat pump",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable": "Heat Pump Max Time Detect Enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce": "Minimum operating time limit for heat pumps",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower": "Heat Pump Startup Power",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc": "Heat pump startup Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower": "Heat pump power supply",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay": "Heat Pump Time 1 End - Day",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth": "Heat pump time 1 ends-",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay": "Heat Pump Time 1 Start - Day",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth": "Heat pump start time 1- month",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1": "Heat pump time 1 week 1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2": "Heat Pump Time 1 Week 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3": "Heat pump time 1 week 3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4": "Heat pump time 1 week 4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5": "Heat Pump Time 1 Week 5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6": "Heat pump time 1 week 6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7": "Heat pump time 1 week 7",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode": "Heat pump working mode",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts": "Heat Pump Operation Time",
  "50901.ctrl_WorkMode.economic.section1WeekRange11": "Period 1 Group 1 Monday",
  "50901.ctrl_WorkMode.economic.section1WeekRange12": "Period 1 Group 1 Tuesday",
  "50901.ctrl_WorkMode.economic.section1WeekRange13": "Period 1 Group 1 Wednesday",
  "50901.ctrl_WorkMode.economic.section1WeekRange14": "Period 1 Group 1 Thursday",
  "50901.ctrl_WorkMode.economic.section1WeekRange15": "Period 1 Group 1 Friday",
  "50901.ctrl_WorkMode.economic.section1WeekRange16": "Period 1 Group 1 Saturday",
  "50901.ctrl_WorkMode.economic.section1WeekRange17": "Period 1 Group 1 Sunday",
  "50901.ctrl_WorkMode.economic.section1WeekRange21": "Period 1 Group 2 Monday",
  "50901.ctrl_WorkMode.economic.section1WeekRange22": "Period 1 Group 2 Tuesday",
  "50901.ctrl_WorkMode.economic.section1WeekRange23": "Period 1 Group 2 Wednesday",
  "50901.ctrl_WorkMode.economic.section1WeekRange24": "Period 1 Group 2 Thursday",
  "50901.ctrl_WorkMode.economic.section1WeekRange25": "Period 1 Group 2 Friday",
  "50901.ctrl_WorkMode.economic.section1WeekRange26": "Period 1 Group 2 Saturday",
  "50901.ctrl_WorkMode.economic.section1WeekRange27": "Period 1 Group 2 Sunday",
  "50901.ctrl_WorkMode.economic.section2WeekRange11": "Period 2 Group 1 Monday",
  "50901.ctrl_WorkMode.economic.section2WeekRange12": "Period 2 Group 1 Tuesday",
  "50901.ctrl_WorkMode.economic.section2WeekRange13": "Period 2 Group 1 Wednesday",
  "50901.ctrl_WorkMode.economic.section2WeekRange14": "Period 2 Group 1 Thursday",
  "50901.ctrl_WorkMode.economic.section2WeekRange15": "Period 2 Group 1 Friday",
  "50901.ctrl_WorkMode.economic.section2WeekRange16": "Period 2 Group 1 Saturday",
  "50901.ctrl_WorkMode.economic.section2WeekRange17": "Period 2 Group 1 Sunday",
  "50901.ctrl_WorkMode.economic.section2WeekRange21": "Period 2 Group 2 Monday",
  "50901.ctrl_WorkMode.economic.section2WeekRange22": "Period 2 Group 2 Tuesday",
  "50901.ctrl_WorkMode.economic.section2WeekRange23": "Period 2 Group 2 Wednesday",
  "50901.ctrl_WorkMode.economic.section2WeekRange24": "Period 2 Group 2 Thursday",
  "50901.ctrl_WorkMode.economic.section2WeekRange25": "Period 2 Group 2 Friday",
  "50901.ctrl_WorkMode.economic.section2WeekRange26": "Period 2 Group 2 Saturday",
  "50901.ctrl_WorkMode.economic.section2WeekRange27": "Period 2 Group 2 Sunday",
  "50901.ctrl_WorkMode.economic.section3WeekRange11": "Period 3 Group 1 Monday",
  "50901.ctrl_WorkMode.economic.section3WeekRange12": "Period 3 Group 1 Tuesday",
  "50901.ctrl_WorkMode.economic.section3WeekRange13": "Period 3 Group 1 Wednesday",
  "50901.ctrl_WorkMode.economic.section3WeekRange14": "Period 3 Group 1 Thursday",
  "50901.ctrl_WorkMode.economic.section3WeekRange15": "Period 3 Group 1 Friday",
  "50901.ctrl_WorkMode.economic.section3WeekRange16": "Period 3 Group 1 Saturday",
  "50901.ctrl_WorkMode.economic.section3WeekRange17": "Period 3 Group 1 Sunday",
  "50901.ctrl_WorkMode.economic.section4WeekRange11": "Period 4, Group 1, Monday",
  "50901.ctrl_WorkMode.economic.section4WeekRange12": "Time slot 4, group 1, Tuesday",
  "50901.ctrl_WorkMode.economic.section4WeekRange13": "Period 4 Group 1 Wednesday",
  "50901.ctrl_WorkMode.economic.section4WeekRange14": "Time slot 4, group 1, Thursday",
  "50901.ctrl_WorkMode.economic.section4WeekRange15": "Time slot 4, group 1, Friday",
  "50901.ctrl_WorkMode.economic.section4WeekRange16": "Period 4 Group 1 Saturday",
  "50901.ctrl_WorkMode.economic.section4WeekRange17": "Time slot 4, Group 1, Monday",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27": "Sunday",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio": "Gcf Export Hard Limit Ratio",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio": "Gcf Export Soft Limit Ratio",
  "module.dashboard": "Dashboard",
  "module.ai": "AI",
  "bw_Param_strl_option_GridUseMeter": "Grid Smart Meter (No CT)",
  "bw_Param_strl_option_GridUseCT": "Grid Smart Meter (CT)",
  "50901.fault.dSPSAFcomparatorFault": "Comparator Fault",
  "50901.fault.dSPPWRfanFault": "Fan Fault",
  "50901.fault.dSPPWRgridRelayProtection": "Grid Relay Protection Triggered",
  "50901.fault.dSPPWRmachineTypeMismatch": "Machine Type Mismatch",
  "50901.fault.dSPSAFbatteryFault": "Battery Fault",
  "50901.fault.dSPSAFfanFault": "Fan Fault",
  "50901.fault.dSPSAFgridRelayProtection": "Grid Relay Protection Triggered",
  "50901.fault.dSPPWRbatteryFault": "Battery Side Fault",
  "50901.fault.dSPPWRcomparatorFault": "Comparator Fault",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality": "Auxiliary Power Abnormality",
  "50901.fault.dSPSAFmachineTypeMismatch": "Machine Type Mismatch",
  "50901.fault.dSPSAFsamplingBiasAbnormality": "Sampling Bias Abnormality",
  "50901.fault.canCommunicationTimeout": "Can Communication Timeout",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality": "Auxiliary Power Supply Abnormal",
  "50901.fault.dSPSAFarmCommunicationFault": "Arm Communication Fault",
  "50901.fault.dSPSAFspiCommunicationFault": "Spi Communication Fault",
  "50901.fault.dSPSAFversionMismatch": "Version Mismatch",
  "50901.fault.dSPPWRarmCommunicationFault": "Arm Communication Fault",
  "50901.fault.dSPPWRsamplingBiasAbnormality": "Sampling Bias Abnormality",
  "50901.fault.dSPPWRspiCommunicationFault": "Spi Communication Fault",
  "50901.fault.dSPPWRversionMismatch": "Version Mismatch (Software/Hardware Version Inconsistency)",
  "50901.fault.hardwareProtection": "Hardware Protection Triggered",
  "50901.fault.lowBatteryEnergy": "Low Battery Energy",
  "50901.fault.dSPPWRgridRelayProtection.0": "Disable",
  "50901.fault.dSPPWRgridRelayProtection.1": "Enable",
  "50901.fault.dSPPWRmachineTypeMismatch.0": "Disable",
  "50901.fault.dSPPWRmachineTypeMismatch.1": "Enable",
  "50901.fault.dSPPWRsamplingBiasAbnormality.0": "Disable",
  "50901.fault.dSPPWRbatteryFault.1": "Enable",
  "50901.fault.dSPPWRcomparatorFault.0": "Disable",
  "50901.fault.dSPPWRcomparatorFault.1": "Enable",
  "50901.fault.dSPPWRfanFault.0": "Disable",
  "50901.fault.dSPPWRfanFault.1": "Enable",
  "50901.fault.canCommunicationTimeout.1": "Enable",
  "50901.fault.dSPPWRarmCommunicationFault.0": "Disable",
  "50901.fault.dSPPWRarmCommunicationFault.1": "Enable",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.0": "Disable",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.1": "Enable",
  "50901.fault.dSPPWRbatteryFault.0": "Disable",
  "50901.fault.canCommunicationTimeout.0": "Disable",
  "50901.fault.dSPPWRsamplingBiasAbnormality.1": "Enable",
  "50901.fault.hardwareProtection.1": "Enable",
  "50901.fault.lowBatteryEnergy.0": "Disable",
  "50901.fault.lowBatteryEnergy.1": "Enable",
  "50901.fault.dSPSAFsamplingBiasAbnormality.1": "Enable",
  "50901.fault.dSPSAFspiCommunicationFault.0": "Disable",
  "50901.fault.dSPSAFspiCommunicationFault.1": "Enable",
  "50901.fault.dSPSAFversionMismatch.0": "Disable",
  "50901.fault.dSPSAFversionMismatch.1": "Enable",
  "50901.fault.hardwareProtection.0": "Disable",
  "50901.fault.dSPSAFarmCommunicationFault.0": "Disable",
  "50901.fault.dSPSAFgridRelayProtection.1": "Enable",
  "50901.fault.dSPSAFmachineTypeMismatch.0": "Disable",
  "50901.fault.dSPSAFmachineTypeMismatch.1": "Enable",
  "50901.fault.dSPSAFsamplingBiasAbnormality.0": "Disable",
  "50901.fault.dSPSAFbatteryFault.0": "Disable",
  "50901.fault.dSPSAFbatteryFault.1": "Enable",
  "50901.fault.dSPSAFcomparatorFault.0": "Disable",
  "50901.fault.dSPSAFcomparatorFault.1": "Enable",
  "50901.fault.dSPSAFfanFault.0": "Disable",
  "50901.fault.dSPSAFfanFault.1": "Enable",
  "50901.fault.dSPPWRversionMismatch.0": "Disable",
  "50901.fault.dSPPWRversionMismatch.1": "Enable",
  "50901.fault.dSPSAFarmCommunicationFault.1": "Enable",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.0": "Disable",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.1": "Enable",
  "50901.fault.dSPPWRspiCommunicationFault.0": "Disable",
  "50901.fault.dSPPWRspiCommunicationFault.1": "Enable",
  "50901.fault.dSPSAFgridRelayProtection.0": "Disable",
  "50901..数据分析_电网功率.tag": "grid power",
  "50901..数据分析_单体SOC.tag": "Single Cell Soc",
  "50901..数据分析_发电机功率.tag": "Generator power",
  "50901..数据分析_混逆光伏功率.tag": "Hybrid Inverter Pv Power",
  "50901..数据分析_电池包.tag": "battery pack",
  "50901..数据分析_电网电压.tag": "Grid Voltage",
  "50901..数据分析_电网电流.tag": "Grid current",
  "50901.Fault": "Fault",
  "50901.Fault.arcFault.0": "Disable",
  "50901.Fault.arcFault.1": "Enable",
  "50901.Fault.arcSelfTestFault.0": "Disable",
  "50901.Fault.arcSelfTestFault.1": "Enable",
  "50901.Fault.batteryCapacityAbnormality.0": "Disable",
  "50901.Fault.batteryCapacityAbnormality.1": "enable",
  "50901.Fault.batteryForceChargeRequest.0": "disable",
  "50901.Fault.batteryForceChargeRequest.1": "enable",
  "50901.Fault.bmsCanCommunicationAbnormality.0": "Disable",
  "50901.Fault.bmsCanCommunicationAbnormality.1": "Enable",
  "50901.Fault.busbarAbnormality.0": "Disable",
  "50901.Fault.busbarAbnormality.1": "Enable",
  "50901.Fault.cmpssBiasCalculationError.0": "Disable",
  "50901.Fault.cmpssBiasCalculationError.1": "Enable",
  "50901.Fault.driveAbnormality.0": "Disable",
  "50901.Fault.driveAbnormality.1": "Enable",
  "50901.Fault.dspPwrCommunicationAbnormality.0": "disable",
  "50901.Fault.dspPwrCommunicationAbnormality.1": "Enable",
  "50901.Fault.dspSafCommunicationAbnormality.0": "Disable",
  "50901.Fault.dspSafCommunicationAbnormality.1": "enable",
  "50901.Fault.dtsCommunicationAbnormality.0": "Disable",
  "50901.Fault.dtsCommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.e2rpomFault.0": "Disable",
  "50901.Fault.e2rpomFault.1": "Enable",
  "50901.Fault.epsOverload.0": "Disable",
  "50901.Fault.epsOverload.1": "Enable",
  "50901.Fault.epsRelayProtection.0": "Disable",
  "50901.Fault.epsRelayProtection.1": "Enable",
  "50901.Fault.epsVoltageAbnormality.0": "Disable",
  "50901.Fault.epsVoltageAbnormality.1": "Enable",
  "50901.Fault.evCharger1CommunicationAbnormality.0": "Disable",
  "50901.Fault.evCharger1CommunicationAbnormality.1": "enable",
  "50901.Fault.evCharger1Fault.0": "disable",
  "50901.Fault.evCharger1Fault.1": "enable",
  "50901.Fault.evCharger2CommunicationAbnormality.0": "disable",
  "50901.Fault.evCharger2CommunicationAbnormality.1": "Enable",
  "50901.Fault.evCharger2Fault.0": "Disable",
  "50901.Fault.evCharger2Fault.1": "enable",
  "50901.Fault.fanSpeedAbnormality.0": "Disable",
  "50901.Fault.fanSpeedAbnormality.1": "Enable",
  "50901.Fault.flashCommunicationFault.0": "Disable",
  "50901.Fault.flashCommunicationFault.1": "Enable",
  "50901.Fault.frequencyVariationRateOutOfRange.0": "Disable",
  "50901.Fault.frequencyVariationRateOutOfRange.1": "Enable",
  "50901.Fault.genAbnormality.0": "Disable",
  "50901.Fault.genAbnormality.1": "Enable",
  "50901.Fault.genOverload.0": "Disable",
  "50901.Fault.genOverload.1": "Enable",
  "50901.fault.genRelayAFault.0": "disable",
  "50901.fault.genRelayAFault.1": "Enable",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.0": "Disable",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.1": "Enable",
  "50901.Fault.gridMeterCommunicationAbnormality.0": "Disable",
  "50901.Fault.gridMeterCommunicationAbnormality.1": "Enable",
  "50901.Fault.gridMeterTypeError.0": "disable",
  "50901.Fault.gridMeterTypeError.1": "Enable",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.0": "Disable",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.1": "Enable",
  "50901.Fault.gridOverfrequency.0": "Disable",
  "50901.Fault.gridOverfrequency.1": "Enable",
  "50901.Fault.gridOvervoltage.0": "Disable",
  "50901.Fault.gridOvervoltage.1": "Enable",
  "50901.fault.gridPortOvercurrent.0": "Disable",
  "50901.fault.gridPortOvercurrent.1": "enable",
  "50901.Fault.gridPowerOutage.0": "Disable",
  "50901.Fault.gridPowerOutage.1": "Enable",
  "50901.Fault.gridUnderfrequency.0": "Disable",
  "50901.Fault.gridUnderfrequency.1": "Enable",
  "50901.Fault.gridUndervoltage.0": "Disable",
  "50901.Fault.gridUndervoltage.1": "Enable",
  "50901.Fault.gridVoltageAbnormality.0": "Disable",
  "50901.Fault.gridVoltageAbnormality.1": "Enable",
  "50901.Fault.hmidCommunicationAbnormality.0": "Disable",
  "50901.Fault.hmidCommunicationAbnormality.1": "enable",
  "50901.Fault.hmidMachineFault.0": "disable",
  "50901.Fault.hmidMachineFault.1": "Enable",
  "50901.Fault.insulationFault.0": "Disable",
  "50901.Fault.insulationFault.1": "Enable",
  "50901.Fault.interruptOverflow.0": "Disable",
  "50901.Fault.interruptOverflow.1": "Enable",
  "50901.fault.inverterCanCommunicationFailed.0": "Disable",
  "50901.fault.inverterCanCommunicationFailed.1": "enable",
  "50901.Fault.lineToEarthFault.0": "Disable",
  "50901.Fault.lineToEarthFault.1": "Enable",
  "50901.fault.loadRelayAFault.0": "disable",
  "50901.fault.loadRelayAFault.1": "Enable",
  "50901.fault.loadRelayBFault.0": "Disable",
  "50901.fault.loadRelayBFault.1": "enable",
  "50901.Fault.lowAmbientTemperature.0": "Disable",
  "50901.Fault.lowAmbientTemperature.1": "Enable",
  "50901.Fault.lowDtuVersion.0": "Disable",
  "50901.Fault.lowDtuVersion.1": "Enable",
  "50901.Fault.masterSlaveCommunicationAbnormality.0": "Disable",
  "50901.Fault.masterSlaveCommunicationAbnormality.1": "enable",
  "50901.Fault.meterWiringAbnormality.0": "Disable",
  "50901.Fault.meterWiringAbnormality.1": "Enable",
  "50901.Fault.microelectronicFault.0": "Disable",
  "50901.Fault.microelectronicFault.1": "Enable",
  "50901.Fault.neutralWireNotConnected.0": "Disable",
  "50901.Fault.neutralWireNotConnected.1": "Enable",
  "50901.Fault.neutralWireToEarthFault.0": "Disable",
  "50901.Fault.neutralWireToEarthFault.1": "Enable",
  "50901.Fault.overTemperature.0": "Disable",
  "50901.Fault.overTemperature.1": "Enable",
  "50901.fault.overtemperatureAlarm.0": "disable",
  "50901.fault.overtemperatureAlarm.1": "Enable",
  "50901.Fault.pllLockFailed.0": "Disable",
  "50901.Fault.pllLockFailed.1": "Enable",
  "50901.Fault.preSynchronizationFailed.0": "Disable",
  "50901.Fault.preSynchronizationFailed.1": "Enable",
  "50901.Fault.pvFault.0": "Disable",
  "50901.Fault.pvFault.1": "Enable",
  "50901.Fault.pvMeterCommunicationAbnormality.0": "Disable",
  "50901.Fault.pvMeterCommunicationAbnormality.1": "enable",
  "50901.Fault.pvMeterTypeError.0": "disable",
  "50901.Fault.pvMeterTypeError.1": "Enable",
  "50901.fault.pvRelayAbFault.0": "Disable",
  "50901.fault.pvRelayAbFault.1": "enable",
  "50901.Fault.pvVoltageExceedingBusVoltage.0": "Disable",
  "50901.Fault.pvVoltageExceedingBusVoltage.1": "Enable",
  "50901.Fault.rcdFault.0": "Disable",
  "50901.Fault.rcdFault.1": "Enable",
  "50901.Fault.rcdSelfTestFault.0": "Disable",
  "50901.Fault.rcdSelfTestFault.1": "Enable",
  "50901.Fault.reconnectionFailed.0": "Disable",
  "50901.Fault.reconnectionFailed.1": "Enable",
  "50901.Fault.shutDown.0": "Disable",
  "50901.Fault.shutDown.1": "Enable",
  "50901.Fault.slaveWrongBatteryConnection.0": "Disable",
  "50901.Fault.slaveWrongBatteryConnection.1": "enable",
  "50901.fault.smartloadPortOvercurrent.0": "disable",
  "50901.fault.smartloadPortOvercurrent.1": "Enable",
  "50901.Fault.sustainedNegativeLoad.0": "Disable",
  "50901.Fault.sustainedNegativeLoad.1": "Enable",
  "50901.Fault.temperatureAbnormality.0": "Disable",
  "50901.Fault.temperatureAbnormality.1": "Enable",
  "50901.Fault.tenMinuteOvervoltage.0": "Disable",
  "50901.Fault.tenMinuteOvervoltage.1": "Enable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.0": "disable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.1": "enable",
  "50901.Fault.wiringAbnormality.0": "Disable",
  "50901.Fault.wiringAbnormality.1": "Enable",
  "50901.HeatPump": "Heat Pump Control",
  "50901.real_time": "Meaning Of Enumeration Value 0",
  "50901.warning": "Heat Pump Control",
  "50901.warning.batteryHighVoltageAlarm.0": "Disable",
  "50901.warning.batteryHighVoltageAlarm.1": "Enable",
  "50901.warning.batteryLowVoltageAlarm.0": "disable",
  "50901.warning.batteryLowVoltageAlarm.1": "Enable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.0": "disable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.1": "enable",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.0": "Disable",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.1": "enable",
  "50901.warning.chargeHighTemperatureAlarm.0": "disable",
  "50901.warning.chargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.chargeLowTemperatureAlarm.0": "disable",
  "50901.warning.chargeLowTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeHighTemperatureAlarm.0": "Disable",
  "50901.warning.dischargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeLowTemperatureAlarm.0": "disable",
  "50901.warning.dischargeLowTemperatureAlarm.1": "enable",
  "50901.warning.inputOvervoltageAlarm.0": "disable",
  "50901.warning.inputOvervoltageAlarm.1": "Enable",
  "50901..cfgMultPcsBmsFlag.0": "No",
  "50901..cfgMultPcsBmsFlag.1": "Yes",
  "50901..hpTime2WeekRange1.0": "Disable",
  "50901..hpTime2WeekRange1.1": "enable",
  "50901..hpTime2WeekRange2.0": "disable",
  "50901..hpTime2WeekRange2.1": "Enable",
  "50901..hpTime2WeekRange3.0": "disable",
  "50901..hpTime2WeekRange3.1": "Enable",
  "50901..hpTime2WeekRange4.0": "Disable",
  "50901..hpTime2WeekRange4.1": "Enable",
  "50901..hpTime2WeekRange5.0": "disable",
  "50901..hpTime2WeekRange5.1": "enable",
  "50901..hpTime2WeekRange6.0": "Disable",
  "50901..hpTime2WeekRange6.1": "Enable",
  "50901..hpTime2WeekRange7.0": "Disable",
  "50901..hpTime2WeekRange7.1": "Enable",
  "50901..hpTime3WeekRange1.0": "disable",
  "50901..hpTime3WeekRange1.1": "enable",
  "50901..hpTime3WeekRange2.0": "Disable",
  "50901..hpTime3WeekRange2.1": "Enable",
  "50901..hpTime3WeekRange3.0": "Disable",
  "50901..hpTime3WeekRange3.1": "Enable",
  "50901..hpTime3WeekRange4.0": "disable",
  "50901..hpTime3WeekRange4.1": "enable",
  "50901..hpTime3WeekRange5.0": "Disable",
  "50901..hpTime3WeekRange5.1": "Enable",
  "50901..hpTime3WeekRange6.0": "Disable",
  "50901..hpTime3WeekRange6.1": "Enable",
  "50901..hpTime3WeekRange7.0": "disable",
  "50901..hpTime3WeekRange7.1": "Enable",
  "50901..hpTime4WeekRange1.0": "disable",
  "50901..hpTime4WeekRange1.1": "Enable",
  "50901..hpTime4WeekRange2.0": "Disable",
  "50901..hpTime4WeekRange2.1": "Enable",
  "50901..hpTime4WeekRange3.0": "disable",
  "50901..hpTime4WeekRange3.1": "enable",
  "50901..hpTime4WeekRange4.0": "Disable",
  "50901..hpTime4WeekRange4.1": "Enable",
  "50901..hpTime4WeekRange5.0": "Disable",
  "50901..hpTime4WeekRange5.1": "enable",
  "50901..hpTime4WeekRange6.0": "Disable",
  "50901..hpTime4WeekRange6.1": "enable",
  "50901..hpTime4WeekRange7.0": "Disable",
  "50901..hpTime4WeekRange7.1": "Enable",
  "50901..materType.0": "No Grid-Side Meter",
  "50901..materType.1": "Zhengtai single-phase",
  "50901..materType.2": "Chint Single-Phase",
  "50901..materType.3": "Zhengtai split phase",
  "50901..materType.5": "Metering Module",
  "50901..materType.6": "Ankerui Single Road",
  "50901..materType.7": "Ankerui Dual Road",
  "50901..section1WeekRange1.0": "Monday",
  "50901..section1WeekRange1.1": "Tuesday",
  "50901..section1WeekRange1.2": "Wednesday",
  "50901..section1WeekRange1.3": "Thursday",
  "50901..section1WeekRange1.4": "Friday",
  "50901..section1WeekRange1.5": "Saturday",
  "50901..section1WeekRange1.6": "Sunday",
  "50901..section1WeekRange2.0": "Meaning Of Enumeration Value 0",
  "50901..section1WeekRange2.1": "Meaning Of Enumeration Value 1",
  "50901..section2WeekRange1.0": "Meaning Of Enumeration Value 0",
  "50901..section2WeekRange1.1": "Meaning Of Enumeration Value 2",
  "50901..section3WeekRange1.0": "Meaning Of Enumeration Value 0",
  "50901..section3WeekRange1.1": "Meaning Of Enumeration Value 2",
  "50901..section4WeekRange1.0": "Meaning Of Enumeration Value 0",
  "50901..section4WeekRange1.1": "The meaning of enumeration value 2",
  "50901.fault.emergencyStopSwitchStatus.0": "Disable",
  "50901.fault.emergencyStopSwitchStatus.1": "Enable",
  "50901.fault.fiveVoltPowerSupplyFault.0": "Disable",
  "50901.fault.fiveVoltPowerSupplyFault.1": "enable",
  "50901.fault.genPortOvercurrent.0": "disable",
  "50901.fault.genPortOvercurrent.1": "Enable",
  "50901.fault.genRelayBFault.0": "disable",
  "50901.fault.genRelayBFault.1": "Enable",
  "50901.fault.gridMeter.0": "Disable",
  "50901.fault.gridMeter.1": "enable",
  "50901.fault.inverterCommunicationFailed.0": "disable",
  "50901.fault.inverterCommunicationFailed.1": "Enable",
  "50901.fault.kmRelayFault.0": "disable",
  "50901.fault.kmRelayFault.1": "Enable",
  "50901.fault.pvPortOvercurrent.0": "Disable",
  "50901.fault.pvPortOvercurrent.1": "enable",
  "50901.fault.twelveVoltPowerSupplyFault.0": "Disable",
  "50901.fault.twelveVoltPowerSupplyFault.1": "enable",
  "50901.real_time.batteryConnectionStatus.0": "No",
  "50901.real_time.batteryConnectionStatus.1": "Yes",
  "50901.real_time.batteryType_04.0": "No Battery",
  "50901.real_time.batteryType_04.1": "lithium battery",
  "50901.real_time.batteryType_04.2": "Lead-Acid Battery",
  "50901.real_time.packNum.0": "0",
  "50901.real_time.packNum.1": "1",
  "50901.real_time.packNum.1023": "10",
  "50901.real_time.packNum.127": "seven",
  "50901.real_time.packNum.15": "four",
  "50901.real_time.packNum.16383": "fourteen",
  "50901.real_time.packNum.2047": "eleven",
  "50901.real_time.packNum.255": "8",
  "50901.real_time.packNum.3": "two",
  "50901.real_time.packNum.31": "5",
  "50901.real_time.packNum.32767": "fifteen",
  "50901.real_time.packNum.4095": "twelve",
  "50901.real_time.packNum.511": "9",
  "50901.real_time.packNum.63": "six",
  "50901.real_time.packNum.65535": "sixteen",
  "50901.real_time.packNum.7": "3",
  "50901.real_time.packNum.8191": "thirteen",
  "50901..parallelNetworking.0": "Invalid",
  "50901..parallelNetworking.1": "Networking In Progress",
  "50901..parallelNetworking.2": "Dissolve Network",
  "50901..phaseOrderInverseDisable.0": "disable",
  "50901..phaseOrderInverseDisable.1": "enable",
  "50901..relayU16NlineRlyTestDis.0": "Disable",
  "50901..relayU16NlineRlyTestDis.1": "enable",
  "50901.ctrl_Config.Device.arcfaultClear.0": "No",
  "50901.ctrl_Config.Device.arcfaultClear.1": "Yes",
  "50901.ctrl_Config.Device.clearfault.0": "No",
  "50901.ctrl_Config.Device.clearfault.1": "Yes",
  "50901.Fault.arcFault": "Arc Fault",
  "50901.Fault.arcSelfTestFault": "Arc Fault Self-Check Failure",
  "50901.Fault.busbarAbnormality": "Dc Bus Abnormal",
  "50901.Fault.cmpssBiasCalculationError": "Cmpss Offset Calculation Error",
  "50901.Fault.driveAbnormality": "Drive Abnormal",
  "50901.Fault.e2rpomFault": "Eeprom Fault",
  "50901.Fault.epsOverload": "Eps Overload",
  "50901.Fault.epsRelayProtection": "Eps Relay Protection",
  "50901.Fault.epsVoltageAbnormality": "Eps Voltage Abnormal",
  "50901.Fault.flashCommunicationFault": "Flash Memory Communication Fault",
  "50901.Fault.frequencyVariationRateOutOfRange": "Frequency Change Rate Over-Limit",
  "50901.Fault.genAbnormality": "Generator Abnormal",
  "50901.Fault.genOverload": "Generator Overload",
  "50901.Fault.gridCurrentDcOffsetOutOfRange": "Grid Current Dc Offset Over-Limit",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange": "Off-Grid Voltage Dc Offset Over-Limit",
  "50901.Fault.gridOverfrequency": "Grid Overfrequency",
  "50901.Fault.gridOvervoltage": "Grid Overvoltage",
  "50901.Fault.gridPowerOutage": "Grid Power Loss",
  "50901.Fault.gridUnderfrequency": "Grid Underfrequency",
  "50901.Fault.gridUndervoltage": "Grid Undervoltage",
  "50901.Fault.gridVoltageAbnormality": "Grid Voltage Abnormal",
  "50901.Fault.insulationFault": "Insulation Fault",
  "50901.Fault.interruptOverflow": "Interrupt Overflow",
  "50901.Fault.lineToEarthFault": "Ground Fault (Line-To-Ground)",
  "50901.Fault.lowAmbientTemperature": "Ambient Temperature Too Low",
  "50901.Fault.meterWiringAbnormality": "Meter Wiring Abnormal",
  "50901.Fault.microelectronicFault": "Microelectronics Fault",
  "50901.Fault.neutralWireNotConnected": "Neutral Line Not Connected",
  "50901.Fault.neutralWireToEarthFault": "Neutral Line-To-Ground Fault",
  "50901.Fault.overTemperature": "Overtemperature",
  "50901.Fault.pllLockFailed": "Pll Lock Failure",
  "50901.Fault.preSynchronizationFailed": "Pre-Synchronization Failure",
  "50901.Fault.pvFault": "Pv Fault",
  "50901.Fault.pvVoltageExceedingBusVoltage": "Pv Voltage Exceeding Bus Voltage",
  "50901.Fault.rcdFault": "Rcd Fault",
  "50901.Fault.rcdSelfTestFault": "Rcd Self-Check Failure",
  "50901.Fault.reconnectionFailed": "Reconnection Failure",
  "50901.Fault.shutDown": "System Shutdown",
  "50901.Fault.temperatureAbnormality": "Temperature Abnormal",
  "50901.Fault.tenMinuteOvervoltage": "10-Minute Overvoltage",
  "50901.Fault.wiringAbnormality": "Wiring Abnormal",
  "50901.real_time.copy_communicationStickSoftwareVersion": "Communication stick software version",
  "50901.real_time.copy_bmsSoftwareVersion": "BMS Version - Software",
  "50901.real_time.copy_controllerarmFirmwareVersion": "Inverter Arm Version",
  "50901.real_time.previous_gridPower": "Grid-Side Power",
  "50901.ctrl_Config.Device.arcfaultClear": "Arc Fault Clearing",
  "50901.ctrl_Config.Device.clearfault": "Clear Fault",
  "50901.real_time.batteryCapacity": "Battery Installed Capacity",
  "50901.real_time.batteryWorkingStatus.0": "Stand By",
  "50901.real_time.batteryWorkingStatus.1": "Standby",
  "org.aiMessage.charge.fail": "Charging failed (retried 3 times). AI will automatically retry in subsequent periods. You can handle it manually after turning off AI mode.",
  "org.aiMessage.charge.success": "Charging command successfully executed. AI strategy is running normally.",
  "org.aiMessage.discharge.fail": "Discharging failed (retried 3 times). AI will automatically retry in subsequent periods. You can handle it manually after turning off AI mode.",
  "org.aiMessage.discharge.success": "Discharging command successfully executed. AI strategy is running normally.",
  "ai.message.charge.title.success": "Charging command executed successfully",
  "ai.message.charge.title.fail": "Charging command execution failed",
  "ai.message.charge.content.success": "Charging command successfully executed. AI strategy is running normally.",
  "ai.message.charge.content.fail": "charging command failed (auto-retried 3 times). AI will retry in subsequent periods. You can operate manually after turning off AI mode.",
  "ai.message.discharge.title.success": "Discharging command executed successfully",
  "ai.message.discharge.title.fail": "Discharging command execution failed",
  "ai.message.discharge.content.success": "Discharging command successfully executed. AI strategy is running normally.",
  "ai.message.discharge.content.fail": "discharging command failed (auto-retried 3 times). AI will retry in subsequent periods. You can operate manually after turning off AI mode.",
  "50901.fault.evCharger1CommunicationAbnormality": "Ev Charger 1 Communication Abnormal",
  "50901.fault.bmsCanCommunicationAbnormality": "Bms Can Communication Abnormal",
  "50901.fault.dtu3Rs485CommunicationAbnormality": "Dtu3 Rs485 Communication Abnormal",
  "50901.fault.gridMeterTypeError": "Grid Meter Type Error",
  "50901.fault.lowDtuVersion": "Dtu Version Too Low",
  "50901.fault.gridMeterCommunicationAbnormality": "Grid Meter Communication Abnormal",
  "50901.fault.pvMeterTypeError": "Pv Meter Type Error",
  "50901.fault.dspPwrCommunicationAbnormality": "Dsp Power Communication Abnormal",
  "50901.fault.evCharger2CommunicationAbnormality": "Ev Charger 2 Communication Abnormal",
  "50901.fault.dtu5Rs485CommunicationAbnormality": "Dtu5 Rs485 Communication Abnormal",
  "50901.fault.dtsCommunicationAbnormality": "Dts Communication Abnormal",
  "50901.fault.dtu4Rs485CommunicationAbnormality": "Dtu4 Rs485 Communication Abnormal",
  "50901.fault.dtu1Rs485CommunicationAbnormality": "Dtu1 Rs485 Communication Abnormal",
  "50901.fault.pvMeterCommunicationAbnormality": "Pv Meter Communication Abnormal",
  "50901.fault.slaveWrongBatteryConnection": "Slave Battery Connection Error",
  "50901.fault.dtu2Rs485CommunicationAbnormality": "Dtu2 Rs485 Communication Abnormal",
  "50901.fault.dspSafCommunicationAbnormality": "Dsp Secure Communication Abnormal",
  "50901.fault.sustainedNegativeLoad": "Sustained Negative Load",
  "50901.fault.hmidMachineFault": "Hmi Device Fault",
  "50901.fault.evCharger1Fault": "Ev Charger 1 Fault",
  "50901.fault.evCharger2Fault": "Ev Charger 2 Fault",
  "50901.fault.fanSpeedAbnormality": "Fan Speed Abnormal",
  "50901.fault.masterSlaveCommunicationAbnormality": "Master-Slave Communication Abnormal",
  "50901.fault.batteryCapacityAbnormality": "Battery Capacity Abnormal",
  "50901.fault.batteryForceChargeRequest": "Battery Force Charge Request",
  "50901.fault.hmidCommunicationAbnormality": "Hmi Communication Abnormal",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.desc": "Generator starts periodically at this time",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.desc": "Generator starts periodically at this time",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.desc": "Generator starts periodically at this time",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.desc": "Generator starts periodically at this time",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.desc": "Generator starts periodically at this time",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.desc": "Generator starts periodically at this time",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.desc": "Generator starts periodically at this time",
  "50901.fault.loadRelayAfault.0": "Disable",
  "50901.fault.fiveVoltPowerSupplyfault.0": "Disable",
  "50901.fault.fiveVoltPowerSupplyfault.1": "Enable",
  "50901.fault.genRelayAfault.0": "Disable",
  "50901.fault.genRelayAfault.1": "Enable",
  "50901.fault.genRelayBfault.0": "Disable",
  "50901.fault.genRelayBfault.1": "Enable",
  "50901.fault.kmRelayfault.0": "Disable",
  "50901.fault.kmRelayfault.1": "Enable",
  "50901.fault.twelveVoltPowerSupplyfault.1": "Enable",
  "50901.fault.loadRelayAfault.1": "Enable",
  "50901.fault.loadRelayBfault.0": "Disable",
  "50901.fault.loadRelayBfault.1": "Enable",
  "50901.fault.pvRelayAbfault.0": "Disable",
  "50901.fault.pvRelayAbfault.1": "Enable",
  "50901.fault.threePointThreeVoltPowerSupplyfault.0": "Disable",
  "50901.fault.threePointThreeVoltPowerSupplyfault.1": "Enable",
  "50901.fault.twelveVoltPowerSupplyfault.0": "Disable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.0": "Disable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.1": "Enable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.0": "Disable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.0": "Disable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.0": "Enable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.1": "Enable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.1": "Enable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.0": "Disable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.1": "Enable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.1": "Enable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.0": "Disable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.1": "Enable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.0": "Disable",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.1": "Enable",
  "50901.fault.loadRelayAfault": "Load A Relay Failure",
  "50901.fault.threePointThreeVoltPowerSupplyfault": "3.3V Power Supply Fault",
  "50901.fault.pvRelayAbfault": "PV AB Relay Fault",
  "50901.fault.twelveVoltPowerSupplyfault": "12V Power Supply Fault",
  "50901.fault.loadRelayBfault": "Load B Relay Failure",
  "50901.fault.kmRelayfault": "KM Relay Fault",
  "50901.fault.genRelayBfault": "Generator B Relay Fault",
  "50901.fault.genRelayAfault": "Generator A Relay Fault",
  "50901.fault.fiveVoltPowerSupplyfault": "5V Power Supply Fault",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4": "Generator exercise mode start time Thursday",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3": "Generator exercise mode start time Wednesday",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5": "Generator exercise mode start time Friday",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6": "Generator exercise mode start time Saturday",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2": "Generator exercise mode start time Tuesday",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7": "Generator exercise mode start time Sunday",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1": "Generator exercise mode start time Monday",
  "50901.fault.evCharger1CommunicationAbnormality.0": "Disable",
  "50901.fault.evCharger1CommunicationAbnormality.1": "Enable",
  "50901.fault.bmsCanCommunicationAbnormality.0": "Disable",
  "50901.fault.bmsCanCommunicationAbnormality.1": "Enable",
  "50901.fault.dtu3Rs485CommunicationAbnormality.0": "Disable",
  "50901.fault.dtu3Rs485CommunicationAbnormality.1": "Enable",
  "50901.fault.gridMeterTypeError.0": "Disable",
  "50901.fault.gridMeterTypeError.1": "Enable",
  "50901.fault.lowDtuVersion.0": "Disable",
  "50901.fault.lowDtuVersion.1": "Enable",
  "50901.fault.gridMeterCommunicationAbnormality.0": "Disable",
  "50901.fault.gridMeterCommunicationAbnormality.1": "Enable",
  "50901.fault.pvMeterTypeError.0": "Disable",
  "50901.fault.pvMeterTypeError.1": "Enable",
  "50901.fault.dspPwrCommunicationAbnormality.0": "Disable",
  "50901.fault.dspPwrCommunicationAbnormality.1": "Enable",
  "50901.fault.evCharger2CommunicationAbnormality.0": "Disable",
  "50901.fault.evCharger2CommunicationAbnormality.1": "Enable",
  "50901.fault.dtu5Rs485CommunicationAbnormality.0": "Disable",
  "50901.fault.dtu5Rs485CommunicationAbnormality.1": "Enable",
  "50901.fault.dtsCommunicationAbnormality.0": "Disable",
  "50901.fault.dtsCommunicationAbnormality.1": "Enable",
  "50901.fault.dtu4Rs485CommunicationAbnormality.0": "Disable",
  "50901.fault.dtu4Rs485CommunicationAbnormality.1": "Enable",
  "50901.fault.dtu1Rs485CommunicationAbnormality.0": "Disable",
  "50901.fault.dtu1Rs485CommunicationAbnormality.1": "Enable",
  "50901.fault.pvMeterCommunicationAbnormality.0": "Disable",
  "50901.fault.pvMeterCommunicationAbnormality.1": "Enable",
  "50901.fault.slaveWrongBatteryConnection.0": "Disable",
  "50901.fault.slaveWrongBatteryConnection.1": "Enable",
  "50901.fault.dtu2Rs485CommunicationAbnormality.0": "Disable",
  "50901.fault.dtu2Rs485CommunicationAbnormality.1": "Enable",
  "50901.fault.dspSafCommunicationAbnormality.0": "Disable",
  "50901.fault.dspSafCommunicationAbnormality.1": "Enable",
  "50901.fault.sustainedNegativeLoad.0": "Disable",
  "50901.fault.sustainedNegativeLoad.1": "Enable",
  "50901.fault.hmidMachineFault.0": "Disable",
  "50901.fault.hmidMachineFault.1": "Enable",
  "50901.fault.evCharger1Fault.0": "Disable",
  "50901.fault.evCharger1Fault.1": "Enable",
  "50901.fault.evCharger2Fault.0": "Disable",
  "50901.fault.evCharger2Fault.1": "Enable",
  "50901.fault.fanSpeedAbnormality.0": "Disable",
  "50901.fault.fanSpeedAbnormality.1": "Enable",
  "50901.fault.masterSlaveCommunicationAbnormality.0": "Disable",
  "50901.fault.masterSlaveCommunicationAbnormality.1": "Enable",
  "50901.fault.batteryCapacityAbnormality.0": "Disable",
  "50901.fault.batteryCapacityAbnormality.1": "Enable",
  "50901.fault.batteryForceChargeRequest.0": "Disable",
  "50901.fault.batteryForceChargeRequest.1": "Enable",
  "50901.fault.hmidCommunicationAbnormality.0": "Disable",
  "50901.fault.hmidCommunicationAbnormality.1": "Enable",
  "50901.fault.batteryFault": "Battery Fault",
  "50901.fault.fanFault.0": "Disable",
  "50901.fault.armCommunicationFault.1": "Enable",
  "50901.fault.batteryFault.0": "Disable",
  "50901.fault.batteryFault.1": "Enable",
  "50901.fault.evCharger1CommunicationAbnormality.desc": "Ev Charger 1 Communication Abnormal Description",
  "50901.fault.bmsCanCommunicationAbnormality.desc": "Bms Can Communication Abnormal Description",
  "50901.fault.dtu3Rs485CommunicationAbnormality.desc": "Dtu3 Rs485 Communication Abnormal Description",
  "50901.fault.gridMeterTypeError.desc": "Grid Meter Type Error Description",
  "50901.fault.lowDtuVersion.desc": "Dtu Version Too Low Description",
  "50901.fault.gridMeterCommunicationAbnormality.desc": "Grid Meter Communication Abnormal Description",
  "50901.fault.pvMeterTypeError.desc": "Pv Meter Type Error Description",
  "50901.fault.dspPwrCommunicationAbnormality.desc": "Dsp Power Communication Abnormal Description",
  "50901.fault.evCharger2CommunicationAbnormality.desc": "Ev Charger 2 Communication Abnormal Description",
  "50901.fault.dtu5Rs485CommunicationAbnormality.desc": "Dtu5 Rs485 Communication Abnormal Description",
  "50901.fault.dtsCommunicationAbnormality.desc": "Dts Communication Abnormal Description",
  "50901.fault.dtu4Rs485CommunicationAbnormality.desc": "Dtu4 Rs485 Communication Abnormal Description",
  "50901.fault.dtu1Rs485CommunicationAbnormality.desc": "Dtu1 Rs485 Communication Abnormal Description",
  "50901.fault.pvMeterCommunicationAbnormality.desc": "Pv Meter Communication Abnormal Description",
  "50901.fault.slaveWrongBatteryConnection.desc": "Slave Battery Connection Error Description",
  "50901.fault.dtu2Rs485CommunicationAbnormality.desc": "Dtu2 Rs485 Communication Abnormal Description",
  "50901.fault.dspSafCommunicationAbnormality.desc": "Dsp Secure Communication Abnormal Description",
  "50901.fault.sustainedNegativeLoad.desc": "Sustained Negative Load Description",
  "50901.fault.hmidMachineFault.desc": "Hmi Device Fault Description",
  "50901.fault.evCharger1Fault.desc": "Ev Charger 1 Fault Description",
  "50901.fault.evCharger2Fault.desc": "Ev Charger 2 Fault Description",
  "50901.fault.fanSpeedAbnormality.desc": "Fan Speed Abnormal Description",
  "50901.fault.batteryFault.desc": "Battery Fault Description",
  "50901.fault.masterSlaveCommunicationAbnormality.desc": "Master-Slave Communication Abnormal Description",
  "50901.fault.batteryCapacityAbnormality.desc": "Battery Capacity Abnormal Description",
  "50901.fault.batteryForceChargeRequest.desc": "Battery Force Charge Request Description",
  "50901.fault.hmidCommunicationAbnormality.desc": "Hmi Communication Abnormal Description",
  "50901.fault.evCharger1CommunicationAbnormality.00": "Disable",
  "50901.fault.evCharger1CommunicationAbnormality.01": "Enable",
  "50901.fault.bmsCanCommunicationAbnormality.00": "Disable",
  "50901.fault.bmsCanCommunicationAbnormality.01": "Enable",
  "50901.fault.dtu3Rs485CommunicationAbnormality.00": "Disable",
  "50901.fault.dtu3Rs485CommunicationAbnormality.01": "Enable",
  "50901.fault.gridMeterTypeError.00": "Disable",
  "50901.fault.gridMeterTypeError.01": "Enable",
  "50901.fault.lowDtuVersion.00": "Disable",
  "50901.fault.lowDtuVersion.01": "Enable",
  "50901.fault.gridMeterCommunicationAbnormality.00": "Disable",
  "50901.fault.gridMeterCommunicationAbnormality.01": "Enable",
  "50901.fault.pvMeterTypeError.00": "Disable",
  "50901.fault.pvMeterTypeError.01": "Enable",
  "50901.fault.dspPwrCommunicationAbnormality.00": "Disable",
  "50901.fault.dspPwrCommunicationAbnormality.01": "Enable",
  "50901.fault.evCharger2CommunicationAbnormality.00": "Disable",
  "50901.fault.evCharger2CommunicationAbnormality.01": "Enable",
  "50901.fault.dtu5Rs485CommunicationAbnormality.00": "Disable",
  "50901.fault.dtu5Rs485CommunicationAbnormality.01": "Enable",
  "50901.fault.dtsCommunicationAbnormality.00": "Disable",
  "50901.fault.dtsCommunicationAbnormality.01": "Enable",
  "50901.fault.dtu4Rs485CommunicationAbnormality.00": "Disable",
  "50901.fault.dtu4Rs485CommunicationAbnormality.01": "Enable",
  "50901.fault.dtu1Rs485CommunicationAbnormality.00": "Disable",
  "50901.fault.dtu1Rs485CommunicationAbnormality.01": "Enable",
  "50901.fault.pvMeterCommunicationAbnormality.00": "Disable",
  "50901.fault.pvMeterCommunicationAbnormality.01": "Enable",
  "50901.fault.slaveWrongBatteryConnection.00": "Disable",
  "50901.fault.slaveWrongBatteryConnection.01": "Enable",
  "50901.fault.dtu2Rs485CommunicationAbnormality.00": "Disable",
  "50901.fault.dtu2Rs485CommunicationAbnormality.01": "Enable",
  "50901.fault.dspSafCommunicationAbnormality.00": "Disable",
  "50901.fault.dspSafCommunicationAbnormality.01": "Enable",
  "50901.fault.sustainedNegativeLoad.00": "Disable",
  "50901.fault.sustainedNegativeLoad.01": "Enable",
  "50901.fault.hmidMachineFault.00": "Disable",
  "50901.fault.hmidMachineFault.01": "Enable",
  "50901.fault.evCharger1Fault.00": "Disable",
  "50901.fault.evCharger1Fault.01": "Enable",
  "50901.fault.evCharger2Fault.00": "Disable",
  "50901.fault.evCharger2Fault.01": "Enable",
  "50901.fault.fanSpeedAbnormality.00": "Disable",
  "50901.fault.fanSpeedAbnormality.01": "Enable",
  "50901.fault.batteryFault.00": "Disable",
  "50901.fault.batteryFault.01": "Enable",
  "50901.fault.masterSlaveCommunicationAbnormality.00": "Disable",
  "50901.fault.masterSlaveCommunicationAbnormality.01": "Enable",
  "50901.fault.batteryCapacityAbnormality.00": "Disable",
  "50901.fault.batteryCapacityAbnormality.01": "Enable",
  "50901.fault.batteryForceChargeRequest.00": "Disable",
  "50901.fault.batteryForceChargeRequest.01": "Enable",
  "50901.fault.hmidCommunicationAbnormality.00": "Disable",
  "50901.fault.hmidCommunicationAbnormality.01": "Enable",
  "alarm.excDesc.2047494139783155712": "ARM Communication Fault",
  "alarm.name.2047494139783155712": "ARM Communication Fault",
  "alarm.desc.20209": "mppt2Err",
  "device.dryWorking": "Dry Working",
  "Other": "Other",
  "not.configured": "Not configured",
  "10001.quickset.note1": "1. Self-Use Mode: The recommended setting is Self-Use Mode.This mode can maximize the use of PV power generation for household electricity or store it in batteries and use it for household electricity; 2. Feed in Priority Mode: This mode can preferentially send power to the grid when the load is met, used in areas with a subsidy for power to the grid; 3. Peak-shaving Mode: After setting Self Use or Feed in Priority Mode, Grid Peak shaving can also be selected when the local grid company charges the electricity price based on the peak power consumption of the system. Customers can select this peak shaving to avoid the peak consumption power at the grid.connection point; 4. Off-Grid Mode: This mode is only used for pure off-grid and is not recommended for standard storage systems. Note that if this mode is enabled in the grid-connected state, the working logic of the machine will be confused, and the \"Off-Grid\" will be displayed; 5. Time Of Use: If you need to manually control the battery charging and discharging with respect to time under Self-Use or Feed in Priority or Peak-shaving Mode,please use the Time of Use switch and the following set points. And the \"Allow Grid Charging\" in these 3 modes is or recommended to be turned on (lf turned off, the inverter will not force charge the battery, and the battery could potentially go to sleep).",
  "10001.quickset.note2": "1. Self-Use Mode: The recommended setting is Self-Use Mode.This mode can maximize the use of PV power generation for household electricity or store it in batteries and use it for household electricity;\n2. Feed in Priority Mode: This mode can preferentially send power to the grid when the load is met, used in areas with a subsidy for power to the grid;\n3. Peak-shaving Mode: After setting Self Use or Feed in Priority Mode, Grid Peak shaving can also be selected when the local grid company charges the electricity price based on the peak power consumption of the system. Customers can select this peak shaving to avoid the peak consumption power at the grid.connection point;\n4. Off-Grid Mode: This mode is only used for pure off-grid and is not recommended for standard storage systems. Note that if this mode is enabled in the grid-connected state, the working logic of the machine will be confused, and the \"Off-Grid\" will be displayed;\n5. Time Of Use: If you need to manually control the battery charging and discharging with respect to time under Self-Use or Feed in Priority or Peak-shaving Mode,please use the Time of Use switch and the following set points. And the \"Allow Grid Charging\" in these 3 modes is or recommended to be turned on (lf turned off, the inverter will not force charge the battery, and the battery could potentially go to sleep).",
  "10001.quickset.note3": "1. Self-Use Mode: The recommended setting is Self-Use Mode.This mode can maximize the use of PV power generation for household electricity or store it in batteries and use it for household electricity;\n2. Feed in Priority Mode: This mode can preferentially send power to the grid when the load is met, used in areas with a subsidy for power to the grid;\n3. Off-Grid Mode: This mode is only used for pure off-grid and is not recommended for standard storage systems. Note that if this mode is enabled in the grid-connected state, the working logic of the machine will be confused, and the \"Off-Grid\" will be displayed;\n4. Time Of Use: If you need to manually control the battery charging and discharging with respect to time under Self-Use or Feed in Priority or Peak-shaving Mode,please use the Time of Use switch and the following set points. And the \"Allow Grid Charging\" in these 3 modes is or recommended to be turned on (lf turned off, the inverter will not force charge the battery, and the battery could potentially go to sleep).",
  "chinaAreas.Shandong": "Shandong",
  "country.China": "China",
  "json.50901.workmode.timeSection": "Time Section",
  "business.role.admin": "business administrator",
  "business.role.common": "business role",
  "json.device.dryWorking": "Dry Working",
  "deptType.business": "business",
  "51002.ctrl_antireverse": "Anti-backflow Control",
  "51002.ctrl_inverter": "Control",
  "51002.null.数据分析_实时监控_PV.tag": "Real-time Monitoring_PV",
  "51002.real_time": "Real-time Monitoring",
  "51002.real_time.Energy_PV1.desc": "PV1 Accumulated Energy",
  "51002.real_time.Energy_PV2.desc": "PV2 Accumulated Energy",
  "51002.real_time.Energy_PV3.desc": "PV3 Accumulated Energy",
  "51002.real_time.Energy_PV4.desc": "PV4 Accumulated Energy",
  "51002.real_time.gridTotalFrequency.desc": "Total Grid Frequency",
  "51002.real_time.inverterTemp.desc": "Inverter Temperature",
  "51002.real_time.pvPower.desc": "PV Output Power",
  "51002.real_time.stRelayoN.desc": "Relay Connection Status",
  "51002.real_time.workStatus.desc": "Operating Status",
  "51002.real_time.数据分析_实时监控_GRID.tag": "Grid Data",
  "51002.real_time.数据分析_实时监控_P.tag": "PV Output Power",
  "51002.real_time.数据分析_实时监控_PV.tag": "PV",
  "51002.real_time.数据分析_实时监控_TP.tag": "Inverter Temperature",
  "51002.warning": "Alarm",
  "51002.warning.stAbnorm_Ris.desc": "Insulation Impedance Anomaly",
  "51002.warning.stErrAccess_EEPROM.desc": "EEPROM Access Anomaly",
  "51002.warning.stErrOP_Relay.desc": "Grid-side Relay Anomaly",
  "51002.warning.stHW_Fault.desc": "Inverter Hardware Protection",
  "51002.warning.stOV_Fgrid.desc": "Grid-side Over-frequency Protection",
  "51002.warning.stOV_Temp.desc": "Inverter Over-temperature Protection",
  "51002.warning.stOV_Vgrid.desc": "Grid-side Over-voltage Protection",
  "51002.warning.stPV1_OV.desc": "PV Input 1 Over-voltage",
  "51002.warning.stPV1_UV.desc": "PV Input 1 Under-voltage",
  "51002.warning.stPV2_OV.desc": "PV Input 2 Over-voltage",
  "51002.warning.stPV2_UV.desc": "PV Input 2 Under-voltage",
  "51002.warning.stPV3_OV.desc": "PV Input 3 Over-voltage",
  "51002.warning.stPV3_UV.desc": "PV Input 3 Under-voltage",
  "51002.warning.stPV4_OV.desc": "PV Input 4 Over-voltage",
  "51002.warning.stPV4_UV.desc": "PV Input 4 Under-voltage",
  "51002.warning.stUV_Fgrid.desc": "Grid-Side Under-frequency Protection",
  "51002.warning.stUV_Vgrid.desc": "Grid-Side Under-voltage Protection",
  "51002..gridtype.desc": "Grid Standard",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.0": "Disable",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.1": "Enable",
  "51002.ctrl_inverter.ena10mVs1Prot.0": "Disable",
  "51002.ctrl_inverter.ena10mVs1Prot.1": "Enable",
  "51002.ctrl_inverter.enaAPP_PWSET.0": "Disable",
  "51002.ctrl_inverter.enaAPP_PWSET.1": "Enable",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.0": "Disable",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.1": "Enable",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.0": "Disable",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.1": "Enable",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.0": "Disable",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.1": "Enable",
  "51002.ctrl_inverter.enaRestoretodefault.0": "Disable",
  "51002.ctrl_inverter.enaRestoretodefault.1": "Enable",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.0": "Disable",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.1": "Enable",
  "51002.real_time.stRelayoN.0": "Disconnect",
  "51002.real_time.stRelayoN.1": "Close",
  "51002.real_time.workStatus.0": "Shutdown",
  "51002.real_time.workStatus.1": "Power On",
  "51002.warning.stAbnorm_Ris.0": "Normal Operation",
  "51002.warning.stAbnorm_Ris.1": "Trigger Alarm",
  "51002.warning.stErrAccess_EEPROM.0": "Normal Operation",
  "51002.warning.stErrAccess_EEPROM.1": "Trigger Alarm",
  "51002.warning.stErrOP_Relay.0": "Normal Operation",
  "51002.warning.stErrOP_Relay.1": "Trigger Alarm",
  "51002.warning.stHW_Fault.0": "Normal Operation",
  "51002.warning.stHW_Fault.1": "Trigger Alarm",
  "51002.warning.stOV_Fgrid.0": "Normal Operation",
  "51002.warning.stOV_Fgrid.1": "Trigger Alarm",
  "51002.warning.stOV_Temp.0": "Normal Operation",
  "51002.warning.stOV_Temp.1": "Trigger Alarm",
  "51002.warning.stOV_Vgrid.0": "Normal Operation",
  "51002.warning.stOV_Vgrid.1": "Trigger Alarm",
  "51002.warning.stPV1_OV.0": "Normal Operation",
  "51002.warning.stPV1_OV.1": "Trigger Alarm",
  "51002.warning.stPV1_UV.0": "Normal Operation",
  "51002.warning.stPV1_UV.1": "Trigger Alarm",
  "51002.warning.stPV2_OV.0": "Normal Operation",
  "51002.warning.stPV2_OV.1": "Trigger Alarm",
  "51002.warning.stPV2_UV.0": "Normal Operation",
  "51002.warning.stPV2_UV.1": "Trigger Alarm",
  "51002.warning.stPV3_OV.0": "Normal Operation",
  "51002.warning.stPV3_OV.1": "Trigger Alarm",
  "51002.warning.stPV3_UV.0": "Normal Operation",
  "51002.warning.stPV3_UV.1": "Trigger Alarm",
  "51002.warning.stPV4_OV.0": "Normal Operation",
  "51002.warning.stPV4_OV.1": "Trigger Alarm",
  "51002.warning.stPV4_UV.0": "Normal Operation",
  "51002.warning.stPV4_UV.1": "Trigger Alarm",
  "51002.warning.stUV_Fgrid.0": "Normal Operation",
  "51002.warning.stUV_Fgrid.1": "Trigger Alarm",
  "51002.warning.stUV_Vgrid.0": "Normal Operation",
  "51002.warning.stUV_Vgrid.1": "Trigger Alarm",
  "51002.ctrl_inverter.ena10mVs1Prot": "10-Minute Level 1 Grid-Side Voltage Average Over-voltage Protection Enable",
  "51002.ctrl_inverter.enaINVTR.0": "Shutdown",
  "51002.ctrl_inverter.enaINVTR.1": "Power On",
  "51002.ctrl_inverter.enaOVTPWDN.0": "Disable",
  "51002.ctrl_inverter.enaOVTPWDN.1": "Enable",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck": "System Protection Interface Self-Test Function Switch",
  "51002.real_time.Energy_PV1": "PV1 Cumulative Power Generation",
  "51002.real_time.Energy_PV2": "PV2 Cumulative Power Generation",
  "51002.real_time.Energy_PV3": "PV3 Cumulative Power Generation",
  "51002.real_time.Energy_PV4": "PV4 Cumulative Power Generation",
  "51002.real_time.Firmware_ver": "Firmware Version Number",
  "51002.real_time.Fn": "Grid-Connected Grid Rated Frequency",
  "51002.real_time.gridTotalFrequency": "Total Frequency",
  "51002.real_time.Iacrms": "Grid-Side Current RMS Value",
  "51002.real_time.inverterTemp": "Inverter Temperature",
  "51002.real_time.Ipv1": "PV1 Input Current",
  "51002.real_time.Ipv2": "PV2 Input Current",
  "51002.real_time.Ipv3": "PV3 Input Current",
  "51002.real_time.Ipv4": "PV4 Input Current",
  "51002.real_time.Ipvmax": "Maximum Input PV Current",
  "51002.real_time.Irmsmax": "Maximum Grid-Connected Current RMS Value",
  "51002.real_time.Pn": "Maximum Grid-Connected Active Power",
  "51002.real_time.powerGeneration": "Total Power Generation",
  "51002.real_time.Powpvmax": "Maximum Input PV Power",
  "51002.real_time.pvPower": "PV Output Power",
  "51002.real_time.stRelayoN": "Relay Connection Status",
  "51002.real_time.Tempmax": "Maximum Operating Temperature",
  "51002.real_time.Un": "Grid-Connected Rated Voltage RMS Value",
  "51002.real_time.Vacrms": "Grid-Side Voltage RMS Value",
  "51002.real_time.Vmpptmax": "Maximum mppt Voltage",
  "51002.real_time.Vmpptmin": "Minimum mppt Voltage",
  "51002.real_time.Vpv1": "PV1 Input Voltage",
  "51002.real_time.Vpv2": "PV2 Input Voltage",
  "51002.real_time.Vpv3": "PV3 Input Voltage",
  "51002.real_time.Vpv4": "PV4 Input Voltage",
  "51002.real_time.workStatus": "Operating Status",
  "51002.warning.stAbnorm_Ris": "Insulation Impedance Anomaly",
  "51002.warning.stErrAccess_EEPROM": "EEPROM Access Anomaly",
  "51002.warning.stErrOP_Relay": "Grid-Side Relay Anomaly Protection",
  "51002.warning.stHW_Fault": "Inverter Hardware Protection",
  "51002.warning.stOV_Fgrid": "Grid-Side Over-Frequency Protection",
  "51002.warning.stOV_Temp": "Inverter Over-temperature Protection",
  "51002.warning.stOV_Vgrid": "Grid-Side Over-voltage Protection",
  "51002.warning.stPV1_OV": "PV Input 1 Over-voltage",
  "51002.warning.stPV1_UV": "PV Input 1 Under-voltage",
  "51002.warning.stPV2_OV": "PV Input 2 Over-voltage",
  "51002.warning.stPV2_UV": "PV Input 2 Under-voltage",
  "51002.warning.stPV3_OV": "PV Input 3 Over-voltage",
  "51002.warning.stPV3_UV": "PV Input 3 Under-voltage",
  "51002.warning.stPV4_OV": "PV Input 4 Over-voltage",
  "51002.warning.stPV4_UV": "PV Input 4 Under-voltage",
  "51002.warning.stUV_Fgrid": "Grid-Side Under-Frequency Protection",
  "51002.warning.stUV_Vgrid": "Grid-Side Under-voltage Protection",
  "51002.ctrl_antireverse.dynamicPowerLimit": "Anti-Reverse Power Limit Percentage Value",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT": "Anti-backflow Enable",
  "51002.ctrl_inverter.enaAPP_PWSET": "User Power Setting Enable",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj": "Frequency Offset Power Regulation Enable",
  "51002.ctrl_inverter.enaINVTR": "Inverter Remote On/Off",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT": "Insulation Impedance Anomaly Protection Enable",
  "51002.ctrl_inverter.enaOVs1_powerdownadj": "First-Level Over-voltage Derating Enable",
  "51002.ctrl_inverter.enaOVTPWDN": "Over-temperature Derating Enable",
  "51002.ctrl_inverter.enaRestoretodefault": "Restore Default Protection Values and Function Switches",
  "51002.ctrl_inverter.powersetUserApp": "User Power Limit Percentage",
  "bw_param_ctrl_option_BackupMode": "Backup power mode",
  "bw_param_ctrl_option_ Feed-inPriorityMode": "Grid feedback priority",
  "51102.ctrl_WorkMode.Switch.ems_ctrl_work_mode.4": "label",
  "50657.fault.comStatus": " Communication Status",
  "50657.fault.comStatus.00": "Disconnected",
  "50657.fault.comStatus.01": "Connected",
  "50657.realtime.FADE": " Forward Deep Valley Active Energy",
  "50657.realtime.FAFE": "Forward Normal Flat Active Energy",
  "50657.realtime.FAFE_PSD": "Forward Flat Active Energy (Previous Billing Day)",
  "50657.realtime.FAPE": "Forward Peak Active Energy",
  "50657.realtime.FAPE_PSD": "Forward Peak Active Energy (Previous Billing Day)",
  "50657.realtime.FAPVE": "Forward Peak & Valley Active Energy",
  "50657.realtime.FAPVE_PSD": "Forward Peak & Valley Active Energy (Previous Billing Day)",
  "50657.realtime.FASE": "Forward Sharp Peak Active Energy",
  "50657.realtime.FASE_PSD": "Forward Sharp Peak Active Energy (Previous Billing Day)",
  "50657.realtime.FAVE": "Forward Valley Active Energy",
  "50657.realtime.FAVE_PSD": "Forward Valley Active Energy (Previous Billing Day)",
  "50657.realtime.FTAE": "Total Forward Active Energy",
  "50657.realtime.FTAE_PSD": "Total Forward Active Energy (Previous Billing Day)",
  "50657.realtime.Fr": "Frequency",
  "50657.realtime.Ia": " Phase A Current",
  "50657.realtime.Ib": "Phase B Current",
  "50657.realtime.Ic": "Phase C Current",
  "50657.realtime.P": "Total Active Power",
  "50657.realtime.Pa": "Total Active Power Phase A",
  "50657.realtime.Pb": "Total Active Power Phase B",
  "50657.realtime.Pc": "Total Active Power Phase C",
  "50657.realtime.Pf": "Total Power Factor",
  "50657.realtime.Pfa": "Power Factor Phase A",
  "50657.realtime.Pfb": "Power Factor Phase B",
  "50657.realtime.Pfc": "Power Factor Phase C",
  "50657.realtime.Q": "Total Reactive Power",
  "50657.realtime.Qa": "Total Reactive Power Phase A",
  "50657.realtime.Qb": "Total Reactive Power Phase B",
  "50657.realtime.Qc": "Total Reactive Power Phase C",
  "50657.realtime.RADE": "Reverse Deep Valley Active Energy",
  "50657.realtime.RAFE": "Reverse Normal Flat Active Energy",
  "50657.realtime.RAPE": "Reverse Peak Active Energy",
  "50657.realtime.RASE": "Reverse Sharp Peak Active Energy",
  "50657.realtime.RAVE": "Reverse Valley Active Energy",
  "50657.realtime.RTAE": "Total Reverse Active Energy",
  "50657.realtime.S": "Total Apparent Power",
  "50657.realtime.Sa": "Apparent Power Phase A",
  "50657.realtime.Sb": "Apparent Power Phase B",
  "50657.realtime.Sc": "Apparent Power Phase C",
  "50657.realtime.T": "Temperature",
  "50657.realtime.Ua": " Phase A Voltage",
  "50657.realtime.Uab": "Line Voltage AB",
  "50657.realtime.Ub": "Phase B Voltage",
  "50657.realtime.Ubc": "Line Voltage BC",
  "50657.realtime.Uc": "Phase C Voltage",
  "50657.realtime.Uca": "Line Voltage CA",
  "50657.realtime.Z0": "Zero Sequence Impedance",
  "50657.realtime.Zf": "Forward Impedance",
  "bw_param_ctrl_note_DispatchActivepower": "Setting this data to a positive number indicates the need for discharge, while setting it to a negative number indicates the need for charging",
  "bw_param_ctrl_option_Forcedcharginganddischarging": "Forced Charging/Discharging",
  "bw_param_ctrl_option_GridUseCT&PVUseMeter": "Grid Smart Meter (CT) + Smart Meter (No CT) for 3rd-Party Inverter",
  "bw_param_ctrl_option_GridUseMeter&PVUseCT": "Grid Smart Meter (No CT) + Smart Meter (CT) for 3rd-Party Invertter",
  "bw_param_ctrl_option_DisableTimePeriodControl": "Disable Time Period Control",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiodcontrol": "Only Enable Charge Time Period Control",
  "bw_RTparam_name_TotalApparentPower_Grid": "Meter Apparent Power (Total)",
  "bw_param_ctrl_name_FactoryReset ": "Factory Reset",
  "bw_param_ctrl_option_FactoryReset ": "Reboot",
  "bw_param_ctrl_note_DSPReset": "When the fault information is inconsistent with the actual situation, it can be recovered by restarting the DSP. For example, if the APP experiences a fault of losing the ground wire, but the ground wire connected to the inverter is not disconnected, it can be recovered by restarting the DSP.",
  "bw_param_ctrl_note_EMSReset": "When abnormal data collection occurs,please resetthe EMS to recover the system.",
  "bw_param_ctrl_note_FactoryReset": "If you want to set all the sparameters of the inverter as default values, this function can be used.",
  "bw_param_ctrl_option_Grid&PVuseCT": "Grid & PV Use CT",
  "bw_param_outage_soc_setting": "Power off SOC Setting",
  "supplier.type.nky": "NKY",
  "Yes": "Yes",
  "No": "No",
  "shipment.No": "No",
  "shipment.Yes": "Yes",
  "the.netherlands": "The Netherlands",
  "netherland.areas": "The Netherlands",
  "norway.areas": "norwayAreas",
  "60420.real_time.versionStr": "version",
  "device.advanced": "advanced",
  "device.quickSetup": "Quick Setup",
  "paramSet.grouping.safetySetting": "Safety Specification Settings",
  "deliver.type.hOn": "hOn",
  "networkEnum.code.1": "LAN",
  "networkEnum.code.2": "WiFi",
  "networkEnum.code.3": "2G",
  "networkEnum.code.63": "4G",
  "networkEnum.code.12": "WiFi + BLE",
  "networkEnum.code.23": "WiFi + 4G + BLE",
  "networkEnum.code.62": "LAN",
  "networkEnum.code.64": "WiFi + AP",
  "networkEnum.code.65": "4G + BLE",
  "networkEnum.code.12,62": "WiFi + BLE + LAN",
  "networkEnum.code.62,63": "LAN + 4G",
  "networkEnum.code.23,62": "WiFi + BLE + LAN + 4G",
  "isShowService.show": "show",
  "faultType.all": "all",
  "faultType.happen": "Happening",
  "faultType.restored": "Restored",
  "transfer.operation.success": "success",
  "transfer.operation.fail": "fail",
  "transfer.operation.unbind": "unbind",
  "transfer.operation.withdraw": "withdraw",
  "login.passLength": "The password must be between 8 and 20 characters long",
  "login.passType": "The password must contain at least three types of digits, lowercase letters, uppercase letters, and English symbols",
  "login.correctEmail": "Please enter the correct email address",
  "placeholder.input": "Please enter",
  "placeholder.startTime": "Start Time",
  "placeholder.endTime": "End time",
  "placeholder.startDate": "Start date",
  "placeholder.endDate": "End Date",
  "upload.imageDetail": "Picture details",
  "upload.seeOrigin": "Click to view the source file",
  "upload.needOpen": "This file may need to be downLoaded and viewed",
  "upload.knowandSure": "Know and confirm",
  "upload.fail": "UpLoad failed",
  "upload.uploadError": "File upLoad failed, please contact the administrator",
  "upload.fielExceed": "The number of files exceeds the limit",
  "upload.fileSizeExceed": "The size of the upLoaded image cannot exceed",
  "upload.fileTypeError": "Please choose the correct file format",
  "upload.image": "Picture",
  "validator.bank": "Please enter the correct bank card number",
  "validator.phone": "Please enter the correct mobile phone or landline number",
  "validator.email": "Please enter the correct email address",
  "validator.password": "The password should be 8-20 characters long and contain at least three types of characters: numbers, uppercase letters, lowercase letters, and English symbols",
  "validator.greater": "Please enter a number greater than zero",
  "org.user": "User",
  "org.role": "Role",
  "org.email": "E-Mail",
  "org.editorginfo": "Edit Organizational Information",
  "org.passwordResetTo": "The password will be reset to",
  "org.pleaseChooseOrg": "Please select an organization first",
  "org.addDept": "Add department",
  "org.editDept": "Edit Department",
  "org.passwordResetSuccess": "Password reset successful",
  "org.passwordResetFail": "Password reset failed",
  "org.deleteTip": "This operation will delete the department. Do you want to continue?",
  "org.deleteSuccess": "Delete successfully",
  "org.parent": "Superior Organization",
  "org.orgName": "Organization Name",
  "org.area": "Country/Region",
  "org.leader": "Person In Charge",
  "org.leaderPhone": "Contact information of the person in charge",
  "org.logo": "Organizational Logo",
  "org.namenick": "Name/Nickname",
  "org.createTime": "Creation Time",
  "org.status": "State",
  "org.action": "Operation",
  "login.password.not.blank": "Login password cannot be empty",
  "token.invalid": "Token invalid, please log in again",
  "token.empty": "Token cannot be empty",
  "user.not.exist": "User does not exist",
  "user.mail.password.not.correct": "The user's email or password is incorrect",
  "user.email.exist": "Email has been registered!",
  "dept.suspend": "Department suspended, no new additions allowed",
  "dept.not.exist": "Department information does not exist",
  "email.code.valid": "The verification code is incorrect",
  "service.not.found": "Service not found",
  "service.internal.error": "Internal server error",
  "login.email.length.error": "The email length cannot exceed 50 characters.",
  "login.password.length.error": "The password length must be between 8-20 characters",
  "menu.edit.exist": "Failed to modify menu '% s', menu name already exists",
  "menu.add.exist": "Failed to add menu '% s', menu name already exists",
  "menu.edit.parent": "Failed to modify menu '% s', the higher-level menu cannot select itself",
  "menu.add.parent": "Failed to add menu '% s', the higher-level menu cannot select itself",
  "menu.child.exist": "There is a submenu that cannot be deleted",
  "menu.assign.error": "Menu assigned, deletion not allowed",
  "password.reset.success": "Password reset successful",
  "user.register.success": "Registered successfully",
  "dept.add.exist": "Failed to add department '% s', department name already exists",
  "dept.edit.exist": "Failed to modify department '% s', department name already exists",
  "menu.show.status": "Display",
  "menu.hide.status": "Hide",
  "menu.category.name": "Catalogue",
  "menu.menu.name": "Menu",
  "menu.button.name": "Button",
  "menu.is.external": "Yes",
  "menu.not.external": "No",
  "dev.type.oem": "OEM",
  "dev.type.odm": "ODM",
  "dev.type.self": "Self developed",
  "supplier.type.hr": "Haier",
  "supplier.type.jl": "Jinlang",
  "supplier.type.nt": "Natong",
  "device.category.inverter": "Inverter",
  "device.category.pv": "Photovoltaic",
  "device.category.battery": "Battery",
  "device.category.switch": "Switch",
  "device.category.charging.pile": "Charging station",
  "product.not.exist": "The Product does not exist",
  "product.binding.error": "The Product is already bound and cannot be deleted",
  "ship.import.empty": "Import data cannot be empty",
  "mdn.exist": "The mdn material number already exists, do not add it again",
  "ship.mdn.not.empty": "Mdn cannot be empty",
  "ship.category.not.empty": "Category cannot be empty",
  "ship.hrSn.not.empty": "Haier serial number cannot be empty",
  "ship.devType.not.empty": "R&D type cannot be empty",
  "ship.supplierSn.not.empty": "MES SN cannot be empty",
  "ship.mdn.not.exist": "The Product mdn does not exist",
  "ship.add.data.error": "Abnormal addition of shipment management data, please contact the administrator",
  "sotrage.sotrage": "Battery Settings",
  "plant.InstallationPlan": "Installation Plan",
  "plant.owner": "Owner",
  "plant.photovoltaicCapacity": "PV Capacity (kWh)",
  "plant.batteryCapacity": "Battery Capacity (kWh)",
  "plant.electricityConsumptionToday": "Today Yield",
  "plant.electricityConsumptionMonth": "This Month Yield",
  "plant.electricityConsumptionTotal": "Total Yield",
  "plant.runningState": "Operating Status",
  "plant.buildState": "Construction Status",
  "plant.plantNum": "Number of Plants",
  "plant.totalPlantNum": "Total",
  "plant.building": "Under Construction",
  "plant.delivered": "Delivered",
  "plant.electricEnergy": "Yield",
  "plant.deleteSuccess": "Plant Deleted Successfully",
  "plant.life": "Lifespan",
  "plant.operatingData": "Operating Data",
  "plant.dataReportingTime": "Data Reporting Time",
  "plant.energyBalance": "Energy Balance (kWh)",
  "plant.onGridEnergy": "Grid Exported Energy",
  "plant.purchaseElectricity": "Imported Energy",
  "plant.statisticalAnalysis": "Statistical Analysis",
  "plant.energyAnalysis": "Energy Analysis",
  "plant.powerAnalysis": "Power Analysis",
  "plant.updateTime": "Weather Data Update Time",
  "plant.stationInfo": "Plant Information",
  "plant.userInfo": "User Information",
  "plant.socialContribution": "Social Contribution",
  "plant.equivalentIncome": "Equivalent Earnings",
  "plant.priceSet": "Electricity Price Settings",
  "plant.photovoltaicPowerGenerations": "PV Total Yield",
  "plant.weather": "Weather",
  "plant.sunriseSunset": "Sunrise and Sunset",
  "plant.temperature": "Temperature(℃)",
  "plant.humidity": "Humidity",
  "plant.windSpeed": "Wind Speed",
  "plant.windDirection": "Wind Direction",
  "plant.primaryUser": "Primary User",
  "plant.receiveMode": "Reception Method",
  "plant.dateOfReceipt": "Reception Date",
  "plant.familyName": "Family Name",
  "plant.familyMembers": "Number of Family Members",
  "plant.currency": "Currency",
  "plant.purchasePrice": "Purchase Price",
  "plant.sellingPrice": "Electricity Sale Price",
  "plant.noUserInfo": "Users Not Yet Delivered",
  "plant.noIncomeTip": "For better calculation of your equivalent earnings, please enter the unit prices for electricity purchase and sale.",
  "subttile.week": "Week",
  "shipment.spread": "Unfold",
  "shipment.packUp": "Pack up",
  "device.empty": "Device does not exist",
  "deviceType.empty": "Unsupported Device Type",
  "collector.params.error": "Abnormal reading of non-Dongle parameters",
  "can.not.empty": "Cannot be empty",
  "shipment.supplierSN": "MES SN",
  "solis.10001.eToday": "Daily  Yield",
  "solis.10001.eMonth": "Monthly Yield",
  "solis.10001.eYear": "Yearly Yield",
  "solis.10001.eTotal": "Total Yield",
  "solis.10001.fAc": "Grid Frequency",
  "solis.10001.pac": "Real-time Power",
  "solis.10001.pacPec": "Power Percentage",
  "solis.10001.fullHour": "Full Power hours",
  "solis.10001.power": "Installed capacity",
  "solis.10001.iAc1": "AC side Current-R",
  "solis.10001.iAc2": "AC side Current-S",
  "solis.10001.iAc3": "AC side Current-T",
  "solis.10001.uAc1": "AC side Voltage-R",
  "solis.10001.uAc2": "AC side Voltage-S",
  "solis.10001.uAc3": "AC side Voltage-T",
  "solis.10001.iPv1": "PV Current-1",
  "solis.10001.iPv2": "PV Current-2",
  "solis.10001.iPv3": "PV Current-3",
  "solis.10001.iPv4": "PV Current-4",
  "solis.10001.iPv5": "PV Current-5",
  "solis.10001.iPv6": "PV Current-6",
  "solis.10001.iPv7": "PV Current-7",
  "solis.10001.iPv8": "PV Current-8",
  "solis.10001.iPv9": "PV Current-9",
  "solis.10001.iPv10": "PV Current-10",
  "solis.10001.iPv11": "PV Current-11",
  "solis.10001.iPv12": "PV Current-12",
  "solis.10001.iPv13": "PV Current-13",
  "solis.10001.iPv14": "PV Current-14",
  "solis.10001.iPv15": "PV Current-15",
  "solis.10001.iPv16": "PV Current-16",
  "solis.10001.iPv17": "PV Current-17",
  "solis.10001.iPv18": "PV Current-18",
  "solis.10001.iPv19": "PV Current-19",
  "solis.10001.iPv20": "PV Current-20",
  "solis.10001.iPv21": "PV Current-21",
  "solis.10001.iPv22": "PV Current-22",
  "solis.10001.iPv23": "PV Current-23",
  "solis.10001.iPv24": "PV Current-24",
  "solis.10001.iPv25": "PV Current-25",
  "solis.10001.iPv26": "PV Current-26",
  "solis.10001.iPv27": "PV Current-27",
  "solis.10001.iPv28": "PV Current-28",
  "solis.10001.iPv29": "PV Current-29",
  "solis.10001.iPv30": "PV Current-30",
  "solis.10001.iPv31": "PV Current-31",
  "solis.10001.iPv32": "PV Current-32",
  "solis.10001.uPv1": "PV Voltage -1",
  "solis.10001.uPv2": "PV Voltage -2",
  "solis.10001.uPv3": "PV Voltage -3",
  "solis.10001.uPv4": "PV Voltage -4",
  "solis.10001.uPv5": "PV Voltage -5",
  "solis.10001.uPv6": "PV Voltage -6",
  "solis.10001.uPv7": "PV Voltage -7",
  "solis.10001.uPv8": "PV Voltage -8",
  "solis.10001.uPv9": "PV Voltage -9",
  "solis.10001.uPv10": "PV Voltage -10",
  "solis.10001.uPv11": "PV Voltage -11",
  "solis.10001.uPv12": "PV Voltage -12",
  "solis.10001.uPv13": "PV Voltage -13",
  "solis.10001.uPv14": "PV Voltage -14",
  "solis.10001.uPv15": "PV Voltage -15",
  "solis.10001.uPv16": "PV Voltage -16",
  "solis.10001.uPv17": "PV Voltage -17",
  "solis.10001.uPv18": "PV Voltage -18",
  "solis.10001.uPv19": "PV Voltage -19",
  "solis.10001.uPv20": "PV Voltage -20",
  "solis.10001.uPv21": "PV Voltage -21",
  "solis.10001.uPv22": "PV Voltage -22",
  "solis.10001.uPv23": "PV Voltage -23",
  "solis.10001.uPv24": "PV Voltage -24",
  "solis.10001.uPv25": "PV Voltage -25",
  "solis.10001.uPv26": "PV Voltage -26",
  "solis.10001.uPv27": "PV Voltage -27",
  "solis.10001.uPv28": "PV Voltage -28",
  "solis.10001.uPv29": "PV Voltage -29",
  "solis.10001.uPv30": "PV Voltage -30",
  "solis.10001.uPv31": "PV Voltage -31",
  "solis.10001.uPv32": "PV Voltage -32",
  "solis.10001.pow1": "PV Power -1",
  "solis.10001.pow2": "PV Power -2",
  "solis.10001.pow3": "PV Power -3",
  "solis.10001.pow4": "PV Power -4",
  "solis.10001.pow5": "PV Power -5",
  "solis.10001.pow6": "PV Power -6",
  "solis.10001.pow7": "PV Power -7",
  "solis.10001.pow8": "PV Power -8",
  "solis.10001.pow9": "PV Power -9",
  "solis.10001.pow10": "PV Power -10",
  "solis.10001.pow11": "PV Power -11",
  "solis.10001.pow12": "PV Power -12",
  "solis.10001.pow13": "PV Power -13",
  "solis.10001.pow14": "PV Power -14",
  "solis.10001.pow15": "PV Power -15",
  "solis.10001.pow16": "PV Power -16",
  "solis.10001.pow17": "PV Power -17",
  "solis.10001.pow18": "PV Power -18",
  "solis.10001.pow19": "PV Power -19",
  "solis.10001.pow20": "PV Power -20",
  "solis.10001.pow21": "PV Power -21",
  "solis.10001.pow22": "PV Power -22",
  "solis.10001.pow23": "PV Power -23",
  "solis.10001.pow24": "PV Power -24",
  "solis.10001.pow25": "PV Power -25",
  "solis.10001.pow26": "PV Power -26",
  "solis.10001.pow27": "PV Power -27",
  "solis.10001.pow28": "PV Power -28",
  "solis.10001.pow29": "PV Power -29",
  "solis.10001.pow30": "PV Power -30",
  "solis.10001.pow31": "PV Power -31",
  "solis.10001.pow32": "PV Power -32",
  "solis.10001.inverterTemperature": "Inverter Temperature(℃)",
  "solis.10001.acOutputType": "AC output level",
  "solis.10001.dcInputType": "Number of DC input channels",
  "solis.10001.powerFactor": "BMS Min.Voltage",
  "solis.10001.batteryPower": "Battery Power",
  "solis.10001.batteryPowerPec": "Battery Power percentage",
  "solis.10001.batteryCapacitySoc": "Battery SOC",
  "solis.10001.batteryHealthSoh": "Battery SOH",
  "solis.10001.socDischargeSet": "The SOC is over-discharged",
  "solis.10001.socChargingSet": "Powerful charging SOC",
  "solis.10001.batteryType": "Battery model",
  "solis.10001.batteryVoltage": "Battery Voltage",
  "solis.10001.batteryCurrent": "Battery Current",
  "solis.10001.batteryTodayChargeEnergy": "Daily Charged Energy",
  "solis.10001.batteryMonthChargeEnergy": "Monthly Charged Energy",
  "solis.10001.batteryYearChargeEnergy": "Yearly Charged Energy",
  "solis.10001.batteryTotalChargeEnergy": "Battery Total Charge Energy",
  "solis.10001.batteryTodayDischargeEnergy": "Daily Discharged Energy",
  "solis.10001.batteryMonthDischargeEnergy": "Monthly Discharged Energy",
  "solis.10001.batteryYearDischargeEnergy": "Yearly Discharged Energy",
  "solis.10001.batteryTotalDischargeEnergy": "Total Discharged Energy",
  "solis.10001.gridPurchasedTodayEnergy": "Daily  Imported",
  "solis.10001.gridPurchasedMonthEnergy": "Monthly  Imported",
  "solis.10001.gridPurchasedYearEnergy": "Yearly  Imported",
  "solis.10001.gridPurchasedTotalEnergy": "Total Imported",
  "solis.10001.gridSellTodayEnergy": "Daily Exported",
  "solis.10001.gridSellMonthEnergy": "Monthly Exported",
  "solis.10001.gridSellYearEnergy": "Yearly Exported",
  "solis.10001.gridSellTotalEnergy": "Total Exported",
  "solis.10001.familyLoadPower": "Household Load Power",
  "solis.10001.bypassLoadPower": "Bypass Load Power",
  "solis.10001.pSum": "The total Active Power of the grid",
  "solis.10001.psumPec": "Percentage of the total Active Power of the grid",
  "solis.10001.homeLoadTodayEnergy": "Daily Load consumption",
  "solis.10001.homeLoadTotalEnergy": "Total Load consumption",
  "solis.10001.model": "Inverter model",
  "solis.10001.type": "Inverter Type",
  "solis.10001.stateExceptionFlag": "The inverter is offline",
  "solis.10001.productModel": "Product Model",
  "solis.10001.nationalStandards": "National Grid Standards",
  "solis.10001.version": "Inverter software version",
  "solis.10001.reactivePower": "Inverter reActive Power",
  "solis.10001.apparentPower": "Inverter Apparent Power",
  "solis.10001.dcPac": "Total input Power of the inverter",
  "solis.10001.updateShelfEndTime": "Warranty end time",
  "solis.10001.iA": "Meter A Current",
  "solis.10001.uA": "Meter A Voltage",
  "solis.10001.pA": "Meter A Power",
  "solis.10001.aLookedPower": "Meter A Apparent Power",
  "solis.10001.aReactivePower": "Meter A reActive Power",
  "solis.10001.aphasePowerFactor": "Meter A Active Power",
  "solis.10001.averagePowerFactor": "Meter A Power factor",
  "solis.10001.iB": "Meter B Current",
  "solis.10001.uB": "Meter B Voltage",
  "solis.10001.pB": "Meter B Power",
  "solis.10001.bLookedPower": "Meter B Apparent Power",
  "solis.10001.bReactivePower": "Meter B reActive Power",
  "solis.10001.bphasePowerFactor": "Meter B Active Power",
  "solis.10001.bveragePowerFactor": "Meter B Power Factor",
  "solis.10001.iC": "Meter C Current",
  "solis.10001.uC": "Meter C Voltage",
  "solis.10001.pC": "Meter C Power",
  "solis.10001.cLookedPower": "Meter C Apparent Power",
  "solis.10001.cReactivePower": "Meter C reActive Power",
  "solis.10001.cphasePowerFactor": "Meter C Active Power",
  "solis.10001.cveragePowerFactor": "Meter C Power factor",
  "jl_param_ctrl_name_Self-UseModeSwitch": "Self-Use Mode Switch",
  "jl_param_ctrl_name_AllowGridCharging": "Allow Grid Charging",
  "jl_param_ctrl_name_BatteryReserveSwitch": "Battery Reserve Switch",
  "jl_param_ctrl_name_ReservedSOC": "Reserved SOC",
  "jl_param_ctrl_name_GridChargingPowerLimit": "Grid Charging Power Limit",
  "jl_param_ctrl_name_FeedinPriorityModeSwitch": "Feed in Priority Mode Switch",
  "jl_param_ctrl_name_Peak-shavingSwitch": "Peak-shaving Switch",
  "jl_param_ctrl_name_Max.usableGridPower": "Max.usable Grid Power",
  "jl_param_ctrl_name_BaselineSOC": "Baseline SOC",
  "jl_param_ctrl_name_Off-gridModeSwitch": "Off-grid Mode Switch",
  "jl_param_ctrl_name_Off-GridOverdischargeSOC": "Off-Grid Overdischarge SOC",
  "jl_param_ctrl_name_TimeofUseSwitch": "Time of Use Switch",
  "jl_param_ctrl_name_TimeofUseChargeCurrentSet": "Time of Use Charge Current Set",
  "jl_param_ctrl_name_TimeofUseDischargeCurrentSet": "Time of Use Discharge Current Set",
  "jl_param_ctrl_name_ChargeTimeSlot1": "Charge Time Slot 1",
  "jl_param_ctrl_name_DischargeTimeSlot1": "Discharge Time Slot 1",
  "jl_param_ctrl_name_ChargeTimeSlot2": "Charge Time Slot 2",
  "jl_param_ctrl_name_DischargeTimeSlot2": "Discharge Time Slot 2",
  "jl_param_ctrl_name_ChargeTimeSlot3": "Charge Time Slot 3",
  "jl_param_ctrl_name_DischargeTimeSlot3": "Discharge Time Slot 3",
  "jl_param_ctrl_name_ChargeTimeSlot4": "Charge Time Slot 4",
  "jl_param_ctrl_name_DischargeTimeSlot4": "Discharge Time Slot 4",
  "jl_param_ctrl_name_ChargeTimeSlot5": "Charge Time Slot 5",
  "jl_param_ctrl_name_DischargeTimeSlot5": "Discharge Time Slot 5",
  "jl_param_ctrl_name_ChargeTimeSlot6": "Charge Time Slot 6",
  "jl_param_ctrl_name_DischargeTimeSlot6": "Discharge Time Slot 6",
  "jl_param_ctrl_name_TimeSetting": "Time Setting",
  "jl_param_ctrl_name_FeedinPowerLimitSwitch": "Feed in Power Limit Switch",
  "jl_param_ctrl_name_FeedinPowerLimitValue": "Feed in Power Limit Value",
  "jl_param_ctrl_name_UnblanceOutput": "Unblance Output",
  "jl_param_ctrl_name_FeedinCurrentLimitSwtich": "Feed in Current Limit Swtich",
  "jl_param_ctrl_name_FeedinCurrentLimitValue": "Feed in Current Limit Value",
  "jl_param_ctrl_name_FailSafeSwitch": "FailSafe Switch",
  "jl_param_ctrl_name_BatteryType": "Battery Type",
  "jl_param_ctrl_name_BatteryModel": "Battery Model",
  "jl_param_ctrl_name_MaxChargingCurrent": "Max Charging Current",
  "jl_param_ctrl_name_MaxDischargingCurrent": "Max Discharging Current",
  "jl_param_ctrl_name_OverdischargeSOC": "Overdischarge SOC",
  "jl_param_ctrl_name_OverdischargeHysteresisSOC": "Overdischarge Hysteresis SOC",
  "jl_param_ctrl_name_ForcechargeSOC": "Forcecharge SOC",
  "jl_param_ctrl_name_BatteryHealingSwitch": "Battery Healing Switch",
  "jl_param_ctrl_name_BatteryHealingSOC": "Battery Healing SOC",
  "jl_param_ctrl_name_BatteryCapacity": "Battery Capacity",
  "jl_param_ctrl_name_Peak-shavingSetting": "Peak-shaving Setting",
  "jl_param_ctrl_name_Max.gridpowerwhenForcecharging": "Max. grid Power when Force charging",
  "jl_param_ctrl_name_ECOFunction": "ECO Function",
  "jl_param_ctrl_name_BatteryWakeupSwitch": "Battery Wakeup Switch",
  "jl_param_ctrl_name_BatteryWakeupVoltageSetting": "Battery WakeupVoltage Setting",
  "jl_param_ctrl_name_BatteryWakeupTimeSetting": "Battery WakeupTime Setting",
  "jl_param_ctrl_name_AutoBatAwaken": "Auto Bat Awaken",
  "jl_param_ctrl_name_AutoBatWakeupVoltageSetting": "Auto Bat WakeupVoltage Setting",
  "jl_param_ctrl_name_AutoBatAwakenTimeSetting": "Auto Bat Awaken Time Setting",
  "jl_param_ctrl_name_GridStandardPrecision": "Grid Standard Precision",
  "jl_param_ctrl_name_GridCode": "Grid Code",
  "jl_param_ctrl_name_OV-G-V01": "OV-G-V 01",
  "jl_param_ctrl_name_OV-G-V-T01": "OV-G-V-T 01",
  "jl_param_ctrl_name_OV-G-V02": "OV-G-V 02",
  "jl_param_ctrl_name_OV-G-V-T02": "OV-G-V-T 02",
  "jl_param_ctrl_name_UN-G-V01": "UN-G-V 01",
  "jl_param_ctrl_name_UN-G-V-T01": "UN-G-V-T 01",
  "jl_param_ctrl_name_UN-G-V02": "UN-G-V 02",
  "jl_param_ctrl_name_UN-G-V-T02": "UN-G-V-T 02",
  "jl_param_ctrl_name_OV-G-F01": "OV-G-F 01",
  "jl_param_ctrl_name_OV-G-F-T01": "OV-G-F-T 01",
  "jl_param_ctrl_name_OV-G-F02": "OV-G-F 02",
  "jl_param_ctrl_name_OV-G-F-T02": "OV-G-F-T 02",
  "jl_param_ctrl_name_UN-G-F01": "UN-G-F 01",
  "jl_param_ctrl_name_UN-G-F-T01": "UN-G-F-T 01",
  "jl_param_ctrl_name_UN-G-F02": "UN-G-F 02",
  "jl_param_ctrl_name_UN-G-F-T02": "UN-G-F-T 02",
  "jl_param_ctrl_name_59.S1": "59.S1",
  "jl_param_ctrl_name_59.S2": "59.S2",
  "jl_param_ctrl_name_59.S2Time": "59.S2 Time",
  "jl_param_ctrl_name_27.S1": "27.S1",
  "jl_param_ctrl_name_27.S1Time": "27.S1 Time",
  "jl_param_ctrl_name_27.S2": "27.S2",
  "jl_param_ctrl_name_27.S2Time": "27.S2 Time",
  "jl_param_ctrl_name_81>S1": "81>S1",
  "jl_param_ctrl_name_81>S1-Time": "81>S1-Time",
  "jl_param_ctrl_name_81<S1": "81<S1",
  "jl_param_ctrl_name_81<S1-Time": "81<S1-Time",
  "jl_param_ctrl_name_81>S2F": "81>S2F",
  "jl_param_ctrl_name_81>S2F-Time": "81>S2F-Time",
  "jl_param_ctrl_name_81<S2F": "81<S2F",
  "jl_param_ctrl_name_81<S2F-Time": "81<S2F-Time",
  "jl_param_ctrl_name_81>S2S": "81>S2S",
  "jl_param_ctrl_name_81>S2S-Time": "81>S2S-Time",
  "jl_param_ctrl_name_81<S2S": "81<S2S",
  "jl_param_ctrl_name_81<S2S-Time": "81<S2S-Time",
  "jl_param_ctrl_name_Startup-VH": "Startup-VH",
  "jl_param_ctrl_name_Startup-VL": "Startup-VL",
  "jl_param_ctrl_name_Recover-VH": "Recover-VH",
  "jl_param_ctrl_name_Recover-VL": "Recover-VL",
  "jl_param_ctrl_name_Startup-FH": "Startup-FH",
  "jl_param_ctrl_name_Startup-FL": "Startup-FL",
  "jl_param_ctrl_name_Recover-FH": "Recover-FH",
  "jl_param_ctrl_name_Recover-FL": "Recover-FL",
  "jl_param_ctrl_name_Startup-T": "Startup-T",
  "jl_param_ctrl_name_Restore-T": "Restore-T",
  "jl_param_ctrl_name_GridCodeWorkMode": "Grid Code Work Mode",
  "jl_param_ctrl_name_GradientLimitforPowerChange": "Gradient Limit for Power Change",
  "jl_param_ctrl_name_Ramp-up-US": "Ramp-up-US",
  "jl_param_ctrl_name_Reconnect-US": "Reconnect-US",
  "jl_param_ctrl_name_EN50549GradientLimitforPower-onChange": "EN50549 Gradient Limit for Power-on Change",
  "jl_param_ctrl_name_EN50549PowerChangeGradientafterFaultTripRestart": "EN50549 Power Change Gradient after Fault Trip Restart",
  "jl_param_ctrl_name_FrequencyDeratingMode": "Frequency Derating Mode",
  "jl_param_ctrl_name_01-FrequencyDeratingFstop": "01-Frequency Derating Fstop",
  "jl_param_ctrl_name_0C-FrequencyDeratingFstart": "0C-Frequency Derating Fstart",
  "jl_param_ctrl_name_0A-FrequencyDeratingFstart": "0A-Frequency Derating Fstart",
  "jl_param_ctrl_name_03&11H&12H-FrequencyDeratingFstart": "03&11H&12H-Frequency Derating Fstart",
  "jl_param_ctrl_name_13H-FrequencyDeratingFstart": "13H-Frequency Derating Fstart",
  "jl_param_ctrl_name_04-FrequencyDeratingFstart": "04-Frequency Derating Fstart",
  "jl_param_ctrl_name_08-FrequencyDeratingFstart": "08-Frequency Derating Fstart",
  "jl_param_ctrl_name_0D-FrequencyDeratingSlope(Fdroop)": "0D-Frequency Derating Slope(Fdroop)",
  "jl_param_ctrl_name_0E-FrequencyDeratingF1": "0E-Frequency Derating F1",
  "jl_param_ctrl_name_01-Under-FreqDerateFstart": "01-Under-Freq Derate Fstart",
  "jl_param_ctrl_name_0C&0A-FrequencyDeratingSlope(Fdroop)": "0C&0A-Frequency Derating Slope(Fdroop)",
  "jl_param_ctrl_name_03&11H&12H-FrequencyDeratingSlope(Fdroop)": "03&11H&12H-Frequency Derating Slope(Fdroop)",
  "jl_param_ctrl_name_13H-FrequencyDeratingSlope(Fdroop)": "13H-Frequency Derating Slope(Fdroop)",
  "jl_param_ctrl_name_04-FrequencyDeratingFstop": "04-Frequency Derating Fstop",
  "jl_param_ctrl_name_08-FrequencyDeratingSlope(Wgra)": "08-Frequency Derating Slope(Wgra)",
  "jl_param_ctrl_name_0E-FrequencyDeratingHysteresis": "0E-Frequency Derating Hysteresis",
  "jl_param_ctrl_name_01-FrequencyDeratingFstart": "01-Frequency Derating Fstart",
  "jl_param_ctrl_name_08-FrequencyDeratingFstop": "08-Frequency Derating Fstop",
  "jl_param_ctrl_name_0E-FrequencyDeratingFstop": "0E-Frequency Derating Fstop",
  "jl_param_ctrl_name_13H-FrequencyDeratingResponseTime": "13H-Frequency Derating Response Time",
  "jl_param_ctrl_name_01-FrequencyDeratingFtransition": "01-Frequency Derating Ftransition",
  "jl_param_ctrl_name_08-FrequencyDeratingHysteresisEnableSwitch(HystEna)": "08-Frequency Derating Hysteresis Enable Switch (HystEna)",
  "jl_param_ctrl_name_0E-FrequencyDeratinghysteresisresponsetime(Tstop)": "0E-Frequency Derating hysteresis response time (Tstop)",
  "jl_param_ctrl_name_0E-FrequencyDeratingSlope(Fdroop)": "0E-Frequency Derating Slope(Fdroop)",
  "jl_param_ctrl_name_0E-FrequencyDeratingResponseDelay(Tintendelay)": "0E-Frequency Derating Response Delay (Tintendelay)",
  "jl_param_ctrl_name_01-UnderfrequencyRampingFdstart": "01-Underfrequency Ramping Fdstart",
  "jl_param_ctrl_name_03&0E-UnderfrequencyRampingFdstart": "03&0E-Underfrequency Ramping Fdstart",
  "jl_param_ctrl_name_13H-UnderfrequencyRampingFdstart": "13H-Underfrequency Ramping Fdstart",
  "jl_param_ctrl_name_01-UnderfrequencyRampingFpmax": "01-Underfrequency Ramping Fpmax",
  "jl_param_ctrl_name_03&0E-UnderfrequencyRampingFD_Droop": "03&0E-Underfrequency Ramping FD_Droop",
  "jl_param_ctrl_name_13H-UnderfrequencyRampingFD_Droop": "13H-Underfrequency Ramping FD_Droop",
  "jl_param_ctrl_name_01-Powerderatechangeslopelimit（Wgra-）": "01-Power derate change slope limit（Wgra-）",
  "jl_param_ctrl_name_BatteryPsmaxPercentageSetting(onlyforCEI0-21)": "Battery Psmax percentage setting (only for CEI 0-21)",
  "jl_param_ctrl_name_BatteryPcmaxPercentageSetting(onlyforCEI0-21)": "Battery Pcmax percentage setting (only for CEI 0-21)",
  "jl_param_ctrl_name_10minOvervoltageSetting": "10min OverVoltage Setting",
  "jl_param_ctrl_name_3Tau(Q)Setting": "3Tau(Q)Setting",
  "jl_param_ctrl_name_3Tau(P)Setting": "3Tau(P)Setting",
  "jl_param_ctrl_name_OverVoltAutoPLmt": "OverVolt Auto PLmt",
  "jl_param_ctrl_name_WorkModeDefault": "Work Mode Default",
  "jl_param_ctrl_name_PowerLimitDefault": "Power Limit Default",
  "jl_param_ctrl_name_FrequencyDeratingDefault": "Frequency Derating Default",
  "jl_param_ctrl_name_10minOvervoltageDefault": "10min OverVoltage Default",
  "jl_param_ctrl_name_DRMSwitch": "DRM Switch",
  "jl_param_ctrl_name_BackupPortEnablingSetting": "Backup Port Enabling Setting",
  "jl_param_ctrl_name_BackupPortReferenceVoltageSetting": "Backup Port Reference Voltage Setting",
  "jl_param_ctrl_name_VoltageDroopSetting": "Voltage Droop Setting",
  "jl_param_ctrl_name_Min.DroopVoltage": "Min.Droop Voltage",
  "jl_param_ctrl_name_ACCouplingSwitch": "AC Coupling Switch",
  "jl_param_ctrl_name_Position": "Position",
  "jl_param_ctrl_name_ACCoupling_OFF_SOC": "AC Coupling_OFF_SOC",
  "jl_param_ctrl_name_ACCoulplingMax.fre": "AC Coulpling Max.fre",
  "jl_param_ctrl_name_DryContact": "Dry Contact",
  "jl_param_ctrl_name_GridPortPoweredBy": "Grid Port Powered By",
  "jl_param_ctrl_name_GeneratorCharge": "Generator Charge",
  "jl_param_ctrl_name_GenChargePower": "Gen Charge Power",
  "jl_param_ctrl_name_StartChargingSOC": "Start Charging SOC",
  "jl_param_ctrl_name_StopChargingSOC": "Stop Charging SOC",
  "jl_param_ctrl_name_Meter.CTSetting": "Meter/CT Setting",
  "jl_param_ctrl_name_MeterTypeandInstallationLocation": "Meter Type",
  "jl_param_ctrl_name_CTDirection": "CT Direction",
  "jl_param_ctrl_name_InverterMaxOutputPowerSetting": "Inverter Max Output Power Setting",
  "jl_param_ctrl_name_LimitedReactivePowerValue": "Limited ReActive Power Value",
  "jl_param_ctrl_name_InverterMaxOutputPowerSettingPowerDownStorage": "Inverter Max Output Power Setting Power Down Storage",
  "jl_param_ctrl_name_PowerFactorSettingValue": "Power Factor Setting Value",
  "jl_param_ctrl_name_PowerFactorSettingPowerDownStorage": "Power Factor Setting Power Down Storage",
  "jl_param_ctrl_name_MPPTMulti-peakScanningSwitch": "MPPT Multi-peak Scanning Switch",
  "jl_param_ctrl_name_MPPTMulti-peakScanInterval": "MPPT Multi-peak Scan Interval",
  "jl_param_ctrl_name_DailyPV-ISODetection": "Daily PV-ISO Detection",
  "jl_param_ctrl_name_FactoryReset": "Factory Reset",
  "jl_param_ctrl_name_OnlyPVPowerLoad": "Only PV Power Load",
  "jl_param_ctrl_name_PVOnlyOverloadReset": "PV Only OverLoad Reset",
  "jl_param_ctrl_name_IgFollow": "IgFollow",
  "jl_param_ctrl_name_AFCIProtect": "AFCI Protect",
  "jl_param_ctrl_name_AFCIlevel": "AFCI level",
  "jl_param_ctrl_name_G100Switch": "G100 Switch",
  "jl_param_ctrl_name_G100BackflowCurrent": "G100 Backflow Current",
  "jl_param_ctrl_name_G100ManualFaultClearing": "G100 Manual Fault Clearing",
  "jl_param_ctrl_name_EPSSwitchingTime": "EPS Switching Time",
  "jl_param_ctrl_name_EPSDOD": "EPS DOD",
  "jl_param_ctrl_name_PassiveModeSwitc": "Passive Mode Switch",
  "jl_param_ctrl_name_FCASDroopSwitch": "FCAS Droop Switch",
  "jl_param_ctrl_name_LSB": "LSB",
  "jl_param_ctrl_name_HSB": "HSB",
  "jl_param_ctrl_name_LDB": "LDB",
  "jl_param_ctrl_name_HDB": "HDB",
  "jl_param_ctrl_name_Pcharge": "Pcharge",
  "jl_param_ctrl_name_Pdischarge": "Pdischarge",
  "jl_param_ctrl_name_ParallelMode": "Parallel Mode",
  "jl_param_ctrl_name_PhysicalAddressID": "Physical Address ID",
  "jl_param_ctrl_name_ManualSetMaster.Slave": "Manual Set Master/Slave",
  "jl_param_ctrl_name_TotalNumberOfHybridInvertersConnected": "Total number of hybrid inverters connected",
  "jl_param_ctrl_name_ParallelSync": "Parallel Sync",
  "jl_param_ctrl_group_WorkMode-Self-UseMode": "Work Mode-Self-Use Mode",
  "jl_param_ctrl_group_WorkMode-FeedinPriorityMode": "Work Mode-Feed in Priority Mode",
  "jl_param_ctrl_group_WorkMode-Peak-shavingMode": "Work Mode-Peak-shaving Mode",
  "jl_param_ctrl_group_WorkMode-Off-GridMode": "Work Mode-Off-Grid Mode",
  "jl_param_ctrl_group_TimeOfUse": "Time of Use",
  "jl_param_ctrl_group_TimeSetting": "Time Setting",
  "jl_param_ctrl_group_GridFeedinPowerLimit": "Grid Feed in Power Limit",
  "jl_param_ctrl_group_BatterySetting": "Battery Setting",
  "jl_param_ctrl_group_GridCodeSetting-GridCodeParameters": "Grid Code Setting-Grid Code Parameters",
  "jl_param_ctrl_group_GridCodeSetting-CERTModeSetting": "Grid Code Setting-CERT Mode Setting",
  "jl_param_ctrl_group_GridCodeSetting-PowerLimit": "Grid Code Setting-Power Limit",
  "jl_param_ctrl_group_GridCodeSetting-FrequencyDeratingSetting": "Grid Code Setting-Frequency Derating Setting",
  "jl_param_ctrl_group_GridCodeSetting-SpecialSetting": "Grid Code Setting-Special Setting",
  "jl_param_ctrl_group_GridCodeSetting-\nInitialSetting": "Grid Code Setting-Special Setting",
  "jl_param_ctrl_group_GridCodeSetting-GridCodeSetting-SpecialSetting": "Grid Code Setting-Grid Code Setting-Special Setting",
  "jl_param_ctrl_group_BackupSetting": "Backup Setting",
  "jl_param_ctrl_group_SmartPort-ACCouplingSetting": "Smart Port-AC Coupling Setting",
  "jl_param_ctrl_group_SmartPort-GENSetting": "Smart Port-GEN Setting",
  "jl_param_ctrl_group_AdvancedSetting-Meter.CTSetting": "Advanced Setting-Meter/CT Setting",
  "jl_param_ctrl_group_AdvancedSetting-InverterOutputPowerSetting": "Advanced Setting-Inverter Output Power Setting",
  "jl_param_ctrl_group_AdvancedSetting-PowerFactorSetting": "Advanced Setting-Power Factor Setting",
  "jl_param_ctrl_group_AdvancedSetting-MPPTMulti-peakScanningSet": "Advanced Setting-MPPT Multi-peak Scanning Set",
  "jl_param_ctrl_group_AdvancedSetting-DailyPV-ISODetection": "Advanced Setting-Daily PV-ISO Detection",
  "jl_param_ctrl_group_AdvancedSetting-OtherSetting": "Advanced Setting-Other Setting",
  "jl_param_ctrl_group_AdvancedSetting-SpecialFunctionSetting": "Advanced Setting-Special Function Setting",
  "jl_param_ctrl_group_AdvancedSetting-EPSMode(OnlyForItaly)": "Advanced Setting-EPS Mode （Only for Italy）",
  "jl_param_ctrl_group_AdvancedSetting-PassiveMode": "Advanced Setting-Passive Mode",
  "jl_param_ctrl_group_ParallelSetting": "Parallel Setting",
  "jl_param_ctrl_note_OnOff": "Enable or disable the inverter operation.",
  "jl_param_ctrl_note_Self-UseModeSwitch": "The switch is to enable/disable the self-use mode.\r\nSelf-Use, Feed in priority mode ,Peak-shaving and Off-grid mode cannot be turned off at the same time. After turning on other modes, Self-Use will be turned off automatically.",
  "jl_param_ctrl_note_AllowGridCharging": "To Set if the system is allowed to use grid Power to charge the battery.",
  "jl_param_ctrl_note_BatteryReserveSwitch": "To Set if the system needs to reserve a certain SOC of battery during normal operation and only to be used when grid is lost to support the Load for a longer time.",
  "jl_param_ctrl_note_ReservedSOC": "Reserved SOC. Only effective when Battery Reserve Switch is enabled.",
  "jl_param_ctrl_note_GridChargingPowerLimit": "The max Power limit from grid can be used to reserve the battery SOC level. Only effective when Battery Reserve Switch is enabled.",
  "jl_param_ctrl_note_FeedinPriorityModeSwitch": "The switch is to enable/disable the Feed in Priority mode.",
  "jl_param_ctrl_note_Peak-shavingSwitch": "The switch is to enable/disable the Peakshaving mode.\r\nThis mode only support the use with lithium batteries with communication.",
  "jl_param_ctrl_note_Max.usableGridPower": "To set the allowed peak imPort Power limit at the grid connection point for the peaksahving mode.",
  "jl_param_ctrl_note_BaselineSOC": "To set battery SOC level that needs to be maintained when the max usable grid Power limit is not reached.",
  "jl_param_ctrl_note_Off-gridModeSwitch": "The switch is to enable/disable the off grid mode.\r\nIf the battery SOC is less than 30%, do not enable the Off-grid Mode.",
  "jl_param_ctrl_note_Off-GridOverdischargeSOC": "To set the overdischarge SOC of the battery under off grid condition.",
  "jl_param_ctrl_note_TimeofUseSwitch": "The switch is to enable/disable the Time of use setting to allow user to set a customized charging/discharging pattern.",
  "jl_param_ctrl_note_ChargeTimeSlot1": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_DischargeTimeSlot1": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_ChargeTimeSlot2": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_DischargeTimeSlot2": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_ChargeTimeSlot3": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_DischargeTimeSlot3": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_ChargeTimeSlot4": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_DischargeTimeSlot4": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_ChargeTimeSlot5": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_DischargeTimeSlot5": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_ChargeTimeSlot6": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_DischargeTimeSlot6": "There should be no overlap with other strong charging and discharging time periods",
  "jl_param_ctrl_note_FeedinPowerLimitSwitch": "The switch is to enable/disable the system feed in Power control function.",
  "jl_param_ctrl_note_FeedinPowerLimitValue": "To set the max allowed feed in Power limit at the grid connection point.\r\nThe value must be a multiple of 100",
  "jl_param_ctrl_note_UnblanceOutput": "The switch is to enable/disable the unbalanced output capability for split phase/three phase inverter.\r\nThis mode cannot be enabled if the N-line is not connected.",
  "jl_param_ctrl_note_FeedinCurrentLimitSwtich": "The switch is to enable/disable the system feed in Current control function.",
  "jl_param_ctrl_note_FeedinCurrentLimitValue": "To set the max allowed feed in Current limit at the grid connection point.",
  "jl_param_ctrl_note_FailSafeSwitch": "To enable/disable the failsafe function. If the meter communication is lost, inverter will report failsafe and stop generation.",
  "jl_param_ctrl_note_BatteryModel": "To set the battery model that is Currently connected to the inverter.",
  "jl_param_ctrl_note_MaxChargingCurrent": "Set the maximum allowable charging Current.",
  "jl_param_ctrl_note_MaxDischargingCurrent": "Set the maximum allowable discharge Current.",
  "jl_param_ctrl_note_OverdischargeSOC": "When battery reached overdischarge SOC, inverter will stop discharging the battery.",
  "jl_param_ctrl_note_ForcechargeSOC": "Due to selfdischarging, battery SOC may drop to lower than overdischarge SOC. When reached forcecharge SOC, inverter will charge the battery automatically to avoid battery entering sleep mode.",
  "jl_param_ctrl_note_BatteryHealingSwitch": "To enable/disable the battery healing function. During low PV period, battery SOC may be kept low SOC for a long time. Battery healing function will charge the battery until the target SOC.",
  "jl_param_ctrl_note_BatteryHealingSOC": "Target SOC for battery healing function.",
  "jl_param_ctrl_note_Peak-shavingSetting": "The switch is to enable/disable the dynamic peak shaving function during forcecharging stage.When this is enabled, inverter will dynamically forcecharge the battery while maintain the \"Max grid Power when force charging\" is not breached at the grid connection point.",
  "jl_param_ctrl_note_Max.gridpowerwhenForcecharging": "Max grid Power allowed for battery forcecharging.",
  "jl_param_ctrl_note_ECOFunction": "To enable/disable the ECO function. When at night and battery SOC recahed overdischarge SOC, inverter will shutdown the battery circuit to avoid battery Power consumption.",
  "jl_param_ctrl_note_BatteryWakeupSwitch": "Manual Wakeup funcion. Inverter will charge the battery port at the wakeup Voltage level and maintain for a certain time period in order to wakeup battery in sleep mode.",
  "jl_param_ctrl_note_BatteryWakeupVoltageSetting": "Wake up Voltage setting.",
  "jl_param_ctrl_note_BatteryWakeupTimeSetting": "Wake up time setting.",
  "jl_param_ctrl_note_AutoBatAwaken": "Automatic battery wake up function. Inverter will initiate the battery wake up function when it is Powered up.",
  "jl_param_ctrl_note_AutoBatAwakenTimeSetting": "Wake up time setting.",
  "jl_param_ctrl_note_GridCode": "Grid Code Setting. Please choose the corresponding grid code which meet the local requirements.",
  "jl_param_ctrl_note_GradientLimitforPowerChange": "The ramp rate limit when changing the max output Power.",
  "jl_param_ctrl_note_EN50549GradientLimitforPower-onChange": "Initial Ramp up Power slope limit for EN50549 grid codes.",
  "jl_param_ctrl_note_EN50549PowerChangeGradientafterFaultTripRestart": "Reconnection Power slope limit for EN50549 grid codes.",
  "jl_param_ctrl_note_10minOvervoltageSetting": "Grid Code related special settings. Please do not modify the settings unless the local network operator allows.",
  "jl_param_ctrl_note_WorkModeDefault": "Reset the grid code related working mode.",
  "jl_param_ctrl_note_PowerLimitDefault": "\r\nReset the grid code related Power limit.",
  "jl_param_ctrl_note_FrequencyDeratingDefault": "\r\nReset the grid code related frequency response.",
  "jl_param_ctrl_note_10minOvervoltageDefault": "Reset the grid code related 10min overVoltage protection.",
  "jl_param_ctrl_note_DRMSwitch": "DRM Closed - To disable DRM function - DRM Open - To Enable DRM function. Inverter will cease to generate until pins 4/5 are shorted.",
  "jl_param_ctrl_note_BackupPortReferenceVoltageSetting": "Reference Voltage setting for backup port when inverter running in off grid condition.",
  "jl_param_ctrl_note_VoltageDroopSetting": "Voltage droop function when overLoad on backup port.",
  "jl_param_ctrl_note_Min.DroopVoltage": "Min allowed Voltage for Voltage droop function.",
  "jl_param_ctrl_note_ACCouplingSwitch": "To enable/disable the AC coupling function to use frequency adjustment to control the PV inverter generation.",
  "jl_param_ctrl_note_Position": "To set the position where the PV inverter is connected.",
  "jl_param_ctrl_note_ACCoupling_OFF_SOC": "\r\nOnly supports lithium battery.",
  "jl_param_ctrl_note_ACCoulplingMax.fre": "The max frequency allowed in the system for controlling PV inverter generation.",
  "jl_param_ctrl_note_StartChargingSOC": "To set the battery SOC at which the generator will step in.",
  "jl_param_ctrl_note_StopChargingSOC": "To set the battery SOC at which the generator will stop operation.",
  "jl_param_ctrl_note_MeterTypeandInstallationLocation": "Meter Type:To set which smart meter is used in this system Meter Installation Location:To set where the smart meter is installed.",
  "jl_param_ctrl_note_CTDirection": "To change the CT effective direction.",
  "jl_param_ctrl_note_InverterMaxOutputPowerSetting": "To set the max output Power limit of the inverter.",
  "jl_param_ctrl_note_LimitedReactivePowerValue": "To set the reActive Power limit of the inverter.",
  "jl_param_ctrl_note_PowerFactorSettingValue": "To set the Power factor of the inverter.",
  "jl_param_ctrl_note_MPPTMulti-peakScanningSwitch": "Used in shadow condition. To enable the global max Power point scanning. Due to the IV scanning operation, generataion may be affected.",
  "jl_param_ctrl_note_MPPTMulti-peakScanInterval": "To set the time interval between IV scanning. Due to the IV scanning operation, generataion may be affected.",
  "jl_param_ctrl_note_DailyPV-ISODetection": "To enable PV ISO detection every day in the morning for hybrid inverters.",
  "jl_param_ctrl_note_AFCIProtect": "Enable/disable AFCI protection.",
  "jl_param_ctrl_note_AFCIlevel": "AFCI protection level, do not adjust it without the guidance of professional engineers.",
  "jl_param_ctrl_note_EPSSwitchingTime": "0 indicates that EPS parameters are invalid and EPS mode is turned off.",
  "jl_param_ctrl_note_ParallelMode": "To set if the inverter is running in single unit condition or parallel condition.",
  "jl_param_ctrl_note_PhysicalAddressID": "To set the physical address ID for parallel operation.",
  "jl_param_ctrl_note_ManualSetMaster.Slave": "To set if the inverter is a master unit or slave unit in parallel operation.",
  "jl_param_ctrl_option_OFF": "OFF",
  "jl_param_ctrl_option_ON": "ON",
  "jl_param_ctrl_option_NotAllowed": "Not Allowed",
  "jl_param_ctrl_option_Allow": "Allow",
  "jl_param_ctrl_option_Lithiumbattery": "Lithium Battery",
  "jl_param_ctrl_option_Lead-aci_Battery": "Lead-acid Battery",
  "jl_param_ctrl_option_48VLithiumBattery_WithoutCOMM": "48VLithium Battery (Without COMM)",
  "jl_param_ctrl_option_51.2VLithium_Battery_Without_COMM": "51.2V Lithium Battery (Without_COMM)",
  "jl_param_ctrl_option_No_Battery": "No Battery",
  "jl_param_ctrl_option_HaierHV": "Haier HV",
  "jl_param_ctrl_option_NoBattery": "No Battery",
  "jl_param_ctrl_option_UserDefine": "User define",
  "jl_param_ctrl_option_PYLON_HV": "PYLON_HV",
  "jl_param_ctrl_option_B_BOX_HV_BYD": "B_BOX_HV BYD",
  "jl_param_ctrl_option_LG_10H": "LG 10H",
  "jl_param_ctrl_option_SOLUNA_HV": "SOLUNA_HV",
  "jl_param_ctrl_option_DynessHV": "Dyness HV",
  "jl_param_ctrl_option_AoboetHV": "Aoboet HV",
  "jl_param_ctrl_option_WECO_HV_": "WECO HV",
  "jl_param_ctrl_option_AlphaHV": "Alpha HV",
  "jl_param_ctrl_option_GS_Energy": "GS Energy",
  "jl_param_ctrl_option_BYD_HVL": "BYD HVL",
  "jl_param_ctrl_option_Jinko": "Jinko",
  "jl_param_ctrl_option_FOX": "FOX",
  "jl_param_ctrl_option_LG_16H": "LG_16H",
  "jl_param_ctrl_option_PureDrive": "PureDrive",
  "jl_param_ctrl_option_UZ_ENERGY": "UZ ENERGY",
  "jl_param_ctrl_option_J-PACK-HV": "J-PACK-HV",
  "jl_param_ctrl_option_SUNWODA_HV": "SUNWODA HV",
  "jl_param_ctrl_option_WTS_Energy_CORE_Power_CORE": "WTS Energy CORE/Power CORE",
  "jl_param_ctrl_option_AMPACE_HV": "AMPACE_HV",
  "jl_param_ctrl_option_DuraHV": "DuraHV",
  "jl_param_ctrl_option_DMEGC": "DMEGC",
  "jl_param_ctrl_option_AlpSolarrHV": "AlpSolarr HV",
  "jl_param_ctrl_option_CNTE_HV": "CNTE_HV",
  "jl_param_ctrl_option_Ucanpower": "UcanPower",
  "jl_param_ctrl_option_ZNTECH": "ZNTECH",
  "jl_param_ctrl_option_Tower_US": "Tower US",
  "jl_param_ctrl_option_PYTESH": "PYTESH",
  "jl_param_ctrl_option_GS-HV": "GS-HV",
  "jl_param_ctrl_option_Lithium_battery": "Lithium battery",
  "jl_param_ctrl_option_JA-H": "JA-H",
  "jl_param_ctrl_option_BMZ_HV": "BMZ_HV",
  "jl_param_ctrl_option_Voltage0.1V_Time0.01s_Frequency0.01Hz": "Voltage0.1V, Time0.01s, Frequency0.01Hz",
  "jl_param_ctrl_option_Voltage1V_Time0.1s_Frequency0.1Hz": "Voltage1V, Time0.1s, Frequency0.1Hz",
  "AS4777_NA": "Australia_AS4777_NA",
  "AS4777_SA": "Australia_AS4777_SA",
  "AS4777-02": "Australia_AS4777-02",
  "AS4777-15": "Australia_AS4777-15",
  "AS4777-NW": "Australia_AS4777-NW",
  "AS4777-WA": "Australia_AS4777-WA",
  "ASNZ4777-A": "Australia_ASNZ4777-A",
  "ASNZ4777-B": "Australia_ASNZ4777-B",
  "ASNZ4777-C": "Australia_ASNZ4777-C",
  "AUS-Q-0.8": "Australia_AUS-Q-0.8",
  "AUS-Q-0.9": "Australia_AUS-Q-0.9",
  "Barbados": "Barbados_Barbados",
  "BDEW": "Germany_BDEW",
  "BRA-N": "Brazil_BRA-N",
  "BRAZIL": "Brazil_BRAZIL",
  "Brazil-H": "Brazil_Brazil-H",
  "C10/11": "Belgium_C10/11",
  "CEI_0-16": "Italy_CEI 0-16",
  "CEI_0-21": "Italy_CEI 0-21",
  "Chile": "Chile_Chile",
  "CQC3310": "China_CQC3310",
  "CQC-B": "China_CQC-B",
  "CQC-DZ": "China_CQC-DZ",
  "Czech_2023_A1/A": "Czech_2023 A1/A",
  "DK": "Denmark_DK",
  "DK1": "Denmark_DK1",
  "DK2": "Denmark_DK2",
  "Dubai-A": "Dubai_Dubai-A",
  "Dubai-B": "Dubai_Dubai-B",
  "Egypt": "Egypt_Egypt",
  "EIFS-SW": "Sweden_EIFS-SW",
  "EN50438_L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "EN50438IE": "Ireland_EN50438IE",
  "EN50549": "EU--EN50549",
  "EN50549-2": "Other_EN50549-2",
  "EN50549ES": "Estonia_EN50549ES",
  "EN50549FI": "Finland_EN50549FI",
  "EN50549IE": "Ireland_EN50549IE",
  "EN50549NL": "Netherlands_EN50549NL",
  "EN50549PO": "Global_EN50549PO",
  "EN50549TR": "Turkey_EN50549TR",
  "ESB-Micro": "Ireland_ESB-Micro",
  "ESB-Mini": "Ireland_ESB-Mini",
  "ESB-MV": "Ireland_ESB-MV",
  "ESB-SC": "Ireland_ESB-SC",
  "ES-L-N": "Spain_ES-L-N",
  "France": "France_France",
  "G59/3": "UK_G59/3",
  "G59/3-A": "UK_G59/3-A",
  "G83/1": "UK_G83/1",
  "G98": "UK--G98",
  "G98-NI": "UK_G98-NI",
  "G99": "UK--G99",
  "G99-B": "UK_G99-B",
  "G99N": "UK_G99N",
  "G99-NI": "UK_G99-NI",
  "GN-DZL": "China_GN-DZL",
  "GNHN-A": "China_GNHN-A",
  "GNHN-B": "China_GNHN-B",
  "GN-L": "China_GN-L",
  "GNL-A": "China_GNL-A",
  "GNSD-A": "China_GNSD-A",
  "GNSD-B": "China_GNSD-B",
  "GREECE": "Greece_GREECE",
  "HK": "China_HK",
  "Hungary": "Hungary",
  "IEC61727": "IEC61727",
  "IEC61727L": "Pakistan,India_IEC61727L",
  "IEEE1547-13": "USA_IEEE1547-13",
  "Indon": "Indonesia_Indon",
  "Iran": "Iran_Iran",
  "Israel": "Israel_Israel",
  "KS1": "Korea_KS1",
  "KS2": "Korea_KS2",
  "KS3": "Korea_KS3",
  "KS3-LVRT": "Korea_KS3-LVRT",
  "KSC8565-D": "Korea_KSC8565-D",
  "KSC8565-T": "Korea_KSC8565-T",
  "LTU-1": "Lithuania_LTU-1",
  "LTU-2": "Lithuania_LTU-2",
  "Mala-LV": "Malaysia_Mala-LV",
  "MEA": "Thailand--MEA",
  "MEX-CFE": "Aruba,El Salvador,Nicaragua,Honduras,Guatemala,Panama,Dominica,Mexico_MEX-CFE",
  "MEX-CFE-SP": "Mexico_MEX-CFE-SP",
  "N4105-BEL": "Belgium_N4105-BEL",
  "NewZeal": "Australia_NewZeal",
  "NRS097": "South Africa_NRS097",
  "NTS631": "Spain_NTS631",
  "PEA": "Thailand--PEA",
  "Philippin": "Philippines_Philippin",
  "PH-L": "Philippines_PH-L",
  "PN-50549": "Poland_PN-50549",
  "RD1699": "Spain--RD1699",
  "RENBLAD": "Norway_RENBLAD",
  "SG": "Singapore_SG",
  "SI-1": "Slovenia_SI-1",
  "SI-2": "Slovenia_SI-2",
  "Sri_Lanka": "Sri Lanka",
  "TOR": "Austria_TOR",
  "TR-2": "Turkey_TR-2",
  "TW": "China_TW",
  "UL-A": "USA_UL-A",
  "User_defined50": "User defined50",
  "User-define": "User defined_User-define",
  "User-define_60": "User-define 60",
  "VDE0126": "Germany_VDE0126",
  "VDE4105": "Germany_VDE4105",
  "VDE4110": "Germany_VDE4110",
  "VIETNAM": "Vietnam_VIETNAM",
  "jl_param_ctrl_option_NoResponseMode": "No response mode",
  "jl_param_ctrl_option_P_Mode-Volt-vatt": "P Mode-Volt-vatt",
  "jl_param_ctrl_option_Q_Mode-Volt-var": "Q Mode-Volt-var",
  "jl_param_ctrl_option_FixPF_": "Fix PF",
  "jl_param_ctrl_option_FixReactive": "Fix Reactive",
  "jl_param_ctrl_option_P-Factor": "P-Factor",
  "jl_param_ctrl_option_Power-Q": "Power-Q",
  "jl_param_ctrl_option_00-NO": "00-NO",
  "jl_param_ctrl_option_01-Australia": "01-Australia",
  "jl_param_ctrl_option_03-VDE&EN50438": "03-VDE&EN50438",
  "jl_param_ctrl_option_04-US_Rule21": "04-US Rule21",
  "jl_param_ctrl_option_05-Brazil": "05-Brazil",
  "jl_param_ctrl_option_06-South_Africa": "06-South Africa",
  "jl_param_ctrl_option_07-US_Rule21Phase1": "07-US Rule21Phase1",
  "jl_param_ctrl_option_08-US_Rule21Phase3": "08-US Rule21Phase3",
  "jl_param_ctrl_option_09-Dubai": "09-Dubai",
  "jl_param_ctrl_option_0A-UK_G98&G99": "0A-UK G98&G99",
  "jl_param_ctrl_option_0B-Germany_BDEW": "0B-Germany BDEW",
  "jl_param_ctrl_option_0C-Denmark": "0C-Denmark",
  "jl_param_ctrl_option_0D-China_2018_New_Standard": "0D-China 2018 New Standard",
  "jl_param_ctrl_option_0E-EN50549": "0E-EN50549",
  "jl_param_ctrl_option_0F-CEI_0-21": "0F-CEI 0-21",
  "jl_param_ctrl_option_10H-South_Africa_levelise": "10H-South Africa levelise",
  "jl_param_ctrl_option_11H-France": "11H-France",
  "jl_param_ctrl_option_12H-Austria": "12H-Austria",
  "jl_param_ctrl_option_13H-Hawaii": "13H-Hawaii",
  "jl_param_ctrl_option_14H-AU_FCAS": "14H-AU FCAS",
  "Reset_the_grid_code_related_working_mod": "Reset the grid code related working mod",
  "Reset_the_grid_code_related_power_limit": "Reset the grid code related Power limit",
  "Reset_the_grid_code_related_frequency_response": "Reset The Grid Code Related Frequency Response",
  "Reset_the_grid_code_related_10min_overvoltage_protection": "Reset the grid code related 10min overVoltage protection",
  "jl_param_ctrl_option_GeneratorPort": "Generator Port",
  "jl_param_ctrl_option_BackupPort": "Backup Port",
  "jl_param_ctrl_option_GeneratorControl": "Generator Control",
  "jl_param_ctrl_option_InverterOnAndOffGridSignal": "Inverter On And Off Grid Signal",
  "jl_param_ctrl_option_Grid": "Grid",
  "jl_param_ctrl_option_Generator": "Generator",
  "jl_param_ctrl_option_Meter": "Meter",
  "jl_param_ctrl_option_CT": "CT",
  "Meter_in_Grid_Acrel_1P_Meter": "Meter in Grid Acrel 1P Meter",
  "Meter_in_Grid_Acrel_3P_Meter": "Meter in Grid Acrel 3P Meter",
  "Meter_in_Grid_Eastron_Standard_1P_Meter": "Meter in Grid Eastron Standard 1P Meter",
  "Meter_in_Grid_Eastron_Standard_3P_Meter": "Meter in Grid Eastron Standard 3P Meter",
  "Meter_in_Load_Acrel_1P_Meter": "Meter in Load Acrel 1P Meter",
  "Meter_in_Load_Acrel_3P_Meter": "Meter in Load Acrel 3P Meter",
  "Meter_in_Load_Eastron_Standard_1P_Meter": "Meter in Load Eastron Standard 1P Meter",
  "Meter_in_Load_Eastron_Standard_3P_Meter": "Meter in Load Eastron Standard 3P Meter",
  "Meter_in_Grid+Grid+PV_Inverter_Acrel_1P_Meter_Only_applicable_for_Eastron_Meter": "Meter in Grid+Grid+PV Inverter Acrel 1P Meter Only applicable for Eastron Meter",
  "Meter_in_Grid+Grid+PV_Inverter_Acrel_3P_Meter_Only_applicable_for_Eastron_Meter": "Meter in Grid+Grid+PV Inverter Acrel 3P Meter Only applicable for Eastron Meter",
  "Meter_in_Grid+Grid+PV_Inverter_Eastron_Standard_1P_Meter_Only_applicable_for_Eastron_Meter": "Meter in Grid+Grid+PV Inverter Eastron Standard 1P Meter Only applicable for Eastron Meter",
  "Meter_in_Grid+Grid+PV_Inverter_Eastron_Standard_3P_Meter_Only_applicable_for_Eastron_Meter": "Meter in Grid+Grid+PV Inverter Eastron Standard 3P Meter Only applicable for Eastron Meter",
  "NO_Meter": "NO Meter",
  "jl_param_ctrl_option_forward": "Forward",
  "jl_param_ctrl_option_backward": "Backward",
  "jl_param_ctrl_option_Disable": "Disable",
  "jl_param_ctrl_option_Enable": "Enable",
  "jl_param_ctrl_option_Factory_Reset": "Factory Reset",
  "Overload_Fault_Clearing": "OverLoad Fault Clearing",
  "jl_param_ctrl_option_0": "0",
  "jl_param_ctrl_option_1": "1",
  "jl_param_ctrl_option_2": "2",
  "jl_param_ctrl_option_3": "3",
  "jl_param_ctrl_option_4": "4",
  "jl_param_ctrl_option_5": "5",
  "jl_param_ctrl_option_6": "6",
  "jl_param_ctrl_option_7": "7",
  "jl_param_ctrl_option_NO": "NO",
  "jl_param_ctrl_option_YES": "YES",
  "jl_param_ctrl_option_Single": "Single",
  "jl_param_ctrl_option_Parallel": "Parallel",
  "jl_param_ctrl_option_Slave": "Slave",
  "jl_param_ctrl_option_Master": "Master",
  "jl_param_ctrl_option_Unlock": "Unlock",
  "jl_param_ctrl_option_Lock": "Lock",
  "form.networkCall11": "Whether to execute distribution network callback",
  "jl_param_ctrl_name_ChargeTimeSlot1Switch": "Charge Time Slot 1 Switch",
  "jl_param_ctrl_name_SOC1": "SOC 1",
  "jl_param_ctrl_name_ChargeCurrent1": "Charge Current 1",
  "jl_param_ctrl_name_ChargeTimeSlot2Switch": "Charge Time Slot 2 Switch",
  "jl_param_ctrl_name_SOC2": "SOC 2",
  "jl_param_ctrl_name_ChargeCurrent2": "Charge Current 2",
  "jl_param_ctrl_name_ChargeTimeSlot3Switch": "Charge Time Slot 3 Switch",
  "jl_param_ctrl_name_SOC3": "SOC 3",
  "jl_param_ctrl_name_ChargeCurrent3": "Charge Current 3",
  "jl_param_ctrl_name_ChargeTimeSlot4Switch": "Charge Time Slot 4 Switch",
  "jl_param_ctrl_name_SOC4": "SOC 4",
  "jl_param_ctrl_name_ChargeCurrent4": "Charge Current 4",
  "jl_param_ctrl_name_ChargeTimeSlot5Switch": "Charge Time Slot 5 Switch",
  "jl_param_ctrl_name_SOC5": "SOC 5",
  "jl_param_ctrl_name_ChargeCurrent5": "Charge Current 5",
  "jl_param_ctrl_name_ChargeTimeSlot6Switch": "Charge Time Slot 6 Switch",
  "jl_param_ctrl_name_SOC6": "SOC 6",
  "jl_param_ctrl_name_ChargeCurrent6": "Charge Current 6",
  "jl_param_ctrl_name_DischargeTimeSlot1Switch": "Discharge Time Slot 1 Switch",
  "jl_param_ctrl_name_DischargeCurrent1": "Discharge Current 1",
  "jl_param_ctrl_name_DischargeTimeSlot2Switch": "Discharge Time Slot 2 Switch",
  "jl_param_ctrl_name_DischargeCurrent2": "Discharge Current 2",
  "jl_param_ctrl_name_DischargeTimeSlot3Switch": "Discharge Time Slot 3 Switch",
  "jl_param_ctrl_name_DischargeCurrent3": "Discharge Current 3",
  "jl_param_ctrl_name_DischargeTimeSlot4Switch": "Discharge Time Slot 4 Switch",
  "jl_param_ctrl_name_DischargeCurrent4": "Discharge Current 4",
  "jl_param_ctrl_name_DischargeTimeSlot5Switch": "Discharge Time Slot 5 Switch",
  "jl_param_ctrl_name_DischargeCurrent5": "Discharge Current 5",
  "jl_param_ctrl_name_DischargeTimeSlot6Switch": "Discharge Time Slot 6 Switch",
  "jl_param_ctrl_name_DischargeCurrent6": "Discharge Current 6",
  "jl_param_ctrl_note_SOC1": "Range: Over discharge SOC~100%",
  "jl_param_ctrl_note_SOC2": "Range: Over discharge SOC~100%",
  "jl_param_ctrl_note_SOC3": "Range: Over discharge SOC~100%",
  "jl_param_ctrl_note_SOC4": "Range: Over discharge SOC~100%",
  "jl_param_ctrl_note_SOC5": "Range: Over discharge SOC~100%",
  "jl_param_ctrl_note_SOC6": "Range: Over discharge SOC~100%",
  "jl_RTparam_name_vatBmsVersion": "BMS Version",
  "jl_RTparam_name_batDcdcVersion": "DCDC Version",
  "device.category.collecting.box": "Combiner Box",
  "device.category.energy.storage": "All-in-one Storage Controller",
  "setting.type22.reactiveControlSet": "ReactiveControl",
  "setting.type22.inputModeSet": "InputMode",
  "ywt.65323.runStatus": "Operating Status",
  "ywt.65323.faultStatus1": "Fault Status 1",
  "ywt.65323.faultStatus2": "Fault Status 2",
  "ywt.65323.warningStatus": "Alarm status",
  "ywt.65323.relayStatus": "Relay status",
  "ywt.65323.inverterTemperature": "Inverter Temperature(℃)",
  "ywt.65323.dcTemperature": "DC Temperature(℃)",
  "ywt.65323.drmStatus": "DRM status",
  "ywt.65323.mpptTemperature": "MPPT Temperature(℃)",
  "ywt.65323.gridVoltageAB": "Grid Voltage AB",
  "ywt.65323.gridVoltageBC": "Grid Voltage BC",
  "ywt.65323.gridVoltageCA": "Grid Voltage CA",
  "ywt.65323.gridCurrentA": "Grid Current A",
  "ywt.65323.gridCurrentB": "Grid Current B",
  "ywt.65323.gridCurrentC": "Grid Current C",
  "ywt.65323.gridFrequencyA": "Grid frequency A",
  "ywt.65323.gridFrequencyB": "Grid frequency B",
  "ywt.65323.gridFrequencyC": "Grid frequency C",
  "ywt.65323.gridActivePower": "Active Power of the Power grid",
  "ywt.65323.gridAPhaseActivePower": "Active Power of phase A in the Power grid",
  "ywt.65323.gridBPhaseActivePower": "Active Power of phase B in the Power grid",
  "ywt.65323.gridCPhaseActivePower": "Active Power of phase C in the Power grid",
  "ywt.65323.gridReactivePower": "ReActive Power of the Power grid",
  "ywt.65323.gridApparentPower": "Apparent Power of the Power grid",
  "ywt.65323.powerFactor": "Power factor",
  "ywt.65323.dcComponentA": "DC component A",
  "ywt.65323.dcComponentB": "DC component B",
  "ywt.65323.dcComponentC": "DC component C",
  "ywt.65323.phaseOrder": "Phase sequence",
  "ywt.65323.leakageCurrent": "Leakage Current",
  "ywt.65323.clsStatus": "CLS status",
  "ywt.65323.clsLockNum": "CLS lock number of times",
  "ywt.65323.clsLockTime": "CLS lock time",
  "ywt.65323.returnFlowPortVoltageA": "Reflux port Voltage A",
  "ywt.65323.returnFlowPortVoltageB": "Reflux port Voltage B",
  "ywt.65323.returnFlowPortVoltageC": "Reflux port Voltage C",
  "ywt.65323.returnFlowPortCurrentA": "Reflux port Current A",
  "ywt.65323.returnFlowPortCurrentB": "Reflux port Current B",
  "ywt.65323.returnFlowPortCurrentC": "Reflux port Current C",
  "ywt.65323.returnFlowPortTotalActivePower": "Total Active Power of reflux Port",
  "ywt.65323.returnFlowPortAPhaseActivePower": "Active Power of phase A at the reflux Port",
  "ywt.65323.returnFlowPortBPhaseActivePower": "Active Power of phase B at the reflux Port",
  "ywt.65323.returnFlowPortCPhaseActivePower": "Active Power of phase C at the reflux Port",
  "ywt.65323.returnFlowPortReactivePower": "ReActive Power of reflux Port",
  "ywt.65323.returnFlowPortApparentPower": "Reflux Port Apparent Power",
  "ywt.65323.returnFlowPortFrequency": "Return port frequency",
  "ywt.65323.returnFlowPortPowerFactor": "Power factor of reflux Port",
  "ywt.65323.todayFeedInGridEnergy": "Daily Power supply to the grid",
  "ywt.65323.todayConsumeEnergy": "Today Consumption",
  "ywt.65323.totalFeedInGridEnergy": "Accumulated Power supply to the grid",
  "ywt.65323.totalConsumeEnergy": "Total Consumption",
  "ywt.65323.ctStatus": "EM status",
  "ywt.65323.ctVoltageA": "EM Voltage A",
  "ywt.65323.ctVoltageB": "EM Voltage B",
  "ywt.65323.ctVoltageC": "EM Voltage C",
  "ywt.65323.ctCurrentA": "EM Current A",
  "ywt.65323.ctCurrentB": "EM Current B",
  "ywt.65323.ctCurrentC": "EM Current C",
  "ywt.65323.ctTotalActivePower": "Total Active Power of the EM",
  "ywt.65323.ctAPhaseActivePower": "Active Power of phase A of the EM",
  "ywt.65323.ctBPhaseActivePower": "Active Power of PhaseB of the EM",
  "ywt.65323.ctCPhaseActivePower": "Active Power of phase C of the EM",
  "ywt.65323.ctReactivePower": "ReActive Power of EM",
  "ywt.65323.ctApparentPower": "Apparent Power of EM",
  "ywt.65323.ctFrequency": "EM frequency",
  "ywt.65323.ctPowerFactor": "Power factor of EM",
  "ywt.65323.loadVoltageA": "Load Voltage A",
  "ywt.65323.loadVoltageB": "Load Voltage B",
  "ywt.65323.loadVoltageC": "Load Voltage C",
  "ywt.65323.loadCurrentA": "Load Current A",
  "ywt.65323.loadCurrentB": "Load Current B",
  "ywt.65323.loadCurrentC": "Load Current C",
  "ywt.65323.loadFrequency": "Load frequency",
  "ywt.65323.loadActivePower": "Load Active Power",
  "ywt.65323.loadAPhaseActivePower": "Active Power of Load A phase",
  "ywt.65323.loadBPhaseActivePower": "Active Power of Load B phase",
  "ywt.65323.loadCPhaseActivePower": "Active Power of Load C phase",
  "ywt.65323.loadReactivePower": "ReActive Power of Load",
  "ywt.65323.loadTodayConsumeEnergy": "Daily Consumption",
  "ywt.65323.loadTotalConsumeEnergy": "Total Consumption",
  "ywt.65323.pv1Voltage": "PV 1 Voltage",
  "ywt.65323.pv2Voltage": "PV 2 Voltage",
  "ywt.65323.pv3Voltage": "PV 3 Voltage",
  "ywt.65323.pv4Voltage": "PV 4 Voltage",
  "ywt.65323.pv5Voltage": "PV 5 Voltage",
  "ywt.65323.pv6Voltage": "PV 6 Voltage",
  "ywt.65323.pv1Current": "PV 1 Current",
  "ywt.65323.pv2Current": "PV 2 Current",
  "ywt.65323.pv3Current": "PV 3 Current",
  "ywt.65323.pv4Current": "PV 4 Current",
  "ywt.65323.pv5Current": "PV 5 Current",
  "ywt.65323.pv6Current": "PV 6 Current",
  "ywt.65323.pv1Power": "PV 1 Power",
  "ywt.65323.pv2Power": "PV 2 Power",
  "ywt.65323.pv3Power": "PV 3 Power",
  "ywt.65323.pv4Power": "PV4 Power",
  "ywt.65323.pv5Power": "PV5 Power",
  "ywt.65323.pv6Power": "PV 6 Power",
  "ywt.65323.pvTotalPower": "Total PV Power",
  "ywt.65323.busVoltage": "Bus Voltage",
  "ywt.65323.pvTodayEnergy": "PV Total Yield",
  "ywt.65323.pvMonthlyEnergy": "Monthly Yield",
  "ywt.65323.pvAnnualEnergy": "Yearly Yield",
  "ywt.65323.pvTotalEnergy": "PV Total Yield",
  "ywt.65323.negativeElectrodeInsulationImpedance": "Negative insulation impedance",
  "ywt.65323.positiveElectrodeInsulationImpedance1": "Positive electrode insulation impedance 1",
  "ywt.65323.positiveElectrodeInsulationImpedance2": "Positive electrode insulation impedance 2",
  "ywt.65323.positiveElectrodeInsulationImpedance3": "Positive electrode insulation impedance 3",
  "ywt.65323.positiveElectrodeInsulationImpedance4": "Positive electrode insulation impedance 4",
  "ywt.65323.positiveElectrodeInsulationImpedance5": "Positive electrode insulation impedance 5",
  "ywt.65323.positiveElectrodeInsulationImpedance6": "Positive electrode insulation impedance 6",
  "ywt.65323.batteryVoltage": "Battery Voltage",
  "ywt.65323.batteryCurrent": "Battery Current",
  "ywt.65323.batteryPower": "Battery Power",
  "ywt.65323.batterySOC": "Battery SOC",
  "ywt.65323.batterySOH": "Battery SOH",
  "ywt.65323.batteryStatus": "Battery status",
  "ywt.65323.batChargeVoltage": "Charging Voltage",
  "ywt.65323.bmsBatteryVoltage": "BMS battery Voltage",
  "ywt.65323.bmsBatteryCurrent": "BMS battery Current",
  "ywt.65323.bmsTemperature": "BMS Temperature(℃)",
  "ywt.65323.bmsChargeCurrentLimit": "BMS charging Current limit",
  "ywt.65323.bmsDischargeCurrentLimit": "BMS discharge Current limiting",
  "ywt.65323.batTodayChargeEnergy": "Today Charged Energy",
  "ywt.65323.batTodayDischargeEnergy": "Total Discharged Energy",
  "ywt.65323.batTotalChargeEnergy": "Battery Total Charge Energy",
  "ywt.65323.batTotalDischargeEnergy": "Total Discharged Energy",
  "ywt.65323.bmsMaxVoltage": "Maximum Voltage of BMS",
  "ywt.65323.bmsMinVoltage": "Minimum Voltage of BMS",
  "ywt.65323.batFaultFlag": "Battery malfunction indicator",
  "ywt.65323.batAlarmFlag": "Battery warning sign",
  "ywt.65323.bmsRequestFlag": "BMS request flag",
  "ywt.65323.generatorRelayStatus": "Generator relay status",
  "ywt.65323.load2GeneratorVoltageA": "Load 2/Generator Voltage A",
  "ywt.65323.load2GeneratorVoltageB": "Load 2/Generator Voltage B",
  "ywt.65323.load2GeneratorVoltageC": "Load 2/Generator Voltage C",
  "ywt.65323.load2GeneratorCurrentA": "Load 2/generator Current A",
  "ywt.65323.load2GeneratorCurrentB": "Load 2/generator Current B",
  "ywt.65323.load2GeneratorCurrentC": "Load 2/generator Current C",
  "ywt.65323.load2GeneratorFrequency": "Load 2/Generator Frequency",
  "ywt.65323.load2GeneratorActivePower": "Load 2/Active Power of generator",
  "ywt.65323.load2GeneratorAPhaseActivePower": "Load 2/Generator A-phase Active Power",
  "ywt.65323.load2GeneratorBPhaseActivePower": "Load 2/Generator B-phase Active Power",
  "ywt.65323.load2GeneratorCPhaseActivePower": "Load 2/Generator V-phase Active Power",
  "ywt.65323.load2GeneratorReactivePower": "Load 2/generator reActive Power",
  "ywt.65323.load2GeneratorTodayConsumeEnergy": "Load2/Generator Daily Consumption",
  "ywt.65323.load2GeneratorTotalConsumeEnergy": "Load2/Generator Total Consumption",
  "ywt.65323.load2GeneratorTodayGenerateEnergy": "Load 2/daily Power generation of the generator",
  "ywt.65323.load2GeneratorTotalGenerateEnergy": "Load 2/ Generator Total Yield",
  "ywt.65323.spiAutoTestResult": "SPI automatic test results",
  "ywt.65323.spiAutoTestEndFlag": "SPI automatic test end flag",
  "ywt.65323.spiAutoTestThresholdAPhaseU1": "SPI automatic test threshold A-phase U>>",
  "ywt.65323.spiAutoTestThresholdAPhaseU2": "SPI automatic test threshold A-phase U>10min",
  "ywt.65323.spiAutoTestThresholdAPhaseU3": "SPI automatic test threshold A-phase U<",
  "ywt.65323.spiAutoTestThresholdAPhaseU4": "SPI automatic test threshold A-phase U<<",
  "ywt.65323.spiAutoTestThresholdBPhaseU1": "SPI automatic test threshold B-phase U>>",
  "ywt.65323.spiAutoTestThresholdBPhaseU2": "SPI automatic test threshold B-phase U>10min",
  "ywt.65323.spiAutoTestThresholdBPhaseU3": "SPI automatic test threshold B-phase U<",
  "ywt.65323.spiAutoTestThresholdBPhaseU4": "SPI automatic test threshold B-phase U<<",
  "ywt.65323.spiAutoTestThresholdCPhaseU1": "SPI automatic test threshold C-phase U>>",
  "ywt.65323.spiAutoTestThresholdCPhaseU2": "SPI automatic test threshold C-phase U>10min",
  "ywt.65323.spiAutoTestThresholdCPhaseU3": "SPI automatic test threshold C-phase U<",
  "ywt.65323.spiAutoTestThresholdCPhaseU4": "SPI automatic test threshold C-phase U<<",
  "ywt.65323.spiAutoTestThresholdF1": "SPI automatic test threshold F>>",
  "ywt.65323.spiAutoTestThresholdF2": "SPI automatic test threshold F>>",
  "ywt.65323.spiAutoTestThresholdF3": "SPI automatic test threshold F<",
  "ywt.65323.spiAutoTestThresholdF4": "SPI automatic test threshold F<<",
  "ywt.65323.spiAutoTestTimeAPhaseU1": "SPI automatic testing time A phase U>>",
  "ywt.65323.spiAutoTestTimeAPhaseU2": "SPI automatic testing time A phase U>10 minutes",
  "ywt.65323.spiAutoTestTimeAPhaseU3": "SPI automatic testing time A phase U<",
  "ywt.65323.spiAutoTestTimeAPhaseU4": "SPI automatic testing time A phase U<<",
  "ywt.65323.spiAutoTestTimeBPhaseU1": "SPI automatic testing time B phase U>>",
  "ywt.65323.spiAutoTestTimeBPhaseU2": "SPI automatic testing time B phase U>10 minutes",
  "ywt.65323.spiAutoTestTimeBPhaseU3": "SPI automatic testing time B phase U<",
  "ywt.65323.spiAutoTestTimeBPhaseU4": "SPI automatic testing time B phase U<<",
  "ywt.65323.spiAutoTestTimeCPhaseU1": "SPI automatic testing time C phase U>>",
  "ywt.65323.spiAutoTestTimeCPhaseU2": "SPI automatic testing time C phase U>10min",
  "ywt.65323.spiAutoTestTimeCPhaseU3": "SPI automatic testing time C phase U<",
  "ywt.65323.spiAutoTestTimeCPhaseU4": "SPI automatic testing time C phase U<<",
  "ywt.65323.spiAutoTestTimeF1": "SPI automatic testing time F>>",
  "ywt.65323.spiAutoTestTimeF2": "SPI automatic testing time F>",
  "ywt.65323.spiAutoTestTimeF3": "SPI automatic testing time F<",
  "ywt.65323.spiAutoTestTimeF4": "SPI automatic testing time F<<",
  "mini.65290.stOV_Vgrid": "Grid side overVoltage protection",
  "mini.65290.stUV_Vgrid": "Grid side underVoltage protection",
  "mini.65290.stOV_Fgrid": "Grid side Voltage overfrequency protection",
  "mini.65290.stUV_Fgrid": "Grid side Voltage underfrequency protection",
  "mini.65290.stOV_Temp": "Inverter over-Temperature protection",
  "mini.65290.stHW_Fault": "Inverter hardware protection",
  "mini.65290.stErrOP_Relay": "Grid side relay exception proteciton",
  "mini.65290.stErrAccess_EEPROM": "EEPROM access exception",
  "mini.65290.stAbnorm_Ris": "Insulation impedance anomaly",
  "mini.65290.Vacrms": "Grid-side RMS Voltage",
  "mini.65290.Iacrms": "Grid-side RMS Current",
  "mini.65290.Fgrid": "Grid-side frequency",
  "mini.65290.Temperature": "Inverter Operating Temperature(℃)",
  "mini.65290.stPV1_UV": "PV input 1 underVoltage",
  "mini.65290.stPV1_OV": "PV input 1 overVoltage",
  "mini.65290.stRes1": "Reserved State 1",
  "mini.65290.Vpv1": "PV1 input Voltage",
  "mini.65290.Ipv1": "PV1 input Current",
  "mini.65290.Energy_PV1": "PV1Total Yield",
  "mini.65290.stPV2_UV": "PV input 2 underVoltage",
  "mini.65290.stPV2_OV": "PV Input 2 overVoltage",
  "mini.65290.stRes2": "Reserved State 2",
  "mini.65290.Vpv2": "PV2 input Voltage",
  "mini.65290.Ipv2": "PV2 input Current",
  "mini.65290.Energy_PV2": "PV2 Total Yield",
  "mini.65290.stPV3_UV": "PV input 3 underVoltage",
  "mini.65290.stPV3_OV": "PV input 3 OverVoltage",
  "mini.65290.stRes3": "Reserved State 3",
  "mini.65290.Vpv3": "PV3 input Voltage",
  "mini.65290.Ipv3": "PV3 input Current",
  "mini.65290.Energy_PV3": "PV3 Total Yield",
  "mini.65290.stPV4_UV": "PV input 4 underVoltage",
  "mini.65290.stPV4_OV": "PV Input4 OverVoltage",
  "mini.65290.stRes4": "Reserved State 4",
  "mini.65290.Vpv4": "PV4 input Voltage",
  "mini.65290.Ipv4": "PV4 input Current",
  "mini.65290.Energy_PV4": "PV4 Total Yield",
  "mini.65290.stPV5_UV": "PV input 5 underVoltage",
  "mini.65290.stPV5_OV": "PV input 5 overVoltage",
  "mini.65290.stRes5": "Reserved State 5",
  "mini.65290.Vpv5": "PV5 input Voltage",
  "mini.65290.Ipv5": "PV5 Input Current",
  "mini.65290.Energy_PV5": "PV5 Total Yield",
  "mini.65290.stPV6_UV": "PV input 6 underVoltage",
  "mini.65290.stPV6_OV": "PV input 6 overVoltage",
  "mini.65290.stRes6": "Reserved State 6",
  "mini.65290.Vpv6": "PV6 input Voltage",
  "mini.65290.Ipv6": "PV6 input Current",
  "mini.65290.Energy_PV6": "PV6 Total Yield",
  "mini.65290.StINVTPOWERON": "Inv output operating status",
  "mini.65290.stRelayoN": "Relay-On State",
  "mini.65290.activePower": "Active Power",
  "mini.65290.Res10": "Retention 10",
  "mini.65290.Res11": "Reservation 11",
  "mini.65290.Res12": "Retention 12",
  "mini.65290.Res13": "Retention 13",
  "mini.65290.Res14": "Retention 14",
  "mini.65290.Res15": "Retention 15",
  "mini.65290.Res16": "Reservation 16",
  "mini.65290.Res17": "Reservation 17",
  "mini.65290.Res18": "Retention 18",
  "mini.65290.Res19": "Reservation 19",
  "mini.65290.Res20": "Retention of 20",
  "mini.65290.Un": "On-grid RMS rated Voltage of the grid",
  "mini.65290.Fn": "On-grid Rated Frequency Of The Grid",
  "mini.65290.Pn": "Maximum On-grid Active Power",
  "mini.65290.Irmsmax": "Maximum On-grid RMS Current",
  "mini.65290.Vmpptmin": "Minimum mppt Voltage",
  "mini.65290.Vmpptmax": "Maximum mppt Voltage",
  "mini.65290.Powpvmax": "Maximum input PV Power",
  "mini.65290.Ipvmax": "Maximum input PV Current",
  "mini.65290.Tempmax": "Maximum Working Temperature(℃)",
  "mini.65290.Firmware_ver1": "Firmware version 1",
  "mini.65290.Firmware_ver2": "Firmware version 2",
  "mini.65290.Firmware_ver3": "Firmware version 3",
  "mini.65290.UpdateProgress": "Upgrade progress",
  "mini.65290.DeviceID": "Device SN",
  "storage.v2.65284.pvInputVoltage": "PV Input Voltage",
  "storage.v2.65284.pvGenerartion": "PV Current generating capacity",
  "storage.v2.65284.pvEnergyDay": "PV Today Yield",
  "storage.v2.65284.pvEnergyTotal": "PV Total Yield",
  "storage.v2.65284.batteryVoltage": "Battery Voltage",
  "storage.v2.65284.batteryCurrent": "Battery charge and discharge Current",
  "storage.v2.65284.dcOutputCurrent": "DC output Current",
  "storage.v2.65284.dcOutputPower": "DC output Power",
  "storage.v2.65284.ratedCapacity": "Rated battery capacity",
  "storage.v2.65284.batterySOC": "Remaining battery capacity SOC",
  "storage.v2.65284.cycleNumber": "Charge and discharge cycles",
  "storage.v2.65284.internalTemp": "System Internal Temperature(℃)",
  "storage.v2.65284.heatsinkTemp": "Radiator Temperature(℃)",
  "storage.v2.65284.batteryTemp1": "Battery Pack Temperature 1(℃)",
  "storage.v2.65284.batteryTemp2": "Battery Pack Temperature 2(℃)",
  "storage.v2.65284.BMSTemp": "BMS Temperature(℃)",
  "storage.v2.65284.cellVoltage1": "Cell 1 Voltage",
  "storage.v2.65284.cellVoltage2": "Cell 2 Voltage",
  "storage.v2.65284.cellVoltage3": "Cell 3 Voltage",
  "storage.v2.65284.cellVoltage4": "Cell 4 Voltage",
  "storage.v2.65284.cellVoltage5": "Cell 5 Voltage",
  "storage.v2.65284.cellVoltage6": "Cell 6 Voltage",
  "storage.v2.65284.cellVoltage7": "Cell 7 Voltage",
  "storage.v2.65284.cellVoltage8": "Cell 8 Voltage",
  "storage.v2.65284.cellVoltage9": "Cell 9 Voltage",
  "storage.v2.65284.cellVoltage10": "Cell 10 Voltage",
  "storage.v2.65284.cellVoltage11": "Cell 11 Voltage",
  "storage.v2.65284.cellVoltage12": "Cell 12 Voltage",
  "storage.v2.65284.cellVoltage13": "Cell 13 Voltage",
  "storage.v2.65284.cellVoltage14": "Cell 14 Voltage",
  "storage.v2.65284.cellVoltage15": "Cell 15 Voltage",
  "storage.v2.65284.cellVoltage16": "Cell 16 Voltage",
  "storage.v2.65284.BMSWorkingStatus": "BMS Working State",
  "storage.v2.65284.runningStatus": "Device Running State",
  "storage.v2.65284.time": "Device time",
  "storage.v2.65284.invPower": "Inverter Power",
  "storage.s3.65292.batVoltage": "Battery Voltage",
  "storage.s3.65292.batCurrent": "Battery Current",
  "storage.s3.65292.batChargePower": "Bat charging Power",
  "storage.s3.65292.mainsChargeCurrent": "Utility Charging Current",
  "storage.s3.65292.pvChargeCurrent": "PV Charging Current",
  "storage.s3.65292.pv1Voltage": "PV1 Voltage",
  "storage.s3.65292.pv1Current": "PV1 Current",
  "storage.s3.65292.pv1Power": "PV1 output Power",
  "storage.s3.65292.pv2Voltage": "PV2 Voltage",
  "storage.s3.65292.pv2Current": "PV2 Current",
  "storage.s3.65292.pv2Power": "PV2 output Power",
  "storage.s3.65292.aPhaseVoltage": "A-phase output Voltage",
  "storage.s3.65292.aPhaseCurrent": "A-phase output Current",
  "storage.s3.65292.aPhaseActivePower": "A-phase output Active Power",
  "storage.s3.65292.aPhaseApparentPower": "A-phase output Apparent Power",
  "storage.s3.65292.bPhaseVoltage": "B-phase output Voltage",
  "storage.s3.65292.bPhaseCurrent": "B-phase output Current",
  "storage.s3.65292.bPhaseActivePower": "B-phase output Active Power",
  "storage.s3.65292.bPhaseApparentPower": "B-phase output Apparent Power",
  "storage.s3.65292.cPhaseVoltage": "Phase C output Voltage",
  "storage.s3.65292.cPhaseCurrent": "C-phase output Current",
  "storage.s3.65292.cPhaseActivePower": "C-phase output Active Power",
  "storage.s3.65292.cPhaseApparentPower": "C-phase output Apparent Power",
  "storage.s3.65292.allActivePower": "Output Active Power",
  "storage.s3.65292.allApparentPower": "Output Apparent Power",
  "storage.s3.65292.aChargeActivePower": "A-phase Generation Active Power",
  "storage.s3.65292.bChargeActivePower": "B-phase Active Power",
  "storage.s3.65292.cChargeActivePower": "C-phase Active Power",
  "storage.s3.65292.mainsApVoltage": "Utility phase A Voltage",
  "storage.s3.65292.mainsApCurrent": "Utility phase A Current",
  "storage.s3.65292.mainsBpVoltage": "Utility phase B Voltage",
  "storage.s3.65292.mainsBpCurrent": "Utility phase B Current",
  "storage.s3.65292.mainsCpVoltage": "Utility phase C Voltage",
  "storage.s3.65292.mainsCpCurrent": "Utility phase C Current",
  "storage.s3.65292.mainsApPower": "Utility phase A Power",
  "storage.s3.65292.mainsBpPower": "Utility phase B Power",
  "storage.s3.65292.mainsCpPower": "Utility phase C Power",
  "storage.s3.65292.onGridActivePower": "Grid-connected Active Power",
  "storage.s3.65292.homeLoadPower": "Household Load Power",
  "storage.s3.65292.afterLoadPower": "Back-end Load Power",
  "storage.s3.65292.totalLoadPower": "Total Load",
  "storage.s3.65292.batPower": "Battery Power",
  "storage.s3.65292.girdDisplayPower": "Grid-side Display Power",
  "storage.s3.65292.invPower": "Inverter Power",
  "storage.s3.65292.beforeLoadMarker": "Front-end Load Energy Flow Symbol",
  "storage.s3.65292.gridMarker": "Grid Energy Flow Symbol",
  "storage.s3.65292.mainsMarker": "Utility energy flow symbol",
  "storage.s3.65292.machineOnStatus": "Working State",
  "storage.s3.65292.chargeStatus": "Charge State",
  "storage.s3.65292.outputStatus": "Output status",
  "storage.s3.65292.acTodayEnergy": "Today's AC Yield",
  "storage.s3.65292.batTodayChargeEnergy": "Today Charged Energy",
  "storage.s3.65292.batTodayDischargeEnergy": "Today Discharged Energy",
  "storage.s3.65292.pvTodayEnergy": "PV Today Yield",
  "storage.s3.65292.loadTodayEnergy": "Today Consumption",
  "storage.s3.65292.mainsTodayChargeEnergy": "Charging Power from utility on the same day",
  "storage.s3.65292.loadTodayUseMainsEnergy": "Today Load Consumption From Grid",
  "storage.s3.65292.batTotalChargeEnergy": "Battery Total Charge Energy",
  "storage.s3.65292.batTotalDischargeEnergy": "Total Discharged Energy",
  "storage.s3.65292.pvTotalEnergy": "PV Total Yield",
  "storage.s3.65292.loadTotalEnergy": "Cumulative Load Power consumption",
  "storage.s3.65292.mainsTotalChargeEnergy": "Total Charged Energy From Grid",
  "storage.s3.65292.loadTotalUseMainsEnergy": "Total Load Consumption From Grid",
  "storage.s3.65292.acTotalEnergy": "Cumulative AC Power Generation",
  "storage.s3.65292.mainsChargeTimerSet": "Timed Utility Charge Enable",
  "storage.s3.65292.batChargeTimerSet": "Timed battery enable",
  "storage.s3.65292.softWareVersion3": "Software Version 3",
  "storage.s3.65292.aPhaseOnGridPower": "Power available on the grid side of phase A",
  "storage.s3.65292.bPhaseOnGridPower": "Power on the grid side of phase B",
  "storage.s3.65292.cPhaseOnGridPower": "Power on the grid side of phase C",
  "storage.s3.65292.aPhaseOnGridCurrent": "Current on the grid side of phase A",
  "storage.s3.65292.bPhaseOnGridCurrent": "B-phase grid-side Current",
  "storage.s3.65292.cPhaseOnGridCurrent": "C-phase grid-side Current",
  "storage.s3.65292.batTemp": "Battery Temperature(℃)",
  "storage.s3.65292.softWareVersion1": "DSP version",
  "storage.s3.65292.softWareVersion2": "BMS Version",
  "storage.s3.65292.softWareVersion4": "ARM version",
  "storage.s3.65292.batChargeCur": "Battery request charging Current",
  "storage.s3.65292.batSurplusCapacity": "Battery residual capacity",
  "storage.s3.65292.batRatedCapacity": "Rated capacity of battery",
  "storage.s3.65292.batMaxPressure": "Maximum pressure difference of single cell",
  "storage.s3.65292.batSoh": "SOH",
  "storage.s3.65292.batChargeLimitVol": "Battery charging Voltage limit value",
  "storage.s3.65292.bat1CellVol": "Cell Voltage 1",
  "storage.s3.65292.bat2CellVol": "Cell Voltage 2",
  "storage.s3.65292.bat3CellVol": "Cell Voltage 3",
  "storage.s3.65292.bat4CellVol": "Cell Voltage 4",
  "storage.s3.65292.bat5CellVol": "Cell Voltage 5",
  "storage.s3.65292.bat6CellVol": "Cell Voltage 6",
  "storage.s3.65292.bat7CellVol": "Cell Voltage 7",
  "storage.s3.65292.bat8CellVol": "Cell Voltage 8",
  "storage.s3.65292.bat9CellVol": "Cell Voltage 9",
  "storage.s3.65292.bat10CellVol": "Cell Voltage 10",
  "storage.s3.65292.bat11CellVol": "Cell Voltage 11",
  "storage.s3.65292.bat12CellVol": "Cell Voltage 12",
  "storage.s3.65292.bat13CellVol": "Cell Voltage 13",
  "storage.s3.65292.bat14CellVol": "Cell Voltage 14",
  "storage.s3.65292.bat15CellVol": "Cell Voltage 15",
  "storage.s3.65292.bat16CellVol": "Cell Voltage 16",
  "storage.s3.65292.batStatus": "Battery status",
  "storage.s3.65292.pvVoltageLevel": "Off-line alarm",
  "storage.s3.65292.pvRadiatorTemp": "PV Radiator Temperature(℃)",
  "storage.s3.65292.invTemp": "Inverter temperature",
  "storage.s3.65292.transformerTemp": "Transformer Temperature(℃)",
  "storage.s3.65292.cellTemp1": "Cell Temperature 1(℃)",
  "storage.s3.65292.cellTemp2": "Cell Temperature 2(℃)",
  "storage.s3.65292.cellTemp3": "Cell Temperature 3(℃)",
  "storage.s3.65292.cellTemp4": "Cell Temperature 4(℃)",
  "storage.s3.65292.mosTemp": "MOS Temperature(℃)",
  "storage.s3.65292.mcuTemp": "MCU Temperature(℃)",
  "storage.s3.65292.msAvgTemp": "Master-Slave Average Temperature(℃)",
  "storage.s3.65292.batSOC": "Bat  SOC",
  "storage.s3.65292.invSubBoardVersion": "DSP subversion",
  "storage.s3.65292.batDischargeCur": "Bat discharge Current",
  "storage.s3.65292.batWorkStatus": "Battery switch status",
  "storage.s3.65292.ctWorkStatus": "Wireless CT switch status",
  "storage.s3.65292.socketPower1": "Socket Power 1",
  "storage.s3.65292.socketPower2": "Socket Power 2",
  "storage.s3.65292.socketPower3": "Socket Power 3",
  "storage.s3.65292.socketPower4": "Socket Power 4",
  "storage.s3.65292.socketPower5": "Socket Power 5",
  "storage.s3.65292.socketPower6": "Socket Power 6",
  "storage.s3.65292.socketPower7": "Socket Power 7",
  "storage.s3.65292.socketPower8": "Socket Power 8",
  "storage.s3.65292.socketPower9": "Socket Power 9",
  "storage.s3.65292.socketPower10": "Socket Power 10",
  "storage.s3.65292.socketPower11": "Socket Power 11",
  "storage.s3.65292.socketPower12": "Socket Power 12",
  "storage.s3.65292.socketPower13": "Socket Power 13",
  "storage.s3.65292.socketPower14": "Socket Power 14",
  "storage.s3.65292.socketPower15": "Socket Power 15",
  "storage.s3.65292.socketPower16": "Socket Power 16",
  "storage.s3.65292.outPutFreq": "Output frequency",
  "storage.s3.65292.mainsFreq": "Mains frequency",
  "storage.s3.65292.socketWorkStatus": "Socket number",
  "storage.s3.65292.time": "Device Time",
  "storage.s3.65292.deviceSn": "Device SN",
  "datalog.sn": "Datalog SN",
  "storage.s3.65292.offlineAlarm": "Off-line alarm",
  "storage.s3.65292.pvPower": "PV Power",
  "hipment.devType": "Development Type",
  "device.voltageV": "Device Voltage V",
  "device.electric.currentA": "Device Current A",
  "device.return.port": "Return port",
  "device.a.phase": "A phase",
  "device.b.phase": "B phase",
  "device.c.phase": "C phase",
  "device.electic.meter.data": "Electricity Meter Data",
  "device.voltage": "Voltage",
  "device.electric.current": "Electric Current",
  "jl_param_ctrl_name_Metercompensation": "Meter compensation",
  "unc.65323.runStatus": "Operating Status",
  "jl_param_ctrl_option_HaierLV": "Haier LV",
  "jl_paran_ctrl_name_InverterConnectedPhaseSetting": "Inverter Connected Phase Setting",
  "jl_param_ctrl_name_ClearOverload(OffGrid)Fault": "Clear OverLoad(Off Grid) Fault",
  "jl_param_ctrl_option_NAHUILV": "NAHUI LV",
  "jl_param_ctrl_option_LeadAcid": "Lead Acid",
  "jl_param_ctrl_option_48VLithiumbatteryLV": "48V Lithium battery LV",
  "jl_param_ctrl_option_51.2VLithiumbatteryLV": "51.2V Lithium battery LV",
  "jl_param_ctrl_option_PYLON_LV": "PYLON_LV",
  "jl_param_ctrl_option_B_BOX_LVBYD": "B_BOX_LV BYD",
  "jl_param_ctrl_option_DynessLV": "Dyness LV",
  "jl_param_ctrl_option_LGChemLV": "LG Chem LV",
  "jl_param_ctrl_option_AoBo": "AoBo",
  "jl_param_ctrl_option_JiaWei": "JiaWei",
  "jl_param_ctrl_option_WECO": "WECO",
  "jl_param_ctrl_option_FreedomWon": "FreedomWon",
  "jl_param_ctrl_option_Soluna": "Soluna",
  "jl_param_ctrl_option_GSL": "GSL",
  "jl_param_ctrl_option_RiSheng": "RiSheng",
  "jl_param_ctrl_option_UZ(Catl)": "UZ(Catl)",
  "jl_param_ctrl_option_Zeta": "Zeta",
  "jl_param_ctrl_option_Highstar": "Highstar",
  "jl_param_ctrl_option_KODAK": "KODAK",
  "jl_param_ctrl_option_EXIDE": "EXIDE",
  "jl_param_ctrl_option_HDEnergy": "HD Energy",
  "jl_param_ctrl_option_GLG": "GLG",
  "jl_param_ctrl_option_PAND": "PAND",
  "jl_param_ctrl_option_Dowell": "Dowell",
  "jl_param_ctrl_option_ROSENESS": "ROSEN ESS",
  "jl_param_ctrl_option_AlpSolarrLV": "AlpSolarr LV",
  "jl_param_ctrl_option_YOSHOPOLV": "YOSHOPO LV",
  "jl_param_ctrl_option_SUNWODALV": "SUNWODA LV",
  "jl_param_ctrl_option_J-Pack-LV": "J-Pack-LV",
  "jl_param_ctrl_option_CFELV": "CFE LV",
  "jl_param_ctrl_option_UpowerUE-H": "UPower UE-H",
  "jl_param_ctrl_option_UpowerUE-I": "UPower UE-I",
  "jl_param_ctrl_option_Duracell": "Duracell",
  "jl_param_ctrl_option_STELTECLV": "STELTEC LV",
  "jl_param_ctrl_option_LithiumBatteryLV(RS485)": "Lithium Battery LV(RS485)",
  "jl_param_ctrl_option_JA-L": "JA-L",
  "jl_param_ctrl_name_PercentagesettingofthereactivepowerunderDRM3mode": "Percentage setting of the reactive Power under DRM3 mode",
  "jl_param_ctrl_name_PercentagesettingofthereactivepowerunderDRM7mode": "Percentage setting of the reactive Power under DRM7 mode",
  "jl_param_ctrl_name_StartFrequency": "Start Frequency",
  "jl_param_ctrl_name_ACCoupling_OFF_Bat_Volt": "AC Coupling_OFF_Bat_Volt",
  "jl_param_ctrl_name_WithGenerator": "With Generator",
  "jl_param_ctrl_name_GENPortLoadON": "GEN Port Load ON",
  "jl_param_ctrl_name_CTRatio": "CT Ratio",
  "jl_param_ctrl_name_InverterConnectedPhaseSetting": "Inverter Connected Phase Setting",
  "jl_param_ctrl_name_FCASFMMode": "FCAS FM Mode",
  "jl_param_ctrl_option_step mode": "Step mode",
  "jl_param_ctrl_option_droop mode": "Droop mode",
  "jl_param_ctrl_option_None": "None",
  "jl_param_ctrl_option_SinglePhase": "Single Phase",
  "jl_param_ctrl_option_PhaseA(3P)": "Phase A(Three Phase)",
  "jl_param_ctrl_option_PhaseB(3P)": "Phase B(Three Phase)",
  "jl_param_ctrl_option_PhaseC(3P)": "Phase C(Three Phase)",
  "bw_RTparam_group_Inverter": "Inverter",
  "bw_RTparam_group_Grid": "Grid",
  "bw_RTparam_group_Battery": "Battery",
  "bw_RTparam_group_Load": "Load",
  "bw_RTparam_group_PVMeter": "PV side meter",
  "common.50100.pv1Voltage": "PV1 Voltage",
  "common.50100.pv1Current": "PV1 Current",
  "common.50100.pv1Power": "PV1 Power",
  "common.50100.pv2Voltage": "PV2 Voltage",
  "common.50100.pv2Current": "PV2 Current",
  "common.50100.pv2Power": "PV2 Power",
  "common.50100.pv3Voltage": "PV3 Voltage",
  "common.50100.pv3Current": "PV3 Current",
  "common.50100.pv3Power": "PV3 Power",
  "common.50100.pv4Voltage": "PV4 Voltage",
  "common.50100.pv4Current": "PV4 Current",
  "common.50100.pv4Power": "PV4 Power",
  "common.50100.temperature": "Inverter Temperature(℃)",
  "common.50100.outputGridVoltage": "Output Grid Voltage",
  "common.50100.outputGridCurrent": "Output Grid Current",
  "common.50100.outputGridPower": "Output Grid Power",
  "common.50100.pv1CumulativePowerGeneration": "PV1 Total Yield",
  "common.50100.pv2CumulativePowerGeneration": "PV2 Total Yield",
  "common.50100.pv3CumulativePowerGeneration": "PV3 Total Yield",
  "common.50100.pv4CumulativePowerGeneration": "PV4 Total Yield",
  "common.50100.totalPowerGeneration": "Total Yield",
  "common.50100.wnSn": "Dongle SN",
  "common.50100.wnWifiVersion": "Dongle Wifi Version",
  "common.50100.wnHardwareVersion": "Dongle Hardware Version",
  "common.50100.wnSoftwareVersion": "Dongle Software Version",
  "ltwn_RTparam_group_Inverter": "Inverter",
  "\nbw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "\nOnly Enable discharge Time period control",
  "plant.already.deliver": "Plant Already Deliver",
  "common.50100.totalPvEnergy": "Total Yield",
  "ltcg_RTparam_name_name": "Device Name",
  "ltcg_RTparam_name_out_pac": "Power generation (kW)",
  "ltcg_RTparam_name_eday": "Today's power generation (kWh)",
  "ltcg_RTparam_name_etotal": "Cumulative power generation (kWh)",
  "ltcg_RTparam_name_status": "Status",
  "ltcg_RTparam_name_turnon_time": "Access time",
  "ltcg_RTparam_name_type": "Device Type",
  "ltcg_RTparam_name_capacity": "Capacity kw",
  "ltcg_RTparam_name_tempperature": "Temperature",
  "ltcg_RTparam_name_creationDate": "Latest data time",
  "ltcg_RTparam_name_pac": "Power generation",
  "ltcg_RTparam_name_hTotal": "Cumulative generation hours",
  "ltcg_RTparam_name_vpv1": "DC Voltage 1",
  "ltcg_RTparam_name_vpv2": "DC Voltage 2",
  "ltcg_RTparam_name_vpv3": "DC voltage 3",
  "ltcg_RTparam_name_vpv4": "DC voltage 4",
  "ltcg_RTparam_name_vpv5": "DC voltage 5",
  "ltcg_RTparam_name_vpv6": "DC voltage 6",
  "ltcg_RTparam_name_vpv7": "DC voltage 7",
  "ltcg_RTparam_name_vpv8": "DC voltage 8",
  "ltcg_RTparam_name_vpv9": "DC voltage 9",
  "ltcg_RTparam_name_vpv10": "DC voltage 10",
  "ltcg_RTparam_name_vpv11": "DC voltage 11",
  "ltcg_RTparam_name_vpv12": "DC voltage 12",
  "ltcg_RTparam_name_ipv1": "DC Current 1",
  "ltcg_RTparam_name_ipv2": "DC current 2",
  "ltcg_RTparam_name_ipv3": "DC current 3",
  "ltcg_RTparam_name_ipv4": "DC current 4",
  "ltcg_RTparam_name_ipv5": "DC current 5",
  "ltcg_RTparam_name_ipv6": "DC current 6",
  "ltcg_RTparam_name_ipv7": "DC current 7",
  "ltcg_RTparam_name_ipv8": "DC current 8",
  "ltcg_RTparam_name_ipv9": "DC current 9",
  "ltcg_RTparam_name_ipv10": "DC current 10",
  "ltcg_RTparam_name_ipv11": "DC current 11",
  "ltcg_RTparam_name_ipv12": "DC current 12",
  "ltcg_RTparam_name_vac1": "AC voltage 1",
  "ltcg_RTparam_name_vac2": "AC voltage 2",
  "ltcg_RTparam_name_vac3": "AC voltage 3",
  "ltcg_RTparam_name_iac1": "AC Current 1",
  "ltcg_RTparam_name_iac2": "Alternating Current 2",
  "ltcg_RTparam_name_iac3": "Alternating current 3",
  "ltcg_RTparam_name_fac1": "Communication Frequency 1",
  "ltcg_RTparam_name_fac2": "Communication Frequency 2",
  "ltcg_RTparam_name_fac3": "Communication frequency 3",
  "ltcg_RTparam_name_istr1": "String current 1",
  "ltcg_RTparam_name_istr2": "String current 2",
  "ltcg_RTparam_name_istr3": "String current 3",
  "ltcg_RTparam_name_istr4": "String current 4",
  "ltcg_RTparam_name_istr5": "String current 5",
  "ltcg_RTparam_name_istr6": "String current 6",
  "ltcg_RTparam_name_istr7": "String current 7",
  "ltcg_RTparam_name_istr8": "String current 8",
  "ltcg_RTparam_name_istr9": "String current 9",
  "ltcg_RTparam_name_istr10": "String current 10",
  "ltcg_RTparam_name_istr11": "String current 11",
  "ltcg_RTparam_name_istr12": "String current 12",
  "ltcg_RTparam_name_istr13": "String current 13",
  "ltcg_RTparam_name_istr14": "String current 14",
  "ltcg_RTparam_name_istr15": "String current 15",
  "ltcg_RTparam_name_istr16": "String current 16",
  "ltcg_RTparam_name_istr17": "String current 17",
  "ltcg_RTparam_name_istr18": "String current 18",
  "ltcg_RTparam_name_istr19": "String current 19",
  "ltcg_RTparam_name_istr20": "String current 20",
  "ltcg_RTparam_name_istr21": "String current 21",
  "ltcg_RTparam_name_istr22": "String current 22",
  "ltcg_RTparam_name_istr23": "String current 23",
  "ltcg_RTparam_name_istr24": "String current 24",
  "ltcg_RTparam_group_Inverter": "Inverter",
  "city.not.exist": "City does not exist",
  "supplier.type.tb": "Special variety",
  "common.50300.sn": "Device Serial Number",
  "common.50300.name": "Device Name",
  "common.50300.out_pac": "Power generation (kW)",
  "common.50300.eday": "Today's power generation (kWh)",
  "common.50300.etotal": "Cumulative power generation (kWh)",
  "common.50300.status": "Status",
  "common.50300.turnon_time": "Access time",
  "common.50300.type": "Device Type",
  "common.50300.capacity": "Capacity kw",
  "common.50300.tempperature": "Temperature(℃)",
  "common.50300.creationDate": "Latest data time",
  "common.50300.pac": "Power generation",
  "common.50300.hTotal": "Cumulative generation hours",
  "common.50300.vpv1": "DC Voltage 1",
  "common.50300.vpv2": "DC Voltage 2",
  "common.50300.vpv3": "DC voltage 3",
  "common.50300.vpv4": "DC voltage 4",
  "common.50300.vpv5": "DC voltage 5",
  "common.50300.vpv6": "DC voltage 6",
  "common.50300.vpv7": "DC voltage 7",
  "common.50300.vpv8": "DC voltage 8",
  "common.50300.vpv9": "DC voltage 9",
  "common.50300.vpv10": "DC voltage 10",
  "common.50300.vpv11": "DC voltage 11",
  "common.50300.vpv12": "DC voltage 12",
  "common.50300.ipv1": "DC Current 1",
  "common.50300.ipv2": "DC current 2",
  "common.50300.ipv3": "DC current 3",
  "common.50300.ipv4": "DC current 4",
  "common.50300.ipv5": "DC current 5",
  "common.50300.ipv6": "DC current 6",
  "common.50300.ipv7": "DC current 7",
  "common.50300.ipv8": "DC current 8",
  "common.50300.ipv9": "DC current 9",
  "common.50300.ipv10": "DC current 10",
  "common.50300.ipv11": "DC current 11",
  "common.50300.ipv12": "DC current 12",
  "common.50300.vac1": "AC voltage 1",
  "common.50300.vac2": "AC voltage 2",
  "common.50300.vac3": "AC voltage 3",
  "common.50300.iac1": "AC Current 1",
  "common.50300.iac2": "Alternating Current 2",
  "common.50300.iac3": "Alternating current 3",
  "common.50300.fac1": "Communication Frequency 1",
  "common.50300.fac2": "Communication Frequency 2",
  "common.50300.fac3": "Communication frequency 3",
  "common.50300.istr1": "String current 1",
  "common.50300.istr2": "String current 2",
  "common.50300.istr3": "String current 3",
  "common.50300.istr4": "String current 4",
  "common.50300.istr5": "String current 5",
  "common.50300.istr6": "String current 6",
  "common.50300.istr7": "String current 7",
  "common.50300.istr8": "String current 8",
  "common.50300.istr9": "String current 9",
  "common.50300.istr10": "String current 10",
  "common.50300.istr11": "String current 11",
  "common.50300.istr12": "String current 12",
  "common.50300.istr13": "String current 13",
  "common.50300.istr14": "String current 14",
  "common.50300.istr15": "String current 15",
  "common.50300.istr16": "String current 16",
  "common.50300.istr17": "String current 17",
  "common.50300.istr18": "String current 18",
  "common.50300.istr19": "String current 19",
  "common.50300.istr20": "String current 20",
  "common.50300.istr21": "String current 21",
  "common.50300.istr22": "String current 22",
  "common.50300.istr23": "String current 23",
  "common.50300.istr24": "String current 24",
  "common.50402.sn": "Inverter SN",
  "common.50402.ID": "Inverter ID",
  "common.50402.STATION_ID": "Power Station ID",
  "common.50402.INV_EG_DAY": "Daily power generation",
  "common.50402.INV_EG_TOTAL": "Inverter cumulative power generation",
  "common.50402.INV_I_AC": "Inverter current",
  "common.50402.INV_U_AC": "Inverter voltage",
  "common.50402.PV1_I": "PV1 Current",
  "common.50402.PV2_I": "PV2 Current",
  "common.50402.PV3_I": "PV3 Current",
  "common.50402.PV4_I": "PV4 Current",
  "common.50402.PV5_I": "PV5 Current",
  "common.50402.PV6_I": "PV6 Current",
  "common.50402.PV7_I": "PV7 Current",
  "common.50402.PV8_I": "PV8 Current",
  "common.50402.PV9_I": "PV9 Current",
  "common.50402.PV10_I": "PV10 current",
  "common.50402.PV11_I": "PV11 Current",
  "common.50402.PV12_I": "PV12 current",
  "common.50402.PV13_I": "PV13 Current",
  "common.50402.PV14_I": "PV14 Current",
  "common.50402.PV15_I": "PV15 Current",
  "common.50402.PV16_I": "PV16 current",
  "common.50402.PV17_I": "PV17 Current",
  "common.50402.PV18_I": "PV18 Current",
  "common.50402.PV19_I": "PV19 Current",
  "common.50402.PV20_I": "PV20 Current",
  "common.50402.PV21_I": "PV21 Current",
  "common.50402.PV22_I": "PV22 current",
  "common.50402.PV23_I": "PV23 current",
  "common.50402.PV24_I": "PV24 Current",
  "common.50402.PV25_I": "PV25 current",
  "common.50402.PV26_I": "PV26 Current",
  "common.50402.PV27_I": "PV27 current",
  "common.50402.PV28_I": "PV28 Current",
  "common.50402.PV29_I": "PV29 current",
  "common.50402.PV30_I": "PV30 Current",
  "common.50402.PV1_V": "PV1 Voltage",
  "common.50402.PV2_V": "PV2 Voltage",
  "common.50402.PV3_V": "PV3 Voltage",
  "common.50402.PV4_V": "PV4 Voltage",
  "common.50402.PV5_V": "PV5 Voltage",
  "common.50402.PV6_V": "PV6 Voltage",
  "common.50402.PV7_V": "PV7 Voltage",
  "common.50402.PV8_V": "PV8 Voltage",
  "common.50402.PV9_V": "PV9 Voltage",
  "common.50402.PV10_V": "PV10 Voltage",
  "common.50402.PV11_V": "PV11 Voltage",
  "common.50402.PV12_V": "PV12 Voltage",
  "common.50402.PV13_V": "PV13 voltage",
  "common.50402.PV14_V": "PV14 voltage",
  "common.50402.PV15_V": "PV15 Voltage",
  "common.50402.PV16_V": "PV16 Voltage",
  "common.50402.PV17_V": "PV17 Voltage",
  "common.50402.PV18_V": "PV18 voltage",
  "common.50402.PV19_V": "PV19 Voltage",
  "common.50402.PV20_V": "PV20 Voltage",
  "common.50402.PV21_V": "PV21 Voltage",
  "common.50402.PV22_V": "PV22 voltage",
  "common.50402.PV23_V": "PV23 Voltage",
  "common.50402.PV24_V": "PV24 Voltage",
  "common.50402.PV25_V": "PV25 Voltage",
  "common.50402.PV26_V": "PV26 Voltage",
  "common.50402.PV27_V": "PV27 Voltage",
  "common.50402.PV28_V": "PV28 Voltage",
  "common.50402.PV29_V": "PV29 Voltage",
  "common.50402.PV30_V": "PV30 Voltage",
  "common.50402.INV_P_AC": "Inverter active power",
  "common.50402.CAPACITY": "capacity",
  "common.50402.INV_RUN_STATE": "Inverter operating status",
  "common.50402.DATA_TIME": "Data Time",
  "common.50402.name": "name",
  "common.50402.out_pac": "out_pac",
  "common.50402.eday": "eday",
  "common.50402.etotal": "etotal",
  "common.50402.status": "status",
  "common.50402.turnon_time": "turnon_time",
  "common.50402.type": "type",
  "common.50402.tempperature": "tempperature(℃)",
  "common.50402.creationDate": "creationDate",
  "common.50402.pac": "pac",
  "common.50402.hTotal": "hTotal",
  "common.50402.vpv1": "vpv1",
  "common.50402.vpv2": "vpv2",
  "common.50402.vpv3": "vpv3",
  "common.50402.vpv4": "vpv4",
  "common.50402.vpv5": "vpv5",
  "common.50402.vpv6": "vpv6",
  "common.50402.vpv7": "vpv7",
  "common.50402.vpv8": "vpv8",
  "common.50402.vpv9": "vpv9",
  "common.50402.vpv10": "vpv10",
  "common.50402.vpv11": "vpv11",
  "common.50402.vpv12": "vpv12",
  "common.50402.ipv1": "ipv1",
  "common.50402.ipv2": "ipv2",
  "common.50402.ipv3": "ipv3",
  "common.50402.ipv4": "ipv4",
  "common.50402.ipv5": "ipv5",
  "common.50402.ipv6": "ipv6",
  "common.50402.ipv7": "ipv7",
  "common.50402.ipv8": "ipv8",
  "common.50402.ipv9": "ipv9",
  "common.50402.ipv10": "ipv10",
  "common.50402.ipv11": "ipv11",
  "common.50402.ipv12": "ipv12",
  "common.50402.vac1": "vac1",
  "common.50402.vac2": "vac2",
  "common.50402.vac3": "vac3",
  "common.50402.iac1": "iac1",
  "common.50402.iac2": "iac2",
  "common.50402.iac3": "iac3",
  "common.50402.fac1": "fac1",
  "common.50402.fac2": "fac2",
  "common.50402.fac3": "fac3",
  "common.50402.istr1": "istr1",
  "common.50402.istr2": "istr2",
  "common.50402.istr3": "istr3",
  "common.50402.istr4": "istr4",
  "common.50402.istr5": "istr5",
  "common.50402.istr6": "istr6",
  "common.50402.istr7": "istr7",
  "common.50402.istr8": "istr8",
  "common.50402.istr9": "istr9",
  "common.50402.istr10": "istr10",
  "common.50402.istr11": "istr11",
  "common.50402.istr12": "istr12",
  "common.50402.istr13": "istr13",
  "common.50402.istr14": "istr14",
  "common.50402.istr15": "istr15",
  "common.50402.istr16": "istr16",
  "common.50402.istr17": "istr17",
  "common.50402.istr18": "istr18",
  "common.50402.istr19": "istr19",
  "common.50402.istr20": "istr20",
  "common.50402.istr21": "istr21",
  "common.50402.istr22": "istr22",
  "common.50402.istr23": "istr23",
  "common.50402.istr24": "istr24",
  "bw_RTparam_group_ Dongle": "Dongle",
  "bw_RTparam_group_Dongle": "Dongle",
  "common.50500.xnl_RTparam_name_FV_P": "Power Factor Value",
  "common.50500.xnl_RTparam_name_GVL": "Grid-connected voltage level",
  "common.50500.xnl_RTparam_name_RS_D": "Running Status (Default)",
  "common.50500.xnl_RTparam_name_Etdy_ge1": "Daily power generation (active)",
  "common.50500.xnl_RTparam_name_A_R_P_D": "AC reactive energy on the day",
  "common.50500.xnl_RTparam_name_GEN_P_D": "Daily Generation Output of Generator",
  "common.50500.xnl_RTparam_name_Et_ge0": "Cumulative Generated Electricity (Active) ",
  "common.50500.xnl_RTparam_name_Emon1": "Monthly power generation (active)",
  "common.50500.xnl_RTparam_name_Etdy_use2": "Monthly electricity consumption",
  "common.50500.xnl_RTparam_name_t_gc_tdy2": "Monthly grid-connected capacity",
  "common.50500.xnl_RTparam_name_Eyr1": "Annual power generation (active)",
  "common.50500.xnl_RTparam_name_Etdy_cg1": "Today's charging volume",
  "common.50500.xnl_RTparam_name_Etdy_dcg1": "Today's Discharge Amount",
  "common.50500.xnl_RTparam_name_t_cg_n1": "Cumulative Charging Capacity ",
  "common.50500.xnl_RTparam_name_t_dcg_n1": "Cumulative Discharge ",
  "common.50500.xnl_RTparam_name_E_B_D": "Daily electricity purchase volume",
  "common.50500.xnl_RTparam_name_GRID_C_D": "Grid-connected capacity of the power grid on the day ",
  "common.50500.xnl_RTparam_name_E_B_TO": "Total Purchased Electricity",
  "common.50500.xnl_RTparam_name_PG_F1": "Grid Frequency",
  "common.50500.xnl_RTparam_name_t_gc1": "Cumulative Grid-connected Capacity ",
  "common.50500.xnl_RTparam_name_GDOH": "Generator daily working hours ",
  "common.50500.xnl_RTparam_name_Etdy_use1": "Today's electricity consumption",
  "common.50500.xnl_RTparam_name_Et_use1": "Cumulative Electricity Consumption ",
  "common.50500.xnl_RTparam_name_Etdy_use3": "Annual electricity consumption ",
  "common.50500.xnl_RTparam_name_T_TFM1": "Transformer Temperature",
  "common.50500.xnl_RTparam_name_T_RDT1": "Radiator Temperature ",
  "common.50500.xnl_RTparam_name_EG_t_ge1": "Total power generation of the generator",
  "common.50500.xnl_RTparam_name_E_PVhis_ge1": "Historical PV power generation",
  "common.50500.xnl_RTparam_name_t_gc_tdy3": "Annual grid-connected capacity ",
  "common.50500.xnl_RTparam_name_LCD": "LCD Test Flag Bit",
  "common.50500.xnl_RTparam_name_CBAC": "Capacity after battery calibration",
  "common.50500.xnl_RTparam_name_PVDE": "Daily PV power generation",
  "common.50500.xnl_RTparam_name_DV1": "DC Voltage PV1",
  "common.50500.xnl_RTparam_name_DC1": "DC Current PV1",
  "common.50500.xnl_RTparam_name_DV2": "DC Voltage PV2",
  "common.50500.xnl_RTparam_name_DC2": "DC Current PV2",
  "common.50500.xnl_RTparam_name_DV3": "DC Voltage PV3",
  "common.50500.xnl_RTparam_name_DC3": "DC Current PV3",
  "common.50500.xnl_RTparam_name_DV4": "DC Voltage PV4",
  "common.50500.xnl_RTparam_name_DC4": "DC Current PV4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_1": "INV DSP Debug Information 1",
  "common.50500.xnl_RTparam_name_INV_DSP_D_2": "INV DSP Debug Information 2",
  "common.50500.xnl_RTparam_name_INV_DSP_D_3": "INV DSP Debug Information 3",
  "common.50500.xnl_RTparam_name_INV_DSP_D_4": "INV DSP Debug Information 4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_5": "INV DSP Debug Information 5",
  "common.50500.xnl_RTparam_name_INV_DSP_D_6": "INV DSP Debug Information 6",
  "common.50500.xnl_RTparam_name_INV_DSP_D_7": "INV DSP Debug Information 7",
  "common.50500.xnl_RTparam_name_INV_DSP_D_8": "INV DSP Debug Information 8",
  "common.50500.xnl_RTparam_name_INV_DSP_D_9": "INV DSP Debug Information 9",
  "common.50500.xnl_RTparam_name_INV_DSP_D_10": "INV DSP Debug Information 10",
  "common.50500.xnl_RTparam_name_INV_DSP_D_11": "INV DSP Debug Information 11",
  "common.50500.xnl_RTparam_name_INV_DSP_D_12": "INV DSP Debug Information 12",
  "common.50500.xnl_RTparam_name_INV_DSP_D_13": "INV DSP Debug Information 13",
  "common.50500.xnl_RTparam_name_INV_DSP_D_14": "INV DSP Debug Information 14",
  "common.50500.xnl_RTparam_name_INV_DSP_D_15": "INV DSP Debug Information 15",
  "common.50500.xnl_RTparam_name_INV_DSP_D_16": "INV DSP Debug Information 16",
  "common.50500.xnl_RTparam_name_INV_DSP_D_17": "INV DSP Debug Information 17",
  "common.50500.xnl_RTparam_name_INV_DSP_D_18": "INV DSP Debug Information 18",
  "common.50500.xnl_RTparam_name_INV_DSP_D_19": "INV DSP Debug Information 19",
  "common.50500.xnl_RTparam_name_INV_DSP_D_20": "INV DSP Debug Information 20",
  "common.50500.xnl_RTparam_name_INV_DSP_D_21": "INV DSP Debug Information 21",
  "common.50500.xnl_RTparam_name_INV_DSP_D_22": "INV DSP Debug Information 22",
  "common.50500.xnl_RTparam_name_INV_DSP_D_23": "INV DSP Debug Information 23",
  "common.50500.xnl_RTparam_name_INV_DSP_D_24": "INV DSP Debug Information 24",
  "common.50500.xnl_RTparam_name_INV_DSP_D_25": "INV DSP Debug Information 25",
  "common.50500.xnl_RTparam_name_INV_DSP_D_26": "INV DSP Debug Information 26",
  "common.50500.xnl_RTparam_name_INV_DSP_D_27": "INV DSP Debug Information 27",
  "common.50500.xnl_RTparam_name_INV_DSP_D_28": "INV DSP Debug Information 28",
  "common.50500.xnl_RTparam_name_G_V_L1_N": "Grid-side voltage L1-N ",
  "common.50500.xnl_RTparam_name_G_V_L2_N": "Grid-side voltage L2-N ",
  "common.50500.xnl_RTparam_name_G_V_L1_L2": "Grid-side voltage L1-L2 ",
  "common.50500.xnl_RTparam_name_R_I_V_L1_L2": "Relay Intermediate Side Voltage L1-L2 ",
  "common.50500.xnl_RTparam_name_AV1": "AC Voltage R/U/A",
  "common.50500.xnl_RTparam_name_AV2": "AC Voltage S/V/B",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L2": "Inverter output voltage L1-L2  ",
  "common.50500.xnl_RTparam_name_C_V_L1": "Load Voltage L1",
  "common.50500.xnl_RTparam_name_C_V_L2": "Load Voltage L2",
  "common.50500.xnl_RTparam_name_I_O_F2": "Inverter Output Frequency L2 ",
  "common.50500.xnl_RTparam_name_G_C_L1": "Grid current L1",
  "common.50500.xnl_RTparam_name_G_C_L2": "Grid current L2",
  "common.50500.xnl_RTparam_name_G_C_A": "Grid Current A",
  "common.50500.xnl_RTparam_name_G_C_B": "Grid Current B",
  "common.50500.xnl_RTparam_name_AC1": "Alternating Current R/U/A",
  "common.50500.xnl_RTparam_name_AC2": "AC Current S/V/B",
  "common.50500.xnl_RTparam_name_GEN_P_T": "Total power of the generator",
  "common.50500.xnl_RTparam_name_G_P_L1": "Grid Power L1",
  "common.50500.xnl_RTparam_name_G_P_L2": "Grid Power L2",
  "common.50500.xnl_RTparam_name_PG_Pt1": "Total Grid Power",
  "common.50500.xnl_RTparam_name_E_CT_P1": "External CT1 Power",
  "common.50500.xnl_RTparam_name_E_CT_P2": "External CT2 Power",
  "common.50500.xnl_RTparam_name_CT_P_T": "Total power of grid CT",
  "common.50500.xnl_RTparam_name_INV_O_P_L1": "Inverter Output Power L1  ",
  "common.50500.xnl_RTparam_name_INV_O_P_L2": "Inverter Output Power L2  ",
  "common.50500.xnl_RTparam_name_I_O_P_LN": "Inverter Output Power L/N ",
  "common.50500.xnl_RTparam_name_C_P_L1": "Load Power L1",
  "common.50500.xnl_RTparam_name_C_P_L2": "Load Power L2",
  "common.50500.xnl_RTparam_name_E_Puse_t1": "Total electrical power consumption",
  "common.50500.xnl_RTparam_name_E_Cuse1": "Electric current R/U/A",
  "common.50500.xnl_RTparam_name_E_Cuse2": "Electrical current S/V/B ",
  "common.50500.xnl_RTparam_name_PVGP_A": "Phase Voltage A of Gen Port",
  "common.50500.xnl_RTparam_name_B_T1": "Battery Temperature ",
  "common.50500.xnl_RTparam_name_B_V1": "Battery Voltage ",
  "common.50500.xnl_RTparam_name_B_R_C": "Remaining battery capacity",
  "common.50500.xnl_RTparam_name_LF2": "Load Frequency L2",
  "common.50500.xnl_RTparam_name_DP1": "DC Power PV1",
  "common.50500.xnl_RTparam_name_DP2": "DC Power PV2",
  "common.50500.xnl_RTparam_name_DP3": "DC Power PV3",
  "common.50500.xnl_RTparam_name_DP4": "DC Power PV4",
  "common.50500.xnl_RTparam_name_B_Pdcg1": "Battery Discharge Power ",
  "common.50500.xnl_RTparam_name_B_C1": "Battery Current ",
  "common.50500.xnl_RTparam_name_LF1": "Load Frequency L1",
  "common.50500.xnl_RTparam_name_I_O_F1": "Inverter Output Frequency L1 ",
  "common.50500.xnl_RTparam_name_GRID_RELAY_ST1": "Grid Relay Status",
  "common.50500.xnl_RTparam_name_ST_EG_RELAY1": "Generator side relay status ",
  "common.50500.xnl_RTparam_name_EG_F1": "Generator Frequency",
  "common.50500.xnl_RTparam_name_BUS_VOL": "Bus Voltage",
  "common.50500.xnl_RTparam_name_H_B_V": "Half busbar voltage",
  "common.50500.xnl_RTparam_name_B_B_C": "Balanced Bridge Current",
  "common.50500.xnl_RTparam_name_I_EARipa1": "Parallel ground impedance",
  "common.50500.xnl_RTparam_name_LBVN": "Lithium Battery Version Number ",
  "common.50500.xnl_RTparam_name_M_P": "Total power of the electricity meter",
  "common.50500.xnl_RTparam_name_M_P_A": "Electric Meter Power A",
  "common.50500.xnl_RTparam_name_M_P_B": "Electric Meter Power B",
  "common.50500.xnl_RTparam_name_M_P_C": "Electric Meter Power C",
  "common.50500.xnl_RTparam_name_t_gc_tdy1": "Today's grid-connected capacity",
  "common.50500.xnl_RTparam_name_Etdy_pu1": "Today's electricity purchase volume",
  "common.50500.xnl_RTparam_name_Et_pu1": "Cumulative Electricity Purchased ",
  "common.50500.xnl_RTparam_name_Vtr1_BAP1": "Total Voltage of Battery Pack 1",
  "common.50500.xnl_RTparam_name_Cr1_BAP1": "Battery Pack 1 Current ",
  "common.50500.xnl_RTparam_name_T_BAP1": "Battery Pack 1 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP1": "Battery Pack 1 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP1": "Remaining Capacity of Battery Pack 1",
  "common.50500.xnl_RTparam_name_T_cap_BAP1": "Total Capacity of Battery Pack 1",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg1": "Battery Pack 1 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg1": "Charging Request Current of Battery Pack 1 ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg1": "Battery Pack 1 Discharge Request Current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP1": "Maximum Voltage of Battery Pack 1",
  "common.50500.xnl_RTparam_name_MIN_V_BAP1": "Minimum voltage of battery in battery pack 1",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP1": "Number of cycles of Battery Pack 1",
  "common.50500.xnl_RTparam_name_Warn_BAP1": "Battery Pack 1 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP1": "Battery Pack 1 Fault ",
  "common.50500.xnl_RTparam_name_Vtr_BAP2": "Total Voltage of Battery Pack 2",
  "common.50500.xnl_RTparam_name_Cr_BAP2": "Battery Pack 2 Current ",
  "common.50500.xnl_RTparam_name_T_BAP2": "Battery Pack 2 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP2": "Battery Pack 2 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP2": "Remaining Capacity of Battery Pack 2",
  "common.50500.xnl_RTparam_name_T_cap_BAP2": "Total Capacity of Battery Pack 2",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg2": "Battery Pack 2 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg2": "Battery Pack 2 Charging Request Current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg2": "Battery pack 2 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP2": "Maximum Voltage of Battery 2 in the Battery Pack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP2": "Minimum Voltage of Battery 2 in Battery Pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP2": "Battery Pack 2 Cycle Count ",
  "common.50500.xnl_RTparam_name_Warn_BAP2": "Battery Pack 2 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP2": "Battery pack 2 failure ",
  "common.50500.xnl_RTparam_name_Vtr_BAP3": "Total Voltage of Battery Pack 3",
  "common.50500.xnl_RTparam_name_Cr_BAP3": "Battery Pack 3 Current ",
  "common.50500.xnl_RTparam_name_T_BAP3": "Battery Pack 3 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP3": "Battery Pack 3 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP3": "Remaining Capacity of Battery Pack 3",
  "common.50500.xnl_RTparam_name_T_cap_BAP3": "Total Capacity of Battery Pack 3",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg3": "Battery Pack 3 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg3": "Battery Pack 3 Charging Request Current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg3": "Battery pack 3 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP3": "Maximum Voltage of Battery 3 in Battery Pack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP3": "Minimum Voltage of Battery 3 in Battery Pack ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP3": "Number of Cycles of Battery Pack 3",
  "common.50500.xnl_RTparam_name_Warn_BAP3": "Battery Pack 3 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP3": "Battery pack 3 malfunction ",
  "common.50500.xnl_RTparam_name_Vtr_BAP4": "Total Voltage of Battery Pack 4",
  "common.50500.xnl_RTparam_name_Cr_BAP4": "Battery Pack 4 Current ",
  "common.50500.xnl_RTparam_name_T_BAP4": "Battery Pack 4 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP4": "Battery Pack 4 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP4": "Remaining Capacity of Battery Pack 4",
  "common.50500.xnl_RTparam_name_T_cap_BAP4": "Total Capacity of Battery Pack 4",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg4": "Battery Pack 4 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg4": "Battery Pack 4 Charging Request Current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg4": "Battery Pack 4 Discharge Request Current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP4": "Maximum Voltage of Battery 4 in Battery Pack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP4": "Minimum voltage of battery 4 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP4": "Battery Pack 4 Cycle Count ",
  "common.50500.xnl_RTparam_name_Warn_BAP4": "Battery Pack 4 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP4": "Battery pack 4 failure ",
  "common.50500.xnl_RTparam_name_Vtr5_BAP5": "Total Voltage of Battery Pack 5",
  "common.50500.xnl_RTparam_name_Cr5_BAP5": "Battery Pack 5 Current ",
  "common.50500.xnl_RTparam_name_T_BAP5": "Battery Pack 5 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP5": "Battery Pack 5 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP5": "Remaining Capacity of Battery Pack 5",
  "common.50500.xnl_RTparam_name_T_cap_BAP5": "Total Capacity of Battery Pack 5",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg5": "Battery Pack 5 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg5": "Battery Pack 5 Charging Request Current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg5": "Battery pack 5 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP5": "Maximum voltage of Battery 5 in the battery pack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP5": "Minimum voltage of Battery 5 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP5": "Battery Pack 5 Cycle Count ",
  "common.50500.xnl_RTparam_name_Warn_BAP5": "Battery Pack 5 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP5": "Battery pack 5 failure ",
  "common.50500.xnl_RTparam_name_Vtr6_BAP6": "Total Voltage of Battery Pack 6",
  "common.50500.xnl_RTparam_name_Cr6_BAP6": "Battery Pack 6 Current ",
  "common.50500.xnl_RTparam_name_T_BAP6": "Battery Pack 6 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP6": "Battery Pack 6 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP6": "Remaining capacity of battery pack 6",
  "common.50500.xnl_RTparam_name_T_cap_BAP6": "Total Capacity of Battery Pack 6",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg6": "Battery Pack 6 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg6": "Battery pack 6 charging request current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg6": "Battery pack 6 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP6": "Battery Pack 6 Battery Maximum Voltage ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP6": "Minimum Voltage of Battery 6 in Battery Pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP6": "Battery Pack 6 Cycle Count ",
  "common.50500.xnl_RTparam_name_Warn_BAP6": "Battery Pack 6 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP6": "Battery pack 6 failure ",
  "common.50500.xnl_RTparam_name_Vtr7_BAP7": "Total Voltage of Battery Pack 7",
  "common.50500.xnl_RTparam_name_Cr7_BAP7": "Battery Pack 7 Current ",
  "common.50500.xnl_RTparam_name_T_BAP7": "Battery Pack 7 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP7": "Battery Pack 7 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP7": "Remaining capacity of battery pack 7",
  "common.50500.xnl_RTparam_name_T_cap_BAP7": "Total Capacity of Battery Pack 7",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg7": "Battery Pack 7 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg7": "Battery Pack 7 Charging Request Current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg7": "Battery pack 7 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP7": "Battery Pack 7 Battery Maximum Voltage ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP7": "Minimum voltage of Battery 7 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP7": "Battery Pack 7 Cycle Count ",
  "common.50500.xnl_RTparam_name_Warn_BAP7": "Battery pack 7 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP7": "Battery pack 7 failure ",
  "common.50500.xnl_RTparam_name_Vtr8_BAP8": "Total Voltage of Battery Pack 8",
  "common.50500.xnl_RTparam_name_Cr8_BAP8": "Battery Pack 8 Current ",
  "common.50500.xnl_RTparam_name_T_BAP8": "Battery Pack 8 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP8": "Battery Pack 8 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP8": "Remaining Capacity of Battery Pack 8",
  "common.50500.xnl_RTparam_name_T_cap_BAP8": "Total Capacity of Battery Pack 8",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg8": "Battery Pack 8 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg8": "Battery Pack 8 Charging Request Current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg8": "Battery pack 8 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP8": "Maximum Voltage of Battery 8 in Battery Pack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP8": "Minimum Voltage of Battery 8 in Battery Pack ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP8": "Battery Pack 8 Cycle Count ",
  "common.50500.xnl_RTparam_name_Warn_BAP8": "Battery Pack 8 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP8": "Battery pack 8 failure ",
  "common.50500.xnl_RTparam_name_Vtr9_BAP9": "Total Voltage of Battery Pack 9",
  "common.50500.xnl_RTparam_name_Cr9_BAP9": "Battery Pack 9 Current ",
  "common.50500.xnl_RTparam_name_T_BAP9": "Battery Pack 9 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP9": "Battery Pack 9 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP9": "Remaining capacity of battery pack 9",
  "common.50500.xnl_RTparam_name_T_cap_BAP9": "Total Capacity of Battery Pack 9",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg9": "Battery Pack 9 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg9": "Battery pack 9 charging request current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg9": "Battery pack 9 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP9": "Battery Pack 9 Battery Maximum Voltage ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP9": "Minimum voltage of Battery 9 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP9": "Battery Pack 9 Cycle Count ",
  "common.50500.xnl_RTparam_name_Warn_BAP9": "Battery pack 9 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP9": "Battery pack 9 failure ",
  "common.50500.xnl_RTparam_name_Vtr10_BAP10": "Total voltage of battery pack 10",
  "common.50500.xnl_RTparam_name_Cr10_BAP10": "Battery Pack 10 Current ",
  "common.50500.xnl_RTparam_name_T_BAP10": "Battery Pack 10 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP10": "Battery Pack 10 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP10": "Remaining Capacity of Battery Pack 10",
  "common.50500.xnl_RTparam_name_T_cap_BAP10": "Total Capacity of Battery Pack 10",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg10": "Battery Pack 10 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg10": "Charging Request Current of Battery Pack 10 ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg10": "Discharge Request Current of Battery Pack 10 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP10": "Maximum Voltage of Battery 10 in Battery Pack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP10": "Minimum Voltage of Battery 10 in Battery Pack ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP10": "Number of cycles of battery pack 10",
  "common.50500.xnl_RTparam_name_Warn_BAP10": "Battery Pack 10 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP10": "Battery pack 10 failure ",
  "common.50500.xnl_RTparam_name_Vtr11_BAP11": "Total Voltage of Battery Pack 11",
  "common.50500.xnl_RTparam_name_Cr11_BAP11": "Battery Pack 11 Current ",
  "common.50500.xnl_RTparam_name_T_BAP11": "Battery Pack 11 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP11": "Battery Pack 11 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP11": "Remaining capacity of battery pack 11",
  "common.50500.xnl_RTparam_name_T_cap_BAP11": "Total capacity of battery pack 11",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg11": "Battery Pack 11 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg11": "Battery Pack 11 Charging Request Current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg11": "Discharge Request Current of Battery Pack 11 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP11": "Maximum Voltage of Battery Pack 11 Batteries",
  "common.50500.xnl_RTparam_name_MIN_V_BAP11": "Minimum Voltage of Battery 11 in Battery Pack ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP11": "Number of cycles of battery pack 11",
  "common.50500.xnl_RTparam_name_Warn_BAP11": "Battery pack 11 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP11": "Battery pack 11 malfunction ",
  "common.50500.xnl_RTparam_name_Vtr12_BAP12": "Total Voltage of Battery Pack 12",
  "common.50500.xnl_RTparam_name_Cr12_BAP12": "Battery Pack 12 Current ",
  "common.50500.xnl_RTparam_name_T_BAP12": "Battery Pack 12 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP12": "Battery Pack 12 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP12": "Remaining capacity of battery pack 12",
  "common.50500.xnl_RTparam_name_T_cap_BAP12": "Total Capacity of Battery Pack 12",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg12": "Battery Pack 12 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg12": "Battery Pack 12 Charging Request Current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg12": "Battery pack 12 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP12": "Maximum Voltage of Battery 12 in Battery Pack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP12": "Minimum voltage of battery 12 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP12": "Number of cycles of battery pack 12",
  "common.50500.xnl_RTparam_name_Warn_BAP12": "Battery pack 12 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP12": "Battery pack 12 failure ",
  "common.50500.xnl_RTparam_name_Vtr13_BAP13": "Total Voltage of Battery Pack 13",
  "common.50500.xnl_RTparam_name_Cr13_BAP13": "Battery Pack 13 Current ",
  "common.50500.xnl_RTparam_name_T_BAP13": "Battery Pack 13 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP13": "Battery Pack 13 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP13": "Remaining capacity of battery pack 13",
  "common.50500.xnl_RTparam_name_T_cap_BAP13": "Total capacity of battery pack 13",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg13": "Battery pack 13 charging request voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg13": "Battery pack 13 charging request current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg13": "Discharge Request Current of Battery Pack 13 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP13": "Maximum Voltage of Battery 13 in Battery Pack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP13": "Minimum voltage of battery 13 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP13": "Number of cycles of battery pack 13",
  "common.50500.xnl_RTparam_name_Warn_BAP13": "Battery pack 13 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP13": "Battery pack 13 malfunction ",
  "common.50500.xnl_RTparam_name_Vtr14_BAP14": "Total voltage of battery pack 14",
  "common.50500.xnl_RTparam_name_Cr14_BAP14": "Battery Pack 14 Current ",
  "common.50500.xnl_RTparam_name_T_BAP14": "Battery Pack 14 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP14": "Battery Pack 14 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP14": "Remaining capacity of battery pack 14",
  "common.50500.xnl_RTparam_name_T_cap_BAP14": "Total capacity of battery pack 14",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg14": "Battery Pack 14 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg14": "Battery pack 14 charging request current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg14": "Discharge Request Current of Battery Pack 14 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP14": "Maximum Voltage of Battery 14 in Battery Pack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP14": "Minimum voltage of battery 14 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP14": "Number of cycles of battery pack 14",
  "common.50500.xnl_RTparam_name_Warn_BAP14": "Battery pack 14 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP14": "Battery pack 14 malfunction ",
  "common.50500.xnl_RTparam_name_Vtr15_BAP15": "Total Voltage of Battery Pack 15",
  "common.50500.xnl_RTparam_name_Cr15_BAP15": "Battery Pack 15 Current ",
  "common.50500.xnl_RTparam_name_T_BAP15": "Battery Pack 15 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP15": "Battery Pack 15 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP15": "Remaining capacity of battery pack 15",
  "common.50500.xnl_RTparam_name_T_cap_BAP15": "Total Capacity of Battery Pack 15",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg15": "Battery Pack 15 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg15": "Battery pack 15 charging request current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg15": "Battery pack 15 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP15": "Maximum Voltage of Battery 15 in Battery Pack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP15": "Minimum voltage of battery 15 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP15": "Number of cycles of battery pack 15",
  "common.50500.xnl_RTparam_name_Warn_BAP15": "Battery pack 15 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP15": "Battery pack 15 malfunction ",
  "common.50500.xnl_RTparam_name_yr1": "Year",
  "common.50500.xnl_RTparam_name_mon1": "Month",
  "common.50500.xnl_RTparam_name_tdy1": "Day",
  "common.50500.xnl_RTparam_name_hou1": "when ",
  "common.50500.xnl_RTparam_name_min1": "points ",
  "common.50500.xnl_RTparam_name_sec1": "seconds ",
  "common.50500.xnl_RTparam_name_BMS_D_V": "BMS Discharge Voltage",
  "common.50500.xnl_RTparam_name_BMS_B_Ccg_thd1": "BMS battery charging limit viewership of",
  "common.50500.xnl_RTparam_name_BMS_B_Cdcg_thd1": "BMS battery discharge limit viewership of",
  "common.50500.xnl_RTparam_name_B_R_P": "BMS remaining power ",
  "common.50500.xnl_RTparam_name_BMS_B_V1": "BMS Battery Voltage",
  "common.50500.xnl_RTparam_name_BMS_B_C1": "BMS Battery Current",
  "common.50500.xnl_RTparam_name_BMST": "BMS Temperature",
  "common.50500.xnl_RTparam_name_BCT": "Battery Type ",
  "common.50500.xnl_RTparam_name_HF_1": "Historical Fault 1",
  "common.50500.xnl_RTparam_name_HF_2": "Historical Fault 2",
  "common.50500.xnl_RTparam_name_HF_3": "Historical Fault 3",
  "common.50500.xnl_RTparam_name_HF_4": "Historical Fault 4",
  "common.50500.xnl_RTparam_name_HF_5": "Historical Fault 5",
  "common.50500.xnl_RTparam_name_HF_6": "Historical Fault 6",
  "common.50500.xnl_RTparam_name_HF_7": "Historical Fault 7",
  "common.50500.xnl_RTparam_name_HF_8": "Historical Fault 8",
  "common.50500.xnl_RTparam_name_HF_9": "Historical Fault 9",
  "common.50500.xnl_RTparam_name_HF_10": "Historical Fault 10",
  "common.50500.xnl_RTparam_name_HF_11": "Historical Fault 11",
  "common.50500.xnl_RTparam_name_HF_12": "Historical Fault 12",
  "common.50500.xnl_RTparam_name_HF_13": "Historical Fault 13",
  "common.50500.xnl_RTparam_name_G_V_L3": "Grid Voltage L3",
  "common.50500.xnl_RTparam_name_G_V_L1_L3": "Grid-side voltage L1-L3 ",
  "common.50500.xnl_RTparam_name_G_V_L2_L3": "Grid-side voltage L2-L3 ",
  "common.50500.xnl_RTparam_name_AV3": "AC Voltage T/W/C",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L3": "Inverter output voltage L1-L3 ",
  "common.50500.xnl_RTparam_name_INV_O_P_L2_L3": "Inverter output voltage L2-L3 ",
  "common.50500.xnl_RTparam_name_C_V_L3": "Load Voltage L3",
  "common.50500.xnl_RTparam_name_NA": "NA",
  "common.50500.xnl_RTparam_name_I_O_F3": "Inverter Output Frequency L3 ",
  "common.50500.xnl_RTparam_name_G_C_L3": "Grid current L3",
  "common.50500.xnl_RTparam_name_G_C_C": "Grid current C",
  "common.50500.xnl_RTparam_name_AC3": "Alternating Current T/W/C",
  "common.50500.xnl_RTparam_name_G_P_L3": "Grid Power L3",
  "common.50500.xnl_RTparam_name_CT3_P_E": "External Power CT3",
  "common.50500.xnl_RTparam_name_INV_O_P_L3": "Inverter Output Power L3  ",
  "common.50500.xnl_RTparam_name_C_P_L3": "Load Power L3",
  "common.50500.xnl_RTparam_name_C_C_L3": "Load current L3",
  "common.50500.xnl_RTparam_name_BMS_C_V": "BMS Charging Voltage",
  "common.50500.xnl_RTparam_name_INV_ADDR": "Inverter Address",
  "common.50100.Inverter": "Inverter",
  "supplier.type.tuobang": "Tuobao",
  "solis.10001.gridVoltageA": "Grid Voltage L1",
  "solis.10001.gridVoltageC": "Grid Voltage L2",
  "solis.10001.gridVoltageB": "Grid Voltage L3",
  "unc.65323.pvTotalEnergy": "Total Yield",
  "validate.email.sendVerificationCodeEmailAddress": "Send Verification Code",
  "validate.email.getVerificationCode": "Get Verification Code",
  "unc.65323.busVoltage": "BUS Voltage",
  "unc.65323.load2GeneratorTotalGenerateEnergy": "Load2 /Generator Total Yield",
  "unc.65323.load2GeneratorTodayGenerateEnergy": "Load2 Generator Today Generate Energy",
  "login.agreement.and": "and",
  "switchover.switchover.Installers": "I'm an installer",
  "unc.65323.spiAutoTestEndFlag": "SPI AutoTest End Flag",
  "unc.65323.batterySOC": "Battery SOC",
  "unc.65323.batterySOH": "Battery SOH",
  "unc.65323.dcComponentC": "DC Component C",
  "unc.65323.dcComponentB": "DC Component B",
  "unc.65323.dcComponentA": "DC Component A",
  "unc.65323.gridVoltageCA": "Grid Voltage CA",
  "unc.65323.mpptTemperature": "MPPT Temperature(℃)",
  "unc.65323.gridVoltageBC": "Grid Voltage BC",
  "unc.65323.gridVoltageAB": "Grid Voltage AB",
  "unc.65323.pv2Power": "PV2 Power",
  "supplier.type.yx": "Rockcore",
  "supplier.type.yw": "Inverttech",
  "unc.65323.pv6Voltage": "PV6 Voltage",
  "jl_param_ctrl_group_GridCodeSetting-InitialSetting": "Grid Code Setting-Initial Setting",
  "unc.65323.loadActivePower": "Load Active Power",
  "unc.65323.dcTemperature": "DC Temperature(℃)",
  "unc.65323.bmsMaxVoltage": "BMS Max Voltage",
  "unc.65323.totalConsumeEnergy": "Total Consumption",
  "unc.65323.pv6Current": "PV6 Current",
  "supplier.type.sk": "SAKO",
  "supplier.type.sh": "SOFAR",
  "unc.65323.pv5Power": "PV5 Power",
  "unc.65323.loadBPhaseActivePower": "LoadB Phase Active Power",
  "unc.65323.bmsRequestFlag": "BMS Request Flag",
  "unc.65323.load2GeneratorTotalConsumeEnergy": "Load2 Generator Total Consume Energy",
  "login.agreement.readAndAgree": "Read and Agree",
  "jl_param_ctrl_group_GridCodeSetting-\r\nInitialSetting": "Grid Code Setting-Special Setting",
  "unc.65323.pvAnnualEnergy": "Yearly Yield",
  "solis.10001.batteryDischargeLimiting": "Battery Discharge Limiting",
  "unc.65323.spiAutoTestTimeF3": "SPI AutoTest TimeF3",
  "solis.10001.totalLoadPower": "Total Load Power",
  "unc.65323.spiAutoTestTimeF4": "SPI AutoTest TimeF4",
  "unc.65323.returnFlowPortReactivePower": "Return Flow Port ReActive Power",
  "unc.65323.spiAutoTestTimeF1": "SPI AutoTest TimeF1",
  "unc.65323.spiAutoTestTimeF2": "SPI AutoTest TimeF2",
  "supplier.type.gd": "GOODWE",
  "unc.65323.returnFlowPortBPhaseActivePower": "Return Flow Port BPhase Active Power",
  "unc.65323.batTodayChargeEnergy": "Today Charged Energy",
  "unc.65323.gridBPhaseActivePower": "Grid BPhase Active Power",
  "unc.65323.bmsMinVoltage": "BMS Min.Voltage",
  "unc.65323.bmsBatteryCurrent": "BMS Battery Current",
  "solis.10001.homeGridTotalEnergy": "Total Grid Load Consumption",
  "unc.65323.bmsBatteryVoltage": "BMS Battery Voltage",
  "unc.65323.load2GeneratorActivePower": "Load2 Generator Active Power",
  "unc.65323.batteryStatus": "Battery Status",
  "retrieve.lable.newPassword": "New Password",
  "product.subTypeNumber": "Sub Type Number",
  "unc.65323.positiveElectrodeInsulationImpedance3": "Positive Electrode InsulationImpedance3",
  "unc.65323.positiveElectrodeInsulationImpedance4": "Positive Electrode InsulationImpedance4",
  "unc.65323.positiveElectrodeInsulationImpedance1": "Positive Electrode InsulationImpedance1",
  "unc.65323.positiveElectrodeInsulationImpedance2": "Positive Electrode InsulationImpedance2",
  "unc.65323.positiveElectrodeInsulationImpedance5": "Positive Electrode InsulationImpedance5",
  "unc.65323.positiveElectrodeInsulationImpedance6": "Positive Electrode InsulationImpedance6",
  "unc.65323.batteryPower": "Battery Power",
  "unc.65323.spiAutoTestThresholdAPhaseU1": "SPI Auto Test Threshold APhase U1",
  "unc.65323.spiAutoTestThresholdAPhaseU4": "SPI Auto Test Threshold APhase U4",
  "unc.65323.spiAutoTestThresholdAPhaseU3": "SPI Auto Test Threshold APhase U3",
  "unc.65323.spiAutoTestThresholdAPhaseU2": "SPI Auto Test Threshold APhase U2",
  "unc.65323.pv1Power": "PV1 Power",
  "switchover.tipsProvisionServices": "Let us provide you with better service!",
  "unc.65323.gridCurrentC": "Grid Current C",
  "unc.65323.gridCurrentB": "Grid Current B",
  "unc.65323.gridCurrentA": "Grid Current A",
  "unc.65323.ctCPhaseActivePower": "CT CPhase Active Power",
  "unc.65323.drmStatus": "DRM Status",
  "unc.65323.pv6Power": "PV6 Power",
  "unc.65323.pv4Current": "PV4 Current",
  "unc.65323.leakageCurrent": "Leakage Current",
  "mini.65290.invPvPower": "PV Power",
  "unc.65323.batAlarmFlag": "Battery Alarm Flag",
  "unc.65323.totalFeedInGridEnergy": "Total Feed In Grid Energy",
  "unc.65323.load2GeneratorVoltageC": "Load2 Generator Voltage C",
  "unc.65323.load2GeneratorVoltageB": "Load2 Generator Voltage B",
  "unc.65323.load2GeneratorVoltageA": "Load2 Generator Voltage A",
  "unc.65323.ctStatus": "CT Status",
  "unc.65323.loadCPhaseActivePower": "Load CPhase Active Power",
  "unc.65323.ctVoltageC": "CT Voltage C",
  "unc.65323.ctVoltageB": "CT Voltage B",
  "unc.65323.ctVoltageA": "CT Voltage A",
  "unc.65323.spiAutoTestTimeAPhaseU4": "SPI Auto Test Time APhase U4",
  "unc.65323.spiAutoTestTimeAPhaseU3": "SPI Auto Test Time APhase U3",
  "unc.65323.spiAutoTestTimeAPhaseU2": "SPI Auto Test Time APhase U2",
  "unc.65323.spiAutoTestTimeAPhaseU1": "SPI Auto Test Time APhase U1",
  "unc.65323.pv1Current": "PV1 Current",
  "unc.65323.pv1Voltage": "PV1 Voltage",
  "unc.65323.returnFlowPortCurrentC": "Return Flow Port Current C",
  "unc.65323.warningStatus": "Alarm Status",
  "unc.65323.returnFlowPortCurrentB": "Return Flow Port Current B",
  "unc.65323.returnFlowPortCurrentA": "Return Flow Port Current A",
  "unc.65323.clsLockNum": "CLS lock Number of times",
  "unc.65323.load2GeneratorTodayConsumeEnergy": "Load2 Generator Today Consume Energy",
  "solis.10001.gridPower": "Grid Power",
  "Ajouterbar.plant": "Add Plant",
  "unc.65323.loadCurrentA": "Load Current A",
  "unc.65323.loadCurrentC": "Load Current C",
  "unc.65323.loadCurrentB": "Load Current B",
  "unc.65323.generatorRelayStatus": "Generator Relay Status",
  "unc.65323.clsLockTime": "CLS lock time",
  "unc.65323.clsStatus": "CLS status",
  "unc.65323.batTotalDischargeEnergy": "Total Discharged Energy",
  "supplier.type.ywt": "INVT",
  "register.lable.Email": "Email",
  "unc.65323.load2GeneratorFrequency": "Load2 Generator Frequency",
  "unc.65323.load2GeneratorAPhaseActivePower": "Load2 Generator APhase Active Power",
  "login.forgotPassword": "Forgot Password",
  "unc.65323.loadFrequency": "Load Frequency",
  "unc.65323.loadAPhaseActivePower": "Load APhase Active Power",
  "unc.65323.load2GeneratorCPhaseActivePower": "Load2 Generator CPhase Active Power",
  "unc.65323.returnFlowPortTotalActivePower": "Return Flow Port Total Active Power",
  "unc.65323.pvMonthlyEnergy": "Monthly Yield",
  "unc.65323.loadTotalConsumeEnergy": "Load Total Consume Energy",
  "validate.tips.PleaseEnterPassword": "Please Enter Password",
  "unc.65323.spiAutoTestTimeCPhaseU1": "SPI AutoTest Time CPhase U1",
  "unc.65323.spiAutoTestTimeCPhaseU3": "SPI AutoTest Time CPhase U3",
  "unc.65323.spiAutoTestTimeCPhaseU2": "SPI AutoTest Time CPhase U2",
  "unc.65323.spiAutoTestTimeCPhaseU4": "SPI AutoTest Time CPhase U4",
  "unc.65323.loadVoltageA": "Load Voltage A",
  "unc.65323.loadVoltageB": "Load Voltage B",
  "unc.65323.loadVoltageC": "Load Voltage C",
  "unc.65323.pv3Voltage": "PV3 Voltage",
  "solis.10001.batteryChargingCurrent": "Battery Charging Current",
  "validate.email.reacquireCode": "Re-fetch",
  "unc.65323.spiAutoTestThresholdCPhaseU4": "SPI AutoTest Threshold CPhase U4",
  "unc.65323.spiAutoTestThresholdCPhaseU2": "SPI AutoTest Threshold CPhase U2",
  "unc.65323.spiAutoTestThresholdCPhaseU3": "SPI AutoTest Threshold CPhase U3",
  "unc.65323.spiAutoTestThresholdCPhaseU1": "SPI AutoTest Threshold CPhase U1",
  "unc.65323.bmsChargeCurrentLimit": "battery Charge Current Limit",
  "unc.65323.batFaultFlag": "Battery Alarm Flag",
  "unc.65323.batteryVoltage": "Battery Voltage",
  "unc.65323.ctAPhaseActivePower": "CT APhase Active Power",
  "unc.65323.spiAutoTestThresholdF4": "SPI AutoTest Threshold F4",
  "unc.65323.spiAutoTestThresholdF3": "SPI AutoTest Threshold F3",
  "unc.65323.spiAutoTestThresholdF2": "SPI AutoTest Threshold F2",
  "unc.65323.spiAutoTestThresholdF1": "SPI AutoTest Threshold F1",
  "validate.email.verificationCodeHasBeenSent": "Verification Code Sent",
  "unc.65323.loadReactivePower": "Load ReActive Power",
  "register.guidance.toLogin": "Already have an account? Go to login",
  "unc.65323.batTotalChargeEnergy": "Battery Total Charge Energy",
  "unc.65323.spiAutoTestTimeBPhaseU1": "SPI AutoTest Time BPhase U1",
  "unc.65323.spiAutoTestTimeBPhaseU2": "SPI AutoTest Time BPhase U2",
  "unc.65323.spiAutoTestTimeBPhaseU3": "SPI AutoTest Time BPhase U3",
  "unc.65323.spiAutoTestTimeBPhaseU4": "SPI AutoTest Time BPhase U4",
  "unc.65323.load2GeneratorReactivePower": "Load2 Generator ReActive Power",
  "register.lable.password": "Password",
  "unc.65323.bmsTemperature": "BMS Temperature(℃)",
  "register.title.WelcomeRegister": "Welcome to Register",
  "unc.65323.gridCPhaseActivePower": "Grid CPhase Active Power",
  "unc.65323.pv4Voltage": "PV4 Voltage",
  "unc.65323.spiAutoTestThresholdBPhaseU3": "SPI AutoTest Threshold BPhase U3",
  "unc.65323.spiAutoTestThresholdBPhaseU4": "SPI AutoTest Threshold BPhase U4",
  "unc.65323.spiAutoTestThresholdBPhaseU1": "SPI AutoTest Threshold BPhase U1",
  "unc.65323.spiAutoTestThresholdBPhaseU2": "SPI AutoTest Threshold BPhase U2",
  "unc.65323.returnFlowPortFrequency": "Return Flow Port Frequency",
  "unc.65323.pv3Current": "PV3 Current",
  "solis.10001.homeGridTodayEnergy": "Today Consumption",
  "login.agreement.checkAgreeAgreement": "Please select that you agree with the Terms of Service and Privacy Policy",
  "unc.65323.returnFlowPortPowerFactor": "Return Flow Port Power Factor",
  "register.lable.VerificationCode": "Verification Code",
  "unc.65323.phaseOrder": "Phase Order",
  "retrieve.tips.sendVerificationCodeEmailAddress": "The verification code has been sent to your {scope} email.",
  "unc.65323.pvTotalPower": "PV Total Power",
  "unc.65323.returnFlowPortCPhaseActivePower": "Return Flow Port CPhase Active Power",
  "switchover.SelectIdentity": "Please choose your identity",
  "unc.65323.bmsDischargeCurrentLimit": "BMS Discharge Current Limit",
  "unc.65323.pv3Power": "PV3 Power",
  "unc.65323.gridFrequencyC": "Grid Frequency C",
  "unc.65323.gridFrequencyB": "Grid Frequency B",
  "unc.65323.gridFrequencyA": "Grid Frequency A",
  "solis.10001.gridCurrentC": "Grid Current C",
  "solis.10001.gridCurrentB": "Grid Current B",
  "solis.10001.gridCurrentA": "Grid Current A",
  "unc.65323.gridAPhaseActivePower": "Grid APhase Active Power",
  "unc.65323.returnFlowPortApparentPower": "Return Flow Port Apparent Power",
  "unc.65323.pv5Voltage": "PV5 Voltage",
  "unc.65323.inverterTemperature": "InverterTemperature(℃)",
  "unc.65323.returnFlowPortAPhaseActivePower": "Return Flow Port APhase Active Power",
  "solis.10001.gridFac": "Grid Frequency",
  "unc.65323.ctCurrentA": "CT Current A",
  "unc.65323.ctCurrentB": "CT Current B",
  "unc.65323.ctCurrentC": "CT Current C",
  "unc.65323.pv2Voltage": "PV2 Voltage",
  "mini.65290.onGridPower": "Active Power",
  "register.lable.register": "Register",
  "unc.65323.gridActivePower": "Grid Active Power",
  "unc.65323.powerFactor": "Power Factor",
  "the.latest.version.was.not.found": "No Latest Version",
  "unc.65323.ctApparentPower": "CT Apparent Power",
  "unc.65323.faultStatus2": "Fault Status2",
  "unc.65323.faultStatus1": "Fault Status1",
  "validate.retrieve.passwordEnteredTwiceInconsistent": "Passwords Do Not Match",
  "supplier.type.nep": "NEP",
  "mini.65290.tmp": "Inverter Temperature(℃)",
  "unc.65323.batteryCurrent": "Battery Current",
  "unc.65323.ctTotalActivePower": "CT Total Active Power",
  "unc.65323.todayFeedInGridEnergy": "Today Feed In Grid Energy",
  "unc.65323.ctBPhaseActivePower": "CT BPhase Active Power",
  "unc.65323.batTodayDischargeEnergy": "Today Discharged Energy",
  "unc.65323.negativeElectrodeInsulationImpedance": "Negative Electrode Insulation Impedance",
  "button.SendVerificationCode": "Send verification code",
  "unc.65323.gridApparentPower": "Grid Apparent Power",
  "unc.65323.ctFrequency": "CT Frequency",
  "unc.65323.pv4Power": "PV4 Power",
  "unc.65323.returnFlowPortVoltageC": "Return Flow Port Voltage C",
  "unc.65323.returnFlowPortVoltageB": "Return Flow Port Voltage B",
  "unc.65323.returnFlowPortVoltageA": "Return Flow Port Voltage A",
  "unc.65323.batChargeVoltage": "Battery Charge Voltage",
  "unc.65323.pv5Current": "PV5 Current",
  "unc.65323.load2GeneratorBPhaseActivePower": "Load2 Generator BPhase Active Power",
  "unc.65323.ctPowerFactor": "CT Power Factor",
  "unc.65323.spiAutoTestResult": "SPI AutoTest Result",
  "50300_E-G3-0-1": "OverVoltage protection for grid",
  "unc.65323.todayConsumeEnergy": "Today Consumption",
  "unc.65323.ctReactivePower": "CT ReActive Power",
  "supplier.type.styr": "Ecological manufacturer",
  "unc.65323.gridReactivePower": "Grid ReActive Power",
  "supplier.type.unc": "UNC",
  "unc.65323.pv2Current": "PV2 Current",
  "login.donTHaveAccount": "No Account Yet?",
  "jl_RTparam_name_BatteryVersion": "Battery Version",
  "unc.65323.loadTodayConsumeEnergy": "Load Today Consume Energy",
  "unc.65323.pvTodayEnergy": "PV Today Yield",
  "validate.tips.passwordRule": "Password must be between 8-20 characters, containing at least three different character types (numbers, uppercase letters, lowercase letters, special characters)",
  "unc.65323.load2GeneratorCurrentB": "Load2 Generator Current  B",
  "unc.65323.load2GeneratorCurrentA": "Load2 Generator Current  A",
  "unc.65323.load2GeneratorCurrentC": "Load2 Generator Current  C",
  "xnl_runningstatus_name_sleep_mode": "sleep mode",
  "xnl_runningstatus_name_self_check_mode": "self check",
  "xnl_runningstatus_name_normal_mode": "normal",
  "xnl_runningstatus_name_fault_mode": "fault",
  "ASNZ4777-N": "Australia_ASNZ4777-N",
  "CEI 0-21": "Italy_CEI 0-21",
  "custom50": "User defined_Custom50",
  "custom60": "User defined_Custom60",
  "EN50438L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "G83/1-A": "UK_G83/1-A",
  "G83/3": "UK_G83/3",
  "General50": "User defined_General 50",
  "General60": "User defined_General 60",
  "GN300V": "China_GN300V",
  "GNB": "China_GNB",
  "GNC": "China_GNC",
  "ISONE208": "USA_ISONE208",
  "ISONE208A": "USA_ISONE208A",
  "ISONE240": "USA_ISONE240",
  "ISONE240A": "USA_ISONE240A",
  "JAM-230": "Jamaica_JAM-230",
  "MEX": "China_MEX",
  "MEX-A": "Mexico_MEX-A",
  "MEX-N": "MEX-N_MEX-N",
  "NA-EEA-A": "Switzerland_NA-EEA-A",
  "R14-208": "USA_R14-208",
  "R14-208A": "USA_R14-208A",
  "R14-240": "USA_R14-240",
  "R14-240A": "USA_R14-240A",
  "R14H-208": "USA_R14H-208",
  "R14H-240": "USA_R14H-240",
  "R21-208": "USA_R21-208",
  "R21-240": "USA_R21-240",
  "R21P3-208": "USA_R21P3-208",
  "R21P3-20A": "USA_R21P3-20A",
  "R21P3-240": "USA_R21P3-240",
  "R21P3-24A": "USA_R21P3-24A",
  "UL-208V-13": "USA_UL-208V-13",
  "UL-208V-18": "USA_UL-208V-18",
  "UL-208V-A": "USA_UL-208V-A",
  "UL240-13": "USA_UL240-13",
  "UL-240V-18": "USA_UL-240V-18",
  "common.50402.Derating": "Derating",
  "common.50402.dispatch": "dispatch",
  "common.50402.fault": "fault",
  "common.50402.outages": "Power rationing and outages",
  "common.50402.generation": "Grid-connected power generation",
  "common.50402.Standby": "Standby",
  "common.50402.Planned": "Planned outages",
  "common.50300.offline": "Offline",
  "common.50300.Standby": "Standby",
  "common.50300.online": "online",
  "common.50300.fault": "fault",
  "device.category.fox": "Fox",
  "xparam_set.xnl_inverter_Factoryresetenable_disable": "disable",
  "param_set.xnl_inverter_Factoryresetenable_enable": "enable",
  "param_set.xnl_inverter_GridMode0": "General standard",
  "param_set.xnl_inverter_GridFrequency0": "disable",
  "param_set.xnl_inverter_GridFrequency1": "enable",
  "param_set.xnl_inverter_Q(V)0": "disable",
  "param_set.xnl_inverter_Q(V)1": "enable",
  "param_set.xnl_inverter_SolarArcFaultON0": "close",
  "param_set.xnl_inverter_SolarArcFaultON1": "open",
  "CEI0-21": "Italy_CEI 0-21",
  "common.50700.xnl_RTparam_group_Load": "Load",
  "common.50700.xnl_RTparam_group_Inverter": "Inverter",
  "common.50700.xnl_RTparam_group_Grid": "Power grid",
  "common.50700.170": "Illegal",
  "common.50700.169": "Factory testing",
  "common.50700.168": "On upgrade",
  "common.50700.167": "Standby",
  "common.50700.166": "Permanent breakdown",
  "common.50700.165": "Breakdown",
  "common.50700.164": "Off-grid",
  "common.50700.163": "Grid-connected",
  "common.50700.162": "In check",
  "common.50700.161": "Wait",
  "common.50700.160": "Self-test",
  "common.50700.TFreq": "T phase frequency",
  "common.50700.TCurrent": "T phase current",
  "common.50700.SVolt": "S phase voltage",
  "common.50700.SPower": "S phase power",
  "common.50700.SOH": "SOH",
  "common.50700.SoC": "SOC",
  "common.50700.SFreq": "S-phase frequency",
  "common.50700.SCurrent": "S phase power",
  "common.50700.RVolt": "R phase voltage",
  "common.50700.runningState": "Operating status",
  "common.50700.RPower": "R phase power",
  "common.50700.RFreq": "R phase frequency",
  "common.50700.ResidualEnergy": "Remaining battery level",
  "common.50700.ReactivePower": "Reactive power",
  "common.50700.RCurrent": "R phase power",
  "common.50700.pvPower": "PV power",
  "common.50700.pv9Volt": "PV9 voltage",
  "common.50700.pv9Power": "PV9 power",
  "common.50700.pv9Current": "PV9 current",
  "common.50700.pv8Volt": "PV8 voltage",
  "common.50700.pv8Power": "PV8 power",
  "common.50700.pv8Current": "PV8 current",
  "common.50700.pv7Volt": "PV7 voltage",
  "common.50700.pv7Power": "PV7 power",
  "common.50700.pv7Current": "PV7 current",
  "common.50700.pv6Volt": "PV6 voltage",
  "common.50700.pv6Power": "PV6 power",
  "common.50700.pv6Current": "PV6 current",
  "common.50700.pv5Volt": "PV5 voltage",
  "common.50700.pv5Power": "PV5 power",
  "common.50700.pv5Current": "PV5 current",
  "common.50700.pv4Volt": "PV4 voltage",
  "common.50700.pv4Power": "PV4 power",
  "common.50700.pv4Current": "PV4 current",
  "common.50700.pv3Volt": "PV3 voltage",
  "common.50700.pv3Power": "PV3 power",
  "common.50700.pv3Current": "PV3 current",
  "common.50700.pv2Volt": "PV2 voltage",
  "common.50700.pv2Power": "PV2 power",
  "common.50700.pv2Current": "PV2 current",
  "common.50700.pv1Volt": "PV1 voltage",
  "common.50700.pv1Power": "PV1 power",
  "common.50700.pv1Current": "PV1 current",
  "common.50700.pv18Volt": "PV18 voltage",
  "common.50700.pv18Power": "PV18 power",
  "common.50700.pv18Current": "PV18 current",
  "common.50700.pv17Volt": "PV17 voltage",
  "common.50700.pv17Power": "PV17 power",
  "common.50700.pv17Current": "PV17 current",
  "common.50700.pv16Volt": "PV16 voltage",
  "common.50700.pv16Power": "PV16 power",
  "common.50700.pv16Current": "PV16 current",
  "common.50700.pv15Volt": "PV15 voltage",
  "common.50700.pv15Power": "PV15 power",
  "common.50700.pv15Current": "PV15 current",
  "common.50700.pv14Volt": "PV14 voltage",
  "common.50700.pv14Power": "PV14 power",
  "common.50700.pv14Current": "PV14 current",
  "common.50700.pv13Volt": "PV13 voltage",
  "common.50700.pv13Power": "PV13 power",
  "common.50700.pv13Current": "PV13 current",
  "common.50700.pv12Volt": "PV12 voltage",
  "common.50700.pv12Power": "PV12 power",
  "common.50700.pv12Current": "PV12 current",
  "common.50700.pv11Volt": "PV11 voltage",
  "common.50700.pv11Power": "PV11 power",
  "common.50700.pv11Current": "PV11 current",
  "common.50700.pv10Volt": "PV10 voltage",
  "common.50700.pv10Power": "PV10 power",
  "common.50700.pv10Current": "PV10 current",
  "common.50700.PowerFactor": "Power factor",
  "common.50700.meterPowerT": "Meter power T",
  "common.50700.meterPowerS": "Meter power S",
  "common.50700.meterPowerR": "Meter 2 power R",
  "common.50700.meterPower2": "Meter 2 power",
  "common.50700.meterPower": "Meter power",
  "common.50700.loadsPowerT": "Load S phase power",
  "common.50700.loadsPowerS": "Load S phase power",
  "common.50700.loadsPowerR": "Load R phase power",
  "common.50700.loadsPower": "Load power",
  "common.50700.loads": "Load electricity consumption",
  "common.50700.invTemperation": "Inverter temperature",
  "common.50700.invBatVolt": "Inverter side battery voltage",
  "common.50700.invBatPower": "Inverter side battery current",
  "common.50700.invBatCurrent": "Inverter side battery voltage",
  "common.50700.gridConsumptionPower": "Grid-lost power",
  "common.50700.gridConsumption": "Total grid electricity consumption",
  "common.50700.generationPower": "Generation power",
  "common.50700.generation": "Cumulative power generation",
  "common.50700.feedinPower": "Grid-connected power",
  "common.50700.feedin": "Total amount of power fed to the net",
  "common.50700.epsVoltT": "EPS-T phase voltage",
  "common.50700.epsVoltS": "EPS-S phase voltage",
  "common.50700.epsVoltR": "EPS-R phase voltage",
  "common.50700.epsPowerT": "EPS-T phase power",
  "common.50700.epsPowerS": "EPS-S phase power",
  "common.50700.epsPowerR": "EPS-R phase power",
  "common.50700.epsPower": "EPS power",
  "common.50700.epsCurrentT": "EPS-T phase current",
  "common.50700.epsCurrentS": "EPS-S phase current",
  "common.50700.epsCurrentR": "EPS-R phase current",
  "common.50700.energyThroughput": "Battery throughput",
  "common.50700.dspTemperature": "DSP temperature",
  "common.50700.dischargeEnergyToTal": "Total charge energy",
  "common.50700.chargeTemperature": "Charging temperature",
  "common.50700.chargeEnergyToTal": "Total amount of charge",
  "common.50700.boostTemperation": "Charger temperature",
  "common.50700.batVolt": "Battery voltage",
  "common.50700.batTemperature": "Battery temperature",
  "common.50700.batStatusV2": "Battery status",
  "common.50700.batStatus": "Battery status",
  "common.50700.batDischargePower": "Battery charge power",
  "common.50700.batCurrent": "Battery current",
  "common.50700.batChargePower": "Battery charging power",
  "common.50700.ambientTemperation": "Ambient temperature",
  "common.50700.xnl_RTparam_group_Battery": "Battery",
  "common.50702.xnl_RTparam_group_Battery": "Battery",
  "common.50698.TVolt": "Phase T Voltage",
  "common.50700.TPower": "Phase T Power",
  "common.50700.TVolt": "Phase T Voltage",
  "supplier.type.ankerui": "ankerui",
  "subtype.collector.4g.meters": "4G meter",
  "param_set.xnl_inverter_Factoryresetenable": "Restore Factory Settings",
  "param_set.xnl_inverter_GridMode": "Grid Connection Standard",
  "param_set.xnl_inverter_GridType": "Grid Type Settings",
  "param_set.xnl_inverter_GridFrequency": "Grid Frequency Setting",
  "param_set.xnl_inverter_Restoreconnectiontime": "Restoration Grid-Connection Time",
  "param_set.xnl_inverter_PF": "Output PF-Measure Setting",
  "param_set.xnl_inverter_GridFrequencyOver": "High Grid Frequency Protection Point",
  "param_set.xnl_inverter_GridFrequencyUnder": "Low Grid Frequency Protection Point",
  "param_set.xnl_inverter_GridVoltageOver": "Grid overvoltage protection point",
  "param_set.xnl_inverter_GridVoltageUnder": "Low-voltage protection point of the power grid",
  "param_set.xnl_inverter_Q(V)": "California CA_QV Enable",
  "param_set.xnl_inverter_V1": "CA_QV_V1",
  "param_set.xnl_inverter_V2": "CA_QV_V2",
  "param_set.xnl_inverter_V3": "CA_QV_V3",
  "param_set.xnl_inverter_V4": "CA_QV_V4",
  "param_set.xnl_inverter_Q1": "CA_QV_Q1",
  "param_set.xnl_inverter_Q2": "CA_QV_Q2",
  "param_set.xnl_inverter_Q3": "CA_QV_Q3",
  "param_set.xnl_inverter_Q4": "CA_QV_Q4",
  "param_set.xnl_inverter_FW": "California CA_FW Enable",
  "param_set.xnl_inverter_Fstart": "CA_Fstart",
  "param_set.xnl_inverter_Fstop": "CA_Fstop",
  "param_set.xnl_inverter_VW": "California CA_VW Enable",
  "param_set.xnl_inverter_Vstart": "CA_Vstart",
  "param_set.xnl_inverter_Vstop": "CA_Vstop",
  "param_set.xnl_inverter_Normalupwardslope": "Normal rising slope",
  "param_set.xnl_inverter_Softstartriserate": "Soft Start Ramp Rate",
  "param_set.xnl_inverter_LHVRT": "California Low-High Voltage Crossing Enable",
  "param_set.xnl_inverter_HV2": "CA_HV2",
  "param_set.xnl_inverter_HV1": "CA_HV1",
  "param_set.xnl_inverter_LV1": "CA_LV1",
  "param_set.xnl_inverter_LV2": "CA_LV2",
  "param_set.xnl_inverter_LV3": "CA_LV3",
  "param_set.xnl_inverter_CA_HV2_Time": "CA_HV2_Time",
  "param_set.xnl_inverter_CA_HV1_Time": "CA_HV1_Time",
  "param_set.xnl_inverter_CA_LV1_Time": "CA_LV1_Time",
  "param_set.xnl_inverter_CA_LV2_Time": "CA_LV2_Time",
  "param_set.xnl_inverter_CA_LV3_Time": "CA_LV3_Time",
  "param_set.xnl_inverter_CA_LHFRT": "California Low Frequency High Frequency Crossing CA_LHFRT Enable",
  "param_set.xnl_inverter_CA_HF2": "CA_HF2",
  "param_set.xnl_inverter_CA_HF1": "CA_HF1",
  "param_set.xnl_inverter_CA_LF1": "CA_LF1",
  "param_set.xnl_inverter_CA_LF2": "CA_LF2",
  "param_set.xnl_inverter_CA_HF2_Time": "CA_HF2_Time",
  "param_set.xnl_inverter_CA_HF1_Time": "CA_HF1_Time",
  "param_set.xnl_inverter_CA_LF1_Time": "CA_LF1_Time",
  "param_set.xnl_inverter_CA_LF2_Time": "CA_LF2_Time",
  "param_set.xnl_inverter_GeneratorInputRatedPower": "Generator Rated Input Power ",
  "param_set.xnl_inverter_GENConnectToGridInput": "The generator is connected to the power grid ",
  "param_set.xnl_inverter_SmartLoadOutput": "Loaded Power ",
  "param_set.xnl_inverter_OnGridAlwayson00": "Conditions for Grid Activation ",
  "param_set.xnl_inverter_OFF1": "SmartLoad OFF Battery Voltage",
  "param_set.xnl_inverter_ON1": "SmartLoad ON Battery Voltage",
  "param_set.xnl_inverter_OFF2": "SmartLoad OFF Battery Level",
  "param_set.xnl_inverter_ON2": "SmartLoad ON Battery Level",
  "param_set.xnl_inverter_Battery_Type": "Battery Type ",
  "param_set.xnl_inverter_Battery_Mode": "Battery Mode ",
  "param_set.xnl_inverter_Activate Battery": "Lithium battery wake-up flag bit ",
  "param_set.xnl_inverter_Batt Capacity": "Battery Capacity ",
  "param_set.xnl_inverter_MaxACharge": "Maximum charging current of battery ",
  "param_set.xnl_inverter_MaxAdischarge": "Maximum Discharge Current of Battery",
  "param_set.xnl_inverter_GenCharge1": "Generator charging enable ",
  "param_set.xnl_inverter_GenSignal1": "Gen Signal",
  "param_set.xnl_inverter_GenStartingCapacityPoint2": "Generator charging start capacity point",
  "param_set.xnl_inverter_GenMainsPowerBattery2": "Generator charging current for battery",
  "param_set.xnl_inverter_MaxRunTime": "Maximum Operating Time of Generator",
  "param_set.xnl_inverter_CoolingTime": "Generator Cool Down Time",
  "param_set.xnl_inverter_GridCharge": "Mains Charging Enable ",
  "param_set.xnl_inverter_GridSignal": "Grid Signal",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge1": "Mains charging start capacity point ",
  "param_set.xnl_inverter_ChargeCurrentBatteryMains1": "Mains charging current for battery ",
  "param_set.xnl_inverter_Lithium Protocol": "Lithium Battery Communication Selection ",
  "param_set.xnl_inverter_ShutDown": "Battery Shutdown ",
  "param_set.xnl_inverter_Restart": "Battery Restart ",
  "param_set.xnl_inverter_LowBatt": "Battery Low Voltage ",
  "param_set.xnl_inverter_GenSignal ": "Mains signal ",
  "param_set.xnl_inverter_GenStartVoltageMainsPowerCharge": "Generator charging start voltage point",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge": "Mains charging start voltage point ",
  "param_set.xnl_inverter_FloatVoltage": "Float Voltage",
  "param_set.xnl_inverter_AbsorptionVoltage": "Absorption Voltage ",
  "param_set.xnl_inverter_EqualizationVoltage": "Equalizing voltage",
  "param_set.xnl_inverter_EqualizationdayS": "How often is equalization charging performed? ",
  "param_set.xnl_inverter_TEMPCO": "Temperature compensation value ",
  "param_set.xnl_inverter_Equalizationhours": "Equalization charge execution time",
  "param_set.xnl_inverter_batteryresistancevalue": "Battery internal resistance value ",
  "param_set.xnl_inverter_GenStartingCapacityPoint": "Generator charging start capacity point",
  "param_set.xnl_inverter_SellingFirst": "Selling electricity takes precedence ",
  "param_set.xnl_inverter_Solarsell": "Photovoltaic power selling rate",
  "param_set.xnl_inverter_MaxSolarPower": "Maximum Photovoltaic Power",
  "param_set.xnl_inverter_MaxSellPower": "Grid-connected maximum power",
  "param_set.xnl_inverter_Zero-Exportpower": "Minimum effective power",
  "param_set.xnl_inverter_EnergyPattern": "Energy Management Mode ",
  "param_set.xnl_inverter_GridPeakShavingPower": "Power grid peak shaving",
  "param_set.xnl_inverter_GridGen10": "Grid charging enable 1",
  "param_set.xnl_inverter_GridGen20": "Grid charging enable 2",
  "param_set.xnl_inverter_GridGen30": "Grid charging enable 3",
  "param_set.xnl_inverter_GridGen40": "Grid charging enable 4",
  "param_set.xnl_inverter_GridGen50": "Grid charging enable 5",
  "param_set.xnl_inverter_GridGen60": "Grid charging enable 6",
  "param_set.xnl_inverter_Time1": "Time Period 1",
  "param_set.xnl_inverter_Time2": "Time Period 2",
  "param_set.xnl_inverter_Time3": "Time Period 3",
  "param_set.xnl_inverter_Time4": "Time Period 4",
  "param_set.xnl_inverter_Time5": "Time Period 5",
  "param_set.xnl_inverter_Time6": "Time Period 6",
  "param_set.xnl_inverter_Power1": "Power",
  "param_set.xnl_inverter_Power2": "Power 2",
  "param_set.xnl_inverter_Power3": "Power 3",
  "param_set.xnl_inverter_Power4": "Power 4",
  "param_set.xnl_inverter_Power5": "Power 5",
  "param_set.xnl_inverter_Power6": "Power 6",
  "param_set.xnl_inverter_BattV1": "Battery Voltage 1  ",
  "param_set.xnl_inverter_BattV2": "Battery Voltage 2  ",
  "param_set.xnl_inverter_BattV3": "Battery Voltage 3  ",
  "param_set.xnl_inverter_BattV4": "Battery Voltage 4  ",
  "param_set.xnl_inverter_BattV5": "Battery Voltage 5  ",
  "param_set.xnl_inverter_BattV6": "Battery Voltage 6  ",
  "param_set.xnl_inverter_Batt1": "Power 1",
  "param_set.xnl_inverter_Batt2": "Power 2",
  "param_set.xnl_inverter_Batt3": "Power 3",
  "param_set.xnl_inverter_Batt4": "Power 4",
  "param_set.xnl_inverter_Batt5": "Power 5",
  "param_set.xnl_inverter_Batt6": "Power 6",
  "param_set.xnl_inverter_SolarArcFaultON": "Arc Fault Mode",
  "param_set.xnl_inverter_CTRatio": "CT Transformation Ratio",
  "param_set.xnl_inverter_BackupDelay": "Ups_time",
  "param_set.xnl_inverter_Parallel1": "Parallel",
  "param_set.xnl_inverter_3P1": "Three-phase parallel operation - Enable Meter CT ",
  "param_set.xnl_inverter_GenCharge": "Generator charging enable ",
  "param_set.xnl_inverter_GenChargeCurrentBatterMains": "Generator charging current for battery",
  "param_set.xnl_inverter_Down Time": "Generator Cool Down Time",
  "param_set.xnl_inverter_Grid Charge": "Mains Charging Enable ",
  "param_set.xnl_inverter_ChargeCurrentBatterMains": "Mains charging current for battery ",
  "param_set.xnl_inverter_GenMainsPowerBattery": "Generator charging current for battery",
  "param_set.xnl_inverter_DownTime": "Generator Cool Down Time",
  "param_set.xnl_inverter_StartingCapacityPoint": "Mains charging start capacity point ",
  "param_set.xnl_inverter_MainsPowerBattery": "Mains charging current for battery ",
  "param_set.xnl_inverter_Equalizationtime": "Equalization charge execution time",
  "param_set.xnl_inverter_Parallel2": "Master",
  "param_set.xnl_inverter_Parallel3": "Phase",
  "param_set.xnl_inverter_Parallel4": "Modbus SN",
  "param_set.xnl_inverter_3P2": "Three-phase parallel operation - Phase A enable ",
  "param_set.xnl_inverter_3P3": "Three-phase parallel operation - Phase B enable ",
  "param_set.xnl_inverter_3P4": "Three-phase parallel operation - Phase C enable ",
  "param_set.xnl_inverter_GridGen11": "Generator/Charging Enable 1",
  "param_set.xnl_inverter_GridGen21": "Generator Charging Enable 2",
  "param_set.xnl_inverter_GridGen31": "Generator charging enable 3",
  "param_set.xnl_inverter_GridGen41": "Generator charging enable 4",
  "param_set.xnl_inverter_GridGen51": "Generator charging enable 5",
  "param_set.xnl_inverter_GridGen61": "Diesel Generator Charging Enable 6 ",
  "param_set.xnl_inverter_OnGridAlwayson04": "Grid connection condition - Generator peak shaving",
  "param_set.xnl_inverter_OnGridAlwayson08": "Grid Activation Conditions - Grid Peak Shaving",
  "param_set.xnl_inverter_OnGridAlwayson12": "Grid Activation Condition - On Grid always on",
  "param_set.xnl_inverter_OnGridAlwayson13": "Grid connection condition - external relay",
  "param_set.xnl_inverter_OnGridAlwayson14": "Grid connection condition - Fault reporting enable bit for lithium battery loss",
  "param_set.xnl_inverter_OnGridAlwayson15": "Grid Activation Condition - DRM Enable Bit",
  "param_set.xnl_inverterGroup_BasicSettings": "Basic Settings",
  "param_set.xnl_inverterGroup_GridSettings": "Grid Settings",
  "param_set.xnl_inverterGroup_GeneratorSettings": "Generator Settings",
  "param_set.xnl_inverterGroup_BatterySettings": "Battery Settings",
  "param_set.xnl_inverterGroup_SystemOperatingMode": "System Operation Mode",
  "param_set.xnl_inverterGroup_AdvancedSettings": "Advanced Settings",
  "param_set.xnl_inverter_GenSignal_fdj": "generator signal",
  "param_set.xnl_inverter_GenSignal_charge": "Mains signal ",
  "param_set.xnl_inverter_GenSignal_fdj_1": "generator signal1",
  "param_set.xnl_inverter_GenSignal_charge_1": "Mains signal1",
  "param_set.xnl_inverter_GenSignal_fdj_2": "generator signal2",
  "param_set.xnl_inverter_GenSignal_charge_2": "Mains signal2",
  "param_set.xnl_inverter_TimeOfUse": "Time of Use",
  "param_set.xnl_inverter_GenPortUsedFor": "Generator Port Used For",
  "common.50300.todayFeedInGridEnergy": "Today Feed In Grid Energy",
  "common.50300.todayConsumeEnergy": "Today Consumption",
  "common.50300.totalFeedInGridEnergy": "Total Feed In Grid Energy",
  "common.50300.Ia": "Phase A current",
  "common.50300.Pa": "Phase A active power",
  "common.50300.Ib": "Phase B current",
  "common.50300.Pb": "Phase B active power",
  "common.50300.Ic": "Phase C current",
  "common.50300.Pc": "Phase C active power",
  "common.50300.ctTotalActivePower": "Total active power",
  "bw_value_ChargeDischargeRelaysAreDisconnected": "Charge Discharge Relays Are Disconnected",
  "bw_value_OnlyDischargeRelayIsClosed": "Only Discharge Relay Is Closed",
  "bw_value_OnlyChargeRelayIsClosed": "Only Charge Relay Is Closed",
  "bw_value_ChargeAndDischargeRelaysAreClosed": "Charge And Discharge Relays Are Closed",
  "bw_value_Single-Phase5KwModel": "Single-Phase 5Kw Model",
  "bw_value_SinglePhaseEnergyStorage5KwModel": "Single Phase Energy Storage 5Kw Model",
  "bw_value_Single-PhaseEnergyStorage3KwModel": "Single-Phase Energy Storage 3Kw Model",
  "bw_value_Single-PhaseEnergyStorage6KwModel": "Single-Phase Energy Storage 6Kw Model",
  "bw_value_SinglePhaseEnergyStorage8KwModel": "Single Phase Energy Storage 8Kw Model",
  "bw_value_Three-Phase4KwModel": "Three-Phase 4Kw Model",
  "bw_value_Three-Phase5KwModel": "Three-Phase 5Kw Model",
  "bw_value_Three-Phase6KwModel": "Three-Phase 6Kw Model",
  "bw_value_Three-Phase8KwModel": "Three-Phase 8Kw Model",
  "bw_value_ThreePhase10KwModel": "Three Phase 10Kw Model",
  "common.device.check.tab.collector": "Communication Stick",
  "common.device.check.tab.grid": "Power Grid",
  "common.device.check.tab.meterselect": "Electric Meter Selection",
  "common.device.check.tab.gridmeter": "Grid-Side Electric Meter",
  "common.device.check.tab.pvmeter": "PV-Side Electric Meter",
  "common.device.check.tab.battery": "Battery",
  "common.check.field.collectorSn": "Communication Stick SN",
  "common.check.field.dongleRSSI": "Signal Strength",
  "common.check.field.inverterHardwareVersion": "Communication Stick Hardware Version",
  "common.check.field.dongleSoftwareVersion": "Communication Stick Software Version",
  "common.check.field.gridVoltageR": "Grid Phase R Voltage",
  "common.check.field.gridVoltageS": "Grid Phase S Voltage",
  "common.check.field.gridVoltageT": "Grid Phase T Voltage",
  "common.check.field.meterCTSelect": "Electric Meter Connection Status (Connected/Disconnected)",
  "common.check.field.gridVoltageOfAPhase": "Electric Meter Phase A Voltage",
  "common.check.field.gridCurrentOfAPhaseV2": "Electric Meter Phase A Current",
  "common.check.field.gridVoltageOfBPhase": "Electric Meter Phase B Voltage",
  "common.check.field.gridCurrentOfBPhaseV2": "Electric Meter Phase B Current",
  "common.check.field.gridVoltageOfCPhase": "Electric Meter Phase C Voltage",
  "common.check.field.gridCurrentOfCPhaseV2": "Electric Meter Phase C Current",
  "common.check.field.gridFrequent": "Electric Meter Frequency",
  "common.check.field.pvVoltageOfAPhase": "Electric Meter Phase A Voltage",
  "common.check.field.pvCurrentOfAPhase": "Electric Meter Phase A Current",
  "common.check.field.pvVoltageOfBPhase": "Electric Meter Phase B Voltage",
  "common.check.field.pvCurrentOfBPhase": "Electric Meter Phase B Current",
  "common.check.field.pvVoltageOfCPhase": "Electric Meter Phase C Voltage",
  "common.check.field.pvCurrentOfCPhase": "Electric Meter Phase C Current",
  "common.check.field.pvFrequent": "Electric Meter Frequency",
  "common.check.field.pvTotalApparentPower": "Electric Meter Apparent Power (Total)",
  "common.check.field.pvMeterTotalActivePower": "Electric Meter Active Power (Total)",
  "common.check.field.pvTotalReactivePower": "Electric Meter Reactive Power (Total)",
  "common.check.field.pvTotalPowerFactor": "Electric Meter Power Factor (Total)",
  "common.check.field.batteryOnlineStatus": "Battery Effective Connection Status (Connected/Disconnected)",
  "device.category.heatpump": "heatpump",
  "device.category.collector": "Dongle",
  "jl_RTparam_name_powerAmmeter2": "powerAmmeter2",
  "jl_RTparam_name_dayEnergyAmmeter2": "dayEnergyAmmeter2",
  "jl_RTparam_name_monthEnergyAmmeter2": "monthEnergyAmmeter2",
  "jl_RTparam_name_yearEnergyAmmeter2": "yearEnergyAmmeter2",
  "jl_RTparam_name_totalEnergyAmmeter2": "totalEnergyAmmeter2",
  "jl_RTparam_group_Ammeter": "Ammeter",
  "ai.robot.manage.family": "Hi, AI Robot is managing your home electricity usage.",
  "ai.robot.predicted.price": "Today's electricity price has been obtained, predicting today's generation at {###}kWh.",
  "ai.robot.regulating.heat.pump": "The heat pump operation will be adjusted as appropriate.",
  "bw_RTparam_Option_NoPV": "No PV",
  "bw_RTparam_Option_HasPV": "Has PV",
  "bw_RTparam_Option_PVMeterNormal": "PV Meter Normal",
  "bw_RTparam_Option_PVMeterReversed": "PV Meter Reversed",
  "device.category.module": "Component",
  "common.device.check.tab.meterYes": "Electric Meter Connection Status",
  "50000_0X561-M-12": "Grid phase is inconsistent",
  "50000_0X561-M-13": "DCV Sample Abnormal",
  "50000_0X561-M-14": "Blackbox Flash Fault",
  "50000_0X561-M-15": "RTC Fault",
  "bw.content.alarm.0X55E-M-60": "Grid phase is inconsistent",
  "bw.content.alarm.0X55E-M-61": "DCV Sample Abnormal",
  "bw.content.alarm.0X55E-M-62": "Blackbox Flash Fault",
  "bw.content.alarm.0X55E-M-63": "RTC Fault",
  "plant.deliver.type.zj": "Haier Smart Home",
  "deliver.type.energy": "Haier Energy",
  "deliver.type.smart": "Haier Smart Home",
  "VDE0126-50Hz": "France--VDE0126-50Hz",
  "VDE4105/11.18": "Germany--VDE4105/11.18",
  "AS4777.2": "Australia--AS4777.2",
  "G83_2": "G83_2",
  "C10/C11": "Belgium--C10/C11",
  "TOR Erzeuger": "Austria--TOR Erzeuger",
  "EN50549-NL": "Netherlands--EN50549-NL",
  "EN50549-DK": "EN50549-DK",
  "CEB": "CEB",
  "CEI-021": "Italy--CEI-021",
  "NRS097-2-1": "South Africa--NRS097-2-1",
  "EN50549-GR": "EN50549-GR",
  "UTE_C15_712": "UTE_C15_712",
  "G59_3": "G59_3",
  "NA": "NA",
  "VDE0126-60Hz": "VDE0126-60Hz",
  "AS4777.2-SA": "Australia--AS4777.2-SA",
  "EN50549-CZ": "EN50549-CZ",
  "BISI": "BISI",
  "JET-GR Series": "JET-GR Series",
  "50Hz Default": "50Hz Default",
  "60Hz Default": "60Hz Default",
  "WAREHOUSE": "WAREHOUSE",
  "AS4777.2-NZ": "Australia--AS4777.2-NZ",
  "Korea": "Korea",
  "G98/G99-IE": "UK--G98/G99-IE",
  "NCRfg": "NCRfg",
  "UL1741": "UL1741",
  "UL1741-Rule21": "UL1741-Rule21",
  "UL1741-Hawaiian": "UL1741-Hawaiian",
  "common.50800.defrosting": "defrosting",
  "common.50800.antiFreezing": "antiFreezing",
  "common.50800.sterilization": "sterilization",
  "common.50800.antiRust": "antiRust",
  "common.50800.auto": "auto",
  "common.50800.cool": "cool",
  "common.50800.heat": "heat",
  "common.50800.dhw": "dhw",
  "common.50800.pool": "pool",
  "common.50800.heat+pool": "heat+pool",
  "common.50800.auto+dhw": "auto+dhw",
  "common.50800.cool+dhw": "cool+dhw",
  "common.50800.heat+dhw": "heat+dhw",
  "supplier.type.lg": "LIGOO",
  "plant.not.delivered": "plant not delivered",
  "plant.not.exist": "plant not exist",
  "plant.pure.light": "Zero Carbon Suitable Home - Pure Solar",
  "ywt.60419.meterTPower\n": "T-phase power of the electric meter",
  "ywt.60419.loadPower\n": "Load power",
  "param_set.lg_inverterGroup_LithiumBattery": "LithiumBattery",
  "param_set.lg_inverterGroup_AdvancedSettings": "AdvancedSettings",
  "param_set.lg_inverterGroup_SystemOperationMode": "SystemOperationMode",
  "param_set.lg_inverterGroup_GeneratorSettings": "GeneratorSettings",
  "param_set.lg_inverterGroup_ParallelOperationSettings": "ParallelUnitSettings",
  "param_set.lg_inverterGroup_PeakShavingandValleyFillingSettings": "PeakShavingandValleyFillingSettings",
  "param_set.lg_inverterGroup_GeneratorInputEnable": "GeneratorInputEnable",
  "param_set.lg_inverterGroup_SmartLoadEnable": "SmartLoadEnable",
  "param_set.lg_inverterGroup_MicroinverterEnable": "MicroinverterEnable",
  "param_set.lg_inverterGroup_Battery(Shared)": "Battery(Common)",
  "param_set.lg_inverterGroup_Lead-AcidBattery": "Lead-AcidBattery",
  "param_set.lg_inverter_SystemOn": "SystemPowerOn/Off",
  "param_set.lg_inverter_ClearFault": "ClearFaults",
  "param_set.lg_inverter_ManualActivation": "ManualActivation",
  "param_set.lg_inverter_InverterRated（%）": "InverterPowerPercentageSetting",
  "param_set.lg_inverter_PVActivePowerSetting": "PVActivePowerSetting(%)",
  "param_set.lg_inverter_PVConnectorMode": "PVConnectionSettings",
  "param_set.lg_inverter_PVStarupEnable": "SinglePVStartupEnable",
  "param_set.lg_inverter_ZeroGroundVoltFaultDetectionEnable": "Zero-GroundVoltageFaultDetectionEnable",
  "param_set.lg_inverter_GFCIEnable": "LeakageCurrentDetectionEnable",
  "param_set.lg_inverter_AllowGridCharging": "AllowGridCharging",
  "param_set.lg_inverter_PVISOEnable": "PVInsulationDetectionEnable",
  "param_set.lg_inverter_CT/MeterOptional": "CTMeterEnableBit",
  "param_set.lg_inverter_PhaseType": "PhaseSequenceType",
  "param_set.lg_inverter_CTRatio": "CTRatio",
  "param_set.lg_inverter_PVOperationMode": "PVOperationMode",
  "param_set.lg_inverter_CVT1CurrentLimit": "CVT1CurrentLimit",
  "param_set.lg_inverter_CVT2CurrentLimit": "CVT2CurrentLimit",
  "param_set.lg_inverter_ChargingCurrent": "ChargingCurrent",
  "param_set.lg_inverter_DischargingCurrent": "DischargingCurrent",
  "param_set.lg_inverter_FloatChargingVoltage": "FloatChargeVoltage",
  "param_set.lg_inverter_EqualChargingVoltage": "EqualizationChargeVoltage",
  "param_set.lg_inverter_CT/MeterAccessDirection": "CT/MeterConnectionDirection",
  "param_set.lg_inverter_HomeloadUnbalancedCurrentEnable": "HomeLoadUnbalanceFlowEnable",
  "param_set.lg_inverter_BMSClearFault": "BMSFaultClear",
  "param_set.lg_inverter_AFCIReset": "AFCIReset",
  "param_set.lg_inverter_HMIBrightness": "HMIBrightness",
  "param_set.lg_inverter_HMIRestTime": "HMIScreenOffTime",
  "param_set.lg_inverter_StatisticClear": "ClearStatistics",
  "param_set.lg_inverter_EnergyPattern": "EnergyManagementMode",
  "param_set.lg_inverter_SyncTimeEnable": "TimeSynchronizationEnable",
  "param_set.lg_inverter_RSDEnable": "RSDEnable",
  "param_set.lg_inverter_Startuptimesetbytheinstaller": "InstallerSetStartupTime",
  "param_set.lg_inverter_DynamicPassword": "DynamicPassword",
  "param_set.lg_inverter_ACType": "ACType",
  "param_set.lg_inverter_ChargingPriorityMode": "ChargingPriorityMode",
  "param_set.lg_inverter_SellPowerLimit": "LimitMaxGridFeedPowerOutput",
  "param_set.lg_inverter_BuzzerEnable": "Buzzer",
  "param_set.lg_inverter_MeterType": "MeterType",
  "param_set.lg_inverter_Specialfeatures": "SpecialFunctions",
  "param_set.lg_inverter_NLineNotGrounded": "NeutralLineNotGrounded",
  "param_set.lg_inverter_AFCIEnable": "ArcFaultDetectionEnable",
  "param_set.lg_inverter_FactoryReset": "RestoreFactorySettings",
  "param_set.lg_inverter_AsymmetricPhaseFeeding": "AsymmetricPhaseFeed",
  "param_set.lg_inverter_ParamsChangeLock": "ParameterModificationLock",
  "param_set.lg_inverter_SystemWorkMode": "SystemOperationMode",
  "param_set.lg_inverter_SolarSell": "PVSell",
  "param_set.lg_inverter_SignalIslandMode": "Off-GridSignalInput",
  "param_set.lg_inverter_GridTOUEnable": "GridPeakShavingTimeSlotEnable",
  "param_set.lg_inverter_AutoRunEnable": "AutoOperationEnable",
  "param_set.lg_inverter_DRMEnable": "DRMEnable",
  "param_set.lg_inverter_Password": "DefaultPassword",
  "param_set.lg_inverter_PasswordValidityTime": "PasswordValidTime",
  "param_set.lg_inverter_GeneratorStartMode": "GeneratorStartMode",
  "param_set.lg_inverter_GeneratorManualStartMode": "GeneratorManualStart",
  "param_set.lg_inverter_Generatorpriority": "GeneratorPriority",
  "param_set.lg_inverter_GeneratorInputPort": "GeneratorInputPort",
  "param_set.lg_inverter_GeneratorPower": "GeneratorPower",
  "param_set.lg_inverter_GeneratorStartupVoltage": "GeneratorStartVoltage",
  "param_set.lg_inverter_GeneratorShutdownVoltage": "GeneratorStopVoltage",
  "param_set.lg_inverter_GeneratorStartupSOC": "GeneratorStartSOC",
  "param_set.lg_inverter_GeneratorShutdownSOC": "GeneratorStopSOC(AutoStartMode)",
  "param_set.lg_inverter_GeneratorStartSignal": "GeneratorStartSignal",
  "param_set.lg_inverter_GeneratorChargeCurrent": "GeneratorChargingCurrent",
  "param_set.lg_inverter_GeneratorOperatingTimeLimit": "GeneratorMaxRunTime",
  "param_set.lg_inverter_GeneratorCutOffTime": "GeneratorCut-OffTime",
  "param_set.lg_inverter_GeneratorTOUEnable": "GeneratorPeakShavingEnable",
  "param_set.lg_inverter_ParallelEnable": "ParallelOperationEnable",
  "param_set.lg_inverter_ParallelAddress": "ParallelUnitAddress",
  "param_set.lg_inverter_ParallelNumber": "NumberofParallelUnits",
  "param_set.lg_inverter_ParallelBatterySharingEnable": "ParallelBatterySharingEnable",
  "param_set.lg_inverter_ParallelPhase": "ParallelUnitPhaseSequence",
  "param_set.lg_inverter_ParallelMode": "ParallelMode",
  "param_set.lg_inverter_Year/Month": "Year/Month",
  "param_set.lg_inverter_Day/Reserve": "Day/Reserved",
  "param_set.lg_inverter_Hour/Minute": "Hour/Minute",
  "param_set.lg_inverter_Second/Week": "Second/Week",
  "param_set.lg_inverter_TOUStartTime1": "PeakShavingCharge/DischargeStartTime1",
  "param_set.lg_inverter_TOUEndTime1": "PeakShavingCharge/DischargeEndTime1",
  "param_set.lg_inverter_Time1TOUPower": "Time1GridCharge/DischargePower",
  "param_set.lg_inverter_TOUStartTime2": "PeakShavingCharge/DischargeStartTime2",
  "param_set.lg_inverter_TOUEndTime2": "PeakShavingCharge/DischargeEndTime2",
  "param_set.lg_inverter_Time2TOUPower": "Time2GridCharge/DischargePower",
  "param_set.lg_inverter_TOUStartTime3": "PeakShavingCharge/DischargeStartTime3",
  "param_set.lg_inverter_TOUEndTime3": "PeakShavingCharge/DischargeEndTime3",
  "param_set.lg_inverter_Time3TOUPower": "Time3GridCharge/DischargePower",
  "param_set.lg_inverter_TOUStartTime4": "PeakShavingCharge/DischargeStartTime4",
  "param_set.lg_inverter_TOUEndTime4": "PeakShavingCharge/DischargeEndTime4",
  "param_set.lg_inverter_Time4TOUPower": "Time4GridCharge/DischargePower",
  "param_set.lg_inverter_TOUStartTime5": "PeakShavingCharge/DischargeStartTime5",
  "param_set.lg_inverter_TOUEndTime5": "PeakShavingCharge/DischargeEndTime5",
  "param_set.lg_inverter_Time5TOUPower": "Time5GridCharge/DischargePower",
  "param_set.lg_inverter_TOUStartTime6": "PeakShavingCharge/DischargeStartTime6",
  "param_set.lg_inverter_TOUEndTime6": "PeakShavingCharge/DischargeEndTime6",
  "param_set.lg_inverter_Time6TOUPower": "Time5GridCharge/DischargePower",
  "param_set.lg_inverter_Time1TOUSOC": "Time1PeakShavingBatterySOC",
  "param_set.lg_inverter_Time2TOUSOC": "Time2PeakShavingBatterySOC",
  "param_set.lg_inverter_Time3TOUSOC": "Time3PeakShavingBatterySOC",
  "param_set.lg_inverter_Time4TOUSOC": "Time4PeakShavingBatterySOC",
  "param_set.lg_inverter_Time5TOUSOC": "Time5PeakShavingBatterySOC",
  "param_set.lg_inverter_Time6TOUSOC": "Time6PeakShavingBatterySOC",
  "param_set.lg_inverter_Time1TOUVoltage": "Time1PeakShavingVoltage",
  "param_set.lg_inverter_Time2TOUVoltage": "Time2PeakShavingVoltage",
  "param_set.lg_inverter_Time3TOUVoltage": "Time3PeakShavingVoltage",
  "param_set.lg_inverter_Time4TOUVoltage": "Time4PeakShavingVoltage",
  "param_set.lg_inverter_Time5TOUVoltage": "Time5PeakShavingVoltage",
  "param_set.lg_inverter_Time6TOUVoltage": "Time6PeakShavingVoltage",
  "param_set.lg_inverter_TOUWeek": "PeakShavingWeekParameters",
  "param_set.lg_inverter_GENTOUEnable": "GeneratorPeakShavingTimeSlotEnable",
  "param_set.lg_inverter_SmartLoadSetting": "SmartLoadSettings",
  "param_set.lg_inverter_SmartLoadStopVoltage": "SmartLoadOffVoltage",
  "param_set.lg_inverter_GeneratorLinktoInput": "GeneratorConnectedtoGridInput",
  "param_set.lg_inverter_MicroINVLinkLoad": "MicroinverterConnectedtoLoadSide",
  "param_set.lg_inverter_MicroINVLinkGrid": "MicroinverterConnectedtoGridSide",
  "param_set.lg_inverter_SolarPower": "SolarPower",
  "param_set.lg_inverter_GridAlwaysOn": "GridAlwaysOn",
  "param_set.lg_inverter_OffGridDisconnection": "Off-GridImmediateDisconnect",
  "param_set.lg_inverter_SmartLoadONSOC": "SmartLoadStartSOC",
  "param_set.lg_inverter_SmartLoadOFFSOC": "SmartLoadStopSOC",
  "param_set.lg_inverter_ACCoupleFreqUpperLimit": "ACCoupleFrequencyUpperLimitSetting",
  "param_set.lg_inverter_MicroINVOutputtoGrid": "MicroinverterOutputtoGridCutoff",
  "param_set.lg_inverter_MicroINVOFFSOC": "MicroinverterOffSOC",
  "param_set.lg_inverter_MicroINVONSOC": "MicroinverterStartSOC",
  "param_set.lg_inverter_SmartLoadStartVoltage": "SmartLoadOnVoltage",
  "param_set.lg_inverter_SmartLoadDuration": "SmartLoadDurationTime",
  "param_set.lg_inverter_SmartLoadStartTime": "SmartLoadStartTime",
  "param_set.lg_inverter_SmartLoadEndTime": "SmartLoadEndTime",
  "param_set.lg_inverter_BatteryType": "BatteryType",
  "param_set.lg_inverter_BatteryInputMode": "BatteryConnectionMode",
  "param_set.lg_inverter_BatteryFailureShutdown": "BatteryCommunicationFaultShutdown",
  "param_set.lg_inverter_GridChargeEnable": "GridEnableCharging",
  "param_set.lg_inverter_GridSignal": "GridSignal",
  "param_set.lg_inverter_GridChargeCurrent": "GridChargingCurrent",
  "param_set.lg_inverter_GridStartupSOC": "GridStartSOC",
  "param_set.lg_inverter_BatteryLowCostMode": "BatteryLowPowerMode",
  "param_set.lg_inverter_LowNoiseMode": "BatteryLowNoiseMode",
  "param_set.lg_inverter_StrongchargeSOC": "ForcedChargeSOCPoint",
  "param_set.lg_inverter_StrongchargeStopSOC": "ForcedChargeCut-offSOCPoint",
  "param_set.lg_inverter_StrongchargeSOCEN": "ForcedChargeSOCEnable",
  "param_set.lg_inverter_LithiumBatteryManufacturers": "LithiumBatteryManufacturer",
  "param_set.lg_inverter_ChargingVoltage": "ChargingVoltage",
  "param_set.lg_inverter_ChargingCurrentLimit": "MaxChargingCurrent",
  "param_set.lg_inverter_DischargingCurrentLimit": "MaxDischargingCurrent",
  "param_set.lg_inverter_DischargingShutdownVoltage": "BatteryDischargeVoltageCut-offPoint",
  "param_set.lg_inverter_BatteryLowVoltage": "BatteryDischargeLowVoltagePoint",
  "param_set.lg_inverter_DischargingShutdownSOC": "BatteryDischargeCut-offSOC",
  "param_set.lg_inverter_ChargingEndSOC": "BatteryChargeCut-offSOC",
  "param_set.lg_inverter_BatteryLowSOC": "BatteryLowSOC",
  "param_set.lg_inverter_BatteryRestartSOC": "BatteryRestartSOC",
  "param_set.lg_inverter_AutoForced-chargeEnable": "AutoForcedChargeEnable",
  "param_set.lg_inverter_AutoActivationEnable": "BatteryAutoActivationEnable",
  "param_set.lg_inverter_BatteryTriggerVoltage": "BatteryActivationVoltage",
  "param_set.lg_inverter_BatteryTriggerTime": "BatteryActivationDuration",
  "param_set.lg_inverter_DisableFloatCharge": "DisableFloatCharge",
  "param_set.lg_inverter_CV-CCChargingTime": "ConstantVoltagetoConstantCurrentTime",
  "param_set.lg_inverter_CC-CVChargingTime": "ConstantCurrenttoConstantVoltageTime",
  "param_set.lg_inverter_CC-FCChargingTime": "EqualizationtoFloatChargeTime",
  "param_set.lg_inverter_LeadAcidOvervolt": "Lead-AcidOvervoltagePoint",
  "param_set.lg_inverter_LeadAcidBatteryType": "Lead-AcidBatteryType",
  "param_set.lg_inverter_BatteryRatedCapacity": "BatteryRatedCapacity",
  "param_set.lg_inverter_BatteryOverTempVoltage": "BatteryOvertemperatureProtectionPoint",
  "param_set.lg_inverter_TempCompensationFactor": "BatteryTemperatureCompensationCoefficient",
  "param_set.lg_inverter_BatteryRestartVoltage": "BatteryRecoveryVoltagePoint",
  "param_set.lg_inverter_EC-FCChargeCurrent": "EqualizationtoFloatChargeCurrent",
  "param_set.lg_inverter_FC-ECChargeCurrent": "FloattoEqualizationChargeCurrent",
  "param_set.lg_inverter_CCChargingTimeLimit": "MaxConstantCurrentEqualizationTime",
  "param_set.lg_inverter_CVChargingTimeLimit": "MaxConstantVoltageEqualizationTime",
  "status.enable": "enable",
  "status.disable": "disable",
  "end.app": "app",
  "end.backend": "backend",
  "module.product_management": "Product Management",
  "module.plant_management": "Plant Management",
  "module.shipment_management": "Shipment Management",
  "module.device_management": "Device Management",
  "module.device_detail": "Device Detail",
  "module.org_management": "Org Management",
  "module.login_register": "Login Register",
  "module.user_management": "User Management",
  "module.family_management": "Family Management",
  "module.physical_model": "Physical Model",
  "module.dictionary_value": "Dictionary Value",
  "50300_E-G3-0-0": "Power grid outage",
  "param.name.dongle.reset.returnTip": "Dongle reset successfully. Please reconnect it.",
  "test.code": "test.code",
  "test.code1": "test.code",
  "test.code3": "test.code",
  "test.code.222": "test.code.222",
  "dict.sttaus.not.normal": "ying",
  "dict.not.normal": "not-normal",
  "dict.status.normal": "normal",
  "rr": "222",
  "dict..status.not.normal": "not-normal",
  "dict.status.not.normal": "not-normal",
  "test": "test",
  "role.status.abnormal": "Abnormal",
  "role.status.normal1": "normal",
  "role.status.normal": "normal",
  "filter.all.blank.null": "all translation versions are empty",
  "fallback.i18n.code": "fallback",
  "plant.smart.investment": "Zero Carbon Smart Investment,",
  "oehrt1": "oehrt1",
  "module.oversea": "Ticket Management",
  "开发中": "开发中",
  "developing": "developing",
  "published": "Published",
  "supplier.type.ts": "tsun",
  "income.unit.cny.pkr": "PKR",
  "common.maintain": "Please maintain first",
  "device.robotChannel": "robot",
  "device.communicationChannel": "communication stick",
  "device.channelType": "communication channel",
  "device.switchChannelFailed": "Failed to switch communication channel",
  "else": "else",
  "All": "All",
  "multilangue.tag.dic": "Dictionary",
  "manual_import": "Manualimport",
  "c": "dong",
  "filter.nl_nl.blank.null": "Dutch translation version are empty",
  "filter.th_th.blank.null": "Thai translation version are empty",
  "test.chuneng": "chuneng",
  "filter.adsf": "Thai translation version are empty",
  "filter.tyu": "Thai translation version are empty",
  "Manual": "Manual",
  "System": "System",
  "Photovoltaic": "Photovoltaic",
  "Processed": "Processed",
  "shandong": "shandong1",
  "Critical": "Critical",
  "Urgent": "Urgent",
  "Severe": "Severe",
  "General": "General",
  "Reminder": "Reminder",
  "c1": "cache test 1",
  "common.cropper": "Image cropping",
  "common.confirmCropper": "Confirm cropping",
  "plant.light.storage1": "Zero Carbon Home",
  "plant.light.storage": "Zero Carbon Home",
  "plant.e-station1": "Zero Carbon E-Station",
  "plant.others1": "Others",
  "end.shared": "shared",
  "welcome": "welcome to here",
  "dynamic.price.not.exist": "Failed to obtain dynamic electricity prices",
  "product.pleaseUploadAtLeastOneImage": "Please upload at least one image.",
  "iot.device.register.failed": "IoT device registration failed",
  "expired": "expired",
  "due.today": "due today",
  "sidebar.bulletinBoard": "Installation",
  "sidebar.dataQuery": "Data Query",
  "physicalModels.functionSet": "Function Set",
  "Setting.timeSet": "Time Range",
  "org.authCompanyName": "Certified Company Name",
  "org.serviceAddress": "Service Address",
  "org.servicePhone": "Service Phone",
  "org.serviceEmail": "Service Email",
  "org.companyLogo": "Company Logo",
  "org.websiteUrl": "Website URL",
  "org.partnerId": "Partner ID",
  "org.serviceAgreement": "Service Agreement",
  "org.serviceCertificate": "Certificate",
  "report.dataQuery.maxDevicesWarning": "You can select up to 10 devices",
  "report.dataQuery.maxParamsWarning": "You can select up to 10 parameters",
  "report.dataQuery.selectDeviceAndParamsFirst": "Please select devices and parameters first",
  "report.dataQuery.chartTitle": "Multi-series operating trend comparison",
  "report.dataQuery.selectDevice": "Select device",
  "report.dataQuery.placeholderSelectDevice": "Please select a device",
  "report.dataQuery.tabByModel": "By model",
  "report.dataQuery.tabByStation": "By plant",
  "report.dataQuery.modelGroupName": "Model name",
  "report.dataQuery.noMore": "No more",
  "report.dataQuery.selectedDevicesFooter": "Selected {current} / 10 devices",
  "report.dataQuery.selectedDevicesShort": "Selected devices",
  "report.dataQuery.clear": "Clear",
  "report.dataQuery.noDeviceSelectedYet": "No device selected yet",
  "report.dataQuery.selectParamsTitle": "Select parameters (up to 10)",
  "report.dataQuery.maxParamsHint": "Up to 10 parameters at the same time",
  "report.dataQuery.searchParamsPlaceholder": "Search parameters",
  "report.dataQuery.noMatchingParams": "No matching parameters",
  "report.dataQuery.selectDeviceFirst": "Please select a device first",
  "report.dataQuery.placeholderDeviceSn": "Enter device serial number",
  "report.dataQuery.placeholderModelName": "Enter model name",
  "report.dataQuery.placeholderStationName": "Enter plant name",
  "report.dataQuery.selectedDevicesSummary": "{count} devices selected",
  "report.dataQuery.startAnalysis": "Start analysis",
  "report.dataQuery.emptyGuide": "Click “Select device” at the top left, choose up to 10 devices to analyze, then select parameters and a time range to start",
  "report.dataQuery.noDataHint": "No data to display for the current query. Adjust devices, parameters, or the time range and try again",
  "report.dataQuery.tableTitle": "Multi-device operating data comparison",
  "report.dataQuery.peakLabel": "Peak:",
  "report.dataQuery.peakColor": "Red",
  "report.dataQuery.valleyLabel": "Valley:",
  "report.dataQuery.valleyColor": "Blue",
  "report.dataQuery.timeByDay": "By day",
  "report.dataQuery.timeByWeek": "By week",
  "report.dataQuery.timeByMonth": "By month",
  "report.dataQuery.timeByCustom": "Custom",
  "report.dataQuery.highlightNone": "No highlight",
  "report.dataQuery.highlightCol": "Column diff highlight",
  "report.dataQuery.highlightRow": "Row diff highlight",
  "report.dataQuery.weekdayMon": "Mon",
  "report.dataQuery.weekdayTue": "Tue",
  "report.dataQuery.weekdayWed": "Wed",
  "report.dataQuery.weekdayThu": "Thu",
  "report.dataQuery.weekdayFri": "Fri",
  "report.dataQuery.weekdaySat": "Sat",
  "report.dataQuery.weekdaySun": "Sun",
  "report.dataQuery.axisMonthDay": "Day {n}",
  "plant.statisticalCycle": "Statistical Cycle",
  "report.dataQuery.maxCurvesWarning": "Current selection exceeds 10 curves",
  "report.dataQuery.maxCurvesLimitHint": "Up to 10 curves can be selected",
  "report.dataQuery.selectParamsHeading": "Select parameters",
  "device.button.cancel": "OK",
  "org.accountNumber": "User Account Number",
  "org.accountName": "User Account Name",
  "org.description": "Electricity User Description",
  "org.creditCode": "Social Credit Code",
  "plant.deptName": "Organization Name",
  "plant.businessScope": "Industrial and Commercial",
  "plant.withdrawBusinessDeliveryTip": "After withdrawing the delivery, {scope} users will no longer be able to manage this power station. Please proceed with caution.",
  "mapScreen.RevenueInfo": "Revenue Info",
  "mapScreen.MonthlyRevenue": "Monthly Revenue",
  "mapScreen.YearlyRevenue": "Yearly Revenue",
  "mapScreen.CumulativeRevenue": "Cumulative Revenue",
  "mapScreen.CarbonIndicator": "Carbon Indicator",
  "mapScreen.StorageInfo": "Storage Info",
  "mapScreen.MonthlyChargeDischarge": "Monthly Charge/Discharge",
  "mapScreen.YearlyChargeDischarge": "Yearly Charge/Discharge",
  "mapScreen.TotalPlants": "Total Plants",
  "mapScreen.PvInstalledCapacity": "PV Installed Capacity",
  "mapScreen.StorageInstalledCapacity": "Storage Installed Capacity",
  "mapScreen.ChargingPileCapacity": "Charging Pile Capacity",
  "mapScreen.Residential": "Residential",
  "mapScreen.Commercial": "Commercial",
  "mapScreen.PlantCount": "Total {count} plants",
  "mapScreen.NewEnergyPower": "New Energy Power",
  "mapScreen.GenerationInfo": "Generation Info",
  "mapScreen.MonthlyGeneration": "Monthly Generation",
  "mapScreen.YearlyGeneration": "Yearly Generation",
  "mapScreen.ChargingPileInfo": "Charging Pile Info",
  "mapScreen.MonthlyConsumption": "Monthly Consumption",
  "mapScreen.YearlyConsumption": "Yearly Consumption",
  "mapScreen.GridConnectionInfo": "Grid Connection Info",
  "mapScreen.MonthlyPurchaseFeedin": "Monthly Purchase/Feed-in",
  "mapScreen.YearlyPurchaseFeedin": "Yearly Purchase/Feed-in",
  "mapScreen.CO2Reduction": "CO2 Reduction",
  "mapScreen.SaveCoal": "Saved Coal",
  "mapScreen.TreePlanting": "Trees Planted",
  "mapScreen.SelectCountry": "Select Country",
  "mapScreen.BackToPrev": "Back to Previous",
  "mapScreen.Revenue": "Revenue",
  "mapScreen.ChargeAmount": "Charge Amount",
  "mapScreen.DischargeAmount": "Discharge Amount",
  "mapScreen.GenerationAmount": "Generation Amount",
  "mapScreen.ConsumptionAmount": "Consumption Amount",
  "mapScreen.PowerGeneration": "Power Generation",
  "mapScreen.PurchaseAmount": "Purchase Amount",
  "mapScreen.GridSellAmount": "Grid Sell Amount",
  "mapScreen.title": "Energy Management Platform",
  "mapScreen.PlantMonthlyRevenue": "Monthly Revenue",
  "mapScreen.PlantYearlyRevenue": "Yearly Revenue",
  "mapScreen.PlantCumulativeRevenue": "Cumulative Revenue",
  "physicalModels.tagGroup": "Tag Group",
  "device.expandAll": "Expand All",
  "device.collapseAll": "Collapse All",
  "common.deleteSuccess": "Deleted successfully",
  "common.unloginOrExpired": "Not logged in or login expired",
  "common.serverError": "Server exception, please try again later",
  "common.requestFailed": "Request failed",
  "common.backendError": "Backend interface connection error",
  "common.timeout": "System interface request timeout",
  "common.systemInterface": "System interface",
  "common.contains": "Contains",
  "common.columnSetting": "Column settings",
  "product.skipShipmentCheck": "Skip Shipment Check",
  "system.mapScreen": "Panoramic large screen",
  "settingDrawer.title": "Layout Settings",
  "settingDrawer.themeMode": "Theme Mode",
  "settingDrawer.darkTheme": "Dark Theme",
  "settingDrawer.lightTheme": "Light Theme",
  "settingDrawer.themeColor": "Theme Color",
  "settingDrawer.navMode": "Navigation Mode",
  "settingDrawer.sideMenu": "Side Menu Layout",
  "settingDrawer.topMenu": "Top Menu Layout",
  "settingDrawer.mixMenu": "Mixed Layout",
  "settingDrawer.columnMenu": "Column Layout",
  "settingDrawer.drawerMenu": "Drawer Layout",
  "settingDrawer.layoutSetting": "Layout Settings",
  "settingDrawer.contentWidth": "Content Width",
  "settingDrawer.contentWidthFixed": "Fixed",
  "settingDrawer.contentWidthFluid": "Fluid",
  "settingDrawer.fixedHeader": "Fixed Header",
  "settingDrawer.fixedSidebar": "Fixed Sidebar",
  "settingDrawer.hideFooter": "Hide Footer",
  "settingDrawer.multiTab": "Multi-tab Mode",
  "settingDrawer.sidebarColorfulIcon": "Colorful Sidebar Icons",
  "settingDrawer.searchMode": "Search Component Mode",
  "settingDrawer.searchModeHeader": "New Version",
  "settingDrawer.searchModeForm": "Old Version",
  "settingDrawer.systemConfig": "System Configuration",
  "settingDrawer.systemTitle": "System Title",
  "settingDrawer.systemCopyright": "Copyright Information",
  "settingDrawer.systemVersion": "System Version",
  "settingDrawer.systemVersionPlaceholder": "Version Number",
  "settingDrawer.tableStyle": "Table Style",
  "settingDrawer.tableSize": "Table Size",
  "settingDrawer.tableSizeDefault": "Default",
  "settingDrawer.tableSizeMiddle": "Middle",
  "settingDrawer.tableSizeSmall": "Compact",
  "settingDrawer.tableBordered": "Show Border",
  "settingDrawer.tableFixHeader": "Fix Header",
  "settingDrawer.tableHeaderBold": "Bold Header",
  "settingDrawer.tableResizable": "Resizable Columns",
  "settingDrawer.tableRowSelection": "Row Selection",
  "settingDrawer.tableHeaderBgColor": "Header Background Color",
  "settingDrawer.tableHeight": "Table Height",
  "settingDrawer.pageSize": "Page Size",
  "settingDrawer.pageSizeUnit": "Items/Page",
  "settingDrawer.showTotal": "Show Total",
  "settingDrawer.showSizeChanger": "Show Size Changer",
  "settingDrawer.showQuickJumper": "Show Quick Jumper",
  "settingDrawer.tableStripe": "Zebra Striping",
  "settingDrawer.tableShowHeader": "Show Header",
  "settingDrawer.saveTableConfig": "Save Table Configuration",
  "settingDrawer.reset": "Reset",
  "settingDrawer.configManagement": "Configuration Management",
  "settingDrawer.saveAll": "Save All Configurations",
  "settingDrawer.exportConfig": "Export Configuration",
  "settingDrawer.importConfig": "Import Configuration",
  "settingDrawer.resetAll": "Reset All Configurations",
  "settingDrawer.msg.initFail": "System initialization failed, please refresh and try again",
  "settingDrawer.msg.configInitFail": "Configuration initialization failed",
  "settingDrawer.msg.themeChangeFail": "Theme switch failed",
  "settingDrawer.msg.colorChangeFail": "Theme color switch failed",
  "settingDrawer.msg.searchModeSwitched": "Switched to {mode} search",
  "settingDrawer.msg.searchModeSwitchFail": "Search component switch failed",
  "settingDrawer.msg.navModeSwitched": "Switched to {mode} mode",
  "settingDrawer.msg.navSide": "Sidebar",
  "settingDrawer.msg.navTop": "Top Menu",
  "settingDrawer.msg.navMix": "Mixed",
  "settingDrawer.msg.navModeSwitchFail": "Navigation mode switch failed",
  "settingDrawer.msg.layoutSwitchFail": "Layout switch failed",
  "settingDrawer.msg.settingUpdateFail": "Setting update failed",
  "settingDrawer.msg.tableStoreNotInit": "Table configuration store not initialized",
  "settingDrawer.msg.tableConfigSaved": "Table configuration saved",
  "settingDrawer.msg.tableConfigSaveFail": "Failed to save table configuration",
  "settingDrawer.msg.tableConfigReset": "Table configuration reset",
  "settingDrawer.msg.tableConfigResetFail": "Failed to reset table configuration",
  "settingDrawer.msg.systemConfigUpdated": "System configuration updated",
  "settingDrawer.msg.systemConfigUpdateFailStore": "System configuration update failed: Store not initialized",
  "settingDrawer.msg.systemConfigUpdateFail": "System configuration update failed",
  "settingDrawer.msg.allConfigSaved": "All configurations saved",
  "settingDrawer.msg.configSaveFail": "Failed to save configuration",
  "settingDrawer.msg.configExported": "Configuration exported",
  "settingDrawer.msg.configExportFail": "Failed to export configuration",
  "settingDrawer.msg.configImportConfirmTitle": "Confirm Import Configuration",
  "settingDrawer.msg.configImportConfirmContent": "Importing configuration will overwrite all current settings. Continue?",
  "settingDrawer.msg.confirm": "Confirm",
  "settingDrawer.msg.cancel": "Cancel",
  "settingDrawer.msg.configImported": "Configuration imported successfully",
  "settingDrawer.msg.configFileInvalid": "Invalid configuration file format",
  "settingDrawer.msg.resetConfirmTitle": "Confirm Reset",
  "settingDrawer.msg.resetConfirmContent": "Resetting will clear all custom configurations and restore to default. Continue?",
  "settingDrawer.msg.allConfigReset": "All configurations reset"
}
